/**
 * Returns a list of all participles used for the Italian passive voice assessment.
 * For each participle, versions for all four possible suffixes (-o, -a, -e, -i) are included.
 * @returns {Array} The list with participles.
 */
export default function() {
	return [
		"abalienato",
		"abbacchiato",
		"abbacinato",
		"abbadato",
		"abbagliato",
		"abbaiato",
		"abballato",
		"abbambinato",
		"abbancato",
		"abbandonato",
		"abbarbagliato",
		"abbarbato",
		"abbarcato",
		"abbaruffato",
		"abbassato",
		"abbatacchiato",
		"abbattuto",
		"abbatuffolato",
		"abbelito",
		"abbellato",
		"abbellito",
		"abbendato",
		"abbeverato",
		"abbiadato",
		"abbicato",
		"abbigliato",
		"abbinato",
		"abbindolato",
		"abbioccato",
		"abbiosciato",
		"abbisciato",
		"abbittato",
		"abboccato",
		"abboffato",
		"abbominato",
		"abbonacciato",
		"abbonato",
		"abbonito",
		"abbordato",
		"abborracciato",
		"abborrato",
		"abborrito",
		"abbottinato",
		"abbottonato",
		"abbozzacchiato",
		"abbozzato",
		"abbozzolato",
		"abbracciato",
		"abbraciato",
		"abbrancato",
		"abbreviato",
		"abbriccato",
		"abbrigliato",
		"abbrivato",
		"abbriviato",
		"abbrividito",
		"abbronzato",
		"abbrostolato",
		"abbrostolito",
		"abbruciacchiato",
		"abbruciato",
		"abbrunato",
		"abbrunito",
		"abbruscato",
		"abbrusciato",
		"abbrustiato",
		"abbrustolato",
		"abbrustolito",
		"abbrutito",
		"abbruttito",
		"abbuffato",
		"abbuiato",
		"abbuonato",
		"abburattato",
		"abbuzzito",
		"abdicato",
		"abdotto",
		"abiettato",
		"abilitato",
		"abissato",
		"abitato",
		"abituato",
		"abiurato",
		"abolito",
		"abominato",
		"abondato",
		"aborrito",
		"abraso",
		"abrogato",
		"abusato",
		"accaffato",
		"accagionato",
		"accagliato",
		"accalappiato",
		"accalcato",
		"accaldato",
		"accallato",
		"accalorato",
		"accalorito",
		"accambiato",
		"accampato",
		"accampionato",
		"accanalato",
		"accanato",
		"accaneggiato",
		"accanito",
		"accantonato",
		"accaparrato",
		"accapezzato",
		"accapigliato",
		"accapottato",
		"accappiato",
		"accappiettato",
		"accapponato",
		"accappucciato",
		"accaprettato",
		"accareggiato",
		"accarezzato",
		"accarnato",
		"accarpionato",
		"accartocciato",
		"accasato",
		"accasciato",
		"accasellato",
		"accasermato",
		"accastellato",
		"accastellinato",
		"accatarrato",
		"accatastato",
		"accattato",
		"accattivato",
		"accavalcato",
		"accavalciato",
		"accavallato",
		"accavezzato",
		"accecato",
		"acceffato",
		"accelerato",
		"accellerato",
		"accennato",
		"accensato",
		"accentato",
		"accentrato",
		"accentuato",
		"acceppato",
		"accerchiato",
		"accercinato",
		"accertato",
		"acceso",
		"accessoriato",
		"accettato",
		"acchetato",
		"acchiappato",
		"acchiocciolato",
		"acchitato",
		"acchiuduto",
		"acciabattato",
		"acciaiato",
		"acciambellato",
		"acciarpato",
		"acciecato",
		"accigliato",
		"acciglionato",
		"accignuto",
		"accincignato",
		"accinto",
		"acciocchito",
		"acciottolato",
		"accipigliato",
		"accismato",
		"acciso",
		"acciucchito",
		"acciuffato",
		"accivettato",
		"acclamato",
		"acclarato",
		"acclimatato",
		"accluso",
		"accoccato",
		"accoccolato",
		"accoccovato",
		"accodato",
		"accollato",
		"accoltellato",
		"accolto",
		"accomandato",
		"accomiatato",
		"accommiatato",
		"accomodato",
		"accompagnato",
		"accomunato",
		"acconciato",
		"acconigliato",
		"accontato",
		"accontentato",
		"accoppato",
		"accoppiato",
		"accorato",
		"accorciato",
		"accorcito",
		"accordato",
		"accordellato",
		"accorpato",
		"accorto",
		"accosciato",
		"accostato",
		"accostumato",
		"accotonato",
		"accottimato",
		"accovacciato",
		"accovato",
		"accovonato",
		"accozzato",
		"accreditato",
		"accresciuto",
		"accrespato",
		"accucciato",
		"accucciolato",
		"accudito",
		"acculato",
		"acculturato",
		"accumulato",
		"accumunato",
		"accusato",
		"acetificato",
		"acetilato",
		"acetito",
		"acidato",
		"acidificato",
		"acidulato",
		"acquadernato",
		"acquarellato",
		"acquartierato",
		"acquato",
		"acquattato",
		"acquerellato",
		"acquetato",
		"acquietato",
		"acquisito",
		"acquistato",
		"acromatizzato",
		"acuito",
		"acuminato",
		"acutizzato",
		"adacquato",
		"adagiato",
		"adattato",
		"addaziato",
		"addebbiato",
		"addebitato",
		"addecimato",
		"addensato",
		"addentato",
		"addentellato",
		"addentrato",
		"addestrato",
		"addetto",
		"addiacciato",
		"addimandato",
		"addimesticato",
		"addimorato",
		"addimostrato",
		"addipanato",
		"addirizzato",
		"additato",
		"additivato",
		"addizionato",
		"addobbato",
		"addocilito",
		"addogliato",
		"addolcato",
		"addolciato",
		"addolcito",
		"addolorato",
		"addomandato",
		"addomesticato",
		"addoppiato",
		"addormentato",
		"addossato",
		"addotto",
		"addottorato",
		"addottrinato",
		"addrizzato",
		"adduato",
		"addugliato",
		"adeguato",
		"adempito",
		"adempiuto",
		"adequato",
		"aderizzato",
		"adescato",
		"adibito",
		"adirato",
		"adito",
		"adiuvato",
		"adizzato",
		"adocchiato",
		"adombrato",
		"adonato",
		"adonestato",
		"adontato",
		"adoperato",
		"adoprato",
		"adorato",
		"adornato",
		"adottato",
		"adsorbito",
		"aduggiato",
		"adugnato",
		"adulato",
		"adulterato",
		"adunato",
		"adunghiato",
		"adusato",
		"aerato",
		"aereato",
		"aerotrainato",
		"aerotrasportato",
		"affabulato",
		"affaccendato",
		"affacchinato",
		"affacciato",
		"affagottato",
		"affaldato",
		"affamato",
		"affamigliato",
		"affannato",
		"affardellato",
		"affascinato",
		"affastellato",
		"affaticato",
		"affattucchiato",
		"affatturato",
		"affermato",
		"afferrato",
		"affettato",
		"affezionato",
		"affiancato",
		"affiatato",
		"affibbiato",
		"affidato",
		"affienato",
		"affievolito",
		"affigliato",
		"affigurato",
		"affilato",
		"affilettato",
		"affiliato",
		"affinato",
		"affiochito",
		"affiorato",
		"affisato",
		"affissato",
		"affisso",
		"affittato",
		"affittito",
		"afflitto",
		"afflosciato",
		"affocato",
		"affogato",
		"affogliato",
		"affollato",
		"affoltato",
		"affondato",
		"afforcato",
		"afforestato",
		"afforzato",
		"affossato",
		"affralito",
		"affrancato",
		"affranto",
		"affratellato",
		"affrenato",
		"affrenellato",
		"affrescato",
		"affrettato",
		"affrittellato",
		"affrontato",
		"affumato",
		"affumicato",
		"affumigato",
		"affuocato",
		"affusolato",
		"africanizzato",
		"ageminato",
		"agevolato",
		"aggallato",
		"agganciato",
		"aggangherato",
		"aggarbato",
		"aggattonato",
		"aggavignato",
		"aggelato",
		"aggettivato",
		"agghiacciato",
		"agghiadato",
		"agghiaiato",
		"agghindato",
		"aggiaccato",
		"aggiogato",
		"aggiornato",
		"aggirato",
		"aggiucchito",
		"aggiudicato",
		"aggiuntato",
		"aggiunto",
		"aggiustato",
		"agglomerato",
		"agglutinato",
		"aggomitolato",
		"aggottato",
		"aggradito",
		"aggraffato",
		"aggranchiato",
		"aggranchito",
		"aggrandito",
		"aggrappato",
		"aggraticciato",
		"aggravato",
		"aggredito",
		"aggregato",
		"aggrevato",
		"aggricciato",
		"aggrinzato",
		"aggrinzito",
		"aggrommato",
		"aggrondato",
		"aggroppato",
		"aggrottato",
		"aggrovigliato",
		"aggrumato",
		"aggruppato",
		"aggruzzolato",
		"agguagliato",
		"agguantato",
		"agguardato",
		"agguatato",
		"aggueffato",
		"agitato",
		"agognato",
		"agrarizzato",
		"aguatato",
		"agucchiato",
		"agunato",
		"agurato",
		"aguzzato",
		"aitato",
		"aiutato",
		"aizzato",
		"alato",
		"alberato",
		"albergato",
		"alcalinizzato",
		"alchilato",
		"alchimiato",
		"alchimizzato",
		"alcolizzato",
		"alcoolizzato",
		"alenato",
		"alesato",
		"alettato",
		"alfabetato",
		"alfabetizzato",
		"alidito",
		"alienato",
		"alimentato",
		"allacciato",
		"allagato",
		"allappato",
		"allargato",
		"allascato",
		"allattato",
		"alleato",
		"allegato",
		"alleggerito",
		"alleggiato",
		"allegorizzato",
		"alleluiato",
		"allenato",
		"allenito",
		"allentato",
		"allertato",
		"allessato",
		"allestito",
		"allettato",
		"allevato",
		"alleviato",
		"allibato",
		"allibito",
		"allibrato",
		"allicciato",
		"allietato",
		"allindato",
		"allineato",
		"alliso",
		"allocato",
		"allogato",
		"alloggiato",
		"allontanato",
		"allottato",
		"allucchettato",
		"allucciolato",
		"allucinato",
		"allumato",
		"alluminato",
		"alluminiato",
		"allungato",
		"allupato",
		"alluso",
		"alluzzato",
		"alogenato",
		"alonato",
		"alpeggiato",
		"alterato",
		"alternato",
		"alzato",
		"amalgamato",
		"amareggiato",
		"amaricato",
		"amato",
		"ambientato",
		"ambiguato",
		"ambito",
		"americanizzato",
		"amicato",
		"ammaccato",
		"ammaestrato",
		"ammainato",
		"ammalato",
		"ammaliato",
		"ammalinconito",
		"ammaltato",
		"ammanettato",
		"ammanicato",
		"ammanierato",
		"ammanigliato",
		"ammannato",
		"ammannellato",
		"ammannito",
		"ammansato",
		"ammansito",
		"ammantato",
		"ammantellato",
		"ammarato",
		"ammarezzato",
		"ammassato",
		"ammassellato",
		"ammassicciato",
		"ammatassato",
		"ammattonato",
		"ammazzato",
		"ammelmato",
		"ammencito",
		"ammendato",
		"ammennicolato",
		"ammesso",
		"ammetato",
		"ammezzito",
		"amministrato",
		"amminutato",
		"ammirato",
		"ammiserito",
		"ammobiliato",
		"ammodernato",
		"ammodernizzato",
		"ammogliato",
		"ammoinato",
		"ammollato",
		"ammollito",
		"ammonito",
		"ammonticchiato",
		"ammonticellato",
		"ammorbato",
		"ammorbidato",
		"ammorbidito",
		"ammorsato",
		"ammortato",
		"ammortito",
		"ammortizzato",
		"ammorzato",
		"ammosciato",
		"ammoscito",
		"ammostato",
		"ammotinato",
		"ammucchiato",
		"ammulinato",
		"ammusato",
		"ammutato",
		"ammutinato",
		"amnistiato",
		"amoracciato",
		"ampiato",
		"ampliato",
		"amplificato",
		"amputato",
		"anagrammato",
		"analizzato",
		"anamorfizzato",
		"anastomizzato",
		"anatematizzato",
		"anatomizzato",
		"anchilosato",
		"anciso",
		"ancorato",
		"andatoseno",
		"andicappato",
		"anellato",
		"anemizzato",
		"anestetizzato",
		"angariato",
		"anglicizzato",
		"angolato",
		"angosciato",
		"angustiato",
		"animato",
		"annacquato",
		"annaffiato",
		"annasato",
		"annaspato",
		"annaspicato",
		"annebbiato",
		"annegato",
		"annerato",
		"annerito",
		"annesso",
		"annestato",
		"annichilato",
		"annichilito",
		"annidato",
		"annientato",
		"annitrito",
		"annobilito",
		"annodato",
		"annodicchiato",
		"annoiato",
		"annotato",
		"annottato",
		"annottolato",
		"annoverato",
		"annullato",
		"annunciato",
		"annunziato",
		"annusato",
		"annuvolato",
		"anodizzato",
		"anonimizzato",
		"anteceduto",
		"anteposto",
		"antergato",
		"anticheggiato",
		"antichizzato",
		"anticipato",
		"anticonosciuto",
		"antidatato",
		"antiveduto",
		"antivisto",
		"antologizzato",
		"antropizzato",
		"antropomorfizzato",
		"aocchiato",
		"aombrato",
		"aonestato",
		"aontato",
		"aperto",
		"apocopato",
		"apologizzato",
		"apostrofato",
		"appaciato",
		"appacificato",
		"appagato",
		"appaiato",
		"appalesato",
		"appallottolato",
		"appaltato",
		"appanettato",
		"appannato",
		"apparato",
		"apparecchiato",
		"apparentato",
		"apparigliato",
		"apparito",
		"appartato",
		"appassionato",
		"appastato",
		"appastellato",
		"appellato",
		"appennellato",
		"appercepito",
		"appertizzato",
		"appesantito",
		"appesito",
		"appeso",
		"appestato",
		"appetito",
		"appezzato",
		"appiacevolito",
		"appianato",
		"appiastrato",
		"appiatato",
		"appiattato",
		"appiattito",
		"appiccato",
		"appiccicato",
		"appiccolito",
		"appiedato",
		"appigionato",
		"appigliato",
		"appinzato",
		"appiombato",
		"appioppato",
		"appisolato",
		"applaudito",
		"applicato",
		"appoderato",
		"appoggiato",
		"appollaiato",
		"appoppato",
		"apportato",
		"appostato",
		"apposto",
		"appratito",
		"appresentato",
		"appreso",
		"appressato",
		"apprestato",
		"apprettato",
		"apprezzato",
		"approcciato",
		"approfittato",
		"approfondato",
		"approfondito",
		"approntato",
		"appropinquato",
		"appropriato",
		"approssimato",
		"approvato",
		"approvisionato",
		"approvvigionato",
		"appruato",
		"appulcrato",
		"appuntato",
		"appuntellato",
		"appuntito",
		"appurato",
		"appuzzato",
		"arabescato",
		"arabizzato",
		"arato",
		"arbitrato",
		"arborato",
		"arcaizzato",
		"arcato",
		"architettato",
		"archiviato",
		"arcuato",
		"ardito",
		"areato",
		"argentato",
		"arginato",
		"argomentato",
		"arguito",
		"arianizzato",
		"arieggiato",
		"armato",
		"armonizzato",
		"aromatizzato",
		"arpeggiato",
		"arpionato",
		"arponato",
		"arrabattato",
		"arraffato",
		"arraffiato",
		"arrandellato",
		"arrangiato",
		"arrapato",
		"arrapinato",
		"arrappato",
		"arrazzato",
		"arrecato",
		"arredato",
		"arreggimentato",
		"arrembato",
		"arrenato",
		"arresiso",
		"arreso",
		"arrestato",
		"arretrato",
		"arricchito",
		"arricciato",
		"arricciolato",
		"arriffato",
		"arringato",
		"arrischiato",
		"arrisicato",
		"arriso",
		"arrocato",
		"arroccato",
		"arrochito",
		"arrogato",
		"arrolato",
		"arroncato",
		"arronzato",
		"arrosato",
		"arrossato",
		"arrostato",
		"arrostito",
		"arrotato",
		"arrotolato",
		"arrotondato",
		"arrovellato",
		"arroventato",
		"arroventito",
		"arrovesciato",
		"arrubinato",
		"arruffato",
		"arruffianato",
		"arrugginito",
		"arruncigliato",
		"arruolato",
		"arruvidito",
		"arsicciato",
		"arso",
		"artefatto",
		"articolato",
		"artigliato",
		"asceso",
		"asciato",
		"asciolvuto",
		"asciugato",
		"ascoltato",
		"ascoso",
		"ascosto",
		"ascritto",
		"asfaltato",
		"asfissiato",
		"asperso",
		"aspettato",
		"aspirato",
		"asportato",
		"aspreggiato",
		"assaettato",
		"assaggiato",
		"assalito",
		"assaltato",
		"assaporato",
		"assaporito",
		"assassinato",
		"assecondato",
		"assecurato",
		"assediato",
		"asseggiato",
		"assegnato",
		"assembiato",
		"assemblato",
		"assembrato",
		"assemprato",
		"assentato",
		"asserito",
		"asserragliato",
		"asservito",
		"assestato",
		"assetato",
		"assettato",
		"asseverato",
		"assibilato",
		"assicurato",
		"assiderato",
		"assiemato",
		"assiepato",
		"assillato",
		"assimigliato",
		"assimilato",
		"assiomatizzato",
		"assiso",
		"assistito",
		"associato",
		"assodato",
		"assoggettato",
		"assolcato",
		"assoldato",
		"assolto",
		"assolutizzato",
		"assomato",
		"assommato",
		"assonato",
		"assonnato",
		"assopito",
		"assorbito",
		"assordato",
		"assordito",
		"assortito",
		"assottigliato",
		"assuefatto",
		"assunto",
		"asteggiato",
		"astenuto",
		"asterso",
		"astratto",
		"astretto",
		"atomizzato",
		"atrofizzato",
		"atrovato",
		"attaccato",
		"attagliato",
		"attanagliato",
		"attardato",
		"attediato",
		"atteggiato",
		"attempato",
		"attendato",
		"attentato",
		"attenuato",
		"attenuto",
		"attergato",
		"atterrato",
		"atterrito",
		"atterzato",
		"atteso",
		"attestato",
		"atticizzato",
		"attillato",
		"attinto",
		"attirato",
		"attivato",
		"attivizzato",
		"attizzato",
		"attorcigliato",
		"attorniato",
		"attorto",
		"attoscato",
		"attossicato",
		"attraccato",
		"attrappito",
		"attratto",
		"attraversato",
		"attrezzato",
		"attribuito",
		"attristato",
		"attristito",
		"attruppato",
		"attualizzato",
		"attuato",
		"attuffato",
		"attutato",
		"attutito",
		"auggiato",
		"augumentato",
		"augurato",
		"aulito",
		"aumentato",
		"aunghiato",
		"ausato",
		"auscultato",
		"auspicato",
		"autenticato",
		"autentificato",
		"autoaccusato",
		"autoaffondato",
		"autoalimentato",
		"autoassolto",
		"autocandidato",
		"autocensurato",
		"autocitato",
		"autocommiserato",
		"autoconsumato",
		"autoconvinto",
		"autodefinito",
		"autodenunciato",
		"autodistrutto",
		"autofinanziato",
		"autogestito",
		"autogovernato",
		"autografato",
		"autoincensato",
		"autointersecato",
		"autoinvitato",
		"autolesionato",
		"autolimitato",
		"automaticizzato",
		"automatizzato",
		"automotivato",
		"autonominato",
		"autoproclamato",
		"autoprodotto",
		"autoprotetto",
		"autopubblicato",
		"autopubblicizzato",
		"autoregolamentato",
		"autoregolato",
		"autoridotto",
		"autoriparato",
		"autorizzato",
		"autosomministrato",
		"autosostenuto",
		"autosuggestionato",
		"autotassato",
		"autotrapiantato",
		"autotrasportato",
		"autovalutato",
		"avallato",
		"avampato",
		"avanzato",
		"avariato",
		"avinto",
		"aviolanciato",
		"aviotrasportato",
		"avocato",
		"avolterato",
		"avulso",
		"avutacelo",
		"avuto",
		"avvalorato",
		"avvalso",
		"avvantaggiato",
		"avvelato",
		"avvelenato",
		"avventato",
		"avventurato",
		"avverato",
		"avversato",
		"avvertito",
		"avvezzato",
		"avviato",
		"avvicendato",
		"avvicinato",
		"avvignato",
		"avvilito",
		"avviluppato",
		"avvinato",
		"avvinchiato",
		"avvinghiato",
		"avvinto",
		"avvisato",
		"avvistato",
		"avvitato",
		"avviticchiato",
		"avvitito",
		"avvivato",
		"avvolto",
		"avvoltolato",
		"aziendalizzato",
		"azionato",
		"azotato",
		"azzannato",
		"azzardato",
		"azzeccato",
		"azzerato",
		"azzimato",
		"azzittato",
		"azzittito",
		"azzoppato",
		"azzoppito",
		"azzuffato",
		"azzurrato",
		"bacato",
		"baccagliato",
		"bacchettato",
		"bacchiato",
		"baciato",
		"badato",
		"bagnato",
		"baipassato",
		"balbettato",
		"balcanizzato",
		"ballato",
		"baloccato",
		"balzato",
		"banalizzato",
		"bancato",
		"bandito",
		"bannato",
		"baraccato",
		"barattato",
		"barbarizzato",
		"barcamenato",
		"bardato",
		"barellato",
		"barrato",
		"barricato",
		"basato",
		"basciato",
		"basculato",
		"bassato",
		"bastato",
		"bastionato",
		"bastito",
		"bastonato",
		"battezzato",
		"battuto",
		"bazzicato",
		"beatificato",
		"beato",
		"beccato",
		"beccheggiato",
		"becchettato",
		"beffato",
		"beffeggiato",
		"bendato",
		"benedetto",
		"beneficato",
		"benvoluto",
		"berlusconizzato",
		"bersagliato",
		"bestemmiato",
		"bevuto",
		"biadato",
		"bianchettato",
		"bianchito",
		"biascicato",
		"biasimato",
		"biasmato",
		"bidonato",
		"biennalizzato",
		"biforcato",
		"bigiato",
		"bilanciato",
		"binato",
		"bindolato",
		"biodegradato",
		"biografato",
		"bipartito",
		"bisbigliato",
		"biscottato",
		"bisecato",
		"bisellato",
		"bisognato",
		"bissato",
		"bistrato",
		"bistrattato",
		"bitumato",
		"bituminato",
		"blandito",
		"bleffato",
		"blindato",
		"bloccato",
		"bobinato",
		"boccheggiato",
		"bocciato",
		"boicottato",
		"bollato",
		"bollito",
		"bombardato",
		"bombato",
		"bonderizzato",
		"bonificato",
		"bootato",
		"borbottato",
		"bordato",
		"boriato",
		"borrato",
		"borseggiato",
		"braccato",
		"bracciato",
		"bramato",
		"bramito",
		"brancicato",
		"brandeggiato",
		"brandito",
		"brasato",
		"bravato",
		"brevettato",
		"breviato",
		"brillantato",
		"brillato",
		"brinato",
		"broccato",
		"brocciato",
		"broccolato",
		"brontolato",
		"bronzato",
		"brucato",
		"bruciacchiato",
		"bruciato",
		"brunito",
		"bruscato",
		"bruschinato",
		"brutalizzato",
		"bruttato",
		"bucato",
		"bucherellato",
		"bufato",
		"buffato",
		"bufferizzato",
		"buggerato",
		"bugnato",
		"bulicato",
		"bulinato",
		"bullettato",
		"bullonato",
		"burattato",
		"burlato",
		"burocratizzato",
		"burrificato",
		"buscato",
		"buttato",
		"butterato",
		"bypassato",
		"cablato",
		"cabrato",
		"cacato",
		"cacciato",
		"cadenzato",
		"cadmiato",
		"caducato",
		"cagato",
		"caggiato",
		"cagionato",
		"cagliato",
		"calafatato",
		"calamitato",
		"calandrato",
		"calato",
		"calcato",
		"calciato",
		"calcificato",
		"calcolato",
		"caldeggiato",
		"calettato",
		"calibrato",
		"calmato",
		"calmierato",
		"calpestato",
		"calumato",
		"calunniato",
		"calzato",
		"cambiato",
		"camerato",
		"campionato",
		"campito",
		"camuffato",
		"canalizzato",
		"cancellato",
		"cancerizzato",
		"candeggiato",
		"candidato",
		"candito",
		"canforato",
		"cangiato",
		"cannato",
		"canneggiato",
		"cannibalizzato",
		"cannoneggiato",
		"canonizzato",
		"cantato",
		"canterellato",
		"canticchiato",
		"cantilenato",
		"canzonato",
		"caolinizzato",
		"capacitato",
		"capeggiato",
		"capillarizzato",
		"capitalizzato",
		"capitanato",
		"capitaneggiato",
		"capito",
		"capitozzato",
		"capivolto",
		"caponato",
		"capotato",
		"capottato",
		"capovolto",
		"capponato",
		"captato",
		"caramellato",
		"caramellizzato",
		"caratato",
		"caratterizzato",
		"carbonizzato",
		"carbossilato",
		"carburato",
		"carcato",
		"carcerato",
		"cardato",
		"carenato",
		"carezzato",
		"cariato",
		"caricato",
		"caricaturato",
		"caricaturizzato",
		"carotato",
		"carpionato",
		"carpito",
		"carreggiato",
		"carrozzato",
		"cartavetrato",
		"carteggiato",
		"cartellinato",
		"cartografato",
		"cartolarizzato",
		"cartonato",
		"cascolato",
		"cassato",
		"casso",
		"castigato",
		"castrato",
		"casualizzato",
		"catabolizzato",
		"catalizzato",
		"catalogato",
		"catapultato",
		"catechizzato",
		"categorizzato",
		"cateterizzato",
		"catramato",
		"cattolicizzato",
		"catturato",
		"causato",
		"cautelato",
		"cauterizzato",
		"cauzionato",
		"cavalcato",
		"cavataselo",
		"cavato",
		"cazzato",
		"cazziato",
		"cazzottato",
		"cedrato",
		"ceduto",
		"celato",
		"celebrato",
		"cellofanato",
		"cementato",
		"cementificato",
		"cennato",
		"censito",
		"censurato",
		"centellato",
		"centellinato",
		"centimetrato",
		"centinato",
		"centralizzato",
		"centrato",
		"centrifugato",
		"centuplicato",
		"cerato",
		"cercato",
		"cerchiato",
		"cernuto",
		"certificato",
		"cesellato",
		"cessato",
		"cestinato",
		"cheratinizzato",
		"chetato",
		"chiamato",
		"chiappato",
		"chiarificato",
		"chiarito",
		"chiaroscurato",
		"chiavato",
		"chiazzato",
		"chiesto",
		"chilificato",
		"chilometrato",
		"chimificato",
		"chinato",
		"chinizzato",
		"chiodato",
		"chiosato",
		"chiuso",
		"choccato",
		"ciancicato",
		"cianfrinato",
		"cianfrugliato",
		"ciangottato",
		"ciattato",
		"cibato",
		"cicatrizzato",
		"ciccato",
		"cicchettato",
		"ciclizzato",
		"ciclostilato",
		"cifrato",
		"cilindrato",
		"cimato",
		"cimentato",
		"cincischiato",
		"cinematografato",
		"cintato",
		"cinto",
		"cioncato",
		"ciondolato",
		"circolato",
		"circoncinto",
		"circonciso",
		"circondato",
		"circondotto",
		"circonflesso",
		"circonfluito",
		"circonfuso",
		"circonscritto",
		"circonvenuto",
		"circoscritto",
		"circostanziato",
		"circuito",
		"circumcinto",
		"circumnavigato",
		"citato",
		"ciucciato",
		"ciurmato",
		"civettato",
		"civilizzato",
		"clamato",
		"classato",
		"classicizzato",
		"classificato",
		"cliccato",
		"climatizzato",
		"clivato",
		"clonato",
		"cloroformizzato",
		"clorurato",
		"clusterizzato",
		"co-diretto",
		"coacervato",
		"coadiuvato",
		"coagulato",
		"coalizzato",
		"coartato",
		"coccolato",
		"codificato",
		"coeditato",
		"coesistito",
		"cofinanziato",
		"cofirmato",
		"cofondato",
		"cogestito",
		"cogitato",
		"coglionato",
		"cognosciuto",
		"coibentato",
		"coinciso",
		"cointeressato",
		"cointestato",
		"coinvolto",
		"cokificato",
		"colato",
		"colettato",
		"collassato",
		"collaudato",
		"collazionato",
		"collegato",
		"collettivizzato",
		"collezionato",
		"collimato",
		"colliquato",
		"colliso",
		"collocato",
		"colluttato",
		"colmato",
		"colonizzato",
		"colorato",
		"colorito",
		"colorizzato",
		"colpevolizzato",
		"colpito",
		"coltellato",
		"coltivato",
		"colto",
		"coltrato",
		"comandato",
		"combattuto",
		"combinato",
		"comburuto",
		"comicizzato",
		"cominciato",
		"commemorato",
		"commendato",
		"commensurato",
		"commentato",
		"commercializzato",
		"commesso",
		"comminato",
		"commiserato",
		"commissariato",
		"commissionato",
		"commisurato",
		"commosso",
		"commutato",
		"comodato",
		"compaginato",
		"comparito",
		"compartimentalizzato",
		"compartito",
		"compassionato",
		"compatibilizzato",
		"compatito",
		"compattato",
		"compendiato",
		"compenetrato",
		"compensato",
		"comperato",
		"compiaciuto",
		"compianto",
		"compilato",
		"compitato",
		"compiuto",
		"complessato",
		"complessificato",
		"complesso",
		"completato",
		"complicato",
		"complimentato",
		"comportato",
		"compostato",
		"composto",
		"comprato",
		"compravenduto",
		"compreso",
		"compresso",
		"compromesso",
		"comprovato",
		"compulsato",
		"compunto",
		"computato",
		"computerizzato",
		"comunicato",
		"comunistizzato",
		"concatenato",
		"conceduto",
		"concelebrato",
		"concentrato",
		"concepito",
		"concertato",
		"concesso",
		"concettato",
		"concettualizzato",
		"conchiuso",
		"conciato",
		"conciliato",
		"concimato",
		"concitato",
		"conclamato",
		"concluso",
		"concordato",
		"concotto",
		"concretato",
		"concretizzato",
		"conculcato",
		"concupito",
		"condannato",
		"condensato",
		"condito",
		"condiviso",
		"condizionato",
		"condoluto",
		"condonato",
		"condotto",
		"confatto",
		"confederato",
		"conferito",
		"confermato",
		"confessato",
		"confettato",
		"confezionato",
		"conficcato",
		"confidato",
		"configurato",
		"confinato",
		"confinto",
		"confiscato",
		"confitto",
		"conformato",
		"confortato",
		"confricato",
		"confrontato",
		"confuso",
		"confutato",
		"congedato",
		"congegnato",
		"congelato",
		"congestionato",
		"congetturato",
		"congiunto",
		"conglobato",
		"conglomerato",
		"conglutinato",
		"congratulato",
		"congregato",
		"conguagliato",
		"coniato",
		"coniugato",
		"connaturato",
		"connesso",
		"connotato",
		"connumerato",
		"conosciuto",
		"conquistato",
		"consacrato",
		"consapevolizzato",
		"consegnato",
		"conseguito",
		"consentito",
		"conservato",
		"considerato",
		"consigliato",
		"consistito",
		"consociato",
		"consolato",
		"consolidato",
		"consorziato",
		"consparso",
		"consperso",
		"constatato",
		"constretto",
		"construito",
		"consultato",
		"consumato",
		"consunto",
		"contabilizzato",
		"contagiato",
		"containerizzato",
		"contaminato",
		"contato",
		"contattato",
		"conteggiato",
		"contemperato",
		"contemplato",
		"contentato",
		"contenuto",
		"conteso",
		"contestato",
		"contestualizzato",
		"contingentato",
		"continuato",
		"contornato",
		"contorto",
		"contrabbandato",
		"contraccambiato",
		"contraddetto",
		"contraddistinto",
		"contradetto",
		"contraffatto",
		"contrappesato",
		"contrapposto",
		"contrappuntato",
		"contrariato",
		"contrassegnato",
		"contrastato",
		"contrato",
		"contrattaccato",
		"contrattato",
		"contratto",
		"contravvalso",
		"contristato",
		"controbattuto",
		"controbilanciato",
		"controdatato",
		"controfirmato",
		"controindicato",
		"controllato",
		"controminato",
		"contronotato",
		"controproposto",
		"controprovato",
		"controquerelato",
		"controsoffittato",
		"controstampato",
		"controventato",
		"conturbato",
		"contuso",
		"convalidato",
		"convenuto",
		"convenzionato",
		"convertito",
		"convinto",
		"convitato",
		"convocato",
		"convogliato",
		"convolto",
		"coobato",
		"cooptato",
		"coordinato",
		"coperchiato",
		"coperto",
		"copiaincollato",
		"copiato",
		"copolimerizzato",
		"coppellato",
		"coprodotto",
		"corazzato",
		"corbellato",
		"corcato",
		"cordonato",
		"coreografato",
		"coricato",
		"cornificato",
		"coronato",
		"corredato",
		"correlato",
		"corresponsabilizzato",
		"corretto",
		"corricchiato",
		"corrisposto",
		"corroborato",
		"corroso",
		"corrotto",
		"corrucciato",
		"corrugato",
		"corso",
		"corteato",
		"corteggiato",
		"cortocircuitato",
		"coruscato",
		"cosato",
		"coscritto",
		"cosparso",
		"cosperso",
		"costatato",
		"costeggiato",
		"costellato",
		"costernato",
		"costicchiato",
		"costipato",
		"costituito",
		"costituzionalizzato",
		"costretto",
		"costruito",
		"costudito",
		"cotonato",
		"cotto",
		"covato",
		"coventrizzato",
		"coverchiato",
		"craccato",
		"creato",
		"creduto",
		"cremato",
		"crepato",
		"cresciuto",
		"cresimato",
		"crespato",
		"criminalizzato",
		"crioconcentrato",
		"criptato",
		"cristallizzato",
		"cristianizzato",
		"criticato",
		"crittato",
		"crittografato",
		"crivellato",
		"crocchiato",
		"crocefisso",
		"crocefitto",
		"crocifisso",
		"crocifitto",
		"crogiolato",
		"cromato",
		"cronicizzato",
		"cronometrato",
		"crostato",
		"crucciato",
		"crucifisso",
		"crucifitto",
		"cuccato",
		"cucinato",
		"cucito",
		"cullato",
		"cumulato",
		"cuntato",
		"curato",
		"curvato",
		"curvato",
		"custodito",
		"customizzato",
		"damascato",
		"damaschinato",
		"damato",
		"dannato",
		"danneggiato",
		"danzato",
		"dardeggiato",
		"datato",
		"dato",
		"dattilografato",
		"dattiloscritto",
		"daziato",
		"deacidificato",
		"deattivato",
		"debbiato",
		"debellato",
		"debilitato",
		"decaffeinato",
		"decaffeinizzato",
		"decalcato",
		"decalcificato",
		"decantato",
		"decapato",
		"decapitato",
		"decappottato",
		"decarbossilato",
		"decarburato",
		"decatizzato",
		"decelerato",
		"decentralizzato",
		"decentrato",
		"decerebrato",
		"decernuto",
		"decespugliato",
		"deciferato",
		"decifrato",
		"decimalizzato",
		"decimato",
		"deciso",
		"declamato",
		"declassato",
		"declassificato",
		"declinato",
		"declorato",
		"decodificato",
		"decolonizzato",
		"decolorato",
		"decompartimentato",
		"decompilato",
		"decomposto",
		"decompresso",
		"deconcentrato",
		"decondizionato",
		"decongelato",
		"decongestionato",
		"decontaminato",
		"decontestualizzato",
		"decontratto",
		"decorato",
		"decorticato",
		"decostruito",
		"decrementato",
		"decretato",
		"decriminalizzato",
		"decriptato",
		"decrittato",
		"decuplicato",
		"decurtato",
		"dedicato",
		"dedotto",
		"defacciato",
		"defalcato",
		"defascistizzato",
		"defecato",
		"defenestrato",
		"deferito",
		"defilato",
		"definito",
		"defiscalizzato",
		"defitto",
		"deflazionato",
		"deflemmato",
		"deflorato",
		"defogliato",
		"defoliato",
		"deforestato",
		"deformato",
		"defosforato",
		"defosforilato",
		"deframmentato",
		"defraudato",
		"degassato",
		"degassificato",
		"deglutito",
		"degnato",
		"degradato",
		"degustato",
		"deidratato",
		"deidrogenato",
		"deificato",
		"deindicizzato",
		"deindustrializzato",
		"deionizzato",
		"delegato",
		"delegificato",
		"delegittimato",
		"delibato",
		"deliberato",
		"delimitato",
		"delineato",
		"delirato",
		"deliziato",
		"delocalizzato",
		"delucidato",
		"deluso",
		"demagnetizzato",
		"demandato",
		"demanializzato",
		"demarcato",
		"demeritato",
		"demerso",
		"demetallizzato",
		"demilitarizzato",
		"demineralizzato",
		"demistificato",
		"demitizzato",
		"democratizzato",
		"demodulato",
		"demolito",
		"demoltiplicato",
		"demonetato",
		"demonetizzato",
		"demonizzato",
		"demoralizzato",
		"demorso",
		"demotivato",
		"denaturalizzato",
		"denaturato",
		"denazificato",
		"denazionalizzato",
		"denicotinizzato",
		"denigrato",
		"denitrificato",
		"denocciolato",
		"denominato",
		"denotato",
		"dentellato",
		"denuclearizzato",
		"denudato",
		"denunciato",
		"denunziato",
		"deodorato",
		"deossidato",
		"deossigenato",
		"deostruito",
		"depauperato",
		"depenalizzato",
		"depennato",
		"depilato",
		"depinto",
		"depistato",
		"deplorato",
		"depolarizzato",
		"depolimerizzato",
		"depoliticizzato",
		"depolverizzato",
		"deportato",
		"depositato",
		"deposto",
		"depotenziato",
		"depravato",
		"deprecato",
		"depredato",
		"depresso",
		"depressurizzato",
		"deprezzato",
		"deprivato",
		"deprotonato",
		"depulso",
		"depurato",
		"dequalificato",
		"deratizzato",
		"derattizzato",
		"dereferenziato",
		"deregolamentato",
		"deregolato",
		"derequisito",
		"deresponsabilizzato",
		"deriso",
		"derubato",
		"derubricato",
		"desacralizzato",
		"desalato",
		"desalinizzato",
		"descolarizzato",
		"descritto",
		"desecretato",
		"desegretato",
		"deselezionato",
		"desensibilizzato",
		"desessualizzato",
		"desiato",
		"desiderato",
		"designato",
		"desinato",
		"desirato",
		"desolato",
		"desolforato",
		"desonorizzato",
		"desorbito",
		"desossidato",
		"desquamato",
		"destabilizzato",
		"destagionalizzato",
		"destalinizzato",
		"destatalizzato",
		"destatizzato",
		"destato",
		"destinato",
		"destituito",
		"destoricizzato",
		"destreggiato",
		"destrutto",
		"destrutturato",
		"desunto",
		"detassato",
		"detenuto",
		"deteriorato",
		"determinato",
		"deterso",
		"detestato",
		"detonato",
		"detorto",
		"detossificato",
		"detratto",
		"detronizzato",
		"dettagliato",
		"dettato",
		"detto",
		"deturpato",
		"deumidificato",
		"devastato",
		"deventato",
		"deviato",
		"deviscerato",
		"devitalizzato",
		"devitaminizzato",
		"devoluto",
		"dezippato",
		"diaframmato",
		"diagnosticato",
		"diagonalizzato",
		"diagrammato",
		"dializzato",
		"dialogato",
		"dialogizzato",
		"diazotato",
		"dibattuto",
		"diboscato",
		"dichiarato",
		"diesato",
		"diesizzato",
		"difeso",
		"diffamato",
		"differito",
		"diffidato",
		"diffranto",
		"diffratto",
		"diffuso",
		"digerito",
		"digitalizzato",
		"digitato",
		"digiunto",
		"digrassato",
		"digrignato",
		"digrossato",
		"dilacerato",
		"dilaniato",
		"dilapidato",
		"dilatato",
		"dilavato",
		"dilazionato",
		"dileggiato",
		"dileguato",
		"dilettato",
		"diletto",
		"diliscato",
		"dilucidato",
		"diluito",
		"dilungato",
		"dimagrato",
		"dimandato",
		"dimenato",
		"dimensionato",
		"dimenticato",
		"dimerizzato",
		"dimesso",
		"dimezzato",
		"diminuito",
		"dimissionato",
		"dimostrato",
		"dimunto",
		"dinamizzato",
		"dinoccato",
		"dipanato",
		"dipelato",
		"dipinto",
		"diplomato",
		"diposto",
		"diradato",
		"diramato",
		"diretto",
		"direzionato",
		"dirimuto",
		"diroccato",
		"dirottato",
		"dirotto",
		"dirozzato",
		"disabilitato",
		"disabituato",
		"disaccentato",
		"disaccoppiato",
		"disaccordato",
		"disacerbato",
		"disacidato",
		"disacidificato",
		"disacidito",
		"disaerato",
		"disaffezionato",
		"disaggregato",
		"disalberato",
		"disallineato",
		"disamato",
		"disambiguato",
		"disaminato",
		"disamorato",
		"disancorato",
		"disanimato",
		"disappannato",
		"disapplicato",
		"disappreso",
		"disapprovato",
		"disarcionato",
		"disarmato",
		"disarticolato",
		"disascosto",
		"disassemblato",
		"disassuefatto",
		"disatomizzato",
		"disatteso",
		"disattivato",
		"disattrezzato",
		"disavvezzato",
		"disboscato",
		"disbrigato",
		"discacciato",
		"discalzato",
		"discantato",
		"discaricato",
		"discernuto",
		"disceso",
		"disceverato",
		"dischiesto",
		"dischiuso",
		"discinto",
		"disciolto",
		"disciplinato",
		"discolorato",
		"discolpato",
		"discommesso",
		"discompagnato",
		"discomposto",
		"disconcluso",
		"disconfitto",
		"discongiunto",
		"disconnesso",
		"disconosciuto",
		"discoperto",
		"discordato",
		"discosceso",
		"discostato",
		"discreditato",
		"discresciuto",
		"discriminato",
		"discritto",
		"discucito",
		"discuoiato",
		"discusso",
		"disdegnato",
		"disdettato",
		"disdetto",
		"diseccato",
		"diseccitato",
		"diseducato",
		"disegnato",
		"diserbato",
		"diseredato",
		"disertato",
		"diserto",
		"disfatto",
		"disgelato",
		"disgiunto",
		"disgraziato",
		"disgregato",
		"disgustato",
		"disidentificato",
		"disiderato",
		"disidratato",
		"disilluso",
		"disimballato",
		"disimparato",
		"disimpegnato",
		"disimpresso",
		"disincagliato",
		"disincantato",
		"disincentivato",
		"disincrostato",
		"disindustrializzato",
		"disinfestato",
		"disinfettato",
		"disinflazionato",
		"disinformato",
		"disingannato",
		"disingranato",
		"disinibito",
		"disinnamorato",
		"disinnescato",
		"disinnestato",
		"disinquinato",
		"disinserito",
		"disinstallato",
		"disintasato",
		"disintegrato",
		"disinteressato",
		"disinteso",
		"disintossicato",
		"disinvestito",
		"disinvolto",
		"disistimato",
		"dislocato",
		"dismesso",
		"disobbedito",
		"disobbligato",
		"disonorato",
		"disordinato",
		"disorganizzato",
		"disorientato",
		"disormeggiato",
		"disossato",
		"disossidato",
		"disostruito",
		"disotterrato",
		"disparito",
		"dispensato",
		"dispento",
		"disperduto",
		"disperso",
		"dispeso",
		"dispiegato",
		"dispinto",
		"dispogliato",
		"disposto",
		"dispregiato",
		"disprezzato",
		"dispromesso",
		"disproporzionato",
		"disputato",
		"disqualificato",
		"disrotto",
		"dissacrato",
		"dissalato",
		"dissaldato",
		"dissanguato",
		"dissecato",
		"disseccato",
		"disselciato",
		"dissellato",
		"disseminato",
		"dissepolto",
		"disseppellito",
		"dissequestrato",
		"disserrato",
		"dissestato",
		"dissetato",
		"dissezionato",
		"dissigillato",
		"dissimulato",
		"dissipato",
		"dissociato",
		"dissodato",
		"dissolto",
		"dissomigliato",
		"dissotterrato",
		"dissuaso",
		"dissuggellato",
		"distaccato",
		"distanziato",
		"disteso",
		"distillato",
		"distinto",
		"distolto",
		"distorto",
		"distratto",
		"distretto",
		"distribuito",
		"districato",
		"distrigato",
		"distrutto",
		"disturbato",
		"disubbidito",
		"disumanato",
		"disumanizzato",
		"disunito",
		"disusato",
		"disveduto",
		"disvelato",
		"disvestito",
		"disviato",
		"disvisto",
		"disvolto",
		"disvoluto",
		"dittongato",
		"divallato",
		"divaricato",
		"divelto",
		"diversificato",
		"divertito",
		"divezzato",
		"divinato",
		"divincolato",
		"divinizzato",
		"diviso",
		"divolto",
		"divorato",
		"divorziato",
		"divulgato",
		"documentato",
		"dogato",
		"dogmatizzato",
		"dolcificato",
		"dollarizzato",
		"dolorato",
		"doluto",
		"domandato",
		"domato",
		"domesticato",
		"domiciliato",
		"dominato",
		"donato",
		"dondolato",
		"dopato",
		"doppiato",
		"dorato",
		"dormitoco",
		"dosato",
		"dotato",
		"dovuto",
		"dragato",
		"drammatizzato",
		"drappeggiato",
		"drenato",
		"dribblato",
		"drizzato",
		"drogato",
		"dugliato",
		"duplicato",
		"duramificato",
		"ebraizzato",
		"ecceduto",
		"eccepito",
		"eccettuato",
		"eccitato",
		"echeggiato",
		"eclissato",
		"economizzato",
		"edificato",
		"editato",
		"edotto",
		"educato",
		"edulcorato",
		"effettuato",
		"efficientato",
		"effigiato",
		"effinto",
		"effluito",
		"effuso",
		"egemonizzato",
		"eguagliato",
		"eiettato",
		"elaborato",
		"elargito",
		"elasticizzato",
		"elementarizzato",
		"elemosinato",
		"elencato",
		"eletto",
		"elettrificato",
		"elettrizzato",
		"elettrocoagulato",
		"elettrolizzato",
		"elevato",
		"eliminato",
		"eliso",
		"elitrasportato",
		"ellenizzato",
		"elogiato",
		"elucidato",
		"elucubrato",
		"eluito",
		"eluso",
		"emanato",
		"emancipato",
		"emarginato",
		"embricato",
		"emendato",
		"emesso",
		"emozionato",
		"empito",
		"empiuto",
		"emulato",
		"emulsionato",
		"emunto",
		"encomiato",
		"endocitato",
		"energizzato",
		"enfatizzato",
		"enfiato",
		"entusiasmato",
		"enucleato",
		"enumerato",
		"enunciato",
		"epicureggiato",
		"epurato",
		"equalizzato",
		"equilibrato",
		"equipaggiato",
		"equiparato",
		"eradicato",
		"eraso",
		"ereditato",
		"eretto",
		"erogato",
		"eroicizzato",
		"eroso",
		"erotizzato",
		"erpicato",
		"erso",
		"erudito",
		"eruttato",
		"esacerbato",
		"esagerato",
		"esagitato",
		"esalato",
		"esaltato",
		"esaminato",
		"esasperato",
		"esaudito",
		"esaurito",
		"esautorato",
		"esborsato",
		"escluso",
		"escogitato",
		"escomiato",
		"escoriato",
		"escosso",
		"escusso",
		"esecrato",
		"esecutato",
		"eseguito",
		"esemplificato",
		"esentato",
		"esercitato",
		"esfoliato",
		"esibito",
		"esilarato",
		"esiliato",
		"esimuto",
		"esitato",
		"esonerato",
		"esorbitato",
		"esorcizzato",
		"esortato",
		"espanso",
		"esparso",
		"esperimentato",
		"esperito",
		"espettorato",
		"espiantato",
		"espiato",
		"espirato",
		"espletato",
		"esplicato",
		"esplicitato",
		"esplorato",
		"esploso",
		"esportato",
		"esposto",
		"espresso",
		"espropriato",
		"espugnato",
		"espulso",
		"espunto",
		"espurgato",
		"essiccato",
		"essuto",
		"estasiato",
		"estenuato",
		"esterificato",
		"esteriorizzato",
		"esterminato",
		"esternalizzato",
		"esternato",
		"esteso",
		"estimato",
		"estinto",
		"estirpato",
		"estivato",
		"estorto",
		"estradato",
		"estraniato",
		"estrapolato",
		"estratto",
		"estremizzato",
		"estrinsecato",
		"estromesso",
		"estruso",
		"estubato",
		"esulcerato",
		"esultato",
		"esumato",
		"eterificato",
		"eterizzato",
		"eternato",
		"eternizzato",
		"etichettato",
		"etossilato",
		"euforizzato",
		"europeizzato",
		"evacuato",
		"evangelizzato",
		"evaso",
		"eveto",
		"evidenziato",
		"evinto",
		"evirato",
		"eviscerato",
		"evitato",
		"evocato",
		"evolto",
		"evoluto",
		"evulso",
		"fabbricato",
		"faccettato",
		"facilitato",
		"fagocitato",
		"falciato",
		"falcidiato",
		"fallito",
		"falsato",
		"falsificato",
		"familiarizzato",
		"fanatizzato",
		"fantasticato",
		"farcito",
		"farfugliato",
		"fasciato",
		"fascicolato",
		"fascistizzato",
		"fattacelo",
		"fatto",
		"fattorizzato",
		"fatturato",
		"favellato",
		"favoreggiato",
		"favorito",
		"faxato",
		"fecondato",
		"fedecommesso",
		"federalizzato",
		"federato",
		"felicitato",
		"felpato",
		"feltrato",
		"femminilizzato",
		"fenduto",
		"ferito",
		"fermato",
		"fermentato",
		"ferrato",
		"fertilizzato",
		"fesso",
		"fessurato",
		"festeggiato",
		"festonato",
		"feudalizzato",
		"fiaccato",
		"fiammeggiato",
		"fiancheggiato",
		"ficcato",
		"fidanzato",
		"fidato",
		"fidecommesso",
		"fidelizzato",
		"figliato",
		"figurato",
		"filato",
		"filettato",
		"filmato",
		"filosofato",
		"filtrato",
		"finalizzato",
		"finanziato",
		"finitalo",
		"finito",
		"finlandizzato",
		"fintato",
		"finto",
		"fiocinato",
		"fiondato",
		"fiorettato",
		"firmato",
		"fiscalizzato",
		"fischiato",
		"fischiettato",
		"fissato",
		"fissionato",
		"fitto",
		"fiutato",
		"flagellato",
		"flaggato",
		"flambato",
		"flangiato",
		"flemmatizzato",
		"flesso",
		"flippato",
		"flottato",
		"fluidificato",
		"fluidizzato",
		"fluorizzato",
		"fluorurato",
		"focalizzato",
		"focheggiato",
		"foderato",
		"foggiato",
		"fognato",
		"folgorato",
		"follato",
		"fomentato",
		"fonato",
		"fondato",
		"foracchiato",
		"foraggiato",
		"forato",
		"forestato",
		"forfettizzato",
		"forgiato",
		"formalizzato",
		"formato",
		"formattato",
		"formilato",
		"formulato",
		"fornito",
		"fortificato",
		"forviato",
		"forwardato",
		"forzato",
		"fosfatato",
		"fosforato",
		"fosforilato",
		"fossilizzato",
		"fotocomposto",
		"fotocopiato",
		"fotografato",
		"fottuto",
		"fracassato",
		"frainteso",
		"framesso",
		"frammentato",
		"frammesso",
		"frammezzato",
		"frammischiato",
		"franceseggiato",
		"francesizzato",
		"frangiato",
		"franto",
		"frantumato",
		"frappato",
		"frapposto",
		"fraseggiato",
		"frastagliato",
		"frastornato",
		"fratturato",
		"frazionato",
		"freddato",
		"fregato",
		"fregiato",
		"frenato",
		"frequentato",
		"fresato",
		"frettato",
		"friendzonato",
		"fritto",
		"frizionato",
		"frodato",
		"frollato",
		"fronteggiato",
		"frugato",
		"fruito",
		"frullato",
		"frusciato",
		"frustato",
		"frustrato",
		"fruttato",
		"fucilato",
		"fucinato",
		"fugato",
		"fuggito",
		"fulminato",
		"fumato",
		"fumigato",
		"funestato",
		"funto",
		"funzionato",
		"fuoriuscito",
		"fuorviato",
		"fuso",
		"fustellato",
		"fustigato",
		"gabbato",
		"gabellato",
		"gallato",
		"gallicizzato",
		"gallonato",
		"galvanizzato",
		"gambizzato",
		"garantito",
		"garnettato",
		"garrotato",
		"garzato",
		"gasato",
		"gassato",
		"gassificato",
		"gazato",
		"gelatinizzato",
		"gelato",
		"gelificato",
		"gemellato",
		"gemicato",
		"geminato",
		"generalizzato",
		"generato",
		"gentrificato",
		"genuflesso",
		"geometrizzato",
		"georeferenziato",
		"gerarchizzato",
		"germanizzato",
		"gestito",
		"gettato",
		"gettonato",
		"ghermito",
		"ghettizzato",
		"ghigliottinato",
		"ghindato",
		"gibollato",
		"gingillato",
		"ginnato",
		"giocato",
		"gioito",
		"gionglato",
		"giovaneggiato",
		"girandolato",
		"girato",
		"giudicato",
		"giulebbato",
		"giuntato",
		"giunto",
		"giuracchiato",
		"giurato",
		"giustapposto",
		"giustificato",
		"giustiziato",
		"glamourizzato",
		"glassato",
		"glissato",
		"globalizzato",
		"gloriato",
		"glorificato",
		"glossato",
		"godronato",
		"goduto",
		"goffrato",
		"gommato",
		"gonfiato",
		"googlato",
		"gottato",
		"governato",
		"gradinato",
		"gradito",
		"gradualizzato",
		"graduato",
		"graffato",
		"graffiato",
		"graffito",
		"graficato",
		"grafitato",
		"gramolato",
		"granagliato",
		"grandinato",
		"granellato",
		"granito",
		"granulato",
		"graticciato",
		"graticolato",
		"gratificato",
		"gratinato",
		"grattato",
		"grattugiato",
		"gravato",
		"graziato",
		"grecheggiato",
		"grecizzato",
		"gremito",
		"gridato",
		"griffato",
		"grigliato",
		"grippato",
		"groccato",
		"grondato",
		"grugato",
		"grugnito",
		"guadagnato",
		"gualcito",
		"guardato",
		"guarito",
		"guarnito",
		"guastato",
		"guatato",
		"guerreggiato",
		"gufato",
		"guidato",
		"gustato",
		"hackerato",
		"handicappato",
		"ibridato",
		"idealizzato",
		"ideato",
		"identificato",
		"ideologizzato",
		"idolatrato",
		"idoleggiato",
		"idratato",
		"idrogenato",
		"idrolizzato",
		"iettato",
		"igienizzato",
		"ignifugato",
		"ignorato",
		"illanguidito",
		"illeggiadrito",
		"illividito",
		"illuminato",
		"illuso",
		"illustrato",
		"imbacuccato",
		"imbaldanzito",
		"imballato",
		"imbalsamato",
		"imbambolato",
		"imbandierato",
		"imbandito",
		"imbarbarito",
		"imbarcato",
		"imbarilato",
		"imbastardito",
		"imbastito",
		"imbattuto",
		"imbavagliato",
		"imbeccato",
		"imbellettato",
		"imbellito",
		"imbestialito",
		"imbestiato",
		"imbevuto",
		"imbiaccato",
		"imbiancato",
		"imbianchito",
		"imbibito",
		"imbiettato",
		"imbiondito",
		"imbizzarrito",
		"imboccato",
		"imbonito",
		"imborghesito",
		"imboscato",
		"imboschito",
		"imbottato",
		"imbottigliato",
		"imbottito",
		"imbozzimato",
		"imbracato",
		"imbracciato",
		"imbragato",
		"imbrancato",
		"imbrattato",
		"imbrecciato",
		"imbrigliato",
		"imbrillantinato",
		"imbroccato",
		"imbrodato",
		"imbrogliato",
		"imbronciato",
		"imbruttito",
		"imbucato",
		"imbudellato",
		"imbullettato",
		"imbullonato",
		"imburrato",
		"imbussolato",
		"imbustato",
		"imbutito",
		"imitato",
		"immagazzinato",
		"immaginato",
		"immalinconito",
		"immatricolato",
		"immedesimato",
		"immerso",
		"immesso",
		"immischiato",
		"immiserito",
		"immobilizzato",
		"immolato",
		"immortalato",
		"immunizzato",
		"immusonito",
		"impaccato",
		"impacchettato",
		"impacciato",
		"impadronito",
		"impaginato",
		"impagliato",
		"impalato",
		"impalcato",
		"impallato",
		"impallinato",
		"impalmato",
		"impaludato",
		"impanato",
		"impaniato",
		"impannato",
		"impantanato",
		"impaperato",
		"impapocchiato",
		"impappinato",
		"imparentato",
		"imparruccato",
		"impartito",
		"impastato",
		"impasticcato",
		"impasticciato",
		"impastocchiato",
		"impastoiato",
		"impataccato",
		"impattato",
		"impaurito",
		"impavesato",
		"impeciato",
		"impedicato",
		"impedito",
		"impegnato",
		"impegolato",
		"impelagato",
		"impellicciato",
		"impennacchiato",
		"impennato",
		"impensierito",
		"impepato",
		"imperlato",
		"impermalito",
		"impermeabilizzato",
		"imperniato",
		"impersonato",
		"impersonificato",
		"impestato",
		"impetrato",
		"impiallacciato",
		"impiantato",
		"impiastrato",
		"impiastricciato",
		"impiccato",
		"impicciato",
		"impicciolito",
		"impiccolito",
		"impidocchiato",
		"impiegato",
		"impietosito",
		"impietrito",
		"impigliato",
		"impigrito",
		"impilato",
		"impillaccherato",
		"impinguato",
		"impinto",
		"impinzato",
		"impiombato",
		"impipato",
		"impiumato",
		"implementato",
		"implicato",
		"implorato",
		"impollinato",
		"impolpato",
		"impoltronito",
		"impolverato",
		"impomatato",
		"imporcato",
		"imporporato",
		"importato",
		"importunato",
		"impossessato",
		"impossibilitato",
		"impostato",
		"imposto",
		"impratichito",
		"impregnato",
		"impreso",
		"impressionato",
		"impresso",
		"imprestato",
		"impreziosito",
		"imprigionato",
		"impromesso",
		"improntato",
		"improsciuttito",
		"impugnato",
		"impuntito",
		"impunturato",
		"impupato",
		"imputato",
		"impuzzolentito",
		"inabilitato",
		"inabissato",
		"inacerbito",
		"inacetito",
		"inacidito",
		"inacutito",
		"inaffiato",
		"inalato",
		"inalberato",
		"inalveato",
		"inalzato",
		"inamidato",
		"inanellato",
		"inarcato",
		"inargentato",
		"inaridito",
		"inasprito",
		"inastato",
		"inattivato",
		"inaugurato",
		"incacchiato",
		"incalcinato",
		"incalorito",
		"incalzato",
		"incamerato",
		"incamiciato",
		"incamminato",
		"incanaglito",
		"incanalato",
		"incannato",
		"incannucciato",
		"incaponito",
		"incappottato",
		"incappucciato",
		"incaprettato",
		"incapricciato",
		"incapsulato",
		"incarcerato",
		"incardinato",
		"incaricato",
		"incarnato",
		"incarrozzato",
		"incartato",
		"incartocciato",
		"incartonato",
		"incasellato",
		"incasinato",
		"incassato",
		"incastellato",
		"incastonato",
		"incastrato",
		"incatenato",
		"incatramato",
		"incattivito",
		"incavato",
		"incavigliato",
		"incavolato",
		"incazzato",
		"incellofanato",
		"incendiato",
		"incenerito",
		"incensato",
		"incentivato",
		"incentrato",
		"inceppato",
		"incerato",
		"incernierato",
		"incerottato",
		"inceso",
		"incettato",
		"inchiappettato",
		"inchiavardato",
		"inchiesto",
		"inchinato",
		"inchiodato",
		"inchiostrato",
		"incipriato",
		"inciso",
		"incistato",
		"incitato",
		"inciuccato",
		"incivilito",
		"inclinato",
		"incluso",
		"incoccato",
		"incocciato",
		"incoiato",
		"incollato",
		"incolonnato",
		"incolpato",
		"incominciato",
		"incomodato",
		"incontrato",
		"incoraggiato",
		"incordato",
		"incornato",
		"incorniciato",
		"incoronato",
		"incorporato",
		"incotto",
		"incravattato",
		"incrementato",
		"increspato",
		"incretinito",
		"incriminato",
		"incrinato",
		"incrociato",
		"incrostato",
		"incrudelito",
		"incrudito",
		"incruscato",
		"incubato",
		"inculato",
		"inculcato",
		"incuneato",
		"incuoiato",
		"incuorato",
		"incupito",
		"incuriosito",
		"incurvato",
		"incusso",
		"indagato",
		"indebitato",
		"indebolito",
		"indemaniato",
		"indennizzato",
		"indetto",
		"indicato",
		"indicizzato",
		"indignato",
		"indiretto",
		"indirizzato",
		"indispettito",
		"indisposto",
		"individualizzato",
		"individuato",
		"indolenzito",
		"indorato",
		"indossato",
		"indotto",
		"indottomo",
		"indottrinato",
		"indovinato",
		"indugiato",
		"indulto",
		"indurato",
		"indurito",
		"industrializzato",
		"industriato",
		"inebetito",
		"inebriato",
		"inerito",
		"inerpicato",
		"infagottato",
		"infamato",
		"infangato",
		"infarcito",
		"infarinato",
		"infastidito",
		"infatuato",
		"infeltrito",
		"inferito",
		"inferocito",
		"inferto",
		"infervorato",
		"infestato",
		"infettato",
		"infeudato",
		"infiacchito",
		"infialato",
		"infialettato",
		"infiammato",
		"infiascato",
		"infibulato",
		"inficiato",
		"infilato",
		"infiltrato",
		"infilzato",
		"infingardito",
		"infinocchiato",
		"infinto",
		"infioccato",
		"infiocchettato",
		"infiochito",
		"infiorato",
		"infirmato",
		"infischiato",
		"infisso",
		"infittito",
		"inflazionato",
		"inflesso",
		"inflitto",
		"influenzato",
		"infocato",
		"infoderato",
		"infognato",
		"infoibato",
		"infoltito",
		"inforcato",
		"informatizzato",
		"informato",
		"informicolato",
		"informicolito",
		"infornaciato",
		"infornato",
		"infortunato",
		"infoscato",
		"infossato",
		"infradiciato",
		"inframesso",
		"inframezzato",
		"inframmesso",
		"inframmezzato",
		"infrancesato",
		"infrapposto",
		"infrascato",
		"infrattato",
		"infreddato",
		"infronzolato",
		"infuocato",
		"infurbito",
		"infuriato",
		"ingabbiato",
		"ingaggiato",
		"ingagliardito",
		"ingannato",
		"ingarbugliato",
		"ingavonato",
		"ingegnato",
		"ingegnerizzato",
		"ingelosito",
		"ingemmato",
		"ingenerato",
		"ingentilito",
		"ingerito",
		"ingessato",
		"inghiaiato",
		"inghiottito",
		"inghirlandato",
		"ingiallito",
		"ingigantito",
		"inginocchiato",
		"ingioiellato",
		"ingiunto",
		"ingiuriato",
		"inglesizzato",
		"inglobato",
		"ingoffito",
		"ingoiato",
		"ingolfato",
		"ingollato",
		"ingolosito",
		"ingombrato",
		"ingommato",
		"ingorgato",
		"ingozzato",
		"ingranato",
		"ingrandito",
		"ingrassato",
		"ingraticciato",
		"ingraticolato",
		"ingravidato",
		"ingraziato",
		"ingraziosito",
		"ingrigito",
		"ingrommato",
		"ingrossato",
		"ingrullito",
		"inguaiato",
		"inguainato",
		"ingualdrappato",
		"inguantato",
		"ingurgitato",
		"inibito",
		"iniettato",
		"inimicato",
		"inizializzato",
		"iniziato",
		"inmillato",
		"innacquato",
		"innaffiato",
		"innalzato",
		"innamorato",
		"innastato",
		"innervato",
		"innervosito",
		"innescato",
		"innestato",
		"innevato",
		"innocentato",
		"innocuizzato",
		"innovato",
		"inoculato",
		"inoltrato",
		"inondato",
		"inorgoglito",
		"inorpellato",
		"inorridito",
		"inquadrato",
		"inquietato",
		"inquisito",
		"insabbiato",
		"insacchettato",
		"insalato",
		"insaldato",
		"insalivato",
		"insanguinato",
		"insaponato",
		"insaporito",
		"inscatolato",
		"inscenato",
		"inscritto",
		"insecchito",
		"insediato",
		"insegnato",
		"inseguito",
		"insellato",
		"inselvatichito",
		"inserito",
		"insidiato",
		"insignito",
		"insilato",
		"insinuato",
		"insolentito",
		"insonnolito",
		"insonorizzato",
		"insordito",
		"insospettito",
		"insozzato",
		"inspessito",
		"inspirato",
		"installato",
		"instaurato",
		"insterilito",
		"instillato",
		"instituito",
		"instradato",
		"insudiciato",
		"insufflato",
		"insultato",
		"insuperbito",
		"intabaccato",
		"intabarrato",
		"intaccato",
		"intagliato",
		"intarsiato",
		"intasato",
		"intascato",
		"intavolato",
		"integrato",
		"intelaiato",
		"intelato",
		"intellettualizzato",
		"intenebrato",
		"intenerito",
		"intensificato",
		"intentato",
		"intepidito",
		"intercalato",
		"intercambiato",
		"intercettato",
		"interciso",
		"intercluso",
		"intercollegato",
		"interconnesso",
		"interconvertito",
		"interdetto",
		"interessato",
		"interfacciato",
		"interfogliato",
		"interfoliato",
		"interiorizzato",
		"interlacciato",
		"interlineato",
		"intermesso",
		"intermezzato",
		"internalizzato",
		"internato",
		"internazionalizzato",
		"interpellato",
		"interpenetrato",
		"interpolato",
		"interposto",
		"interpretato",
		"interpunto",
		"interrato",
		"interrogato",
		"interrotto",
		"intersecato",
		"intervallato",
		"intervistato",
		"inteso",
		"intessuto",
		"intestardito",
		"intestato",
		"intiepidito",
		"intimato",
		"intimidito",
		"intimorito",
		"intinto",
		"intirizzito",
		"intitolato",
		"intonacato",
		"intonato",
		"intontito",
		"intorbidato",
		"intorbidito",
		"intorpidito",
		"intortato",
		"intossicato",
		"intralciato",
		"intramesso",
		"intramezzato",
		"intrappolato",
		"intrapreso",
		"intrattenuto",
		"intraveduto",
		"intravisto",
		"intravveduto",
		"intravvisto",
		"intrecciato",
		"intricato",
		"intrigato",
		"intrinsecato",
		"intrippato",
		"intriso",
		"introdotto",
		"introflesso",
		"introiettato",
		"introitato",
		"intromesso",
		"intronato",
		"intronizzato",
		"intruduto",
		"intrufolato",
		"intrugliato",
		"intruppato",
		"intruso",
		"intubato",
		"intubettato",
		"intuito",
		"inumato",
		"inumidito",
		"inurbato",
		"inutilizzato",
		"invaghito",
		"invaginato",
		"invalidato",
		"invasato",
		"invaso",
		"invelenito",
		"inventariato",
		"inventato",
		"invenuto",
		"inverdito",
		"invergato",
		"inverniciato",
		"investigato",
		"investito",
		"invetriato",
		"inviato",
		"invidiato",
		"invigorito",
		"inviluppato",
		"invischiato",
		"invitato",
		"invocato",
		"invogliato",
		"involato",
		"involgarito",
		"involtato",
		"involto",
		"inzaccherato",
		"inzeppato",
		"inzigato",
		"inzolfato",
		"inzuccato",
		"inzuccherato",
		"inzuppato",
		"iodurato",
		"ionizzato",
		"ipertrofizzato",
		"ipnotizzato",
		"ipostatizzato",
		"ipotecato",
		"ipotizzato",
		"iridato",
		"irradiato",
		"irraggiato",
		"irreggimentato",
		"irretito",
		"irrigato",
		"irrigidito",
		"irriso",
		"irritato",
		"irrobustito",
		"irrogato",
		"irrorato",
		"irrugginito",
		"irruvidito",
		"ischeletrito",
		"iscritto",
		"islamizzato",
		"isolato",
		"isomerizzato",
		"ispanizzato",
		"ispessito",
		"ispezionato",
		"ispirato",
		"issato",
		"istallato",
		"istanziato",
		"istaurato",
		"isterilito",
		"istigato",
		"istillato",
		"istituito",
		"istituzionalizzato",
		"istoriato",
		"istradato",
		"istruito",
		"istupidito",
		"italianeggiato",
		"italianizzato",
		"iterato",
		"iudicato",
		"killerato",
		"labbreggiato",
		"labializzato",
		"laccato",
		"lacerato",
		"laconizzato",
		"lacrimato",
		"ladroneggiato",
		"lagnato",
		"lagrimato",
		"laicizzato",
		"lambiccato",
		"lambito",
		"lamentato",
		"laminato",
		"lanciato",
		"lapidato",
		"lappato",
		"lardato",
		"lardellato",
		"largito",
		"larvato",
		"lascato",
		"lasciato",
		"lastricato",
		"latinizzato",
		"laudato",
		"laureato",
		"lavato",
		"lavorato",
		"leccato",
		"legalizzato",
		"legato",
		"leggicchiato",
		"leggiucchiato",
		"legittimato",
		"legittimizzato",
		"legnato",
		"lemmatizzato",
		"lenito",
		"lesinato",
		"lesionato",
		"leso",
		"lessato",
		"letto",
		"levato",
		"levigato",
		"liberalizzato",
		"liberato",
		"licenziato",
		"lievitato",
		"liftato",
		"lignificato",
		"limato",
		"limitato",
		"linciato",
		"linearizzato",
		"lineato",
		"linkato",
		"liofilizzato",
		"liquefatto",
		"liquidato",
		"lisato",
		"lisciato",
		"lisciviato",
		"listato",
		"litografato",
		"livellato",
		"lizzato",
		"lobotomizzato",
		"localizzato",
		"locato",
		"lodato",
		"logorato",
		"lordato",
		"lottato",
		"lottizzato",
		"lubrificato",
		"lucchettato",
		"lucidato",
		"lucrato",
		"lumeggiato",
		"luppolizzato",
		"lusingato",
		"lussato",
		"lustrato",
		"macadamizzato",
		"macchiato",
		"macchinato",
		"macellato",
		"macerato",
		"maciullato",
		"maggesato",
		"maggiorato",
		"magnato",
		"magnetizzato",
		"magnificato",
		"maiolicato",
		"maledetto",
		"malfatto",
		"malignato",
		"malmenato",
		"malmesso",
		"maltato",
		"maltrattato",
		"malveduto",
		"malversato",
		"malvisto",
		"malvoluto",
		"mandato",
		"mandrinato",
		"manducato",
		"maneggiato",
		"manganato",
		"manganellato",
		"mangiato",
		"mangiucchiato",
		"manifatturato",
		"manifestato",
		"manimesso",
		"manipolato",
		"manlevato",
		"manomesso",
		"manoscritto",
		"manovrato",
		"mansuefatto",
		"mantecato",
		"mantenutaso",
		"mantenuto",
		"manualizzato",
		"manutenuto",
		"mappato",
		"marcato",
		"marchiato",
		"marcito",
		"marezzato",
		"marginalizzato",
		"marginato",
		"margottato",
		"marimesso",
		"marinato",
		"maritato",
		"marmorizzato",
		"marnato",
		"marocchinato",
		"martellato",
		"martellinato",
		"martirizzato",
		"martoriato",
		"mascherato",
		"maschiato",
		"maschiettato",
		"mascolinizzato",
		"massacrato",
		"massaggiato",
		"massellato",
		"massicciato",
		"massificato",
		"massimato",
		"massimizzato",
		"mastectomizzato",
		"masterizzato",
		"masticato",
		"masturbato",
		"matematizzato",
		"materializzato",
		"matricolato",
		"mattonato",
		"maturato",
		"mazziato",
		"mazzolato",
		"meccanizzato",
		"medagliato",
		"mediato",
		"medicalizzato",
		"medicato",
		"meditato",
		"membrato",
		"memorizzato",
		"menato",
		"mendicato",
		"menomato",
		"mentovato",
		"menzionato",
		"meravigliato",
		"mercanteggiato",
		"mercerizzato",
		"mercificato",
		"meriato",
		"meridionalizzato",
		"meritato",
		"merlato",
		"merlettato",
		"merso",
		"mesciato",
		"mesciuto",
		"mescolato",
		"mescuto",
		"mesmerizzato",
		"messaggiato",
		"messo",
		"messoco",
		"mestato",
		"mesticato",
		"mestruato",
		"metabolizzato",
		"metaforeggiato",
		"metaforizzato",
		"metallizzato",
		"metamorfizzato",
		"metamorfosato",
		"metanizzato",
		"metilato",
		"metodizzato",
		"microfilmato",
		"microfonato",
		"microminiaturizzato",
		"micronizzato",
		"mietuto",
		"migliorato",
		"militarizzato",
		"millantato",
		"millimetrato",
		"mimato",
		"mimeografato",
		"mimetizzato",
		"minacciato",
		"minato",
		"minchionato",
		"mineralizzato",
		"miniato",
		"miniaturizzato",
		"minimizzato",
		"minuito",
		"minuzzato",
		"miracolato",
		"miscelato",
		"mischiato",
		"misconosciuto",
		"missato",
		"mistificato",
		"misturato",
		"misurato",
		"miticizzato",
		"mitigato",
		"mitizzato",
		"mitragliato",
		"mitrato",
		"mixato",
		"mobiliato",
		"mobilitato",
		"mobilizzato",
		"modanato",
		"modellato",
		"modellizzato",
		"moderato",
		"modernizzato",
		"modificato",
		"modulato",
		"molato",
		"molestato",
		"mollato",
		"molleggiato",
		"moltiplicato",
		"monacato",
		"mondato",
		"mondializzato",
		"monetarizzato",
		"monetato",
		"monetizzato",
		"monitorato",
		"monitorizzato",
		"monocromatizzato",
		"monopolizzato",
		"monottongato",
		"montato",
		"monumentalizzato",
		"mordenzato",
		"mordicchiato",
		"mormorato",
		"morphato",
		"morsicato",
		"morsicchiato",
		"morso",
		"mortasato",
		"mortificato",
		"mosso",
		"mostrato",
		"motivato",
		"motorizzato",
		"motteggiato",
		"movimentato",
		"mozzato",
		"mugolato",
		"mulcito",
		"multato",
		"multiplexato",
		"mummificato",
		"municipalizzato",
		"munito",
		"munto",
		"murato",
		"musato",
		"musicato",
		"mussato",
		"mutato",
		"mutilato",
		"mutizzato",
		"mutuato",
		"nappato",
		"narcotizzato",
		"narrativizzato",
		"narrato",
		"nasalizzato",
		"nascoso",
		"nascosto",
		"nastrato",
		"naturaleggiato",
		"naturalizzato",
		"nauseato",
		"naverato",
		"navicato",
		"navigato",
		"nazificato",
		"nazionalizzato",
		"nebulizzato",
		"necessitato",
		"necrosato",
		"necrotizzato",
		"negativizzato",
		"negato",
		"negletto",
		"negoziato",
		"negreggiato",
		"neologizzato",
		"nerbato",
		"nericato",
		"nettato",
		"neutralizzato",
		"nevato",
		"nevicato",
		"nevischiato",
		"nevrotizzato",
		"nichelato",
		"niellato",
		"ninfeggiato",
		"ninnato",
		"ninnolato",
		"nitratato",
		"nitrificato",
		"nobilitato",
		"noiato",
		"noleggiato",
		"nomato",
		"nominalizzato",
		"nominato",
		"normalizzato",
		"normato",
		"notato",
		"notificato",
		"notiziato",
		"notricato",
		"noverato",
		"nuclearizzato",
		"nudricato",
		"nullificato",
		"numerato",
		"numerizzato",
		"nuotato",
		"nutrito",
		"obbiettato",
		"obbliato",
		"obbligato",
		"oberato",
		"obiettato",
		"obiettivato",
		"obiettivizzato",
		"obiurgato",
		"obliato",
		"obliterato",
		"obnubilato",
		"occasionato",
		"occhieggiato",
		"occidentalizzato",
		"occiso",
		"occluso",
		"occultato",
		"occupato",
		"ocheggiato",
		"odiato",
		"odorato",
		"odorizzato",
		"offerito",
		"offerto",
		"offeso",
		"officiato",
		"offiziato",
		"offuscato",
		"ofiziato",
		"oggettivato",
		"oggettivizzato",
		"oggettualizzato",
		"oliato",
		"olito",
		"olografato",
		"oltraggiato",
		"oltrapassato",
		"oltrepassato",
		"omaggiato",
		"ombrato",
		"ombreggiato",
		"omesso",
		"omogeneizzato",
		"omogenizzato",
		"omologato",
		"ondato",
		"ondulato",
		"onestato",
		"onnubilato",
		"onorato",
		"opacato",
		"opacizzato",
		"operato",
		"opinato",
		"oppiato",
		"oppignorato",
		"oppilato",
		"opposto",
		"oppresso",
		"oppugnato",
		"oprato",
		"opsonizzato",
		"optato",
		"opzionato",
		"orbitato",
		"orchestrato",
		"ordinato",
		"ordito",
		"orecchiato",
		"organato",
		"organicato",
		"organizzato",
		"orgasmato",
		"orientalizzato",
		"orientato",
		"originato",
		"origliato",
		"orizzontato",
		"orlato",
		"orlettato",
		"ormato",
		"ormeggiato",
		"ornato",
		"orpellato",
		"orrato",
		"orripilato",
		"ortogonalizzato",
		"osannato",
		"osato",
		"osculato",
		"oscurato",
		"ospedalizzato",
		"ospitato",
		"osseduto",
		"ossequiato",
		"osservato",
		"ossessionato",
		"ossidato",
		"ossificato",
		"ossitonizzato",
		"ostacolato",
		"osteggiato",
		"ostentato",
		"ostinato",
		"ostracizzato",
		"ostruito",
		"ottemperato",
		"ottenebrato",
		"ottenuto",
		"ottimalizzato",
		"ottimato",
		"ottimizzato",
		"ottonato",
		"ottriato",
		"ottuplicato",
		"otturato",
		"ottuso",
		"ottusso",
		"ovalizzato",
		"ovariectomizzato",
		"ovattato",
		"overcloccato",
		"ovrato",
		"ovviato",
		"ozieggiato",
		"ozonizzato",
		"pacato",
		"pacciamato",
		"pacificato",
		"padroneggiato",
		"paganizzato",
		"pagato",
		"paginato",
		"palafittato",
		"palatalizzato",
		"palato",
		"palesato",
		"palettato",
		"palettizzato",
		"palificato",
		"palleggiato",
		"pallettizzato",
		"palpato",
		"palpeggiato",
		"panato",
		"panneggiato",
		"panoramicato",
		"pappato",
		"paracadutato",
		"parafato",
		"paraffinato",
		"parafrasato",
		"paragonato",
		"paragrafato",
		"paralizzato",
		"parallelizzato",
		"parametrato",
		"parametrizzato",
		"parassitato",
		"parato",
		"parcato",
		"parcellizzato",
		"parcheggiato",
		"pareggiato",
		"parificato",
		"parkerizzato",
		"parlato",
		"parlucchiato",
		"parodiato",
		"partecipato",
		"particolareggiato",
		"particolarizzato",
		"partizionato",
		"partorito",
		"parzializzato",
		"pasciuto",
		"pascolato",
		"passato",
		"passeggiato",
		"passionato",
		"passivato",
		"pasticciato",
		"pastorizzato",
		"pasturato",
		"patinato",
		"patito",
		"patrocinato",
		"patteggiato",
		"pattugliato",
		"pattuito",
		"paventato",
		"pavesato",
		"pavimentato",
		"pavoneggiato",
		"pazziato",
		"pedinato",
		"pedonalizzato",
		"peggiorato",
		"pelato",
		"pellettizzato",
		"penalizzato",
		"penetrato",
		"pennellato",
		"pensato",
		"pensionato",
		"pentito",
		"pepato",
		"peptonizzato",
		"peragrato",
		"percentualizzato",
		"percepito",
		"percolato",
		"percorso",
		"percosso",
		"perdonato",
		"perdotto",
		"perduto",
		"perequato",
		"perfatto",
		"perfezionato",
		"perforato",
		"performato",
		"perito",
		"periziato",
		"perlustrato",
		"permeato",
		"permesso",
		"perorato",
		"perpetrato",
		"perpetuato",
		"perplimuto",
		"perquisito",
		"perscrutato",
		"perseguitato",
		"perseguito",
		"perso",
		"personalizzato",
		"personificato",
		"persuaso",
		"perturbato",
		"pervaso",
		"pervertito",
		"pesato",
		"pescato",
		"pestato",
		"petrarcheggiato",
		"pettegolato",
		"pettinato",
		"piagato",
		"piaggiato",
		"piallato",
		"pianeggiato",
		"pianificato",
		"piantato",
		"piantatalo",
		"piantato",
		"pianto",
		"piantonato",
		"piantumato",
		"piastrellato",
		"piatito",
		"piazzato",
		"picchettato",
		"picchiato",
		"picchierellato",
		"picchiettato",
		"picconato",
		"piegato",
		"pieghettato",
		"pietrificato",
		"pigiato",
		"pigliato",
		"pigmentato",
		"pignorato",
		"pigolato",
		"pilotato",
		"pimentato",
		"pinto",
		"pinzato",
		"piombato",
		"piovigginato",
		"piovuto",
		"pipato",
		"pippato",
		"piratato",
		"pirogenato",
		"pisciato",
		"pitoccato",
		"pittato",
		"pitturato",
		"pizzicato",
		"pizzicottato",
		"placato",
		"placcato",
		"plagiato",
		"plasmato",
		"plasticato",
		"plastificato",
		"platinato",
		"plissettato",
		"pluralizzato",
		"poetato",
		"poeticizzato",
		"poggiato",
		"polarizzato",
		"poligrafato",
		"polimerizzato",
		"politicizzato",
		"polverizzato",
		"pomiciato",
		"pompato",
		"ponderato",
		"ponzato",
		"popolarizzato",
		"popolato",
		"poppato",
		"porcellanato",
		"porfirizzato",
		"portato",
		"porteso",
		"porto",
		"porzionato",
		"posato",
		"posdatato",
		"positivizzato",
		"posizionato",
		"posposto",
		"posseduto",
		"postato",
		"postdatato",
		"posteggiato",
		"posticipato",
		"postillato",
		"posto",
		"postsincronizzato",
		"postulato",
		"potabilizzato",
		"potato",
		"potenziato",
		"potuto",
		"pralinato",
		"praticato",
		"preaccennato",
		"preannunciato",
		"preannunziato",
		"preavvertito",
		"preavvisato",
		"precaricato",
		"preceduto",
		"precettato",
		"precinto",
		"precisato",
		"precluso",
		"precompilato",
		"precompresso",
		"preconfezionato",
		"preconizzato",
		"preconosciuto",
		"precorso",
		"precostituito",
		"predato",
		"predefinito",
		"predestinato",
		"predeterminato",
		"predetto",
		"predicato",
		"predigerito",
		"prediletto",
		"predisposto",
		"preeletto",
		"preesistuto",
		"prefabbricato",
		"prefato",
		"prefatto",
		"prefazionato",
		"preferito",
		"prefigurato",
		"prefinanziato",
		"prefissato",
		"prefisso",
		"preformato",
		"pregato",
		"pregiato",
		"pregiudicato",
		"pregustato",
		"preimpregnato",
		"prelevato",
		"premeditato",
		"premescolato",
		"premesso",
		"premiato",
		"premonito",
		"premunito",
		"premurato",
		"premuto",
		"prenotato",
		"preoccupato",
		"preordinato",
		"preparato",
		"prepensionato",
		"prepigmentato",
		"preposto",
		"preprogrammato",
		"preraffreddato",
		"prerefrigerato",
		"preregistrato",
		"preregolato",
		"preriscaldato",
		"preso",
		"presagito",
		"presaputo",
		"presaselo",
		"prescelto",
		"prescritto",
		"preseduto",
		"presegnalato",
		"preselezionato",
		"presentato",
		"presentito",
		"preservato",
		"presidiato",
		"presieduto",
		"preso",
		"pressato",
		"presso",
		"pressurizzato",
		"prestabilito",
		"prestampato",
		"prestato",
		"prestigiato",
		"presunto",
		"presupposto",
		"pretermesso",
		"preteso",
		"pretrattato",
		"prevaricato",
		"preveduto",
		"prevenduto",
		"preventivato",
		"prevenuto",
		"previsto",
		"prezzato",
		"prezzolato",
		"principiato",
		"privatizzato",
		"privato",
		"privilegiato",
		"problematizzato",
		"procacciato",
		"processato",
		"proclamato",
		"procrastinato",
		"procreato",
		"procurato",
		"prodigato",
		"prodotto",
		"profanato",
		"proferito",
		"professato",
		"professionalizzato",
		"profetato",
		"profetizzato",
		"profferito",
		"profilato",
		"profondato",
		"profumato",
		"profuso",
		"progettato",
		"prognosticato",
		"programmato",
		"proibito",
		"proiettato",
		"proletarizzato",
		"prolungato",
		"promanato",
		"promesso",
		"promosso",
		"promozionato",
		"promulgato",
		"pronosticato",
		"pronunciato",
		"pronunziato",
		"propagandato",
		"propagato",
		"propagginato",
		"propalato",
		"propinato",
		"propiziato",
		"proporzionato",
		"proposto",
		"propugnato",
		"propulso",
		"prorogato",
		"prosciolto",
		"prosciugato",
		"proscritto",
		"proseguito",
		"prospettato",
		"prosternato",
		"prosteso",
		"prostituito",
		"prostrato",
		"prosunto",
		"proteso",
		"protestato",
		"protetto",
		"protocollato",
		"protonato",
		"protratto",
		"protruso",
		"provato",
		"proveduto",
		"provincializzato",
		"provisto",
		"provocato",
		"provveduto",
		"provvisto",
		"psicanalizzato",
		"psichiatrizzato",
		"psicoanalizzato",
		"psicologizzato",
		"pubblicato",
		"pubblicizzato",
		"puddellato",
		"pugnalato",
		"pulito",
		"pungolato",
		"punito",
		"puntato",
		"punteggiato",
		"puntellato",
		"punto",
		"puntualizzato",
		"punzecchiato",
		"punzonato",
		"purgato",
		"purificato",
		"putito",
		"putrefatto",
		"putrito",
		"quadrato",
		"quadrettato",
		"quadriennalizzato",
		"quadruplicato",
		"qualificato",
		"quantificato",
		"quantizzato",
		"querelato",
		"questuato",
		"quetato",
		"quietanzato",
		"quietato",
		"quintessenziato",
		"quintuplicato",
		"quotato",
		"quotizzato",
		"rabberciato",
		"rabboccato",
		"rabbonito",
		"rabbuffato",
		"rabuffato",
		"raccapezzato",
		"raccapricciato",
		"raccattato",
		"raccerchiato",
		"racceso",
		"racchetato",
		"racchiuso",
		"raccolto",
		"raccolto",
		"raccomandato",
		"raccomodato",
		"raccontato",
		"raccorciato",
		"raccorcito",
		"raccordato",
		"raccostato",
		"raccozzato",
		"racemizzato",
		"racimolato",
		"radazzato",
		"raddensato",
		"raddobbato",
		"raddolcito",
		"raddoppiato",
		"raddotto",
		"raddrizzato",
		"radiato",
		"radicalizzato",
		"radioassistito",
		"radioattivato",
		"radiocomandato",
		"radiodiffuso",
		"radiografato",
		"radioguidato",
		"radiolocalizzato",
		"radiomarcato",
		"radiotelegrafato",
		"radiotrasmesso",
		"radunato",
		"raffazzonato",
		"raffermato",
		"raffigurato",
		"raffilato",
		"raffinato",
		"rafforzato",
		"raffreddato",
		"raffrenato",
		"raffrescato",
		"raffrontato",
		"raggelato",
		"raggentilito",
		"ragghiato",
		"raggirato",
		"raggiunto",
		"raggiustato",
		"raggomitolato",
		"raggranchiato",
		"raggranchito",
		"raggranellato",
		"raggrinzato",
		"raggrinzito",
		"raggrumato",
		"raggruppato",
		"raggruzzolato",
		"ragguagliato",
		"ralingato",
		"rallegrato",
		"rallentato",
		"ramato",
		"ramazzato",
		"rammagliato",
		"rammaricato",
		"rammemorato",
		"rammendato",
		"rammentato",
		"rammodernato",
		"rammollito",
		"rammorbidito",
		"rampognato",
		"randellato",
		"randomizzato",
		"rannicchiato",
		"rannuvolato",
		"ranzato",
		"rapato",
		"rapinato",
		"rapito",
		"rappacificato",
		"rappato",
		"rappattumato",
		"rappezzato",
		"rapportato",
		"rappresantato",
		"rappresentato",
		"rappreso",
		"rarefatto",
		"rasato",
		"raschiato",
		"raschiettato",
		"rasentato",
		"raso",
		"raspato",
		"rassegnato",
		"rasserenato",
		"rassettato",
		"rassicurato",
		"rassodato",
		"rassomigliato",
		"rassottigliato",
		"rassunto",
		"rastrellato",
		"rastremato",
		"rateato",
		"rateizzato",
		"ratificato",
		"ratinato",
		"rattizzato",
		"rattoppato",
		"rattorto",
		"rattrappito",
		"rattristato",
		"rattristito",
		"raunato",
		"ravvalorato",
		"ravveduto",
		"ravviato",
		"ravvicinato",
		"ravviluppato",
		"ravvisato",
		"ravvisto",
		"ravvivato",
		"ravvolto",
		"ravvoltolato",
		"razionalizzato",
		"razionato",
		"razziato",
		"razzolato",
		"realizzato",
		"reassunto",
		"recapitato",
		"recato",
		"receduto",
		"recensito",
		"recepito",
		"recidivato",
		"recintato",
		"recinto",
		"reciprocato",
		"reciso",
		"recitato",
		"reclamato",
		"reclamizzato",
		"reclinato",
		"recluso",
		"reclutato",
		"recuperato",
		"redarguito",
		"redatto",
		"redazzato",
		"redduto",
		"redento",
		"redistribuito",
		"redotto",
		"referenziato",
		"refertato",
		"refilato",
		"reflesso",
		"reflettuto",
		"refranto",
		"refrigerato",
		"regalato",
		"regimato",
		"regimentato",
		"regionalizzato",
		"registrato",
		"regolamentato",
		"regolarizzato",
		"regolato",
		"reidratato",
		"reificato",
		"reimbarcato",
		"reimmerso",
		"reimmesso",
		"reimparato",
		"reimpastato",
		"reimpiantato",
		"reimpiegato",
		"reimportato",
		"reimpostato",
		"reincarcerato",
		"reincaricato",
		"reincarnato",
		"reinciso",
		"reincontrato",
		"reindirizzato",
		"reindustrializzato",
		"reinfettato",
		"reingaggiato",
		"reinizializzato",
		"reinnestato",
		"reinoltrato",
		"reinscritto",
		"reinsediato",
		"reinserito",
		"reinstallato",
		"reinstaurato",
		"reintegrato",
		"reinterpretato",
		"reintitolato",
		"reintrodotto",
		"reinventato",
		"reinvestito",
		"reiterato",
		"relativizzato",
		"relazionato",
		"relegato",
		"remixato",
		"remunerato",
		"renderizzato",
		"reperito",
		"repertato",
		"replicato",
		"represso",
		"repulso",
		"reputato",
		"requisito",
		"rescisso",
		"resecato",
		"resettato",
		"residuato",
		"resinificato",
		"reso",
		"resolato",
		"resolto",
		"respinto",
		"respirato",
		"responsabilizzato",
		"resposto",
		"restaurato",
		"restituito",
		"resunto",
		"resuscitato",
		"reticolato",
		"retinato",
		"retribuito",
		"retroceduto",
		"retrocesso",
		"retrodatato",
		"rettificato",
		"retto",
		"reumatizzato",
		"revisionato",
		"revocato",
		"riabbassato",
		"riabbellito",
		"riabbonato",
		"riabbottonato",
		"riabbracciato",
		"riabilitato",
		"riabitato",
		"riabituato",
		"riaccaduto",
		"riaccasato",
		"riacceso",
		"riaccettato",
		"riacchiappato",
		"riacciuffato",
		"riaccolto",
		"riaccomodato",
		"riaccompagnato",
		"riaccordato",
		"riaccostato",
		"riaccreditato",
		"riacquisito",
		"riacquistato",
		"riacutizzato",
		"riadattato",
		"riaddestrato",
		"riaddormentato",
		"riadoperato",
		"riaffacciato",
		"riaffermato",
		"riafferrato",
		"riaffiorato",
		"riaffittato",
		"riaffrontato",
		"riagganciato",
		"riaggiornato",
		"riaggiustato",
		"riaggravato",
		"riaggregato",
		"riagguantato",
		"rialimentato",
		"riallacciato",
		"riallargato",
		"riallineato",
		"riallocato",
		"riallungato",
		"rialzato",
		"riamato",
		"riambientato",
		"riammalato",
		"riammesso",
		"riammodernato",
		"riammogliato",
		"rianimato",
		"riannesso",
		"riannodato",
		"riannunciato",
		"riaperto",
		"riappacificato",
		"riappaltato",
		"riapparecchiato",
		"riapparito",
		"riappeso",
		"riappiccicato",
		"riapplicato",
		"riappreso",
		"riapprodato",
		"riappropriato",
		"riapprovato",
		"riarmato",
		"riarrangiato",
		"riarredato",
		"riascoltato",
		"riasfaltato",
		"riassalito",
		"riassaporato",
		"riassegnato",
		"riassemblato",
		"riassestato",
		"riassettato",
		"riassicurato",
		"riassociato",
		"riassopito",
		"riassorbito",
		"riassunto",
		"riattaccato",
		"riattato",
		"riatteso",
		"riattinto",
		"riattivato",
		"riattizzato",
		"riattraversato",
		"riaumentato",
		"riavuto",
		"riavventato",
		"riavvertito",
		"riavviato",
		"riavvicinato",
		"riavvinto",
		"riavvisato",
		"riavvistato",
		"riavvolto",
		"riazzuffato",
		"ribaciato",
		"ribadito",
		"ribaltato",
		"ribassato",
		"ribattezzato",
		"ribattuto",
		"ribellato",
		"ribenedetto",
		"ribevuto",
		"ributtato",
		"ricacciato",
		"ricalato",
		"ricalcato",
		"ricalcificato",
		"ricalcitrato",
		"ricalcolato",
		"ricalibrato",
		"ricamato",
		"ricambiato",
		"ricanalizzato",
		"ricandidato",
		"ricantato",
		"ricapitalizzato",
		"ricapitolato",
		"ricaricato",
		"ricategorizzato",
		"ricattato",
		"ricavato",
		"ricelebrato",
		"ricercato",
		"ricetrasmesso",
		"ricettato",
		"ricevuto",
		"richiamato",
		"richiesto",
		"richiuso",
		"riciclato",
		"ricinto",
		"ricircolato",
		"riclassificato",
		"ricodificato",
		"ricollegato",
		"ricollocato",
		"ricolmato",
		"ricolonizzato",
		"ricolorato",
		"ricolorito",
		"ricoltivato",
		"ricombinato",
		"ricominciato",
		"ricommesso",
		"ricomparito",
		"ricompattato",
		"ricompensato",
		"ricomperato",
		"ricompilato",
		"ricompiuto",
		"ricomposto",
		"ricomprato",
		"ricompresso",
		"ricomunicato",
		"riconceduto",
		"riconcesso",
		"riconciliato",
		"ricondizionato",
		"ricondotto",
		"riconfermato",
		"riconfezionato",
		"riconfigurato",
		"riconfortato",
		"riconfuso",
		"ricongelato",
		"ricongiunto",
		"riconnesso",
		"riconosciuto",
		"riconquistato",
		"riconsacrato",
		"riconsegnato",
		"riconsiderato",
		"riconsigliato",
		"riconsolato",
		"ricontato",
		"ricontattato",
		"ricontrattato",
		"ricontratto",
		"ricontrollato",
		"riconvalidato",
		"riconvenuto",
		"riconvertito",
		"riconvinto",
		"riconvocato",
		"riconvogliato",
		"ricoperto",
		"ricopiato",
		"ricordato",
		"ricoricato",
		"ricorretto",
		"ricosparso",
		"ricostituito",
		"ricostretto",
		"ricostruito",
		"ricotto",
		"ricoverato",
		"ricreato",
		"ricristallizzato",
		"ricrocifisso",
		"ricucito",
		"ricuperato",
		"ricusato",
		"ridato",
		"ridecorato",
		"ridefinito",
		"ridenominato",
		"ridestato",
		"rideterminato",
		"ridetto",
		"ridicolizzato",
		"ridigitato",
		"ridimensionato",
		"ridipinto",
		"ridisceso",
		"ridisciolto",
		"ridisciplinato",
		"ridiscusso",
		"ridisegnato",
		"ridisfatto",
		"ridisposto",
		"ridisteso",
		"ridistinto",
		"ridistribuito",
		"ridiviso",
		"ridomandato",
		"ridonato",
		"ridondato",
		"ridorato",
		"ridotato",
		"ridotto",
		"ridovuto",
		"riecheggiato",
		"riedificato",
		"rieducato",
		"rielaborato",
		"rieletto",
		"riemesso",
		"riempito",
		"riempiuto",
		"rientrato",
		"riepilogato",
		"riequilibrato",
		"riequipaggiato",
		"riesaminato",
		"rieseguito",
		"riesercitato",
		"riesploso",
		"riesportato",
		"riesposto",
		"riespresso",
		"riespulso",
		"riesteso",
		"riesumato",
		"rietichettato",
		"rievaporato",
		"rievocato",
		"rifabbricato",
		"rifasciato",
		"rifatto",
		"rifenduto",
		"riferito",
		"rifermato",
		"rifermentato",
		"rifesso",
		"rificcato",
		"rifilato",
		"rifiltrato",
		"rifinanziato",
		"rifinito",
		"rifirmato",
		"rifischiato",
		"rifisso",
		"rifiutato",
		"riflesso",
		"riflettuto",
		"rifocillato",
		"rifoderato",
		"rifondato",
		"riforestato",
		"riforgiato",
		"riformato",
		"riformattato",
		"riformulato",
		"rifornito",
		"rifranto",
		"rifritto",
		"rifrugato",
		"rifuggito",
		"rifugiato",
		"rifuso",
		"rigassificato",
		"rigato",
		"rigelato",
		"rigenerato",
		"rigettato",
		"righettato",
		"rigiocato",
		"rigirato",
		"rigiudicato",
		"rigiunto",
		"rigoduto",
		"rigonfiato",
		"rigovernato",
		"riguadagnato",
		"riguardato",
		"rigurgitato",
		"rilanciato",
		"rilasciato",
		"rilassato",
		"rilavato",
		"rilavorato",
		"rilegato",
		"riletto",
		"rilevato",
		"rilocalizzato",
		"rimagliato",
		"rimandato",
		"rimaneggiato",
		"rimangiato",
		"rimappato",
		"rimarcato",
		"rimarchiato",
		"rimarginato",
		"rimaritato",
		"rimasticato",
		"rimato",
		"rimbacuccato",
		"rimbaldanzito",
		"rimbarcato",
		"rimbeccato",
		"rimbecillito",
		"rimbellito",
		"rimbiancato",
		"rimbiondito",
		"rimboccato",
		"rimbombato",
		"rimborsato",
		"rimboscato",
		"rimboschito",
		"rimbrottato",
		"rimediato",
		"rimembrato",
		"rimemorato",
		"rimenato",
		"rimeritato",
		"rimescolato",
		"rimesso",
		"rimestato",
		"rimilitarizzato",
		"rimirato",
		"rimischiato",
		"rimisurato",
		"rimodellato",
		"rimodernato",
		"rimodulato",
		"rimondato",
		"rimontato",
		"rimorchiato",
		"rimorso",
		"rimosso",
		"rimostrato",
		"rimotivato",
		"rimpacchettato",
		"rimpadronito",
		"rimpaginato",
		"rimpagliato",
		"rimpannucciato",
		"rimpastato",
		"rimpatriato",
		"rimpiallacciato",
		"rimpianto",
		"rimpiattato",
		"rimpiazzato",
		"rimpicciolito",
		"rimpiccolito",
		"rimpiegato",
		"rimpinguato",
		"rimpinzato",
		"rimpolpato",
		"rimpossessato",
		"rimpresso",
		"rimproverato",
		"rimuginato",
		"rimunerato",
		"rimunto",
		"rimusicato",
		"rimutato",
		"rinarrato",
		"rinascosto",
		"rincalcato",
		"rincalzato",
		"rincamminato",
		"rincantucciato",
		"rincarato",
		"rincarcerato",
		"rincarnato",
		"rincentrato",
		"rinchiesto",
		"rinchiodato",
		"rinchiuso",
		"rincitrullito",
		"rincivilito",
		"rincoglionito",
		"rincollato",
		"rincominciato",
		"rincontrato",
		"rincoraggiato",
		"rincorato",
		"rincorporato",
		"rincorso",
		"rincretinito",
		"rincrudito",
		"rinculcato",
		"rincuorato",
		"rindossato",
		"rindurito",
		"rinegoziato",
		"rinfacciato",
		"rinfagottato",
		"rinfiammato",
		"rinfiancato",
		"rinfilato",
		"rinfittito",
		"rinfocolato",
		"rinfoderato",
		"rinforzato",
		"rinfrancato",
		"rinfranto",
		"rinfrescato",
		"rinfuso",
		"ringagliardito",
		"ringalluzzito",
		"ringiovanito",
		"ringiovenito",
		"ringoiato",
		"ringorgato",
		"ringraziato",
		"ringuainato",
		"rinnamorato",
		"rinnegato",
		"rinnestato",
		"rinnovato",
		"rinnovellato",
		"rinociuto",
		"rinomato",
		"rinominato",
		"rinormalizzato",
		"rinquadrato",
		"rinsaccato",
		"rinsaldato",
		"rinsanguato",
		"rinselvatichito",
		"rinselvato",
		"rinserrato",
		"rintanato",
		"rintasato",
		"rintascato",
		"rintavolato",
		"rintenerito",
		"rinterrato",
		"rinterrogato",
		"rinteso",
		"rintiepidito",
		"rintoccato",
		"rintonacato",
		"rintontito",
		"rintorpidito",
		"rintracciato",
		"rintrodotto",
		"rintronato",
		"rintuzzato",
		"rinunciato",
		"rinunziato",
		"rinutrito",
		"rinvangato",
		"rinvasato",
		"rinvenuto",
		"rinverdito",
		"rinvestito",
		"rinviato",
		"rinvigorito",
		"rinvilito",
		"rinvitato",
		"rinvoltato",
		"rinvolto",
		"rinvoltolato",
		"rinzaffato",
		"rinzeppato",
		"riobbligato",
		"rioccupato",
		"riofferto",
		"rioffeso",
		"rioperato",
		"riordinato",
		"riorganizzato",
		"riorientato",
		"riosservato",
		"riottenuto",
		"riottimizzato",
		"riotturato",
		"ripagato",
		"riparametrizzato",
		"riparato",
		"ripartito",
		"ripassato",
		"ripercorso",
		"ripercosso",
		"riperduto",
		"riperso",
		"ripesato",
		"ripescato",
		"ripestato",
		"ripetuto",
		"ripianato",
		"ripianificato",
		"ripiantato",
		"ripianto",
		"ripicchiato",
		"ripiegato",
		"ripigliato",
		"ripinto",
		"ripiovuto",
		"ripitturato",
		"riplasmato",
		"ripolarizzato",
		"ripopolato",
		"riportato",
		"riporto",
		"riposato",
		"riposizionato",
		"riposseduto",
		"riposto",
		"ripotuto",
		"ripresentato",
		"ripreso",
		"riprestato",
		"ripreteso",
		"riprincipiato",
		"ripristinato",
		"riprivatizzato",
		"riprodotto",
		"riprogettato",
		"riprogrammato",
		"ripromesso",
		"riproposto",
		"riprotetto",
		"riprovato",
		"riprovveduto",
		"riprovvisto",
		"ripubblicato",
		"ripudiato",
		"ripugnato",
		"ripulito",
		"ripuntato",
		"ripunto",
		"ripurgato",
		"riputato",
		"riquadrato",
		"riqualificato",
		"rireso",
		"rirotto",
		"risaldato",
		"risalito",
		"risaltato",
		"risalutato",
		"risanato",
		"risaputo",
		"risarcito",
		"riscalato",
		"riscaldato",
		"riscattato",
		"riscelto",
		"risceso",
		"rischiarato",
		"rischiato",
		"risciacquato",
		"risciolto",
		"riscommesso",
		"riscontato",
		"riscontrato",
		"risconvolto",
		"riscoperto",
		"riscoppiato",
		"riscorso",
		"riscosso",
		"riscritto",
		"risecato",
		"riseduto",
		"risegato",
		"risegnato",
		"riselciato",
		"riselezionato",
		"riseminato",
		"risentito",
		"riseppellito",
		"riserbato",
		"riservato",
		"risicato",
		"risigillato",
		"risistemato",
		"riso",
		"risoffiato",
		"risoggiunto",
		"risolato",
		"risolidificato",
		"risollevato",
		"risolto",
		"risommato",
		"risommerso",
		"risonato",
		"risorpassato",
		"risospeso",
		"risospinto",
		"risottomesso",
		"risparmiato",
		"risparso",
		"rispecchiato",
		"rispedito",
		"rispento",
		"risperso",
		"rispettato",
		"rispiegato",
		"rispinto",
		"rispolverato",
		"risposato",
		"risposto",
		"rissato",
		"ristabilito",
		"ristagnato",
		"ristampato",
		"ristaurato",
		"risteso",
		"ristilizzato",
		"ristorato",
		"ristretto",
		"ristrutto",
		"ristrutturato",
		"ristuccato",
		"ristudiato",
		"risucchiato",
		"risultato",
		"risuolato",
		"risuonato",
		"risuscitato",
		"risvegliato",
		"risvolto",
		"ritagliato",
		"ritarato",
		"ritardato",
		"ritemprato",
		"ritentato",
		"ritenuto",
		"riterso",
		"riteso",
		"ritinto",
		"ritirato",
		"ritoccato",
		"ritolto",
		"ritorto",
		"ritracciato",
		"ritradotto",
		"ritrascorso",
		"ritrascritto",
		"ritrasferito",
		"ritrasformato",
		"ritrasmesso",
		"ritrasposto",
		"ritrattato",
		"ritratto",
		"ritrovato",
		"ritualizzato",
		"rituffato",
		"riudito",
		"riunificato",
		"riunito",
		"riusato",
		"riutilizzato",
		"rivaccinato",
		"rivaleggiato",
		"rivalorizzato",
		"rivalso",
		"rivalutato",
		"rivangato",
		"riveduto",
		"rivelato",
		"rivendicato",
		"rivenduto",
		"riverberato",
		"riverito",
		"riverniciato",
		"riversato",
		"rivestito",
		"rivettato",
		"rivinto",
		"rivisitato",
		"rivissuto",
		"rivisto",
		"rivitalizzato",
		"rivivificato",
		"rivoltato",
		"rivolto",
		"rivoltolato",
		"rivoluto",
		"rivoluzionato",
		"rizappato",
		"rizzato",
		"robotizzato",
		"rodato",
		"rogato",
		"rollato",
		"romanizzato",
		"romanticizzato",
		"romanzato",
		"roncolato",
		"rosicato",
		"rosicchiato",
		"roso",
		"rosolato",
		"rotacizzato",
		"rotato",
		"roteato",
		"rotolato",
		"rottamato",
		"rotto",
		"rovesciato",
		"rovinato",
		"rovistato",
		"rubacchiato",
		"rubato",
		"rullato",
		"ruminato",
		"ruotato",
		"russificato",
		"ruzzolato",
		"sabbiato",
		"sabotato",
		"saccarificato",
		"saccheggiato",
		"sacralizzato",
		"sacramentato",
		"sacrificato",
		"saettato",
		"saggiato",
		"sagginato",
		"sagomato",
		"salamoiato",
		"salariato",
		"salassato",
		"salato",
		"saldato",
		"salificato",
		"salinizzato",
		"salito",
		"salmeggiato",
		"salmistrato",
		"salpato",
		"saltato",
		"salutato",
		"salvaguardato",
		"salvato",
		"sanato",
		"sancito",
		"sanforizzato",
		"sanificato",
		"sanitizzato",
		"santificato",
		"sanzionato",
		"saponificato",
		"saputo",
		"sarchiato",
		"sarchiellato",
		"sartiato",
		"satellizzato",
		"satinato",
		"satireggiato",
		"satisfatto",
		"satollato",
		"saturato",
		"saziato",
		"sbaccellato",
		"sbaciucchiato",
		"sbafato",
		"sbaffato",
		"sbalestrato",
		"sballato",
		"sballottato",
		"sballottolato",
		"sbalordito",
		"sbalzato",
		"sbancato",
		"sbandato",
		"sbandierato",
		"sbandito",
		"sbaraccato",
		"sbaragliato",
		"sbarazzato",
		"sbarbato",
		"sbarcato",
		"sbardato",
		"sbarrato",
		"sbassato",
		"sbastito",
		"sbatacchiato",
		"sbattezzato",
		"sbattuto",
		"sbeccato",
		"sbeffeggiato",
		"sbellicato",
		"sbendato",
		"sbertucciato",
		"sbiadito",
		"sbiancato",
		"sbianchito",
		"sbiellato",
		"sbiettato",
		"sbigottito",
		"sbilanciato",
		"sbirbato",
		"sbirciato",
		"sbizzarrito",
		"sbloccato",
		"sbobinato",
		"sboccato",
		"sbocconcellato",
		"sbollentato",
		"sbolognato",
		"sborniato",
		"sborsato",
		"sboscato",
		"sbottonato",
		"sbozzato",
		"sbozzimato",
		"sbozzolato",
		"sbracato",
		"sbracciato",
		"sbraciato",
		"sbraitato",
		"sbranato",
		"sbrancato",
		"sbrattato",
		"sbreccato",
		"sbriciolato",
		"sbrigato",
		"sbrigliato",
		"sbrinato",
		"sbrindellato",
		"sbrodolato",
		"sbrogliato",
		"sbronzato",
		"sbruffato",
		"sbucciato",
		"sbudellato",
		"sbuffato",
		"sbugiardato",
		"sbullettato",
		"sbullonato",
		"sburrato",
		"scacazzato",
		"scacchiato",
		"scacciato",
		"scaccolato",
		"scadenzato",
		"scafato",
		"scaffalato",
		"scagionato",
		"scagliato",
		"scaglionato",
		"scalato",
		"scalcato",
		"scalcinato",
		"scaldato",
		"scalettato",
		"scalfato",
		"scalfito",
		"scalmanato",
		"scaloppato",
		"scalpato",
		"scalpellato",
		"scalpellinato",
		"scaltrito",
		"scalzato",
		"scambiato",
		"scamiciato",
		"scamosciato",
		"scamozzato",
		"scampato",
		"scampatalo",
		"scampato",
		"scamuffato",
		"scanalato",
		"scancellato",
		"scandagliato",
		"scandalizzato",
		"scandito",
		"scannato",
		"scannellato",
		"scannerato",
		"scannerizato",
		"scannerizzato",
		"scansato",
		"scansionato",
		"scapecchiato",
		"scapezzato",
		"scapicollato",
		"scapigliato",
		"scapitozzato",
		"scapocchiato",
		"scappato",
		"scappellato",
		"scappottato",
		"scapricciato",
		"scapsulato",
		"scarabocchiato",
		"scaracchiato",
		"scaraventato",
		"scarcerato",
		"scardassato",
		"scardato",
		"scardinato",
		"scaricato",
		"scarificato",
		"scarmigliato",
		"scarnato",
		"scarnificato",
		"scarnito",
		"scarrellato",
		"scarrocciato",
		"scarrozzato",
		"scarruffato",
		"scartabellato",
		"scartato",
		"scartavetrato",
		"scartinato",
		"scartocciato",
		"scassato",
		"scassinato",
		"scatenato",
		"scattato",
		"scavalcato",
		"scavallato",
		"scavato",
		"scavezzato",
		"scazzottato",
		"scekerato",
		"scelto",
		"scempiato",
		"sceneggiato",
		"scernuto",
		"scervellato",
		"sceso",
		"sceverato",
		"schedato",
		"schedulato",
		"scheggiato",
		"scheletrito",
		"schematizzato",
		"schermato",
		"schermito",
		"schermografato",
		"schernito",
		"schiacciato",
		"schiaffato",
		"schiaffeggiato",
		"schiantato",
		"schiarito",
		"schiavardato",
		"schiavizzato",
		"schiccherato",
		"schierato",
		"schifato",
		"schinciato",
		"schioccato",
		"schiodato",
		"schiumato",
		"schiuso",
		"schivato",
		"schizzato",
		"schizzettato",
		"sciabolato",
		"sciabordato",
		"sciacquato",
		"scialacquato",
		"sciamanizzato",
		"sciamannato",
		"sciancato",
		"sciancrato",
		"scimmieggiato",
		"scimmiottato",
		"scinto",
		"scioccato",
		"sciolinato",
		"sciolto",
		"sciorinato",
		"scippato",
		"sciroppato",
		"scisso",
		"sciupacchiato",
		"sciupato",
		"sclamato",
		"sclerosato",
		"sclerotizzato",
		"scoccato",
		"scocciato",
		"scodato",
		"scodellato",
		"scoiato",
		"scolarizzato",
		"scolato",
		"scollacciato",
		"scollato",
		"scollegato",
		"scolorato",
		"scolorito",
		"scolpato",
		"scolpito",
		"scombaciato",
		"scombinato",
		"scombussolato",
		"scommesso",
		"scomodato",
		"scompaginato",
		"scompagnato",
		"scompartito",
		"scompattato",
		"scompensato",
		"scompiacuto",
		"scompigliato",
		"scomposto",
		"scomputato",
		"scomunicato",
		"sconcertato",
		"sconciato",
		"sconcluso",
		"sconfessato",
		"sconficcato",
		"sconﬁtto",
		"sconfortato",
		"sconfuso",
		"scongelato",
		"scongiurato",
		"sconnesso",
		"sconosciuto",
		"sconquassato",
		"sconsacrato",
		"sconsigliato",
		"sconsolato",
		"scontato",
		"scontentato",
		"scontornato",
		"scontorto",
		"scontrato",
		"sconvolto",
		"scopato",
		"scoperchiato",
		"scoperto",
		"scopiazzato",
		"scoraggiato",
		"scoraggito",
		"scorato",
		"scorazzato",
		"scorciato",
		"scorcito",
		"scordato",
		"scoreggiato",
		"scorificato",
		"scornato",
		"scorniciato",
		"scoronato",
		"scorporato",
		"scorrazzato",
		"scorreggiato",
		"scorretto",
		"scorso",
		"scortato",
		"scortecciato",
		"scorticato",
		"scorto",
		"scorzato",
		"scosceso",
		"scosciato",
		"scosso",
		"scostato",
		"scostolato",
		"scotennato",
		"scoticato",
		"scotolato",
		"scotomizzato",
		"scottato",
		"scotto",
		"scovato",
		"scoverto",
		"scozzato",
		"scozzonato",
		"screditato",
		"scremato",
		"screpolato",
		"screziato",
		"scribacchiato",
		"scriminato",
		"scristianizzato",
		"scritto",
		"scritturato",
		"scroccato",
		"scrocchiato",
		"scrollato",
		"scrostato",
		"scrutato",
		"scrutinato",
		"scucito",
		"scudisciato",
		"scuffiato",
		"sculacciato",
		"sculettato",
		"scuoiato",
		"scuriosato",
		"scurito",
		"scusato",
		"sdaziato",
		"sdebitato",
		"sdegnato",
		"sdemanializzato",
		"sdentato",
		"sdilinquito",
		"sdoganato",
		"sdoluto",
		"sdoppiato",
		"sdraiato",
		"sdrammatizzato",
		"sdrucito",
		"secato",
		"seccato",
		"secernuto",
		"secolarizzato",
		"secondato",
		"secretato",
		"secreto",
		"sedato",
		"sedentarizzato",
		"sedotto",
		"segato",
		"seghettato",
		"segmentato",
		"segnalato",
		"segnato",
		"segnoreggiato",
		"segregato",
		"segretato",
		"seguitato",
		"seguito",
		"selciato",
		"selezionato",
		"sellato",
		"sembrato",
		"sementato",
		"semicinto",
		"seminato",
		"semplificato",
		"senilizzato",
		"sensibilizzato",
		"sensorizzato",
		"sentenziato",
		"sentito",
		"sentitaselo",
		"sentito",
		"sentito",
		"separato",
		"sepolto",
		"seppellito",
		"sequenziato",
		"sequestrato",
		"serbato",
		"serrato",
		"servito",
		"servoassistito",
		"sessualizzato",
		"sestuplicato",
		"setacciato",
		"setificato",
		"settato",
		"settorializzato",
		"settuplicato",
		"seviziato",
		"sezionato",
		"sfaccettato",
		"sfagliato",
		"sfaldato",
		"sfalsato",
		"sfamato",
		"sfanalato",
		"sfangato",
		"sfarinato",
		"sfasato",
		"sfasciato",
		"sfatato",
		"sfatto",
		"sfavillato",
		"sfavorito",
		"sfegatato",
		"sfeltrato",
		"sfenduto",
		"sferragliato",
		"sferrato",
		"sferzato",
		"sfesso",
		"sfiancato",
		"sfiatato",
		"sfiato",
		"sfibbiato",
		"sfibrato",
		"sfidato",
		"sfiduciato",
		"sfigurato",
		"sfilato",
		"sfilettato",
		"sfinito",
		"sfioccato",
		"sfiorato",
		"sfittato",
		"sfocato",
		"sfociato",
		"sfoderato",
		"sfogato",
		"sfoggiato",
		"sfogliato",
		"sfollato",
		"sfoltito",
		"sfondato",
		"sforacchiato",
		"sforato",
		"sforbiciato",
		"sformato",
		"sfornaciato",
		"sfornato",
		"sfornito",
		"sforzato",
		"sfottuto",
		"sfracellato",
		"sfrangiato",
		"sfrascato",
		"sfratato",
		"sfrattato",
		"sfrecciato",
		"sfregato",
		"sfregiato",
		"sfrenato",
		"sfrisato",
		"sfrondato",
		"sfrucugliato",
		"sfruculiato",
		"sfruttato",
		"sfumato",
		"sfuocato",
		"sgamato",
		"sganasciato",
		"sganciato",
		"sgarbugliato",
		"sgattaiolato",
		"sgelato",
		"sghiacciato",
		"sgocciolato",
		"sgolato",
		"sgomberato",
		"sgombrato",
		"sgomentato",
		"sgominato",
		"sgomitato",
		"sgomitolato",
		"sgonfiato",
		"sgorbiato",
		"sgottato",
		"sgovernato",
		"sgozzato",
		"sgraffiato",
		"sgraffignato",
		"sgranato",
		"sgranchito",
		"sgranellato",
		"sgrassato",
		"sgravato",
		"sgretolato",
		"sgridato",
		"sgrommato",
		"sgrondato",
		"sgroppato",
		"sgrossato",
		"sgrovigliato",
		"sgrugnato",
		"sguainato",
		"sgualcito",
		"sguanciato",
		"sguarnito",
		"sguinzagliato",
		"sgusciato",
		"shakerato",
		"shoccato",
		"shuntato",
		"sigillato",
		"siglato",
		"significato",
		"signoreggiato",
		"silenziato",
		"silicizzato",
		"sillabato",
		"sillogizzato",
		"silurato",
		"simboleggiato",
		"simbolizzato",
		"simmetrizzato",
		"simpatizzato",
		"simulato",
		"sincerato",
		"sincopato",
		"sincretizzato",
		"sincronizzato",
		"sindacalizzato",
		"sindacato",
		"singolarizzato",
		"sinistrato",
		"sinizzato",
		"sinterizzato",
		"sintetizzato",
		"sintonizzato",
		"siringato",
		"sistematizzato",
		"sistemato",
		"situato",
		"slabbrato",
		"slacciato",
		"slamato",
		"slanciato",
		"slappolato",
		"slargato",
		"slavizzato",
		"slegato",
		"slentato",
		"slinguato",
		"slogato",
		"sloggato",
		"sloggiato",
		"slombato",
		"slungato",
		"smaccato",
		"smacchiato",
		"smagliato",
		"smagnetizzato",
		"smagrito",
		"smaliziato",
		"smallato",
		"smaltato",
		"smaltito",
		"smammato",
		"smanacciato",
		"smangiato",
		"smantellato",
		"smarcato",
		"smarginato",
		"smarrito",
		"smascellato",
		"smascherato",
		"smaterializzato",
		"smattonato",
		"smembrato",
		"smentito",
		"smerciato",
		"smerdato",
		"smerigliato",
		"smerlato",
		"smerlettato",
		"smessalo",
		"smesso",
		"smezzato",
		"smidollato",
		"smielato",
		"smilitarizzato",
		"sminato",
		"sminuito",
		"sminuzzato",
		"smistato",
		"smitizzato",
		"smobiliato",
		"smobilitato",
		"smobilizzato",
		"smoccolato",
		"smollicato",
		"smonacato",
		"smontato",
		"smorbato",
		"smorzato",
		"smosso",
		"smozzicato",
		"smunto",
		"smurato",
		"smussato",
		"smutandato",
		"snaturato",
		"snazionalizzato",
		"snebbiato",
		"snellito",
		"snervato",
		"snidato",
		"sniffato",
		"snobbato",
		"snocciolato",
		"snodato",
		"snudato",
		"sobbarcato",
		"sobbollito",
		"sobillato",
		"socchiuso",
		"soccorso",
		"soddisfatto",
		"sodisfatto",
		"sodomizzato",
		"sofferito",
		"soffermato",
		"sofferto",
		"soffiato",
		"soffocato",
		"soffregato",
		"soffritto",
		"soffuso",
		"sofisticato",
		"soggettivato",
		"soggettivizzato",
		"sogghignato",
		"soggiogato",
		"soggiunto",
		"sogguardato",
		"sognato",
		"solarizzato",
		"solcato",
		"soleggiato",
		"solennizzato",
		"solfeggiato",
		"solfitato",
		"solfonato",
		"solforato",
		"solidificato",
		"solito",
		"sollazzato",
		"sollecitato",
		"solleticato",
		"sollevato",
		"solto",
		"solubilizzato",
		"soluto",
		"soluzionato",
		"solvatato",
		"somatizzato",
		"someggiato",
		"somigliato",
		"sommato",
		"sommerso",
		"sommesso",
		"somministrato",
		"sommosso",
		"sonato",
		"sondato",
		"sonorizzato",
		"sopito",
		"soppalcato",
		"soppesato",
		"soppiantato",
		"sopportato",
		"sopposto",
		"soppresso",
		"sopraddotato",
		"sopraeccitato",
		"sopraedificato",
		"sopraelevato",
		"sopraffato",
		"sopraffatto",
		"sopraggiunto",
		"soprainteso",
		"soprammesso",
		"soprannominato",
		"sopraposto",
		"soprappreso",
		"soprascritto",
		"sopraspeso",
		"soprassaturato",
		"soprasseduto",
		"sopravanzato",
		"sopravvalutato",
		"sopravveduto",
		"sopravvinto",
		"sopravvisto",
		"sopreccitato",
		"sopredificato",
		"soprelevato",
		"soprinteso",
		"sorbettato",
		"sorbito",
		"sorgiunto",
		"sormontato",
		"sorpassato",
		"sorpreso",
		"sorraso",
		"sorretto",
		"sorseggiato",
		"sorteggiato",
		"sortito",
		"sorvegliato",
		"sorvolato",
		"soscritto",
		"sospeso",
		"sospettato",
		"sospinto",
		"sospirato",
		"sostantivato",
		"sostanziato",
		"sostentato",
		"sostenuto",
		"sostituito",
		"sottaciuto",
		"sotterrato",
		"sotteso",
		"sottinteso",
		"sottoalimentato",
		"sottocapitalizzato",
		"sottodiviso",
		"sottoesposto",
		"sottofirmato",
		"sottolineato",
		"sottomesso",
		"sottomurato",
		"sottopagato",
		"sottopassato",
		"sottoposto",
		"sottorappresentato",
		"sottoriso",
		"sottoscritto",
		"sottostimato",
		"sottosviluppato",
		"sottotitolato",
		"sottovalutato",
		"sottratto",
		"soverchiato",
		"sovesciato",
		"sovietizzato",
		"sovracapitalizzato",
		"sovraccaricato",
		"sovradimensionato",
		"sovraeccitato",
		"sovraesposto",
		"sovraffaticato",
		"sovraffollato",
		"sovraggiunto",
		"sovraimposto",
		"sovrainteso",
		"sovralimentato",
		"sovramodulato",
		"sovrappopolato",
		"sovrapposto",
		"sovrariscaldato",
		"sovrasaturato",
		"sovrascritto",
		"sovrastampato",
		"sovrastato",
		"sovrastimato",
		"sovrautilizzato",
		"sovreccitato",
		"sovresposto",
		"sovrimposto",
		"sovrinteso",
		"sovvenuto",
		"sovvenzionato",
		"sovvertito",
		"spaccato",
		"spacchettato",
		"spacciato",
		"spaginato",
		"spaiato",
		"spalancato",
		"spalato",
		"spalcato",
		"spalleggiato",
		"spalmato",
		"spammato",
		"spampanato",
		"spampinato",
		"spanato",
		"spanciato",
		"spanduto",
		"spannato",
		"spannocchiato",
		"spanso",
		"spantanato",
		"spanto",
		"spaparacchiato",
		"spaparanzato",
		"spappolato",
		"sparato",
		"sparecchiato",
		"sparigliato",
		"sparito",
		"sparlato",
		"sparpagliato",
		"spartito",
		"spassato",
		"spassatoselo",
		"spastoiato",
		"spaurato",
		"spaurito",
		"spaventato",
		"spazializzato",
		"spaziato",
		"spazieggiato",
		"spazientito",
		"spazzato",
		"spazzolato",
		"specchiato",
		"specializzato",
		"specificato",
		"specillato",
		"specolato",
		"spedito",
		"spegnato",
		"spelacchiato",
		"spelato",
		"spellato",
		"spennacchiato",
		"spennato",
		"spennellato",
		"spento",
		"spenzolato",
		"sperato",
		"sperimentato",
		"spernacchiato",
		"speronato",
		"sperperato",
		"spersonalizzato",
		"sperticato",
		"spesato",
		"speso",
		"spessito",
		"spettacolarizzato",
		"spettinato",
		"spezzato",
		"spezzettato",
		"spezziato",
		"spezzonato",
		"spiaccicato",
		"spianato",
		"spiantato",
		"spiato",
		"spiattellato",
		"spiazzato",
		"spiccato",
		"spicciato",
		"spiccicato",
		"spicciolato",
		"spicconato",
		"spidocchiato",
		"spiegato",
		"spiegazzato",
		"spietrato",
		"spifferato",
		"spigionato",
		"spignorato",
		"spigolato",
		"spigrito",
		"spillato",
		"spilluzzicato",
		"spiluccato",
		"spinto",
		"spintonato",
		"spiombato",
		"spiralizzato",
		"spirantizzato",
		"spirato",
		"spiritualizzato",
		"spiumato",
		"spizzicato",
		"spodestato",
		"spoetizzato",
		"spogliato",
		"spolettato",
		"spoliato",
		"spoliticizzato",
		"spollonato",
		"spolmonato",
		"spolpato",
		"spoltronito",
		"spolverato",
		"spolverizzato",
		"spompato",
		"spompinato",
		"sponsorizzato",
		"spopolato",
		"spoppato",
		"sporcato",
		"sportato",
		"sporto",
		"sposato",
		"sposseduto",
		"spossessato",
		"spostato",
		"sposto",
		"sprangato",
		"sprecato",
		"spregiato",
		"spremuto",
		"spretato",
		"sprezzato",
		"sprigionato",
		"sprimacciato",
		"spromesso",
		"spronato",
		"sprotetto",
		"sprovincializzato",
		"sprovveduto",
		"sprovvisto",
		"spruzzato",
		"spugnato",
		"spulato",
		"spulciato",
		"spuntato",
		"spuntellato",
		"spupazzato",
		"spurgato",
		"sputacchiato",
		"sputato",
		"sputtanato",
		"squadernato",
		"squadrato",
		"squagliato",
		"squagliataselo",
		"squagliato",
		"squalificato",
		"squamato",
		"squarciato",
		"squartato",
		"squassato",
		"squattrinato",
		"squilibrato",
		"squinternato",
		"sradicato",
		"srotolato",
		"srugginito",
		"stabbiato",
		"stabilito",
		"stabilizzato",
		"stabulato",
		"staccato",
		"stacciato",
		"staffato",
		"staffilato",
		"staggiato",
		"staggito",
		"stagionato",
		"stagliato",
		"stagnato",
		"stamburato",
		"stampato",
		"stampigliato",
		"stanato",
		"stancato",
		"standardizzato",
		"stangato",
		"stanziato",
		"stappato",
		"starato",
		"starnazzato",
		"stasato",
		"statalizzato",
		"statizzato",
		"statoco",
		"statoseno",
		"statuito",
		"stazzato",
		"stazzonato",
		"steccacciato",
		"steccato",
		"stecchito",
		"stecconato",
		"stemperato",
		"stempiato",
		"stenografato",
		"stereotipato",
		"sterilito",
		"sterilizzato",
		"sterpato",
		"sterrato",
		"sterzato",
		"steso",
		"stigliato",
		"stigmatizzato",
		"stilato",
		"stilettato",
		"stilizzato",
		"stillato",
		"stimato",
		"stimolato",
		"stinto",
		"stipato",
		"stipendiato",
		"stipulato",
		"stiracchiato",
		"stirato",
		"stivato",
		"stizzito",
		"stoccato",
		"stolto",
		"stomacato",
		"stonato",
		"stondato",
		"stoppato",
		"stordito",
		"storicizzato",
		"stornato",
		"storpiato",
		"stortato",
		"storto",
		"stozzato",
		"strabenedetto",
		"strabuzzato",
		"stracannato",
		"straccato",
		"stracciato",
		"stracotto",
		"strafogato",
		"stragoduto",
		"stralciato",
		"stralodato",
		"stralunato",
		"stramaledetto",
		"stramortito",
		"strangolato",
		"straniato",
		"stranito",
		"straorzato",
		"strapagato",
		"strapazzato",
		"straperduto",
		"straperso",
		"strappato",
		"strasaputo",
		"strascicato",
		"strascinato",
		"strasformato",
		"stratificato",
		"strattonato",
		"stravaccato",
		"stravinto",
		"stravolto",
		"stravoluto",
		"straziato",
		"stregato",
		"stremato",
		"stressato",
		"striato",
		"stridulato",
		"strigato",
		"strigliato",
		"strillato",
		"striminzito",
		"strimpellato",
		"strinato",
		"stringato",
		"strisciato",
		"stritolato",
		"strizzato",
		"strofinato",
		"strombato",
		"strombazzato",
		"stroncato",
		"stronzato",
		"stropicciato",
		"stroppato",
		"stroppiato",
		"strozzato",
		"struccato",
		"strumentalizzato",
		"strumentato",
		"strusciato",
		"strutto",
		"strutturalizzato",
		"strutturato",
		"stuccato",
		"studiacchiato",
		"studiato",
		"stuellato",
		"stufato",
		"stupefatto",
		"stupito",
		"stuprato",
		"sturato",
		"stutato",
		"stuzzicato",
		"suaso",
		"subaffittato",
		"subappaltato",
		"subbiato",
		"subdelegato",
		"subissato",
		"subito",
		"sublicenziato",
		"sublimato",
		"sublocato",
		"subodorato",
		"subordinato",
		"subornato",
		"suburbanizzato",
		"sucato",
		"succhiato",
		"succhiellato",
		"succiato",
		"succinto",
		"succiso",
		"suddistinto",
		"suddiviso",
		"suffissato",
		"suffisso",
		"suffragato",
		"suffumicato",
		"suffuso",
		"suggellato",
		"suggerito",
		"suggestionato",
		"suicidato",
		"sunteggiato",
		"sunto",
		"suolato",
		"suonato",
		"superato",
		"superpagato",
		"superraffreddato",
		"supervalutato",
		"supervisionato",
		"supplicato",
		"supplito",
		"supportato",
		"supposto",
		"suppurato",
		"surclassato",
		"surfato",
		"surgelato",
		"surraffreddato",
		"surriscaldato",
		"surrogato",
		"survoltato",
		"suscitato",
		"susseguito",
		"sussidiato",
		"sussunto",
		"sussurrato",
		"suturato",
		"svaccato",
		"svagato",
		"svaligiato",
		"svalutato",
		"svapato",
		"svariato",
		"svasato",
		"svecchiato",
		"svegliato",
		"svelato",
		"svelenito",
		"sveltito",
		"svelto",
		"svenato",
		"svenduto",
		"sventagliato",
		"sventato",
		"sventolato",
		"sventrato",
		"sverginato",
		"svergognato",
		"svergolato",
		"sverminato",
		"sverniciato",
		"svestito",
		"svettato",
		"svezzato",
		"sviato",
		"svignatoselo",
		"svigorito",
		"svilito",
		"svillaneggiato",
		"sviluppato",
		"svinato",
		"svincolato",
		"sviolinato",
		"svirgolato",
		"svirilizzato",
		"svisato",
		"sviscerato",
		"svitato",
		"sviticchiato",
		"svolato",
		"svolazzato",
		"svolto",
		"svoluto",
		"svuotato",
		"tabuizzato",
		"tabulato",
		"taccato",
		"taccheggiato",
		"tacciato",
		"tacitato",
		"taciuto",
		"tagliato",
		"taglieggiato",
		"tagliuzzato",
		"talebanizzato",
		"tallonato",
		"tampinato",
		"tamponato",
		"tanguto",
		"tannato",
		"tappato",
		"tappezzato",
		"tarato",
		"tardato",
		"targato",
		"tariffato",
		"tarlato",
		"tarmato",
		"taroccato",
		"tarpato",
		"tartagliato",
		"tartassato",
		"tartufato",
		"tassato",
		"tassellato",
		"tastato",
		"tasteggiato",
		"tatuato",
		"tecnicizzato",
		"tecnologizzato",
		"tedeschizzato",
		"tediato",
		"teflonato",
		"telecomandato",
		"telecontrollato",
		"telediffuso",
		"telefonato",
		"telegrafato",
		"teleguidato",
		"telematizzato",
		"telemetrato",
		"teleradiotrasmesso",
		"teletrasmesso",
		"teletrasportato",
		"tematizzato",
		"temperato",
		"tempestato",
		"tempificato",
		"templatizzato",
		"temporizzato",
		"temprato",
		"temuto",
		"tentato",
		"tenuto",
		"teologizzato",
		"teorizzato",
		"tepefatto",
		"terebrato",
		"terminato",
		"termostatato",
		"terrazzato",
		"terrificato",
		"terrorizzato",
		"terso",
		"terzarolato",
		"terziarizzato",
		"terziato",
		"tesato",
		"tesaurizzato",
		"teso",
		"tesserato",
		"testato",
		"testificato",
		"testimoniato",
		"timbrato",
		"tindalizzato",
		"tinteggiato",
		"tinto",
		"tipicizzato",
		"tipizzato",
		"tippato",
		"tiranneggiato",
		"tirato",
		"titillato",
		"titolato",
		"toccato",
		"toelettato",
		"tollerato",
		"tolto",
		"tonalizzato",
		"tonificato",
		"tonneggiato",
		"tonsurato",
		"torchiato",
		"tormentato",
		"tornatoseno",
		"tornito",
		"torrefatto",
		"torto",
		"tortoreggiato",
		"torturato",
		"tosato",
		"toscaneggiato",
		"toscanizzato",
		"tostato",
		"totalizzato",
		"traboccato",
		"trabuccato",
		"tracannato",
		"tracciato",
		"tradito",
		"tradotto",
		"trafficato",
		"trafilato",
		"trafitto",
		"traforato",
		"trafugato",
		"traghettato",
		"traguardato",
		"trainato",
		"tralasciato",
		"tralignato",
		"tramandato",
		"tramato",
		"trambasciato",
		"tramesso",
		"tramestato",
		"tramezzato",
		"tramortito",
		"tramutato",
		"tranciato",
		"trangugiato",
		"tranquillato",
		"tranquillizzato",
		"transatto",
		"transceso",
		"transcodificato",
		"transcorso",
		"transcritto",
		"transennato",
		"transfluito",
		"transfuso",
		"transistorizzato",
		"translitterato",
		"transposto",
		"transricevuto",
		"transustanziato",
		"transveduto",
		"transvisto",
		"trapanato",
		"trapassato",
		"trapiantato",
		"traportato",
		"traposto",
		"trapposto",
		"trapuntato",
		"trapunto",
		"trarotto",
		"trasandato",
		"trasbordato",
		"trascelto",
		"trasceso",
		"trascinato",
		"trascorso",
		"trascritto",
		"trascurato",
		"trasdotto",
		"trasferito",
		"trasfigurato",
		"trasformato",
		"trasfuso",
		"trasgredito",
		"traslato",
		"traslitterato",
		"traslocato",
		"trasmesso",
		"trasmutato",
		"trasparito",
		"traspirato",
		"trasportato",
		"trasposto",
		"trastullato",
		"trasudato",
		"trasvolato",
		"trasvolto",
		"trattato",
		"tratteggiato",
		"trattenuto",
		"tratto",
		"traumatizzato",
		"travagliato",
		"travalicato",
		"travasato",
		"traveduto",
		"traversato",
		"travestito",
		"traviato",
		"travisato",
		"travisto",
		"travolto",
		"trebbiato",
		"triangolato",
		"tribbiato",
		"tribolato",
		"tributato",
		"triennalizzato",
		"trimestralizzato",
		"trincato",
		"trincerato",
		"trinciato",
		"tripartito",
		"triplicato",
		"trisecato",
		"trisezionato",
		"tritato",
		"triturato",
		"trivellato",
		"trollato",
		"trombato",
		"troncato",
		"tropicalizzato",
		"trovato",
		"truccato",
		"trucidato",
		"truffato",
		"tuffato",
		"tumefatto",
		"tumulato",
		"turato",
		"turbato",
		"turlupinato",
		"tutelato",
		"ubbligato",
		"ubicato",
		"ubidito",
		"ubiquitinato",
		"ubriacato",
		"uccellato",
		"uccellinato",
		"ucciso",
		"udito",
		"ufficializzato",
		"uggito",
		"ugnato",
		"uguagliato",
		"ulcerato",
		"ulito",
		"ulolato",
		"ultimato",
		"ultracentrifugato",
		"ululato",
		"umanato",
		"umanizzato",
		"umettato",
		"umidificato",
		"umidito",
		"umiliato",
		"uncinato",
		"unguentato",
		"unificato",
		"uniformato",
		"unito",
		"univerbato",
		"universaleggiato",
		"universalizzato",
		"untato",
		"unto",
		"uperizzato",
		"urbanizzato",
		"urgenzato",
		"urlato",
		"urtacchiato",
		"urtato",
		"urticchiato",
		"usato",
		"usciolato",
		"usolato",
		"ustionato",
		"usucapito",
		"usurato",
		"usurpato",
		"utilitato",
		"utilizzato",
		"vaccinato",
		"vagabondeggiato",
		"vagellato",
		"vagheggiato",
		"vagillato",
		"vagliato",
		"valcato",
		"valicato",
		"validato",
		"valorizzato",
		"valso",
		"valutato",
		"vanagloriato",
		"vanato",
		"vandalizzato",
		"vangato",
		"vangelizzato",
		"vanificato",
		"vanito",
		"vantaggiato",
		"vantato",
		"vaporato",
		"vaporizzato",
		"varato",
		"varcato",
		"variato",
		"vasectomizzato",
		"vaticinato",
		"vedovato",
		"veduto",
		"vegetato",
		"veggiato",
		"vegliato",
		"veicolato",
		"velarizzato",
		"velato",
		"velettato",
		"velinato",
		"vellicato",
		"vellutato",
		"velocizzato",
		"vendemmiato",
		"vendicato",
		"vendicchiato",
		"venducchiato",
		"venduto",
		"venerato",
		"vengiato",
		"ventagliato",
		"ventilato",
		"ventolato",
		"verbalizzato",
		"vergato",
		"vergheggiato",
		"vergognato",
		"vergolato",
		"verificato",
		"verminato",
		"vernalizzato",
		"verniciato",
		"verrinato",
		"versato",
		"verseggiato",
		"versificato",
		"verticalizzato",
		"vessato",
		"vestito",
		"vestito",
		"vetrificato",
		"vetrinato",
		"vetrioleggiato",
		"vettovagliato",
		"vezzeggiato",
		"viaggiato",
		"vicinato",
		"vicitato",
		"videochattato",
		"videochiamato",
		"videocomunicato",
		"videoregistrato",
		"videotrasmesso",
		"vidimato",
		"vigilato",
		"vigliato",
		"vigoreggiato",
		"vigorito",
		"vilificato",
		"vilipeso",
		"villaneggiato",
		"vincolato",
		"vinto",
		"violato",
		"violentato",
		"violinato",
		"virgolato",
		"virgoleggiato",
		"virgolettato",
		"virilizzato",
		"virtualizzato",
		"visionato",
		"visitato",
		"vissuto",
		"vistato",
		"visto",
		"visualizzato",
		"vitaliziato",
		"vitalizzato",
		"vitaminizzato",
		"vittimizzato",
		"vituperato",
		"vivacizzato",
		"vivandato",
		"vivificato",
		"vivisezionato",
		"viziato",
		"vocabolarizzato",
		"vocalizzato",
		"vocato",
		"vociferato",
		"volantinato",
		"volatilizzato",
		"volgarizzato",
		"volicchiato",
		"volpeggiato",
		"voltato",
		"volto",
		"voltolato",
		"volturato",
		"voluminizzato",
		"voluto",
		"volutoco",
		"vomitato",
		"vorato",
		"votato",
		"vulcanizzato",
		"vuotato",
		"wappato",
		"wikificato",
		"xerocopiato",
		"zaffato",
		"zampato",
		"zampettato",
		"zampillato",
		"zannato",
		"zappato",
		"zappettato",
		"zapponato",
		"zavorrato",
		"zeppato",
		"zigrinato",
		"zigzagato",
		"zimbellato",
		"zincato",
		"zinnato",
		"zipolato",
		"zippato",
		"zirlato",
		"zittito",
		"zizzagato",
		"zoccolato",
		"zollato",
		"zombato",
		"zonato",
		"zonizzato",
		"zoppato",
		"zoppeggiato",
		"zoppicato",
		"zucconato",
		"zufolato",
		"zumato",
		"zuppato",
		"abalienata",
		"abbacchiata",
		"abbacinata",
		"abbadata",
		"abbagliata",
		"abbaiata",
		"abballata",
		"abbambinata",
		"abbancata",
		"abbandonata",
		"abbarbagliata",
		"abbarbata",
		"abbarcata",
		"abbaruffata",
		"abbassata",
		"abbatacchiata",
		"abbattuta",
		"abbatuffolata",
		"abbelita",
		"abbellata",
		"abbellita",
		"abbendata",
		"abbeverata",
		"abbiadata",
		"abbicata",
		"abbigliata",
		"abbinata",
		"abbindolata",
		"abbioccata",
		"abbiosciata",
		"abbisciata",
		"abbittata",
		"abboccata",
		"abboffata",
		"abbominata",
		"abbonacciata",
		"abbonata",
		"abbonita",
		"abbordata",
		"abborracciata",
		"abborrata",
		"abborrita",
		"abbottinata",
		"abbottonata",
		"abbozzacchiata",
		"abbozzata",
		"abbozzolata",
		"abbracciata",
		"abbraciata",
		"abbrancata",
		"abbreviata",
		"abbriccata",
		"abbrigliata",
		"abbrivata",
		"abbriviata",
		"abbrividita",
		"abbronzata",
		"abbrostolata",
		"abbrostolita",
		"abbruciacchiata",
		"abbruciata",
		"abbrunata",
		"abbrunita",
		"abbruscata",
		"abbrusciata",
		"abbrustiata",
		"abbrustolata",
		"abbrustolita",
		"abbrutita",
		"abbruttita",
		"abbuffata",
		"abbuiata",
		"abbuonata",
		"abburattata",
		"abbuzzita",
		"abdicata",
		"abdotta",
		"abiettata",
		"abilitata",
		"abissata",
		"abitata",
		"abituata",
		"abiurata",
		"abolita",
		"abominata",
		"abondata",
		"aborrita",
		"abrasa",
		"abrogata",
		"abusata",
		"accaffata",
		"accagionata",
		"accagliata",
		"accalappiata",
		"accalcata",
		"accaldata",
		"accallata",
		"accalorata",
		"accalorita",
		"accambiata",
		"accampata",
		"accampionata",
		"accanalata",
		"accanata",
		"accaneggiata",
		"accanita",
		"accantonata",
		"accaparrata",
		"accapezzata",
		"accapigliata",
		"accapottata",
		"accappiata",
		"accappiettata",
		"accapponata",
		"accappucciata",
		"accaprettata",
		"accareggiata",
		"accarezzata",
		"accarnata",
		"accarpionata",
		"accartocciata",
		"accasata",
		"accasciata",
		"accasellata",
		"accasermata",
		"accastellata",
		"accastellinata",
		"accatarrata",
		"accatastata",
		"accattata",
		"accattivata",
		"accavalcata",
		"accavalciata",
		"accavallata",
		"accavezzata",
		"accecata",
		"acceffata",
		"accelerata",
		"accellerata",
		"accennata",
		"accensata",
		"accentata",
		"accentrata",
		"accentuata",
		"acceppata",
		"accerchiata",
		"accercinata",
		"accertata",
		"accesa",
		"accessoriata",
		"accettata",
		"acchetata",
		"acchiappata",
		"acchiocciolata",
		"acchitata",
		"acchiuduta",
		"acciabattata",
		"acciaiata",
		"acciambellata",
		"acciarpata",
		"acciecata",
		"accigliata",
		"acciglionata",
		"accignuta",
		"accincignata",
		"accinta",
		"acciocchita",
		"acciottolata",
		"accipigliata",
		"accismata",
		"accisa",
		"acciucchita",
		"acciuffata",
		"accivettata",
		"acclamata",
		"acclarata",
		"acclimatata",
		"acclusa",
		"accoccata",
		"accoccolata",
		"accoccovata",
		"accodata",
		"accollata",
		"accoltellata",
		"accolta",
		"accomandata",
		"accomiatata",
		"accommiatata",
		"accomodata",
		"accompagnata",
		"accomunata",
		"acconciata",
		"acconigliata",
		"accontata",
		"accontentata",
		"accoppata",
		"accoppiata",
		"accorata",
		"accorciata",
		"accorcita",
		"accordata",
		"accordellata",
		"accorpata",
		"accorta",
		"accosciata",
		"accostata",
		"accostumata",
		"accotonata",
		"accottimata",
		"accovacciata",
		"accovata",
		"accovonata",
		"accozzata",
		"accreditata",
		"accresciuta",
		"accrespata",
		"accucciata",
		"accucciolata",
		"accudita",
		"acculata",
		"acculturata",
		"accumulata",
		"accumunata",
		"accusata",
		"acetificata",
		"acetilata",
		"acetita",
		"acidata",
		"acidificata",
		"acidulata",
		"acquadernata",
		"acquarellata",
		"acquartierata",
		"acquata",
		"acquattata",
		"acquerellata",
		"acquetata",
		"acquietata",
		"acquisita",
		"acquistata",
		"acromatizzata",
		"acuita",
		"acuminata",
		"acutizzata",
		"adacquata",
		"adagiata",
		"adattata",
		"addaziata",
		"addebbiata",
		"addebitata",
		"addecimata",
		"addensata",
		"addentata",
		"addentellata",
		"addentrata",
		"addestrata",
		"addetta",
		"addiacciata",
		"addimandata",
		"addimesticata",
		"addimorata",
		"addimostrata",
		"addipanata",
		"addirizzata",
		"additata",
		"additivata",
		"addizionata",
		"addobbata",
		"addocilita",
		"addogliata",
		"addolcata",
		"addolciata",
		"addolcita",
		"addolorata",
		"addomandata",
		"addomesticata",
		"addoppiata",
		"addormentata",
		"addossata",
		"addotta",
		"addottorata",
		"addottrinata",
		"addrizzata",
		"adduata",
		"addugliata",
		"adeguata",
		"adempita",
		"adempiuta",
		"adequata",
		"aderizzata",
		"adescata",
		"adibita",
		"adirata",
		"adita",
		"adiuvata",
		"adizzata",
		"adocchiata",
		"adombrata",
		"adonata",
		"adonestata",
		"adontata",
		"adoperata",
		"adoprata",
		"adorata",
		"adornata",
		"adottata",
		"adsorbita",
		"aduggiata",
		"adugnata",
		"adulata",
		"adulterata",
		"adunata",
		"adunghiata",
		"adusata",
		"aerata",
		"aereata",
		"aerotrainata",
		"aerotrasportata",
		"affabulata",
		"affaccendata",
		"affacchinata",
		"affacciata",
		"affagottata",
		"affaldata",
		"affamata",
		"affamigliata",
		"affannata",
		"affardellata",
		"affascinata",
		"affastellata",
		"affaticata",
		"affattucchiata",
		"affatturata",
		"affermata",
		"afferrata",
		"affettata",
		"affezionata",
		"affiancata",
		"affiatata",
		"affibbiata",
		"affidata",
		"affienata",
		"affievolita",
		"affigliata",
		"affigurata",
		"affilata",
		"affilettata",
		"affiliata",
		"affinata",
		"affiochita",
		"affiorata",
		"affisata",
		"affissata",
		"affissa",
		"affittata",
		"affittita",
		"afflitta",
		"afflosciata",
		"affocata",
		"affogata",
		"affogliata",
		"affollata",
		"affoltata",
		"affondata",
		"afforcata",
		"afforestata",
		"afforzata",
		"affossata",
		"affralita",
		"affrancata",
		"affranta",
		"affratellata",
		"affrenata",
		"affrenellata",
		"affrescata",
		"affrettata",
		"affrittellata",
		"affrontata",
		"affumata",
		"affumicata",
		"affumigata",
		"affuocata",
		"affusolata",
		"africanizzata",
		"ageminata",
		"agevolata",
		"aggallata",
		"agganciata",
		"aggangherata",
		"aggarbata",
		"aggattonata",
		"aggavignata",
		"aggelata",
		"aggettivata",
		"agghiacciata",
		"agghiadata",
		"agghiaiata",
		"agghindata",
		"aggiaccata",
		"aggiogata",
		"aggiornata",
		"aggirata",
		"aggiucchita",
		"aggiudicata",
		"aggiuntata",
		"aggiunta",
		"aggiustata",
		"agglomerata",
		"agglutinata",
		"aggomitolata",
		"aggottata",
		"aggradita",
		"aggraffata",
		"aggranchiata",
		"aggranchita",
		"aggrandita",
		"aggrappata",
		"aggraticciata",
		"aggravata",
		"aggredita",
		"aggregata",
		"aggrevata",
		"aggricciata",
		"aggrinzata",
		"aggrinzita",
		"aggrommata",
		"aggrondata",
		"aggroppata",
		"aggrottata",
		"aggrovigliata",
		"aggrumata",
		"aggruppata",
		"aggruzzolata",
		"agguagliata",
		"agguantata",
		"agguardata",
		"agguatata",
		"aggueffata",
		"agitata",
		"agognata",
		"agrarizzata",
		"aguatata",
		"agucchiata",
		"agunata",
		"agurata",
		"aguzzata",
		"aitata",
		"aiutata",
		"aizzata",
		"alata",
		"alberata",
		"albergata",
		"alcalinizzata",
		"alchilata",
		"alchimiata",
		"alchimizzata",
		"alcolizzata",
		"alcoolizzata",
		"alenata",
		"alesata",
		"alettata",
		"alfabetata",
		"alfabetizzata",
		"alidita",
		"alienata",
		"alimentata",
		"allacciata",
		"allagata",
		"allappata",
		"allargata",
		"allascata",
		"allattata",
		"alleata",
		"allegata",
		"alleggerita",
		"alleggiata",
		"allegorizzata",
		"alleluiata",
		"allenata",
		"allenita",
		"allentata",
		"allertata",
		"allessata",
		"allestita",
		"allettata",
		"allevata",
		"alleviata",
		"allibata",
		"allibita",
		"allibrata",
		"allicciata",
		"allietata",
		"allindata",
		"allineata",
		"allisa",
		"allocata",
		"allogata",
		"alloggiata",
		"allontanata",
		"allottata",
		"allucchettata",
		"allucciolata",
		"allucinata",
		"allumata",
		"alluminata",
		"alluminiata",
		"allungata",
		"allupata",
		"allusa",
		"alluzzata",
		"alogenata",
		"alonata",
		"alpeggiata",
		"alterata",
		"alternata",
		"alzata",
		"amalgamata",
		"amareggiata",
		"amaricata",
		"amata",
		"ambientata",
		"ambiguata",
		"ambita",
		"americanizzata",
		"amicata",
		"ammaccata",
		"ammaestrata",
		"ammainata",
		"ammalata",
		"ammaliata",
		"ammalinconita",
		"ammaltata",
		"ammanettata",
		"ammanicata",
		"ammanierata",
		"ammanigliata",
		"ammannata",
		"ammannellata",
		"ammannita",
		"ammansata",
		"ammansita",
		"ammantata",
		"ammantellata",
		"ammarata",
		"ammarezzata",
		"ammassata",
		"ammassellata",
		"ammassicciata",
		"ammatassata",
		"ammattonata",
		"ammazzata",
		"ammelmata",
		"ammencita",
		"ammendata",
		"ammennicolata",
		"ammessa",
		"ammetata",
		"ammezzita",
		"amministrata",
		"amminutata",
		"ammirata",
		"ammiserita",
		"ammobiliata",
		"ammodernata",
		"ammodernizzata",
		"ammogliata",
		"ammoinata",
		"ammollata",
		"ammollita",
		"ammonita",
		"ammonticchiata",
		"ammonticellata",
		"ammorbata",
		"ammorbidata",
		"ammorbidita",
		"ammorsata",
		"ammortata",
		"ammortita",
		"ammortizzata",
		"ammorzata",
		"ammosciata",
		"ammoscita",
		"ammostata",
		"ammotinata",
		"ammucchiata",
		"ammulinata",
		"ammusata",
		"ammutata",
		"ammutinata",
		"amnistiata",
		"amoracciata",
		"ampiata",
		"ampliata",
		"amplificata",
		"amputata",
		"anagrammata",
		"analizzata",
		"anamorfizzata",
		"anastomizzata",
		"anatematizzata",
		"anatomizzata",
		"anchilosata",
		"ancisa",
		"ancorata",
		"andatosena",
		"andicappata",
		"anellata",
		"anemizzata",
		"anestetizzata",
		"angariata",
		"anglicizzata",
		"angolata",
		"angosciata",
		"angustiata",
		"animata",
		"annacquata",
		"annaffiata",
		"annasata",
		"annaspata",
		"annaspicata",
		"annebbiata",
		"annegata",
		"annerata",
		"annerita",
		"annessa",
		"annestata",
		"annichilata",
		"annichilita",
		"annidata",
		"annientata",
		"annitrita",
		"annobilita",
		"annodata",
		"annodicchiata",
		"annoiata",
		"annotata",
		"annottata",
		"annottolata",
		"annoverata",
		"annullata",
		"annunciata",
		"annunziata",
		"annusata",
		"annuvolata",
		"anodizzata",
		"anonimizzata",
		"anteceduta",
		"anteposta",
		"antergata",
		"anticheggiata",
		"antichizzata",
		"anticipata",
		"anticonosciuta",
		"antidatata",
		"antiveduta",
		"antivista",
		"antologizzata",
		"antropizzata",
		"antropomorfizzata",
		"aocchiata",
		"aombrata",
		"aonestata",
		"aontata",
		"aperta",
		"apocopata",
		"apologizzata",
		"apostrofata",
		"appaciata",
		"appacificata",
		"appagata",
		"appaiata",
		"appalesata",
		"appallottolata",
		"appaltata",
		"appanettata",
		"appannata",
		"apparata",
		"apparecchiata",
		"apparentata",
		"apparigliata",
		"apparita",
		"appartata",
		"appassionata",
		"appastata",
		"appastellata",
		"appellata",
		"appennellata",
		"appercepita",
		"appertizzata",
		"appesantita",
		"appesita",
		"appesa",
		"appestata",
		"appetita",
		"appezzata",
		"appiacevolita",
		"appianata",
		"appiastrata",
		"appiatata",
		"appiattata",
		"appiattita",
		"appiccata",
		"appiccicata",
		"appiccolita",
		"appiedata",
		"appigionata",
		"appigliata",
		"appinzata",
		"appiombata",
		"appioppata",
		"appisolata",
		"applaudita",
		"applicata",
		"appoderata",
		"appoggiata",
		"appollaiata",
		"appoppata",
		"apportata",
		"appostata",
		"apposta",
		"appratita",
		"appresentata",
		"appresa",
		"appressata",
		"apprestata",
		"apprettata",
		"apprezzata",
		"approcciata",
		"approfittata",
		"approfondata",
		"approfondita",
		"approntata",
		"appropinquata",
		"appropriata",
		"approssimata",
		"approvata",
		"approvisionata",
		"approvvigionata",
		"appruata",
		"appulcrata",
		"appuntata",
		"appuntellata",
		"appuntita",
		"appurata",
		"appuzzata",
		"arabescata",
		"arabizzata",
		"arata",
		"arbitrata",
		"arborata",
		"arcaizzata",
		"arcata",
		"architettata",
		"archiviata",
		"arcuata",
		"ardita",
		"areata",
		"argentata",
		"arginata",
		"argomentata",
		"arguita",
		"arianizzata",
		"arieggiata",
		"armata",
		"armonizzata",
		"aromatizzata",
		"arpeggiata",
		"arpionata",
		"arponata",
		"arrabattata",
		"arraffata",
		"arraffiata",
		"arrandellata",
		"arrangiata",
		"arrapata",
		"arrapinata",
		"arrappata",
		"arrazzata",
		"arrecata",
		"arredata",
		"arreggimentata",
		"arrembata",
		"arrenata",
		"arresisa",
		"arresa",
		"arrestata",
		"arretrata",
		"arricchita",
		"arricciata",
		"arricciolata",
		"arriffata",
		"arringata",
		"arrischiata",
		"arrisicata",
		"arrisa",
		"arrocata",
		"arroccata",
		"arrochita",
		"arrogata",
		"arrolata",
		"arroncata",
		"arronzata",
		"arrosata",
		"arrossata",
		"arrostata",
		"arrostita",
		"arrotata",
		"arrotolata",
		"arrotondata",
		"arrovellata",
		"arroventata",
		"arroventita",
		"arrovesciata",
		"arrubinata",
		"arruffata",
		"arruffianata",
		"arrugginita",
		"arruncigliata",
		"arruolata",
		"arruvidita",
		"arsicciata",
		"arsa",
		"artefatta",
		"articolata",
		"artigliata",
		"ascesa",
		"asciata",
		"asciolvuta",
		"asciugata",
		"ascoltata",
		"ascosa",
		"ascosta",
		"ascritta",
		"asfaltata",
		"asfissiata",
		"aspersa",
		"aspettata",
		"aspirata",
		"asportata",
		"aspreggiata",
		"assaettata",
		"assaggiata",
		"assalita",
		"assaltata",
		"assaporata",
		"assaporita",
		"assassinata",
		"assecondata",
		"assecurata",
		"assediata",
		"asseggiata",
		"assegnata",
		"assembiata",
		"assemblata",
		"assembrata",
		"assemprata",
		"assentata",
		"asserita",
		"asserragliata",
		"asservita",
		"assestata",
		"assetata",
		"assettata",
		"asseverata",
		"assibilata",
		"assicurata",
		"assiderata",
		"assiemata",
		"assiepata",
		"assillata",
		"assimigliata",
		"assimilata",
		"assiomatizzata",
		"assisa",
		"assistita",
		"associata",
		"assodata",
		"assoggettata",
		"assolcata",
		"assoldata",
		"assolta",
		"assolutizzata",
		"assomata",
		"assommata",
		"assonata",
		"assonnata",
		"assopita",
		"assorbita",
		"assordata",
		"assordita",
		"assortita",
		"assottigliata",
		"assuefatta",
		"assunta",
		"asteggiata",
		"astenuta",
		"astersa",
		"astratta",
		"astretta",
		"atomizzata",
		"atrofizzata",
		"atrovata",
		"attaccata",
		"attagliata",
		"attanagliata",
		"attardata",
		"attediata",
		"atteggiata",
		"attempata",
		"attendata",
		"attentata",
		"attenuata",
		"attenuta",
		"attergata",
		"atterrata",
		"atterrita",
		"atterzata",
		"attesa",
		"attestata",
		"atticizzata",
		"attillata",
		"attinta",
		"attirata",
		"attivata",
		"attivizzata",
		"attizzata",
		"attorcigliata",
		"attorniata",
		"attorta",
		"attoscata",
		"attossicata",
		"attraccata",
		"attrappita",
		"attratta",
		"attraversata",
		"attrezzata",
		"attribuita",
		"attristata",
		"attristita",
		"attruppata",
		"attualizzata",
		"attuata",
		"attuffata",
		"attutata",
		"attutita",
		"auggiata",
		"augumentata",
		"augurata",
		"aulita",
		"aumentata",
		"aunghiata",
		"ausata",
		"auscultata",
		"auspicata",
		"autenticata",
		"autentificata",
		"autoaccusata",
		"autoaffondata",
		"autoalimentata",
		"autoassolta",
		"autocandidata",
		"autocensurata",
		"autocitata",
		"autocommiserata",
		"autoconsumata",
		"autoconvinta",
		"autodefinita",
		"autodenunciata",
		"autodistrutta",
		"autofinanziata",
		"autogestita",
		"autogovernata",
		"autografata",
		"autoincensata",
		"autointersecata",
		"autoinvitata",
		"autolesionata",
		"autolimitata",
		"automaticizzata",
		"automatizzata",
		"automotivata",
		"autonominata",
		"autoproclamata",
		"autoprodotta",
		"autoprotetta",
		"autopubblicata",
		"autopubblicizzata",
		"autoregolamentata",
		"autoregolata",
		"autoridotta",
		"autoriparata",
		"autorizzata",
		"autosomministrata",
		"autosostenuta",
		"autosuggestionata",
		"autotassata",
		"autotrapiantata",
		"autotrasportata",
		"autovalutata",
		"avallata",
		"avampata",
		"avanzata",
		"avariata",
		"avinta",
		"aviolanciata",
		"aviotrasportata",
		"avocata",
		"avolterata",
		"avulsa",
		"avutacela",
		"avuta",
		"avvalorata",
		"avvalsa",
		"avvantaggiata",
		"avvelata",
		"avvelenata",
		"avventata",
		"avventurata",
		"avverata",
		"avversata",
		"avvertita",
		"avvezzata",
		"avviata",
		"avvicendata",
		"avvicinata",
		"avvignata",
		"avvilita",
		"avviluppata",
		"avvinata",
		"avvinchiata",
		"avvinghiata",
		"avvinta",
		"avvisata",
		"avvistata",
		"avvitata",
		"avviticchiata",
		"avvitita",
		"avvivata",
		"avvolta",
		"avvoltolata",
		"aziendalizzata",
		"azionata",
		"azotata",
		"azzannata",
		"azzardata",
		"azzeccata",
		"azzerata",
		"azzimata",
		"azzittata",
		"azzittita",
		"azzoppata",
		"azzoppita",
		"azzuffata",
		"azzurrata",
		"bacata",
		"baccagliata",
		"bacchettata",
		"bacchiata",
		"baciata",
		"badata",
		"bagnata",
		"baipassata",
		"balbettata",
		"balcanizzata",
		"ballata",
		"baloccata",
		"balzata",
		"banalizzata",
		"bancata",
		"bandita",
		"bannata",
		"baraccata",
		"barattata",
		"barbarizzata",
		"barcamenata",
		"bardata",
		"barellata",
		"barrata",
		"barricata",
		"basata",
		"basciata",
		"basculata",
		"bassata",
		"bastata",
		"bastionata",
		"bastita",
		"bastonata",
		"battezzata",
		"battuta",
		"bazzicata",
		"beatificata",
		"beata",
		"beccata",
		"beccheggiata",
		"becchettata",
		"beffata",
		"beffeggiata",
		"bendata",
		"benedetta",
		"beneficata",
		"benvoluta",
		"berlusconizzata",
		"bersagliata",
		"bestemmiata",
		"bevuta",
		"biadata",
		"bianchettata",
		"bianchita",
		"biascicata",
		"biasimata",
		"biasmata",
		"bidonata",
		"biennalizzata",
		"biforcata",
		"bigiata",
		"bilanciata",
		"binata",
		"bindolata",
		"biodegradata",
		"biografata",
		"bipartita",
		"bisbigliata",
		"biscottata",
		"bisecata",
		"bisellata",
		"bisognata",
		"bissata",
		"bistrata",
		"bistrattata",
		"bitumata",
		"bituminata",
		"blandita",
		"bleffata",
		"blindata",
		"bloccata",
		"bobinata",
		"boccheggiata",
		"bocciata",
		"boicottata",
		"bollata",
		"bollita",
		"bombardata",
		"bombata",
		"bonderizzata",
		"bonificata",
		"bootata",
		"borbottata",
		"bordata",
		"boriata",
		"borrata",
		"borseggiata",
		"braccata",
		"bracciata",
		"bramata",
		"bramita",
		"brancicata",
		"brandeggiata",
		"brandita",
		"brasata",
		"bravata",
		"brevettata",
		"breviata",
		"brillantata",
		"brillata",
		"brinata",
		"broccata",
		"brocciata",
		"broccolata",
		"brontolata",
		"bronzata",
		"brucata",
		"bruciacchiata",
		"bruciata",
		"brunita",
		"bruscata",
		"bruschinata",
		"brutalizzata",
		"bruttata",
		"bucata",
		"bucherellata",
		"bufata",
		"buffata",
		"bufferizzata",
		"buggerata",
		"bugnata",
		"bulicata",
		"bulinata",
		"bullettata",
		"bullonata",
		"burattata",
		"burlata",
		"burocratizzata",
		"burrificata",
		"buscata",
		"buttata",
		"butterata",
		"bypassata",
		"cablata",
		"cabrata",
		"cacata",
		"cacciata",
		"cadenzata",
		"cadmiata",
		"caducata",
		"cagata",
		"caggiata",
		"cagionata",
		"cagliata",
		"calafatata",
		"calamitata",
		"calandrata",
		"calata",
		"calcata",
		"calciata",
		"calcificata",
		"calcolata",
		"caldeggiata",
		"calettata",
		"calibrata",
		"calmata",
		"calmierata",
		"calpestata",
		"calumata",
		"calunniata",
		"calzata",
		"cambiata",
		"camerata",
		"campionata",
		"campita",
		"camuffata",
		"canalizzata",
		"cancellata",
		"cancerizzata",
		"candeggiata",
		"candidata",
		"candita",
		"canforata",
		"cangiata",
		"cannata",
		"canneggiata",
		"cannibalizzata",
		"cannoneggiata",
		"canonizzata",
		"cantata",
		"canterellata",
		"canticchiata",
		"cantilenata",
		"canzonata",
		"caolinizzata",
		"capacitata",
		"capeggiata",
		"capillarizzata",
		"capitalizzata",
		"capitanata",
		"capitaneggiata",
		"capita",
		"capitozzata",
		"capivolta",
		"caponata",
		"capotata",
		"capottata",
		"capovolta",
		"capponata",
		"captata",
		"caramellata",
		"caramellizzata",
		"caratata",
		"caratterizzata",
		"carbonizzata",
		"carbossilata",
		"carburata",
		"carcata",
		"carcerata",
		"cardata",
		"carenata",
		"carezzata",
		"cariata",
		"caricata",
		"caricaturata",
		"caricaturizzata",
		"carotata",
		"carpionata",
		"carpita",
		"carreggiata",
		"carrozzata",
		"cartavetrata",
		"carteggiata",
		"cartellinata",
		"cartografata",
		"cartolarizzata",
		"cartonata",
		"cascolata",
		"cassata",
		"cassa",
		"castigata",
		"castrata",
		"casualizzata",
		"catabolizzata",
		"catalizzata",
		"catalogata",
		"catapultata",
		"catechizzata",
		"categorizzata",
		"cateterizzata",
		"catramata",
		"cattolicizzata",
		"catturata",
		"causata",
		"cautelata",
		"cauterizzata",
		"cauzionata",
		"cavalcata",
		"cavatasela",
		"cavata",
		"cazzata",
		"cazziata",
		"cazzottata",
		"cedrata",
		"ceduta",
		"celata",
		"celebrata",
		"cellofanata",
		"cementata",
		"cementificata",
		"cennata",
		"censita",
		"censurata",
		"centellata",
		"centellinata",
		"centimetrata",
		"centinata",
		"centralizzata",
		"centrata",
		"centrifugata",
		"centuplicata",
		"cerata",
		"cercata",
		"cerchiata",
		"cernuta",
		"certificata",
		"cesellata",
		"cessata",
		"cestinata",
		"cheratinizzata",
		"chetata",
		"chiamata",
		"chiappata",
		"chiarificata",
		"chiarita",
		"chiaroscurata",
		"chiavata",
		"chiazzata",
		"chiesta",
		"chilificata",
		"chilometrata",
		"chimificata",
		"chinata",
		"chinizzata",
		"chiodata",
		"chiosata",
		"chiusa",
		"choccata",
		"ciancicata",
		"cianfrinata",
		"cianfrugliata",
		"ciangottata",
		"ciattata",
		"cibata",
		"cicatrizzata",
		"ciccata",
		"cicchettata",
		"ciclizzata",
		"ciclostilata",
		"cifrata",
		"cilindrata",
		"cimata",
		"cimentata",
		"cincischiata",
		"cinematografata",
		"cintata",
		"cinta",
		"cioncata",
		"ciondolata",
		"circolata",
		"circoncinta",
		"circoncisa",
		"circondata",
		"circondotta",
		"circonflessa",
		"circonfluita",
		"circonfusa",
		"circonscritta",
		"circonvenuta",
		"circoscritta",
		"circostanziata",
		"circuita",
		"circumcinta",
		"circumnavigata",
		"citata",
		"ciucciata",
		"ciurmata",
		"civettata",
		"civilizzata",
		"clamata",
		"classata",
		"classicizzata",
		"classificata",
		"cliccata",
		"climatizzata",
		"clivata",
		"clonata",
		"cloroformizzata",
		"clorurata",
		"clusterizzata",
		"co-diretta",
		"coacervata",
		"coadiuvata",
		"coagulata",
		"coalizzata",
		"coartata",
		"coccolata",
		"codificata",
		"coeditata",
		"coesistita",
		"cofinanziata",
		"cofirmata",
		"cofondata",
		"cogestita",
		"cogitata",
		"coglionata",
		"cognosciuta",
		"coibentata",
		"coincisa",
		"cointeressata",
		"cointestata",
		"coinvolta",
		"cokificata",
		"colata",
		"colettata",
		"collassata",
		"collaudata",
		"collazionata",
		"collegata",
		"collettivizzata",
		"collezionata",
		"collimata",
		"colliquata",
		"collisa",
		"collocata",
		"colluttata",
		"colmata",
		"colonizzata",
		"colorata",
		"colorita",
		"colorizzata",
		"colpevolizzata",
		"colpita",
		"coltellata",
		"coltivata",
		"colta",
		"coltrata",
		"comandata",
		"combattuta",
		"combinata",
		"comburuta",
		"comicizzata",
		"cominciata",
		"commemorata",
		"commendata",
		"commensurata",
		"commentata",
		"commercializzata",
		"commessa",
		"comminata",
		"commiserata",
		"commissariata",
		"commissionata",
		"commisurata",
		"commossa",
		"commutata",
		"comodata",
		"compaginata",
		"comparita",
		"compartimentalizzata",
		"compartita",
		"compassionata",
		"compatibilizzata",
		"compatita",
		"compattata",
		"compendiata",
		"compenetrata",
		"compensata",
		"comperata",
		"compiaciuta",
		"compianta",
		"compilata",
		"compitata",
		"compiuta",
		"complessata",
		"complessificata",
		"complessa",
		"completata",
		"complicata",
		"complimentata",
		"comportata",
		"compostata",
		"composta",
		"comprata",
		"compravenduta",
		"compresa",
		"compressa",
		"compromessa",
		"comprovata",
		"compulsata",
		"compunta",
		"computata",
		"computerizzata",
		"comunicata",
		"comunistizzata",
		"concatenata",
		"conceduta",
		"concelebrata",
		"concentrata",
		"concepita",
		"concertata",
		"concessa",
		"concettata",
		"concettualizzata",
		"conchiusa",
		"conciata",
		"conciliata",
		"concimata",
		"concitata",
		"conclamata",
		"conclusa",
		"concordata",
		"concotta",
		"concretata",
		"concretizzata",
		"conculcata",
		"concupita",
		"condannata",
		"condensata",
		"condita",
		"condivisa",
		"condizionata",
		"condoluta",
		"condonata",
		"condotta",
		"confatta",
		"confederata",
		"conferita",
		"confermata",
		"confessata",
		"confettata",
		"confezionata",
		"conficcata",
		"confidata",
		"configurata",
		"confinata",
		"confinta",
		"confiscata",
		"confitta",
		"conformata",
		"confortata",
		"confricata",
		"confrontata",
		"confusa",
		"confutata",
		"congedata",
		"congegnata",
		"congelata",
		"congestionata",
		"congetturata",
		"congiunta",
		"conglobata",
		"conglomerata",
		"conglutinata",
		"congratulata",
		"congregata",
		"conguagliata",
		"coniata",
		"coniugata",
		"connaturata",
		"connessa",
		"connotata",
		"connumerata",
		"conosciuta",
		"conquistata",
		"consacrata",
		"consapevolizzata",
		"consegnata",
		"conseguita",
		"consentita",
		"conservata",
		"considerata",
		"consigliata",
		"consistita",
		"consociata",
		"consolata",
		"consolidata",
		"consorziata",
		"consparsa",
		"conspersa",
		"constatata",
		"constretta",
		"construita",
		"consultata",
		"consumata",
		"consunta",
		"contabilizzata",
		"contagiata",
		"containerizzata",
		"contaminata",
		"contata",
		"contattata",
		"conteggiata",
		"contemperata",
		"contemplata",
		"contentata",
		"contenuta",
		"contesa",
		"contestata",
		"contestualizzata",
		"contingentata",
		"continuata",
		"contornata",
		"contorta",
		"contrabbandata",
		"contraccambiata",
		"contraddetta",
		"contraddistinta",
		"contradetta",
		"contraffatta",
		"contrappesata",
		"contrapposta",
		"contrappuntata",
		"contrariata",
		"contrassegnata",
		"contrastata",
		"contrata",
		"contrattaccata",
		"contrattata",
		"contratta",
		"contravvalsa",
		"contristata",
		"controbattuta",
		"controbilanciata",
		"controdatata",
		"controfirmata",
		"controindicata",
		"controllata",
		"controminata",
		"contronotata",
		"controproposta",
		"controprovata",
		"controquerelata",
		"controsoffittata",
		"controstampata",
		"controventata",
		"conturbata",
		"contusa",
		"convalidata",
		"convenuta",
		"convenzionata",
		"convertita",
		"convinta",
		"convitata",
		"convocata",
		"convogliata",
		"convolta",
		"coobata",
		"cooptata",
		"coordinata",
		"coperchiata",
		"coperta",
		"copiaincollata",
		"copiata",
		"copolimerizzata",
		"coppellata",
		"coprodotta",
		"corazzata",
		"corbellata",
		"corcata",
		"cordonata",
		"coreografata",
		"coricata",
		"cornificata",
		"coronata",
		"corredata",
		"correlata",
		"corresponsabilizzata",
		"corretta",
		"corricchiata",
		"corrisposta",
		"corroborata",
		"corrosa",
		"corrotta",
		"corrucciata",
		"corrugata",
		"corsa",
		"corteata",
		"corteggiata",
		"cortocircuitata",
		"coruscata",
		"cosata",
		"coscritta",
		"cosparsa",
		"cospersa",
		"costatata",
		"costeggiata",
		"costellata",
		"costernata",
		"costicchiata",
		"costipata",
		"costituita",
		"costituzionalizzata",
		"costretta",
		"costruita",
		"costudita",
		"cotonata",
		"cotta",
		"covata",
		"coventrizzata",
		"coverchiata",
		"craccata",
		"creata",
		"creduta",
		"cremata",
		"crepata",
		"cresciuta",
		"cresimata",
		"crespata",
		"criminalizzata",
		"crioconcentrata",
		"criptata",
		"cristallizzata",
		"cristianizzata",
		"criticata",
		"crittata",
		"crittografata",
		"crivellata",
		"crocchiata",
		"crocefissa",
		"crocefitta",
		"crocifissa",
		"crocifitta",
		"crogiolata",
		"cromata",
		"cronicizzata",
		"cronometrata",
		"crostata",
		"crucciata",
		"crucifissa",
		"crucifitta",
		"cuccata",
		"cucinata",
		"cucita",
		"cullata",
		"cumulata",
		"cuntata",
		"curata",
		"curvata",
		"curvata",
		"custodita",
		"customizzata",
		"damascata",
		"damaschinata",
		"damata",
		"dannata",
		"danneggiata",
		"danzata",
		"dardeggiata",
		"datata",
		"data",
		"dattilografata",
		"dattiloscritta",
		"daziata",
		"deacidificata",
		"deattivata",
		"debbiata",
		"debellata",
		"debilitata",
		"decaffeinata",
		"decaffeinizzata",
		"decalcata",
		"decalcificata",
		"decantata",
		"decapata",
		"decapitata",
		"decappottata",
		"decarbossilata",
		"decarburata",
		"decatizzata",
		"decelerata",
		"decentralizzata",
		"decentrata",
		"decerebrata",
		"decernuta",
		"decespugliata",
		"deciferata",
		"decifrata",
		"decimalizzata",
		"decimata",
		"decisa",
		"declamata",
		"declassata",
		"declassificata",
		"declinata",
		"declorata",
		"decodificata",
		"decolonizzata",
		"decolorata",
		"decompartimentata",
		"decompilata",
		"decomposta",
		"decompressa",
		"deconcentrata",
		"decondizionata",
		"decongelata",
		"decongestionata",
		"decontaminata",
		"decontestualizzata",
		"decontratta",
		"decorata",
		"decorticata",
		"decostruita",
		"decrementata",
		"decretata",
		"decriminalizzata",
		"decriptata",
		"decrittata",
		"decuplicata",
		"decurtata",
		"dedicata",
		"dedotta",
		"defacciata",
		"defalcata",
		"defascistizzata",
		"defecata",
		"defenestrata",
		"deferita",
		"defilata",
		"definita",
		"defiscalizzata",
		"defitta",
		"deflazionata",
		"deflemmata",
		"deflorata",
		"defogliata",
		"defoliata",
		"deforestata",
		"deformata",
		"defosforata",
		"defosforilata",
		"deframmentata",
		"defraudata",
		"degassata",
		"degassificata",
		"deglutita",
		"degnata",
		"degradata",
		"degustata",
		"deidratata",
		"deidrogenata",
		"deificata",
		"deindicizzata",
		"deindustrializzata",
		"deionizzata",
		"delegata",
		"delegificata",
		"delegittimata",
		"delibata",
		"deliberata",
		"delimitata",
		"delineata",
		"delirata",
		"deliziata",
		"delocalizzata",
		"delucidata",
		"delusa",
		"demagnetizzata",
		"demandata",
		"demanializzata",
		"demarcata",
		"demeritata",
		"demersa",
		"demetallizzata",
		"demilitarizzata",
		"demineralizzata",
		"demistificata",
		"demitizzata",
		"democratizzata",
		"demodulata",
		"demolita",
		"demoltiplicata",
		"demonetata",
		"demonetizzata",
		"demonizzata",
		"demoralizzata",
		"demorsa",
		"demotivata",
		"denaturalizzata",
		"denaturata",
		"denazificata",
		"denazionalizzata",
		"denicotinizzata",
		"denigrata",
		"denitrificata",
		"denocciolata",
		"denominata",
		"denotata",
		"dentellata",
		"denuclearizzata",
		"denudata",
		"denunciata",
		"denunziata",
		"deodorata",
		"deossidata",
		"deossigenata",
		"deostruita",
		"depauperata",
		"depenalizzata",
		"depennata",
		"depilata",
		"depinta",
		"depistata",
		"deplorata",
		"depolarizzata",
		"depolimerizzata",
		"depoliticizzata",
		"depolverizzata",
		"deportata",
		"depositata",
		"deposta",
		"depotenziata",
		"depravata",
		"deprecata",
		"depredata",
		"depressa",
		"depressurizzata",
		"deprezzata",
		"deprivata",
		"deprotonata",
		"depulsa",
		"depurata",
		"dequalificata",
		"deratizzata",
		"derattizzata",
		"dereferenziata",
		"deregolamentata",
		"deregolata",
		"derequisita",
		"deresponsabilizzata",
		"derisa",
		"derubata",
		"derubricata",
		"desacralizzata",
		"desalata",
		"desalinizzata",
		"descolarizzata",
		"descritta",
		"desecretata",
		"desegretata",
		"deselezionata",
		"desensibilizzata",
		"desessualizzata",
		"desiata",
		"desiderata",
		"designata",
		"desinata",
		"desirata",
		"desolata",
		"desolforata",
		"desonorizzata",
		"desorbita",
		"desossidata",
		"desquamata",
		"destabilizzata",
		"destagionalizzata",
		"destalinizzata",
		"destatalizzata",
		"destatizzata",
		"destata",
		"destinata",
		"destituita",
		"destoricizzata",
		"destreggiata",
		"destrutta",
		"destrutturata",
		"desunta",
		"detassata",
		"detenuta",
		"deteriorata",
		"determinata",
		"detersa",
		"detestata",
		"detonata",
		"detorta",
		"detossificata",
		"detratta",
		"detronizzata",
		"dettagliata",
		"dettata",
		"detta",
		"deturpata",
		"deumidificata",
		"devastata",
		"deventata",
		"deviata",
		"deviscerata",
		"devitalizzata",
		"devitaminizzata",
		"devoluta",
		"dezippata",
		"diaframmata",
		"diagnosticata",
		"diagonalizzata",
		"diagrammata",
		"dializzata",
		"dialogata",
		"dialogizzata",
		"diazotata",
		"dibattuta",
		"diboscata",
		"dichiarata",
		"diesata",
		"diesizzata",
		"difesa",
		"diffamata",
		"differita",
		"diffidata",
		"diffranta",
		"diffratta",
		"diffusa",
		"digerita",
		"digitalizzata",
		"digitata",
		"digiunta",
		"digrassata",
		"digrignata",
		"digrossata",
		"dilacerata",
		"dilaniata",
		"dilapidata",
		"dilatata",
		"dilavata",
		"dilazionata",
		"dileggiata",
		"dileguata",
		"dilettata",
		"diletta",
		"diliscata",
		"dilucidata",
		"diluita",
		"dilungata",
		"dimagrata",
		"dimandata",
		"dimenata",
		"dimensionata",
		"dimenticata",
		"dimerizzata",
		"dimessa",
		"dimezzata",
		"diminuita",
		"dimissionata",
		"dimostrata",
		"dimunta",
		"dinamizzata",
		"dinoccata",
		"dipanata",
		"dipelata",
		"dipinta",
		"diplomata",
		"diposta",
		"diradata",
		"diramata",
		"diretta",
		"direzionata",
		"dirimuta",
		"diroccata",
		"dirottata",
		"dirotta",
		"dirozzata",
		"disabilitata",
		"disabituata",
		"disaccentata",
		"disaccoppiata",
		"disaccordata",
		"disacerbata",
		"disacidata",
		"disacidificata",
		"disacidita",
		"disaerata",
		"disaffezionata",
		"disaggregata",
		"disalberata",
		"disallineata",
		"disamata",
		"disambiguata",
		"disaminata",
		"disamorata",
		"disancorata",
		"disanimata",
		"disappannata",
		"disapplicata",
		"disappresa",
		"disapprovata",
		"disarcionata",
		"disarmata",
		"disarticolata",
		"disascosta",
		"disassemblata",
		"disassuefatta",
		"disatomizzata",
		"disattesa",
		"disattivata",
		"disattrezzata",
		"disavvezzata",
		"disboscata",
		"disbrigata",
		"discacciata",
		"discalzata",
		"discantata",
		"discaricata",
		"discernuta",
		"discesa",
		"disceverata",
		"dischiesta",
		"dischiusa",
		"discinta",
		"disciolta",
		"disciplinata",
		"discolorata",
		"discolpata",
		"discommessa",
		"discompagnata",
		"discomposta",
		"disconclusa",
		"disconfitta",
		"discongiunta",
		"disconnessa",
		"disconosciuta",
		"discoperta",
		"discordata",
		"discoscesa",
		"discostata",
		"discreditata",
		"discresciuta",
		"discriminata",
		"discritta",
		"discucita",
		"discuoiata",
		"discussa",
		"disdegnata",
		"disdettata",
		"disdetta",
		"diseccata",
		"diseccitata",
		"diseducata",
		"disegnata",
		"diserbata",
		"diseredata",
		"disertata",
		"diserta",
		"disfatta",
		"disgelata",
		"disgiunta",
		"disgraziata",
		"disgregata",
		"disgustata",
		"disidentificata",
		"disiderata",
		"disidratata",
		"disillusa",
		"disimballata",
		"disimparata",
		"disimpegnata",
		"disimpressa",
		"disincagliata",
		"disincantata",
		"disincentivata",
		"disincrostata",
		"disindustrializzata",
		"disinfestata",
		"disinfettata",
		"disinflazionata",
		"disinformata",
		"disingannata",
		"disingranata",
		"disinibita",
		"disinnamorata",
		"disinnescata",
		"disinnestata",
		"disinquinata",
		"disinserita",
		"disinstallata",
		"disintasata",
		"disintegrata",
		"disinteressata",
		"disintesa",
		"disintossicata",
		"disinvestita",
		"disinvolta",
		"disistimata",
		"dislocata",
		"dismessa",
		"disobbedita",
		"disobbligata",
		"disonorata",
		"disordinata",
		"disorganizzata",
		"disorientata",
		"disormeggiata",
		"disossata",
		"disossidata",
		"disostruita",
		"disotterrata",
		"disparita",
		"dispensata",
		"dispenta",
		"disperduta",
		"dispersa",
		"dispesa",
		"dispiegata",
		"dispinta",
		"dispogliata",
		"disposta",
		"dispregiata",
		"disprezzata",
		"dispromessa",
		"disproporzionata",
		"disputata",
		"disqualificata",
		"disrotta",
		"dissacrata",
		"dissalata",
		"dissaldata",
		"dissanguata",
		"dissecata",
		"disseccata",
		"disselciata",
		"dissellata",
		"disseminata",
		"dissepolta",
		"disseppellita",
		"dissequestrata",
		"disserrata",
		"dissestata",
		"dissetata",
		"dissezionata",
		"dissigillata",
		"dissimulata",
		"dissipata",
		"dissociata",
		"dissodata",
		"dissolta",
		"dissomigliata",
		"dissotterrata",
		"dissuasa",
		"dissuggellata",
		"distaccata",
		"distanziata",
		"distesa",
		"distillata",
		"distinta",
		"distolta",
		"distorta",
		"distratta",
		"distretta",
		"distribuita",
		"districata",
		"distrigata",
		"distrutta",
		"disturbata",
		"disubbidita",
		"disumanata",
		"disumanizzata",
		"disunita",
		"disusata",
		"disveduta",
		"disvelata",
		"disvestita",
		"disviata",
		"disvista",
		"disvolta",
		"disvoluta",
		"dittongata",
		"divallata",
		"divaricata",
		"divelta",
		"diversificata",
		"divertita",
		"divezzata",
		"divinata",
		"divincolata",
		"divinizzata",
		"divisa",
		"divolta",
		"divorata",
		"divorziata",
		"divulgata",
		"documentata",
		"dogata",
		"dogmatizzata",
		"dolcificata",
		"dollarizzata",
		"dolorata",
		"doluta",
		"domandata",
		"domata",
		"domesticata",
		"domiciliata",
		"dominata",
		"donata",
		"dondolata",
		"dopata",
		"doppiata",
		"dorata",
		"dormitoca",
		"dosata",
		"dotata",
		"dovuta",
		"dragata",
		"drammatizzata",
		"drappeggiata",
		"drenata",
		"dribblata",
		"drizzata",
		"drogata",
		"dugliata",
		"duplicata",
		"duramificata",
		"ebraizzata",
		"ecceduta",
		"eccepita",
		"eccettuata",
		"eccitata",
		"echeggiata",
		"eclissata",
		"economizzata",
		"edificata",
		"editata",
		"edotta",
		"educata",
		"edulcorata",
		"effettuata",
		"efficientata",
		"effigiata",
		"effinta",
		"effluita",
		"effusa",
		"egemonizzata",
		"eguagliata",
		"eiettata",
		"elaborata",
		"elargita",
		"elasticizzata",
		"elementarizzata",
		"elemosinata",
		"elencata",
		"eletta",
		"elettrificata",
		"elettrizzata",
		"elettrocoagulata",
		"elettrolizzata",
		"elevata",
		"eliminata",
		"elisa",
		"elitrasportata",
		"ellenizzata",
		"elogiata",
		"elucidata",
		"elucubrata",
		"eluita",
		"elusa",
		"emanata",
		"emancipata",
		"emarginata",
		"embricata",
		"emendata",
		"emessa",
		"emozionata",
		"empita",
		"empiuta",
		"emulata",
		"emulsionata",
		"emunta",
		"encomiata",
		"endocitata",
		"energizzata",
		"enfatizzata",
		"enfiata",
		"entusiasmata",
		"enucleata",
		"enumerata",
		"enunciata",
		"epicureggiata",
		"epurata",
		"equalizzata",
		"equilibrata",
		"equipaggiata",
		"equiparata",
		"eradicata",
		"erasa",
		"ereditata",
		"eretta",
		"erogata",
		"eroicizzata",
		"erosa",
		"erotizzata",
		"erpicata",
		"ersa",
		"erudita",
		"eruttata",
		"esacerbata",
		"esagerata",
		"esagitata",
		"esalata",
		"esaltata",
		"esaminata",
		"esasperata",
		"esaudita",
		"esaurita",
		"esautorata",
		"esborsata",
		"esclusa",
		"escogitata",
		"escomiata",
		"escoriata",
		"escossa",
		"escussa",
		"esecrata",
		"esecutata",
		"eseguita",
		"esemplificata",
		"esentata",
		"esercitata",
		"esfoliata",
		"esibita",
		"esilarata",
		"esiliata",
		"esimuta",
		"esitata",
		"esonerata",
		"esorbitata",
		"esorcizzata",
		"esortata",
		"espansa",
		"esparsa",
		"esperimentata",
		"esperita",
		"espettorata",
		"espiantata",
		"espiata",
		"espirata",
		"espletata",
		"esplicata",
		"esplicitata",
		"esplorata",
		"esplosa",
		"esportata",
		"esposta",
		"espressa",
		"espropriata",
		"espugnata",
		"espulsa",
		"espunta",
		"espurgata",
		"essiccata",
		"essuta",
		"estasiata",
		"estenuata",
		"esterificata",
		"esteriorizzata",
		"esterminata",
		"esternalizzata",
		"esternata",
		"estesa",
		"estimata",
		"estinta",
		"estirpata",
		"estivata",
		"estorta",
		"estradata",
		"estraniata",
		"estrapolata",
		"estratta",
		"estremizzata",
		"estrinsecata",
		"estromessa",
		"estrusa",
		"estubata",
		"esulcerata",
		"esultata",
		"esumata",
		"eterificata",
		"eterizzata",
		"eternata",
		"eternizzata",
		"etichettata",
		"etossilata",
		"euforizzata",
		"europeizzata",
		"evacuata",
		"evangelizzata",
		"evasa",
		"eveta",
		"evidenziata",
		"evinta",
		"evirata",
		"eviscerata",
		"evitata",
		"evocata",
		"evolta",
		"evoluta",
		"evulsa",
		"fabbricata",
		"faccettata",
		"facilitata",
		"fagocitata",
		"falciata",
		"falcidiata",
		"fallita",
		"falsata",
		"falsificata",
		"familiarizzata",
		"fanatizzata",
		"fantasticata",
		"farcita",
		"farfugliata",
		"fasciata",
		"fascicolata",
		"fascistizzata",
		"fattacela",
		"fatta",
		"fattorizzata",
		"fatturata",
		"favellata",
		"favoreggiata",
		"favorita",
		"faxata",
		"fecondata",
		"fedecommessa",
		"federalizzata",
		"federata",
		"felicitata",
		"felpata",
		"feltrata",
		"femminilizzata",
		"fenduta",
		"ferita",
		"fermata",
		"fermentata",
		"ferrata",
		"fertilizzata",
		"fessa",
		"fessurata",
		"festeggiata",
		"festonata",
		"feudalizzata",
		"fiaccata",
		"fiammeggiata",
		"fiancheggiata",
		"ficcata",
		"fidanzata",
		"fidata",
		"fidecommessa",
		"fidelizzata",
		"figliata",
		"figurata",
		"filata",
		"filettata",
		"filmata",
		"filosofata",
		"filtrata",
		"finalizzata",
		"finanziata",
		"finitala",
		"finita",
		"finlandizzata",
		"fintata",
		"finta",
		"fiocinata",
		"fiondata",
		"fiorettata",
		"firmata",
		"fiscalizzata",
		"fischiata",
		"fischiettata",
		"fissata",
		"fissionata",
		"fitta",
		"fiutata",
		"flagellata",
		"flaggata",
		"flambata",
		"flangiata",
		"flemmatizzata",
		"flessa",
		"flippata",
		"flottata",
		"fluidificata",
		"fluidizzata",
		"fluorizzata",
		"fluorurata",
		"focalizzata",
		"focheggiata",
		"foderata",
		"foggiata",
		"fognata",
		"folgorata",
		"follata",
		"fomentata",
		"fonata",
		"fondata",
		"foracchiata",
		"foraggiata",
		"forata",
		"forestata",
		"forfettizzata",
		"forgiata",
		"formalizzata",
		"formata",
		"formattata",
		"formilata",
		"formulata",
		"fornita",
		"fortificata",
		"forviata",
		"forwardata",
		"forzata",
		"fosfatata",
		"fosforata",
		"fosforilata",
		"fossilizzata",
		"fotocomposta",
		"fotocopiata",
		"fotografata",
		"fottuta",
		"fracassata",
		"fraintesa",
		"framessa",
		"frammentata",
		"frammessa",
		"frammezzata",
		"frammischiata",
		"franceseggiata",
		"francesizzata",
		"frangiata",
		"franta",
		"frantumata",
		"frappata",
		"frapposta",
		"fraseggiata",
		"frastagliata",
		"frastornata",
		"fratturata",
		"frazionata",
		"freddata",
		"fregata",
		"fregiata",
		"frenata",
		"frequentata",
		"fresata",
		"frettata",
		"friendzonata",
		"fritta",
		"frizionata",
		"frodata",
		"frollata",
		"fronteggiata",
		"frugata",
		"fruita",
		"frullata",
		"frusciata",
		"frustata",
		"frustrata",
		"fruttata",
		"fucilata",
		"fucinata",
		"fugata",
		"fuggita",
		"fulminata",
		"fumata",
		"fumigata",
		"funestata",
		"funta",
		"funzionata",
		"fuoriuscita",
		"fuorviata",
		"fusa",
		"fustellata",
		"fustigata",
		"gabbata",
		"gabellata",
		"gallata",
		"gallicizzata",
		"gallonata",
		"galvanizzata",
		"gambizzata",
		"garantita",
		"garnettata",
		"garrotata",
		"garzata",
		"gasata",
		"gassata",
		"gassificata",
		"gazata",
		"gelatinizzata",
		"gelata",
		"gelificata",
		"gemellata",
		"gemicata",
		"geminata",
		"generalizzata",
		"generata",
		"gentrificata",
		"genuflessa",
		"geometrizzata",
		"georeferenziata",
		"gerarchizzata",
		"germanizzata",
		"gestita",
		"gettata",
		"gettonata",
		"ghermita",
		"ghettizzata",
		"ghigliottinata",
		"ghindata",
		"gibollata",
		"gingillata",
		"ginnata",
		"giocata",
		"gioita",
		"gionglata",
		"giovaneggiata",
		"girandolata",
		"girata",
		"giudicata",
		"giulebbata",
		"giuntata",
		"giunta",
		"giuracchiata",
		"giurata",
		"giustapposta",
		"giustificata",
		"giustiziata",
		"glamourizzata",
		"glassata",
		"glissata",
		"globalizzata",
		"gloriata",
		"glorificata",
		"glossata",
		"godronata",
		"goduta",
		"goffrata",
		"gommata",
		"gonfiata",
		"googlata",
		"gottata",
		"governata",
		"gradinata",
		"gradita",
		"gradualizzata",
		"graduata",
		"graffata",
		"graffiata",
		"graffita",
		"graficata",
		"grafitata",
		"gramolata",
		"granagliata",
		"grandinata",
		"granellata",
		"granita",
		"granulata",
		"graticciata",
		"graticolata",
		"gratificata",
		"gratinata",
		"grattata",
		"grattugiata",
		"gravata",
		"graziata",
		"grecheggiata",
		"grecizzata",
		"gremita",
		"gridata",
		"griffata",
		"grigliata",
		"grippata",
		"groccata",
		"grondata",
		"grugata",
		"grugnita",
		"guadagnata",
		"gualcita",
		"guardata",
		"guarita",
		"guarnita",
		"guastata",
		"guatata",
		"guerreggiata",
		"gufata",
		"guidata",
		"gustata",
		"hackerata",
		"handicappata",
		"ibridata",
		"idealizzata",
		"ideata",
		"identificata",
		"ideologizzata",
		"idolatrata",
		"idoleggiata",
		"idratata",
		"idrogenata",
		"idrolizzata",
		"iettata",
		"igienizzata",
		"ignifugata",
		"ignorata",
		"illanguidita",
		"illeggiadrita",
		"illividita",
		"illuminata",
		"illusa",
		"illustrata",
		"imbacuccata",
		"imbaldanzita",
		"imballata",
		"imbalsamata",
		"imbambolata",
		"imbandierata",
		"imbandita",
		"imbarbarita",
		"imbarcata",
		"imbarilata",
		"imbastardita",
		"imbastita",
		"imbattuta",
		"imbavagliata",
		"imbeccata",
		"imbellettata",
		"imbellita",
		"imbestialita",
		"imbestiata",
		"imbevuta",
		"imbiaccata",
		"imbiancata",
		"imbianchita",
		"imbibita",
		"imbiettata",
		"imbiondita",
		"imbizzarrita",
		"imboccata",
		"imbonita",
		"imborghesita",
		"imboscata",
		"imboschita",
		"imbottata",
		"imbottigliata",
		"imbottita",
		"imbozzimata",
		"imbracata",
		"imbracciata",
		"imbragata",
		"imbrancata",
		"imbrattata",
		"imbrecciata",
		"imbrigliata",
		"imbrillantinata",
		"imbroccata",
		"imbrodata",
		"imbrogliata",
		"imbronciata",
		"imbruttita",
		"imbucata",
		"imbudellata",
		"imbullettata",
		"imbullonata",
		"imburrata",
		"imbussolata",
		"imbustata",
		"imbutita",
		"imitata",
		"immagazzinata",
		"immaginata",
		"immalinconita",
		"immatricolata",
		"immedesimata",
		"immersa",
		"immessa",
		"immischiata",
		"immiserita",
		"immobilizzata",
		"immolata",
		"immortalata",
		"immunizzata",
		"immusonita",
		"impaccata",
		"impacchettata",
		"impacciata",
		"impadronita",
		"impaginata",
		"impagliata",
		"impalata",
		"impalcata",
		"impallata",
		"impallinata",
		"impalmata",
		"impaludata",
		"impanata",
		"impaniata",
		"impannata",
		"impantanata",
		"impaperata",
		"impapocchiata",
		"impappinata",
		"imparentata",
		"imparruccata",
		"impartita",
		"impastata",
		"impasticcata",
		"impasticciata",
		"impastocchiata",
		"impastoiata",
		"impataccata",
		"impattata",
		"impaurita",
		"impavesata",
		"impeciata",
		"impedicata",
		"impedita",
		"impegnata",
		"impegolata",
		"impelagata",
		"impellicciata",
		"impennacchiata",
		"impennata",
		"impensierita",
		"impepata",
		"imperlata",
		"impermalita",
		"impermeabilizzata",
		"imperniata",
		"impersonata",
		"impersonificata",
		"impestata",
		"impetrata",
		"impiallacciata",
		"impiantata",
		"impiastrata",
		"impiastricciata",
		"impiccata",
		"impicciata",
		"impicciolita",
		"impiccolita",
		"impidocchiata",
		"impiegata",
		"impietosita",
		"impietrita",
		"impigliata",
		"impigrita",
		"impilata",
		"impillaccherata",
		"impinguata",
		"impinta",
		"impinzata",
		"impiombata",
		"impipata",
		"impiumata",
		"implementata",
		"implicata",
		"implorata",
		"impollinata",
		"impolpata",
		"impoltronita",
		"impolverata",
		"impomatata",
		"imporcata",
		"imporporata",
		"importata",
		"importunata",
		"impossessata",
		"impossibilitata",
		"impostata",
		"imposta",
		"impratichita",
		"impregnata",
		"impresa",
		"impressionata",
		"impressa",
		"imprestata",
		"impreziosita",
		"imprigionata",
		"impromessa",
		"improntata",
		"improsciuttita",
		"impugnata",
		"impuntita",
		"impunturata",
		"impupata",
		"imputata",
		"impuzzolentita",
		"inabilitata",
		"inabissata",
		"inacerbita",
		"inacetita",
		"inacidita",
		"inacutita",
		"inaffiata",
		"inalata",
		"inalberata",
		"inalveata",
		"inalzata",
		"inamidata",
		"inanellata",
		"inarcata",
		"inargentata",
		"inaridita",
		"inasprita",
		"inastata",
		"inattivata",
		"inaugurata",
		"incacchiata",
		"incalcinata",
		"incalorita",
		"incalzata",
		"incamerata",
		"incamiciata",
		"incamminata",
		"incanaglita",
		"incanalata",
		"incannata",
		"incannucciata",
		"incaponita",
		"incappottata",
		"incappucciata",
		"incaprettata",
		"incapricciata",
		"incapsulata",
		"incarcerata",
		"incardinata",
		"incaricata",
		"incarnata",
		"incarrozzata",
		"incartata",
		"incartocciata",
		"incartonata",
		"incasellata",
		"incasinata",
		"incassata",
		"incastellata",
		"incastonata",
		"incastrata",
		"incatenata",
		"incatramata",
		"incattivita",
		"incavata",
		"incavigliata",
		"incavolata",
		"incazzata",
		"incellofanata",
		"incendiata",
		"incenerita",
		"incensata",
		"incentivata",
		"incentrata",
		"inceppata",
		"incerata",
		"incernierata",
		"incerottata",
		"incesa",
		"incettata",
		"inchiappettata",
		"inchiavardata",
		"inchiesta",
		"inchinata",
		"inchiodata",
		"inchiostrata",
		"incipriata",
		"incisa",
		"incistata",
		"incitata",
		"inciuccata",
		"incivilita",
		"inclinata",
		"inclusa",
		"incoccata",
		"incocciata",
		"incoiata",
		"incollata",
		"incolonnata",
		"incolpata",
		"incominciata",
		"incomodata",
		"incontrata",
		"incoraggiata",
		"incordata",
		"incornata",
		"incorniciata",
		"incoronata",
		"incorporata",
		"incotta",
		"incravattata",
		"incrementata",
		"increspata",
		"incretinita",
		"incriminata",
		"incrinata",
		"incrociata",
		"incrostata",
		"incrudelita",
		"incrudita",
		"incruscata",
		"incubata",
		"inculata",
		"inculcata",
		"incuneata",
		"incuoiata",
		"incuorata",
		"incupita",
		"incuriosita",
		"incurvata",
		"incussa",
		"indagata",
		"indebitata",
		"indebolita",
		"indemaniata",
		"indennizzata",
		"indetta",
		"indicata",
		"indicizzata",
		"indignata",
		"indiretta",
		"indirizzata",
		"indispettita",
		"indisposta",
		"individualizzata",
		"individuata",
		"indolenzita",
		"indorata",
		"indossata",
		"indotta",
		"indottoma",
		"indottrinata",
		"indovinata",
		"indugiata",
		"indulta",
		"indurata",
		"indurita",
		"industrializzata",
		"industriata",
		"inebetita",
		"inebriata",
		"inerita",
		"inerpicata",
		"infagottata",
		"infamata",
		"infangata",
		"infarcita",
		"infarinata",
		"infastidita",
		"infatuata",
		"infeltrita",
		"inferita",
		"inferocita",
		"inferta",
		"infervorata",
		"infestata",
		"infettata",
		"infeudata",
		"infiacchita",
		"infialata",
		"infialettata",
		"infiammata",
		"infiascata",
		"infibulata",
		"inficiata",
		"infilata",
		"infiltrata",
		"infilzata",
		"infingardita",
		"infinocchiata",
		"infinta",
		"infioccata",
		"infiocchettata",
		"infiochita",
		"infiorata",
		"infirmata",
		"infischiata",
		"infissa",
		"infittita",
		"inflazionata",
		"inflessa",
		"inflitta",
		"influenzata",
		"infocata",
		"infoderata",
		"infognata",
		"infoibata",
		"infoltita",
		"inforcata",
		"informatizzata",
		"informata",
		"informicolata",
		"informicolita",
		"infornaciata",
		"infornata",
		"infortunata",
		"infoscata",
		"infossata",
		"infradiciata",
		"inframessa",
		"inframezzata",
		"inframmessa",
		"inframmezzata",
		"infrancesata",
		"infrapposta",
		"infrascata",
		"infrattata",
		"infreddata",
		"infronzolata",
		"infuocata",
		"infurbita",
		"infuriata",
		"ingabbiata",
		"ingaggiata",
		"ingagliardita",
		"ingannata",
		"ingarbugliata",
		"ingavonata",
		"ingegnata",
		"ingegnerizzata",
		"ingelosita",
		"ingemmata",
		"ingenerata",
		"ingentilita",
		"ingerita",
		"ingessata",
		"inghiaiata",
		"inghiottita",
		"inghirlandata",
		"ingiallita",
		"ingigantita",
		"inginocchiata",
		"ingioiellata",
		"ingiunta",
		"ingiuriata",
		"inglesizzata",
		"inglobata",
		"ingoffita",
		"ingoiata",
		"ingolfata",
		"ingollata",
		"ingolosita",
		"ingombrata",
		"ingommata",
		"ingorgata",
		"ingozzata",
		"ingranata",
		"ingrandita",
		"ingrassata",
		"ingraticciata",
		"ingraticolata",
		"ingravidata",
		"ingraziata",
		"ingraziosita",
		"ingrigita",
		"ingrommata",
		"ingrossata",
		"ingrullita",
		"inguaiata",
		"inguainata",
		"ingualdrappata",
		"inguantata",
		"ingurgitata",
		"inibita",
		"iniettata",
		"inimicata",
		"inizializzata",
		"iniziata",
		"inmillata",
		"innacquata",
		"innaffiata",
		"innalzata",
		"innamorata",
		"innastata",
		"innervata",
		"innervosita",
		"innescata",
		"innestata",
		"innevata",
		"innocentata",
		"innocuizzata",
		"innovata",
		"inoculata",
		"inoltrata",
		"inondata",
		"inorgoglita",
		"inorpellata",
		"inorridita",
		"inquadrata",
		"inquietata",
		"inquisita",
		"insabbiata",
		"insacchettata",
		"insalata",
		"insaldata",
		"insalivata",
		"insanguinata",
		"insaponata",
		"insaporita",
		"inscatolata",
		"inscenata",
		"inscritta",
		"insecchita",
		"insediata",
		"insegnata",
		"inseguita",
		"insellata",
		"inselvatichita",
		"inserita",
		"insidiata",
		"insignita",
		"insilata",
		"insinuata",
		"insolentita",
		"insonnolita",
		"insonorizzata",
		"insordita",
		"insospettita",
		"insozzata",
		"inspessita",
		"inspirata",
		"installata",
		"instaurata",
		"insterilita",
		"instillata",
		"instituita",
		"instradata",
		"insudiciata",
		"insufflata",
		"insultata",
		"insuperbita",
		"intabaccata",
		"intabarrata",
		"intaccata",
		"intagliata",
		"intarsiata",
		"intasata",
		"intascata",
		"intavolata",
		"integrata",
		"intelaiata",
		"intelata",
		"intellettualizzata",
		"intenebrata",
		"intenerita",
		"intensificata",
		"intentata",
		"intepidita",
		"intercalata",
		"intercambiata",
		"intercettata",
		"intercisa",
		"interclusa",
		"intercollegata",
		"interconnessa",
		"interconvertita",
		"interdetta",
		"interessata",
		"interfacciata",
		"interfogliata",
		"interfoliata",
		"interiorizzata",
		"interlacciata",
		"interlineata",
		"intermessa",
		"intermezzata",
		"internalizzata",
		"internata",
		"internazionalizzata",
		"interpellata",
		"interpenetrata",
		"interpolata",
		"interposta",
		"interpretata",
		"interpunta",
		"interrata",
		"interrogata",
		"interrotta",
		"intersecata",
		"intervallata",
		"intervistata",
		"intesa",
		"intessuta",
		"intestardita",
		"intestata",
		"intiepidita",
		"intimata",
		"intimidita",
		"intimorita",
		"intinta",
		"intirizzita",
		"intitolata",
		"intonacata",
		"intonata",
		"intontita",
		"intorbidata",
		"intorbidita",
		"intorpidita",
		"intortata",
		"intossicata",
		"intralciata",
		"intramessa",
		"intramezzata",
		"intrappolata",
		"intrapresa",
		"intrattenuta",
		"intraveduta",
		"intravista",
		"intravveduta",
		"intravvista",
		"intrecciata",
		"intricata",
		"intrigata",
		"intrinsecata",
		"intrippata",
		"intrisa",
		"introdotta",
		"introflessa",
		"introiettata",
		"introitata",
		"intromessa",
		"intronata",
		"intronizzata",
		"intruduta",
		"intrufolata",
		"intrugliata",
		"intruppata",
		"intrusa",
		"intubata",
		"intubettata",
		"intuita",
		"inumata",
		"inumidita",
		"inurbata",
		"inutilizzata",
		"invaghita",
		"invaginata",
		"invalidata",
		"invasata",
		"invasa",
		"invelenita",
		"inventariata",
		"inventata",
		"invenuta",
		"inverdita",
		"invergata",
		"inverniciata",
		"investigata",
		"investita",
		"invetriata",
		"inviata",
		"invidiata",
		"invigorita",
		"inviluppata",
		"invischiata",
		"invitata",
		"invocata",
		"invogliata",
		"involata",
		"involgarita",
		"involtata",
		"involta",
		"inzaccherata",
		"inzeppata",
		"inzigata",
		"inzolfata",
		"inzuccata",
		"inzuccherata",
		"inzuppata",
		"iodurata",
		"ionizzata",
		"ipertrofizzata",
		"ipnotizzata",
		"ipostatizzata",
		"ipotecata",
		"ipotizzata",
		"iridata",
		"irradiata",
		"irraggiata",
		"irreggimentata",
		"irretita",
		"irrigata",
		"irrigidita",
		"irrisa",
		"irritata",
		"irrobustita",
		"irrogata",
		"irrorata",
		"irrugginita",
		"irruvidita",
		"ischeletrita",
		"iscritta",
		"islamizzata",
		"isolata",
		"isomerizzata",
		"ispanizzata",
		"ispessita",
		"ispezionata",
		"ispirata",
		"issata",
		"istallata",
		"istanziata",
		"istaurata",
		"isterilita",
		"istigata",
		"istillata",
		"istituita",
		"istituzionalizzata",
		"istoriata",
		"istradata",
		"istruita",
		"istupidita",
		"italianeggiata",
		"italianizzata",
		"iterata",
		"iudicata",
		"killerata",
		"labbreggiata",
		"labializzata",
		"laccata",
		"lacerata",
		"laconizzata",
		"lacrimata",
		"ladroneggiata",
		"lagnata",
		"lagrimata",
		"laicizzata",
		"lambiccata",
		"lambita",
		"lamentata",
		"laminata",
		"lanciata",
		"lapidata",
		"lappata",
		"lardata",
		"lardellata",
		"largita",
		"larvata",
		"lascata",
		"lasciata",
		"lastricata",
		"latinizzata",
		"laudata",
		"laureata",
		"lavata",
		"lavorata",
		"leccata",
		"legalizzata",
		"legata",
		"leggicchiata",
		"leggiucchiata",
		"legittimata",
		"legittimizzata",
		"legnata",
		"lemmatizzata",
		"lenita",
		"lesinata",
		"lesionata",
		"lesa",
		"lessata",
		"letta",
		"levata",
		"levigata",
		"liberalizzata",
		"liberata",
		"licenziata",
		"lievitata",
		"liftata",
		"lignificata",
		"limata",
		"limitata",
		"linciata",
		"linearizzata",
		"lineata",
		"linkata",
		"liofilizzata",
		"liquefatta",
		"liquidata",
		"lisata",
		"lisciata",
		"lisciviata",
		"listata",
		"litografata",
		"livellata",
		"lizzata",
		"lobotomizzata",
		"localizzata",
		"locata",
		"lodata",
		"logorata",
		"lordata",
		"lottata",
		"lottizzata",
		"lubrificata",
		"lucchettata",
		"lucidata",
		"lucrata",
		"lumeggiata",
		"luppolizzata",
		"lusingata",
		"lussata",
		"lustrata",
		"macadamizzata",
		"macchiata",
		"macchinata",
		"macellata",
		"macerata",
		"maciullata",
		"maggesata",
		"maggiorata",
		"magnata",
		"magnetizzata",
		"magnificata",
		"maiolicata",
		"maledetta",
		"malfatta",
		"malignata",
		"malmenata",
		"malmessa",
		"maltata",
		"maltrattata",
		"malveduta",
		"malversata",
		"malvista",
		"malvoluta",
		"mandata",
		"mandrinata",
		"manducata",
		"maneggiata",
		"manganata",
		"manganellata",
		"mangiata",
		"mangiucchiata",
		"manifatturata",
		"manifestata",
		"manimessa",
		"manipolata",
		"manlevata",
		"manomessa",
		"manoscritta",
		"manovrata",
		"mansuefatta",
		"mantecata",
		"mantenutasa",
		"mantenuta",
		"manualizzata",
		"manutenuta",
		"mappata",
		"marcata",
		"marchiata",
		"marcita",
		"marezzata",
		"marginalizzata",
		"marginata",
		"margottata",
		"marimessa",
		"marinata",
		"maritata",
		"marmorizzata",
		"marnata",
		"marocchinata",
		"martellata",
		"martellinata",
		"martirizzata",
		"martoriata",
		"mascherata",
		"maschiata",
		"maschiettata",
		"mascolinizzata",
		"massacrata",
		"massaggiata",
		"massellata",
		"massicciata",
		"massificata",
		"massimata",
		"massimizzata",
		"mastectomizzata",
		"masterizzata",
		"masticata",
		"masturbata",
		"matematizzata",
		"materializzata",
		"matricolata",
		"mattonata",
		"maturata",
		"mazziata",
		"mazzolata",
		"meccanizzata",
		"medagliata",
		"mediata",
		"medicalizzata",
		"medicata",
		"meditata",
		"membrata",
		"memorizzata",
		"menata",
		"mendicata",
		"menomata",
		"mentovata",
		"menzionata",
		"meravigliata",
		"mercanteggiata",
		"mercerizzata",
		"mercificata",
		"meriata",
		"meridionalizzata",
		"meritata",
		"merlata",
		"merlettata",
		"mersa",
		"mesciata",
		"mesciuta",
		"mescolata",
		"mescuta",
		"mesmerizzata",
		"messaggiata",
		"messa",
		"messoca",
		"mestata",
		"mesticata",
		"mestruata",
		"metabolizzata",
		"metaforeggiata",
		"metaforizzata",
		"metallizzata",
		"metamorfizzata",
		"metamorfosata",
		"metanizzata",
		"metilata",
		"metodizzata",
		"microfilmata",
		"microfonata",
		"microminiaturizzata",
		"micronizzata",
		"mietuta",
		"migliorata",
		"militarizzata",
		"millantata",
		"millimetrata",
		"mimata",
		"mimeografata",
		"mimetizzata",
		"minacciata",
		"minata",
		"minchionata",
		"mineralizzata",
		"miniata",
		"miniaturizzata",
		"minimizzata",
		"minuita",
		"minuzzata",
		"miracolata",
		"miscelata",
		"mischiata",
		"misconosciuta",
		"missata",
		"mistificata",
		"misturata",
		"misurata",
		"miticizzata",
		"mitigata",
		"mitizzata",
		"mitragliata",
		"mitrata",
		"mixata",
		"mobiliata",
		"mobilitata",
		"mobilizzata",
		"modanata",
		"modellata",
		"modellizzata",
		"moderata",
		"modernizzata",
		"modificata",
		"modulata",
		"molata",
		"molestata",
		"mollata",
		"molleggiata",
		"moltiplicata",
		"monacata",
		"mondata",
		"mondializzata",
		"monetarizzata",
		"monetata",
		"monetizzata",
		"monitorata",
		"monitorizzata",
		"monocromatizzata",
		"monopolizzata",
		"monottongata",
		"montata",
		"monumentalizzata",
		"mordenzata",
		"mordicchiata",
		"mormorata",
		"morphata",
		"morsicata",
		"morsicchiata",
		"morsa",
		"mortasata",
		"mortificata",
		"mossa",
		"mostrata",
		"motivata",
		"motorizzata",
		"motteggiata",
		"movimentata",
		"mozzata",
		"mugolata",
		"mulcita",
		"multata",
		"multiplexata",
		"mummificata",
		"municipalizzata",
		"munita",
		"munta",
		"murata",
		"musata",
		"musicata",
		"mussata",
		"mutata",
		"mutilata",
		"mutizzata",
		"mutuata",
		"nappata",
		"narcotizzata",
		"narrativizzata",
		"narrata",
		"nasalizzata",
		"nascosa",
		"nascosta",
		"nastrata",
		"naturaleggiata",
		"naturalizzata",
		"nauseata",
		"naverata",
		"navicata",
		"navigata",
		"nazificata",
		"nazionalizzata",
		"nebulizzata",
		"necessitata",
		"necrosata",
		"necrotizzata",
		"negativizzata",
		"negata",
		"negletta",
		"negoziata",
		"negreggiata",
		"neologizzata",
		"nerbata",
		"nericata",
		"nettata",
		"neutralizzata",
		"nevata",
		"nevicata",
		"nevischiata",
		"nevrotizzata",
		"nichelata",
		"niellata",
		"ninfeggiata",
		"ninnata",
		"ninnolata",
		"nitratata",
		"nitrificata",
		"nobilitata",
		"noiata",
		"noleggiata",
		"nomata",
		"nominalizzata",
		"nominata",
		"normalizzata",
		"normata",
		"notata",
		"notificata",
		"notiziata",
		"notricata",
		"noverata",
		"nuclearizzata",
		"nudricata",
		"nullificata",
		"numerata",
		"numerizzata",
		"nuotata",
		"nutrita",
		"obbiettata",
		"obbliata",
		"obbligata",
		"oberata",
		"obiettata",
		"obiettivata",
		"obiettivizzata",
		"obiurgata",
		"obliata",
		"obliterata",
		"obnubilata",
		"occasionata",
		"occhieggiata",
		"occidentalizzata",
		"occisa",
		"occlusa",
		"occultata",
		"occupata",
		"ocheggiata",
		"odiata",
		"odorata",
		"odorizzata",
		"offerita",
		"offerta",
		"offesa",
		"officiata",
		"offiziata",
		"offuscata",
		"ofiziata",
		"oggettivata",
		"oggettivizzata",
		"oggettualizzata",
		"oliata",
		"olita",
		"olografata",
		"oltraggiata",
		"oltrapassata",
		"oltrepassata",
		"omaggiata",
		"ombrata",
		"ombreggiata",
		"omessa",
		"omogeneizzata",
		"omogenizzata",
		"omologata",
		"ondata",
		"ondulata",
		"onestata",
		"onnubilata",
		"onorata",
		"opacata",
		"opacizzata",
		"operata",
		"opinata",
		"oppiata",
		"oppignorata",
		"oppilata",
		"opposta",
		"oppressa",
		"oppugnata",
		"oprata",
		"opsonizzata",
		"optata",
		"opzionata",
		"orbitata",
		"orchestrata",
		"ordinata",
		"ordita",
		"orecchiata",
		"organata",
		"organicata",
		"organizzata",
		"orgasmata",
		"orientalizzata",
		"orientata",
		"originata",
		"origliata",
		"orizzontata",
		"orlata",
		"orlettata",
		"ormata",
		"ormeggiata",
		"ornata",
		"orpellata",
		"orrata",
		"orripilata",
		"ortogonalizzata",
		"osannata",
		"osata",
		"osculata",
		"oscurata",
		"ospedalizzata",
		"ospitata",
		"osseduta",
		"ossequiata",
		"osservata",
		"ossessionata",
		"ossidata",
		"ossificata",
		"ossitonizzata",
		"ostacolata",
		"osteggiata",
		"ostentata",
		"ostinata",
		"ostracizzata",
		"ostruita",
		"ottemperata",
		"ottenebrata",
		"ottenuta",
		"ottimalizzata",
		"ottimata",
		"ottimizzata",
		"ottonata",
		"ottriata",
		"ottuplicata",
		"otturata",
		"ottusa",
		"ottussa",
		"ovalizzata",
		"ovariectomizzata",
		"ovattata",
		"overcloccata",
		"ovrata",
		"ovviata",
		"ozieggiata",
		"ozonizzata",
		"pacata",
		"pacciamata",
		"pacificata",
		"padroneggiata",
		"paganizzata",
		"pagata",
		"paginata",
		"palafittata",
		"palatalizzata",
		"palata",
		"palesata",
		"palettata",
		"palettizzata",
		"palificata",
		"palleggiata",
		"pallettizzata",
		"palpata",
		"palpeggiata",
		"panata",
		"panneggiata",
		"panoramicata",
		"pappata",
		"paracadutata",
		"parafata",
		"paraffinata",
		"parafrasata",
		"paragonata",
		"paragrafata",
		"paralizzata",
		"parallelizzata",
		"parametrata",
		"parametrizzata",
		"parassitata",
		"parata",
		"parcata",
		"parcellizzata",
		"parcheggiata",
		"pareggiata",
		"parificata",
		"parkerizzata",
		"parlata",
		"parlucchiata",
		"parodiata",
		"partecipata",
		"particolareggiata",
		"particolarizzata",
		"partizionata",
		"partorita",
		"parzializzata",
		"pasciuta",
		"pascolata",
		"passata",
		"passeggiata",
		"passionata",
		"passivata",
		"pasticciata",
		"pastorizzata",
		"pasturata",
		"patinata",
		"patita",
		"patrocinata",
		"patteggiata",
		"pattugliata",
		"pattuita",
		"paventata",
		"pavesata",
		"pavimentata",
		"pavoneggiata",
		"pazziata",
		"pedinata",
		"pedonalizzata",
		"peggiorata",
		"pelata",
		"pellettizzata",
		"penalizzata",
		"penetrata",
		"pennellata",
		"pensata",
		"pensionata",
		"pentita",
		"pepata",
		"peptonizzata",
		"peragrata",
		"percentualizzata",
		"percepita",
		"percolata",
		"percorsa",
		"percossa",
		"perdonata",
		"perdotta",
		"perduta",
		"perequata",
		"perfatta",
		"perfezionata",
		"perforata",
		"performata",
		"perita",
		"periziata",
		"perlustrata",
		"permeata",
		"permessa",
		"perorata",
		"perpetrata",
		"perpetuata",
		"perplimuta",
		"perquisita",
		"perscrutata",
		"perseguitata",
		"perseguita",
		"persa",
		"personalizzata",
		"personificata",
		"persuasa",
		"perturbata",
		"pervasa",
		"pervertita",
		"pesata",
		"pescata",
		"pestata",
		"petrarcheggiata",
		"pettegolata",
		"pettinata",
		"piagata",
		"piaggiata",
		"piallata",
		"pianeggiata",
		"pianificata",
		"piantata",
		"piantatala",
		"piantata",
		"pianta",
		"piantonata",
		"piantumata",
		"piastrellata",
		"piatita",
		"piazzata",
		"picchettata",
		"picchiata",
		"picchierellata",
		"picchiettata",
		"picconata",
		"piegata",
		"pieghettata",
		"pietrificata",
		"pigiata",
		"pigliata",
		"pigmentata",
		"pignorata",
		"pigolata",
		"pilotata",
		"pimentata",
		"pinta",
		"pinzata",
		"piombata",
		"piovigginata",
		"piovuta",
		"pipata",
		"pippata",
		"piratata",
		"pirogenata",
		"pisciata",
		"pitoccata",
		"pittata",
		"pitturata",
		"pizzicata",
		"pizzicottata",
		"placata",
		"placcata",
		"plagiata",
		"plasmata",
		"plasticata",
		"plastificata",
		"platinata",
		"plissettata",
		"pluralizzata",
		"poetata",
		"poeticizzata",
		"poggiata",
		"polarizzata",
		"poligrafata",
		"polimerizzata",
		"politicizzata",
		"polverizzata",
		"pomiciata",
		"pompata",
		"ponderata",
		"ponzata",
		"popolarizzata",
		"popolata",
		"poppata",
		"porcellanata",
		"porfirizzata",
		"portata",
		"portesa",
		"porta",
		"porzionata",
		"posata",
		"posdatata",
		"positivizzata",
		"posizionata",
		"posposta",
		"posseduta",
		"postata",
		"postdatata",
		"posteggiata",
		"posticipata",
		"postillata",
		"posta",
		"postsincronizzata",
		"postulata",
		"potabilizzata",
		"potata",
		"potenziata",
		"potuta",
		"pralinata",
		"praticata",
		"preaccennata",
		"preannunciata",
		"preannunziata",
		"preavvertita",
		"preavvisata",
		"precaricata",
		"preceduta",
		"precettata",
		"precinta",
		"precisata",
		"preclusa",
		"precompilata",
		"precompressa",
		"preconfezionata",
		"preconizzata",
		"preconosciuta",
		"precorsa",
		"precostituita",
		"predata",
		"predefinita",
		"predestinata",
		"predeterminata",
		"predetta",
		"predicata",
		"predigerita",
		"prediletta",
		"predisposta",
		"preeletta",
		"preesistuta",
		"prefabbricata",
		"prefata",
		"prefatta",
		"prefazionata",
		"preferita",
		"prefigurata",
		"prefinanziata",
		"prefissata",
		"prefissa",
		"preformata",
		"pregata",
		"pregiata",
		"pregiudicata",
		"pregustata",
		"preimpregnata",
		"prelevata",
		"premeditata",
		"premescolata",
		"premessa",
		"premiata",
		"premonita",
		"premunita",
		"premurata",
		"premuta",
		"prenotata",
		"preoccupata",
		"preordinata",
		"preparata",
		"prepensionata",
		"prepigmentata",
		"preposta",
		"preprogrammata",
		"preraffreddata",
		"prerefrigerata",
		"preregistrata",
		"preregolata",
		"preriscaldata",
		"presa",
		"presagita",
		"presaputa",
		"presasela",
		"prescelta",
		"prescritta",
		"preseduta",
		"presegnalata",
		"preselezionata",
		"presentata",
		"presentita",
		"preservata",
		"presidiata",
		"presieduta",
		"presa",
		"pressata",
		"pressa",
		"pressurizzata",
		"prestabilita",
		"prestampata",
		"prestata",
		"prestigiata",
		"presunta",
		"presupposta",
		"pretermessa",
		"pretesa",
		"pretrattata",
		"prevaricata",
		"preveduta",
		"prevenduta",
		"preventivata",
		"prevenuta",
		"prevista",
		"prezzata",
		"prezzolata",
		"principiata",
		"privatizzata",
		"privata",
		"privilegiata",
		"problematizzata",
		"procacciata",
		"processata",
		"proclamata",
		"procrastinata",
		"procreata",
		"procurata",
		"prodigata",
		"prodotta",
		"profanata",
		"proferita",
		"professata",
		"professionalizzata",
		"profetata",
		"profetizzata",
		"profferita",
		"profilata",
		"profondata",
		"profumata",
		"profusa",
		"progettata",
		"prognosticata",
		"programmata",
		"proibita",
		"proiettata",
		"proletarizzata",
		"prolungata",
		"promanata",
		"promessa",
		"promossa",
		"promozionata",
		"promulgata",
		"pronosticata",
		"pronunciata",
		"pronunziata",
		"propagandata",
		"propagata",
		"propagginata",
		"propalata",
		"propinata",
		"propiziata",
		"proporzionata",
		"proposta",
		"propugnata",
		"propulsa",
		"prorogata",
		"prosciolta",
		"prosciugata",
		"proscritta",
		"proseguita",
		"prospettata",
		"prosternata",
		"prostesa",
		"prostituita",
		"prostrata",
		"prosunta",
		"protesa",
		"protestata",
		"protetta",
		"protocollata",
		"protonata",
		"protratta",
		"protrusa",
		"provata",
		"proveduta",
		"provincializzata",
		"provista",
		"provocata",
		"provveduta",
		"provvista",
		"psicanalizzata",
		"psichiatrizzata",
		"psicoanalizzata",
		"psicologizzata",
		"pubblicata",
		"pubblicizzata",
		"puddellata",
		"pugnalata",
		"pulita",
		"pungolata",
		"punita",
		"puntata",
		"punteggiata",
		"puntellata",
		"punta",
		"puntualizzata",
		"punzecchiata",
		"punzonata",
		"purgata",
		"purificata",
		"putita",
		"putrefatta",
		"putrita",
		"quadrata",
		"quadrettata",
		"quadriennalizzata",
		"quadruplicata",
		"qualificata",
		"quantificata",
		"quantizzata",
		"querelata",
		"questuata",
		"quetata",
		"quietanzata",
		"quietata",
		"quintessenziata",
		"quintuplicata",
		"quotata",
		"quotizzata",
		"rabberciata",
		"rabboccata",
		"rabbonita",
		"rabbuffata",
		"rabuffata",
		"raccapezzata",
		"raccapricciata",
		"raccattata",
		"raccerchiata",
		"raccesa",
		"racchetata",
		"racchiusa",
		"raccolta",
		"raccolta",
		"raccomandata",
		"raccomodata",
		"raccontata",
		"raccorciata",
		"raccorcita",
		"raccordata",
		"raccostata",
		"raccozzata",
		"racemizzata",
		"racimolata",
		"radazzata",
		"raddensata",
		"raddobbata",
		"raddolcita",
		"raddoppiata",
		"raddotta",
		"raddrizzata",
		"radiata",
		"radicalizzata",
		"radioassistita",
		"radioattivata",
		"radiocomandata",
		"radiodiffusa",
		"radiografata",
		"radioguidata",
		"radiolocalizzata",
		"radiomarcata",
		"radiotelegrafata",
		"radiotrasmessa",
		"radunata",
		"raffazzonata",
		"raffermata",
		"raffigurata",
		"raffilata",
		"raffinata",
		"rafforzata",
		"raffreddata",
		"raffrenata",
		"raffrescata",
		"raffrontata",
		"raggelata",
		"raggentilita",
		"ragghiata",
		"raggirata",
		"raggiunta",
		"raggiustata",
		"raggomitolata",
		"raggranchiata",
		"raggranchita",
		"raggranellata",
		"raggrinzata",
		"raggrinzita",
		"raggrumata",
		"raggruppata",
		"raggruzzolata",
		"ragguagliata",
		"ralingata",
		"rallegrata",
		"rallentata",
		"ramata",
		"ramazzata",
		"rammagliata",
		"rammaricata",
		"rammemorata",
		"rammendata",
		"rammentata",
		"rammodernata",
		"rammollita",
		"rammorbidita",
		"rampognata",
		"randellata",
		"randomizzata",
		"rannicchiata",
		"rannuvolata",
		"ranzata",
		"rapata",
		"rapinata",
		"rapita",
		"rappacificata",
		"rappata",
		"rappattumata",
		"rappezzata",
		"rapportata",
		"rappresantata",
		"rappresentata",
		"rappresa",
		"rarefatta",
		"rasata",
		"raschiata",
		"raschiettata",
		"rasentata",
		"rasa",
		"raspata",
		"rassegnata",
		"rasserenata",
		"rassettata",
		"rassicurata",
		"rassodata",
		"rassomigliata",
		"rassottigliata",
		"rassunta",
		"rastrellata",
		"rastremata",
		"rateata",
		"rateizzata",
		"ratificata",
		"ratinata",
		"rattizzata",
		"rattoppata",
		"rattorta",
		"rattrappita",
		"rattristata",
		"rattristita",
		"raunata",
		"ravvalorata",
		"ravveduta",
		"ravviata",
		"ravvicinata",
		"ravviluppata",
		"ravvisata",
		"ravvista",
		"ravvivata",
		"ravvolta",
		"ravvoltolata",
		"razionalizzata",
		"razionata",
		"razziata",
		"razzolata",
		"realizzata",
		"reassunta",
		"recapitata",
		"recata",
		"receduta",
		"recensita",
		"recepita",
		"recidivata",
		"recintata",
		"recinta",
		"reciprocata",
		"recisa",
		"recitata",
		"reclamata",
		"reclamizzata",
		"reclinata",
		"reclusa",
		"reclutata",
		"recuperata",
		"redarguita",
		"redatta",
		"redazzata",
		"redduta",
		"redenta",
		"redistribuita",
		"redotta",
		"referenziata",
		"refertata",
		"refilata",
		"reflessa",
		"reflettuta",
		"refranta",
		"refrigerata",
		"regalata",
		"regimata",
		"regimentata",
		"regionalizzata",
		"registrata",
		"regolamentata",
		"regolarizzata",
		"regolata",
		"reidratata",
		"reificata",
		"reimbarcata",
		"reimmersa",
		"reimmessa",
		"reimparata",
		"reimpastata",
		"reimpiantata",
		"reimpiegata",
		"reimportata",
		"reimpostata",
		"reincarcerata",
		"reincaricata",
		"reincarnata",
		"reincisa",
		"reincontrata",
		"reindirizzata",
		"reindustrializzata",
		"reinfettata",
		"reingaggiata",
		"reinizializzata",
		"reinnestata",
		"reinoltrata",
		"reinscritta",
		"reinsediata",
		"reinserita",
		"reinstallata",
		"reinstaurata",
		"reintegrata",
		"reinterpretata",
		"reintitolata",
		"reintrodotta",
		"reinventata",
		"reinvestita",
		"reiterata",
		"relativizzata",
		"relazionata",
		"relegata",
		"remixata",
		"remunerata",
		"renderizzata",
		"reperita",
		"repertata",
		"replicata",
		"repressa",
		"repulsa",
		"reputata",
		"requisita",
		"rescissa",
		"resecata",
		"resettata",
		"residuata",
		"resinificata",
		"resa",
		"resolata",
		"resolta",
		"respinta",
		"respirata",
		"responsabilizzata",
		"resposta",
		"restaurata",
		"restituita",
		"resunta",
		"resuscitata",
		"reticolata",
		"retinata",
		"retribuita",
		"retroceduta",
		"retrocessa",
		"retrodatata",
		"rettificata",
		"retta",
		"reumatizzata",
		"revisionata",
		"revocata",
		"riabbassata",
		"riabbellita",
		"riabbonata",
		"riabbottonata",
		"riabbracciata",
		"riabilitata",
		"riabitata",
		"riabituata",
		"riaccaduta",
		"riaccasata",
		"riaccesa",
		"riaccettata",
		"riacchiappata",
		"riacciuffata",
		"riaccolta",
		"riaccomodata",
		"riaccompagnata",
		"riaccordata",
		"riaccostata",
		"riaccreditata",
		"riacquisita",
		"riacquistata",
		"riacutizzata",
		"riadattata",
		"riaddestrata",
		"riaddormentata",
		"riadoperata",
		"riaffacciata",
		"riaffermata",
		"riafferrata",
		"riaffiorata",
		"riaffittata",
		"riaffrontata",
		"riagganciata",
		"riaggiornata",
		"riaggiustata",
		"riaggravata",
		"riaggregata",
		"riagguantata",
		"rialimentata",
		"riallacciata",
		"riallargata",
		"riallineata",
		"riallocata",
		"riallungata",
		"rialzata",
		"riamata",
		"riambientata",
		"riammalata",
		"riammessa",
		"riammodernata",
		"riammogliata",
		"rianimata",
		"riannessa",
		"riannodata",
		"riannunciata",
		"riaperta",
		"riappacificata",
		"riappaltata",
		"riapparecchiata",
		"riapparita",
		"riappesa",
		"riappiccicata",
		"riapplicata",
		"riappresa",
		"riapprodata",
		"riappropriata",
		"riapprovata",
		"riarmata",
		"riarrangiata",
		"riarredata",
		"riascoltata",
		"riasfaltata",
		"riassalita",
		"riassaporata",
		"riassegnata",
		"riassemblata",
		"riassestata",
		"riassettata",
		"riassicurata",
		"riassociata",
		"riassopita",
		"riassorbita",
		"riassunta",
		"riattaccata",
		"riattata",
		"riattesa",
		"riattinta",
		"riattivata",
		"riattizzata",
		"riattraversata",
		"riaumentata",
		"riavuta",
		"riavventata",
		"riavvertita",
		"riavviata",
		"riavvicinata",
		"riavvinta",
		"riavvisata",
		"riavvistata",
		"riavvolta",
		"riazzuffata",
		"ribaciata",
		"ribadita",
		"ribaltata",
		"ribassata",
		"ribattezzata",
		"ribattuta",
		"ribellata",
		"ribenedetta",
		"ribevuta",
		"ributtata",
		"ricacciata",
		"ricalata",
		"ricalcata",
		"ricalcificata",
		"ricalcitrata",
		"ricalcolata",
		"ricalibrata",
		"ricamata",
		"ricambiata",
		"ricanalizzata",
		"ricandidata",
		"ricantata",
		"ricapitalizzata",
		"ricapitolata",
		"ricaricata",
		"ricategorizzata",
		"ricattata",
		"ricavata",
		"ricelebrata",
		"ricercata",
		"ricetrasmessa",
		"ricettata",
		"ricevuta",
		"richiamata",
		"richiesta",
		"richiusa",
		"riciclata",
		"ricinta",
		"ricircolata",
		"riclassificata",
		"ricodificata",
		"ricollegata",
		"ricollocata",
		"ricolmata",
		"ricolonizzata",
		"ricolorata",
		"ricolorita",
		"ricoltivata",
		"ricombinata",
		"ricominciata",
		"ricommessa",
		"ricomparita",
		"ricompattata",
		"ricompensata",
		"ricomperata",
		"ricompilata",
		"ricompiuta",
		"ricomposta",
		"ricomprata",
		"ricompressa",
		"ricomunicata",
		"riconceduta",
		"riconcessa",
		"riconciliata",
		"ricondizionata",
		"ricondotta",
		"riconfermata",
		"riconfezionata",
		"riconfigurata",
		"riconfortata",
		"riconfusa",
		"ricongelata",
		"ricongiunta",
		"riconnessa",
		"riconosciuta",
		"riconquistata",
		"riconsacrata",
		"riconsegnata",
		"riconsiderata",
		"riconsigliata",
		"riconsolata",
		"ricontata",
		"ricontattata",
		"ricontrattata",
		"ricontratta",
		"ricontrollata",
		"riconvalidata",
		"riconvenuta",
		"riconvertita",
		"riconvinta",
		"riconvocata",
		"riconvogliata",
		"ricoperta",
		"ricopiata",
		"ricordata",
		"ricoricata",
		"ricorretta",
		"ricosparsa",
		"ricostituita",
		"ricostretta",
		"ricostruita",
		"ricotta",
		"ricoverata",
		"ricreata",
		"ricristallizzata",
		"ricrocifissa",
		"ricucita",
		"ricuperata",
		"ricusata",
		"ridata",
		"ridecorata",
		"ridefinita",
		"ridenominata",
		"ridestata",
		"rideterminata",
		"ridetta",
		"ridicolizzata",
		"ridigitata",
		"ridimensionata",
		"ridipinta",
		"ridiscesa",
		"ridisciolta",
		"ridisciplinata",
		"ridiscussa",
		"ridisegnata",
		"ridisfatta",
		"ridisposta",
		"ridistesa",
		"ridistinta",
		"ridistribuita",
		"ridivisa",
		"ridomandata",
		"ridonata",
		"ridondata",
		"ridorata",
		"ridotata",
		"ridotta",
		"ridovuta",
		"riecheggiata",
		"riedificata",
		"rieducata",
		"rielaborata",
		"rieletta",
		"riemessa",
		"riempita",
		"riempiuta",
		"rientrata",
		"riepilogata",
		"riequilibrata",
		"riequipaggiata",
		"riesaminata",
		"rieseguita",
		"riesercitata",
		"riesplosa",
		"riesportata",
		"riesposta",
		"riespressa",
		"riespulsa",
		"riestesa",
		"riesumata",
		"rietichettata",
		"rievaporata",
		"rievocata",
		"rifabbricata",
		"rifasciata",
		"rifatta",
		"rifenduta",
		"riferita",
		"rifermata",
		"rifermentata",
		"rifessa",
		"rificcata",
		"rifilata",
		"rifiltrata",
		"rifinanziata",
		"rifinita",
		"rifirmata",
		"rifischiata",
		"rifissa",
		"rifiutata",
		"riflessa",
		"riflettuta",
		"rifocillata",
		"rifoderata",
		"rifondata",
		"riforestata",
		"riforgiata",
		"riformata",
		"riformattata",
		"riformulata",
		"rifornita",
		"rifranta",
		"rifritta",
		"rifrugata",
		"rifuggita",
		"rifugiata",
		"rifusa",
		"rigassificata",
		"rigata",
		"rigelata",
		"rigenerata",
		"rigettata",
		"righettata",
		"rigiocata",
		"rigirata",
		"rigiudicata",
		"rigiunta",
		"rigoduta",
		"rigonfiata",
		"rigovernata",
		"riguadagnata",
		"riguardata",
		"rigurgitata",
		"rilanciata",
		"rilasciata",
		"rilassata",
		"rilavata",
		"rilavorata",
		"rilegata",
		"riletta",
		"rilevata",
		"rilocalizzata",
		"rimagliata",
		"rimandata",
		"rimaneggiata",
		"rimangiata",
		"rimappata",
		"rimarcata",
		"rimarchiata",
		"rimarginata",
		"rimaritata",
		"rimasticata",
		"rimata",
		"rimbacuccata",
		"rimbaldanzita",
		"rimbarcata",
		"rimbeccata",
		"rimbecillita",
		"rimbellita",
		"rimbiancata",
		"rimbiondita",
		"rimboccata",
		"rimbombata",
		"rimborsata",
		"rimboscata",
		"rimboschita",
		"rimbrottata",
		"rimediata",
		"rimembrata",
		"rimemorata",
		"rimenata",
		"rimeritata",
		"rimescolata",
		"rimessa",
		"rimestata",
		"rimilitarizzata",
		"rimirata",
		"rimischiata",
		"rimisurata",
		"rimodellata",
		"rimodernata",
		"rimodulata",
		"rimondata",
		"rimontata",
		"rimorchiata",
		"rimorsa",
		"rimossa",
		"rimostrata",
		"rimotivata",
		"rimpacchettata",
		"rimpadronita",
		"rimpaginata",
		"rimpagliata",
		"rimpannucciata",
		"rimpastata",
		"rimpatriata",
		"rimpiallacciata",
		"rimpianta",
		"rimpiattata",
		"rimpiazzata",
		"rimpicciolita",
		"rimpiccolita",
		"rimpiegata",
		"rimpinguata",
		"rimpinzata",
		"rimpolpata",
		"rimpossessata",
		"rimpressa",
		"rimproverata",
		"rimuginata",
		"rimunerata",
		"rimunta",
		"rimusicata",
		"rimutata",
		"rinarrata",
		"rinascosta",
		"rincalcata",
		"rincalzata",
		"rincamminata",
		"rincantucciata",
		"rincarata",
		"rincarcerata",
		"rincarnata",
		"rincentrata",
		"rinchiesta",
		"rinchiodata",
		"rinchiusa",
		"rincitrullita",
		"rincivilita",
		"rincoglionita",
		"rincollata",
		"rincominciata",
		"rincontrata",
		"rincoraggiata",
		"rincorata",
		"rincorporata",
		"rincorsa",
		"rincretinita",
		"rincrudita",
		"rinculcata",
		"rincuorata",
		"rindossata",
		"rindurita",
		"rinegoziata",
		"rinfacciata",
		"rinfagottata",
		"rinfiammata",
		"rinfiancata",
		"rinfilata",
		"rinfittita",
		"rinfocolata",
		"rinfoderata",
		"rinforzata",
		"rinfrancata",
		"rinfranta",
		"rinfrescata",
		"rinfusa",
		"ringagliardita",
		"ringalluzzita",
		"ringiovanita",
		"ringiovenita",
		"ringoiata",
		"ringorgata",
		"ringraziata",
		"ringuainata",
		"rinnamorata",
		"rinnegata",
		"rinnestata",
		"rinnovata",
		"rinnovellata",
		"rinociuta",
		"rinomata",
		"rinominata",
		"rinormalizzata",
		"rinquadrata",
		"rinsaccata",
		"rinsaldata",
		"rinsanguata",
		"rinselvatichita",
		"rinselvata",
		"rinserrata",
		"rintanata",
		"rintasata",
		"rintascata",
		"rintavolata",
		"rintenerita",
		"rinterrata",
		"rinterrogata",
		"rintesa",
		"rintiepidita",
		"rintoccata",
		"rintonacata",
		"rintontita",
		"rintorpidita",
		"rintracciata",
		"rintrodotta",
		"rintronata",
		"rintuzzata",
		"rinunciata",
		"rinunziata",
		"rinutrita",
		"rinvangata",
		"rinvasata",
		"rinvenuta",
		"rinverdita",
		"rinvestita",
		"rinviata",
		"rinvigorita",
		"rinvilita",
		"rinvitata",
		"rinvoltata",
		"rinvolta",
		"rinvoltolata",
		"rinzaffata",
		"rinzeppata",
		"riobbligata",
		"rioccupata",
		"riofferta",
		"rioffesa",
		"rioperata",
		"riordinata",
		"riorganizzata",
		"riorientata",
		"riosservata",
		"riottenuta",
		"riottimizzata",
		"riotturata",
		"ripagata",
		"riparametrizzata",
		"riparata",
		"ripartita",
		"ripassata",
		"ripercorsa",
		"ripercossa",
		"riperduta",
		"ripersa",
		"ripesata",
		"ripescata",
		"ripestata",
		"ripetuta",
		"ripianata",
		"ripianificata",
		"ripiantata",
		"ripianta",
		"ripicchiata",
		"ripiegata",
		"ripigliata",
		"ripinta",
		"ripiovuta",
		"ripitturata",
		"riplasmata",
		"ripolarizzata",
		"ripopolata",
		"riportata",
		"riporta",
		"riposata",
		"riposizionata",
		"riposseduta",
		"riposta",
		"ripotuta",
		"ripresentata",
		"ripresa",
		"riprestata",
		"ripretesa",
		"riprincipiata",
		"ripristinata",
		"riprivatizzata",
		"riprodotta",
		"riprogettata",
		"riprogrammata",
		"ripromessa",
		"riproposta",
		"riprotetta",
		"riprovata",
		"riprovveduta",
		"riprovvista",
		"ripubblicata",
		"ripudiata",
		"ripugnata",
		"ripulita",
		"ripuntata",
		"ripunta",
		"ripurgata",
		"riputata",
		"riquadrata",
		"riqualificata",
		"riresa",
		"rirotta",
		"risaldata",
		"risalita",
		"risaltata",
		"risalutata",
		"risanata",
		"risaputa",
		"risarcita",
		"riscalata",
		"riscaldata",
		"riscattata",
		"riscelta",
		"riscesa",
		"rischiarata",
		"rischiata",
		"risciacquata",
		"risciolta",
		"riscommessa",
		"riscontata",
		"riscontrata",
		"risconvolta",
		"riscoperta",
		"riscoppiata",
		"riscorsa",
		"riscossa",
		"riscritta",
		"risecata",
		"riseduta",
		"risegata",
		"risegnata",
		"riselciata",
		"riselezionata",
		"riseminata",
		"risentita",
		"riseppellita",
		"riserbata",
		"riservata",
		"risicata",
		"risigillata",
		"risistemata",
		"risa",
		"risoffiata",
		"risoggiunta",
		"risolata",
		"risolidificata",
		"risollevata",
		"risolta",
		"risommata",
		"risommersa",
		"risonata",
		"risorpassata",
		"risospesa",
		"risospinta",
		"risottomessa",
		"risparmiata",
		"risparsa",
		"rispecchiata",
		"rispedita",
		"rispenta",
		"rispersa",
		"rispettata",
		"rispiegata",
		"rispinta",
		"rispolverata",
		"risposata",
		"risposta",
		"rissata",
		"ristabilita",
		"ristagnata",
		"ristampata",
		"ristaurata",
		"ristesa",
		"ristilizzata",
		"ristorata",
		"ristretta",
		"ristrutta",
		"ristrutturata",
		"ristuccata",
		"ristudiata",
		"risucchiata",
		"risultata",
		"risuolata",
		"risuonata",
		"risuscitata",
		"risvegliata",
		"risvolta",
		"ritagliata",
		"ritarata",
		"ritardata",
		"ritemprata",
		"ritentata",
		"ritenuta",
		"ritersa",
		"ritesa",
		"ritinta",
		"ritirata",
		"ritoccata",
		"ritolta",
		"ritorta",
		"ritracciata",
		"ritradotta",
		"ritrascorsa",
		"ritrascritta",
		"ritrasferita",
		"ritrasformata",
		"ritrasmessa",
		"ritrasposta",
		"ritrattata",
		"ritratta",
		"ritrovata",
		"ritualizzata",
		"rituffata",
		"riudita",
		"riunificata",
		"riunita",
		"riusata",
		"riutilizzata",
		"rivaccinata",
		"rivaleggiata",
		"rivalorizzata",
		"rivalsa",
		"rivalutata",
		"rivangata",
		"riveduta",
		"rivelata",
		"rivendicata",
		"rivenduta",
		"riverberata",
		"riverita",
		"riverniciata",
		"riversata",
		"rivestita",
		"rivettata",
		"rivinta",
		"rivisitata",
		"rivissuta",
		"rivista",
		"rivitalizzata",
		"rivivificata",
		"rivoltata",
		"rivolta",
		"rivoltolata",
		"rivoluta",
		"rivoluzionata",
		"rizappata",
		"rizzata",
		"robotizzata",
		"rodata",
		"rogata",
		"rollata",
		"romanizzata",
		"romanticizzata",
		"romanzata",
		"roncolata",
		"rosicata",
		"rosicchiata",
		"rosa",
		"rosolata",
		"rotacizzata",
		"rotata",
		"roteata",
		"rotolata",
		"rottamata",
		"rotta",
		"rovesciata",
		"rovinata",
		"rovistata",
		"rubacchiata",
		"rubata",
		"rullata",
		"ruminata",
		"ruotata",
		"russificata",
		"ruzzolata",
		"sabbiata",
		"sabotata",
		"saccarificata",
		"saccheggiata",
		"sacralizzata",
		"sacramentata",
		"sacrificata",
		"saettata",
		"saggiata",
		"sagginata",
		"sagomata",
		"salamoiata",
		"salariata",
		"salassata",
		"salata",
		"saldata",
		"salificata",
		"salinizzata",
		"salita",
		"salmeggiata",
		"salmistrata",
		"salpata",
		"saltata",
		"salutata",
		"salvaguardata",
		"salvata",
		"sanata",
		"sancita",
		"sanforizzata",
		"sanificata",
		"sanitizzata",
		"santificata",
		"sanzionata",
		"saponificata",
		"saputa",
		"sarchiata",
		"sarchiellata",
		"sartiata",
		"satellizzata",
		"satinata",
		"satireggiata",
		"satisfatta",
		"satollata",
		"saturata",
		"saziata",
		"sbaccellata",
		"sbaciucchiata",
		"sbafata",
		"sbaffata",
		"sbalestrata",
		"sballata",
		"sballottata",
		"sballottolata",
		"sbalordita",
		"sbalzata",
		"sbancata",
		"sbandata",
		"sbandierata",
		"sbandita",
		"sbaraccata",
		"sbaragliata",
		"sbarazzata",
		"sbarbata",
		"sbarcata",
		"sbardata",
		"sbarrata",
		"sbassata",
		"sbastita",
		"sbatacchiata",
		"sbattezzata",
		"sbattuta",
		"sbeccata",
		"sbeffeggiata",
		"sbellicata",
		"sbendata",
		"sbertucciata",
		"sbiadita",
		"sbiancata",
		"sbianchita",
		"sbiellata",
		"sbiettata",
		"sbigottita",
		"sbilanciata",
		"sbirbata",
		"sbirciata",
		"sbizzarrita",
		"sbloccata",
		"sbobinata",
		"sboccata",
		"sbocconcellata",
		"sbollentata",
		"sbolognata",
		"sborniata",
		"sborsata",
		"sboscata",
		"sbottonata",
		"sbozzata",
		"sbozzimata",
		"sbozzolata",
		"sbracata",
		"sbracciata",
		"sbraciata",
		"sbraitata",
		"sbranata",
		"sbrancata",
		"sbrattata",
		"sbreccata",
		"sbriciolata",
		"sbrigata",
		"sbrigliata",
		"sbrinata",
		"sbrindellata",
		"sbrodolata",
		"sbrogliata",
		"sbronzata",
		"sbruffata",
		"sbucciata",
		"sbudellata",
		"sbuffata",
		"sbugiardata",
		"sbullettata",
		"sbullonata",
		"sburrata",
		"scacazzata",
		"scacchiata",
		"scacciata",
		"scaccolata",
		"scadenzata",
		"scafata",
		"scaffalata",
		"scagionata",
		"scagliata",
		"scaglionata",
		"scalata",
		"scalcata",
		"scalcinata",
		"scaldata",
		"scalettata",
		"scalfata",
		"scalfita",
		"scalmanata",
		"scaloppata",
		"scalpata",
		"scalpellata",
		"scalpellinata",
		"scaltrita",
		"scalzata",
		"scambiata",
		"scamiciata",
		"scamosciata",
		"scamozzata",
		"scampata",
		"scampatala",
		"scampata",
		"scamuffata",
		"scanalata",
		"scancellata",
		"scandagliata",
		"scandalizzata",
		"scandita",
		"scannata",
		"scannellata",
		"scannerata",
		"scannerizata",
		"scannerizzata",
		"scansata",
		"scansionata",
		"scapecchiata",
		"scapezzata",
		"scapicollata",
		"scapigliata",
		"scapitozzata",
		"scapocchiata",
		"scappata",
		"scappellata",
		"scappottata",
		"scapricciata",
		"scapsulata",
		"scarabocchiata",
		"scaracchiata",
		"scaraventata",
		"scarcerata",
		"scardassata",
		"scardata",
		"scardinata",
		"scaricata",
		"scarificata",
		"scarmigliata",
		"scarnata",
		"scarnificata",
		"scarnita",
		"scarrellata",
		"scarrocciata",
		"scarrozzata",
		"scarruffata",
		"scartabellata",
		"scartata",
		"scartavetrata",
		"scartinata",
		"scartocciata",
		"scassata",
		"scassinata",
		"scatenata",
		"scattata",
		"scavalcata",
		"scavallata",
		"scavata",
		"scavezzata",
		"scazzottata",
		"scekerata",
		"scelta",
		"scempiata",
		"sceneggiata",
		"scernuta",
		"scervellata",
		"scesa",
		"sceverata",
		"schedata",
		"schedulata",
		"scheggiata",
		"scheletrita",
		"schematizzata",
		"schermata",
		"schermita",
		"schermografata",
		"schernita",
		"schiacciata",
		"schiaffata",
		"schiaffeggiata",
		"schiantata",
		"schiarita",
		"schiavardata",
		"schiavizzata",
		"schiccherata",
		"schierata",
		"schifata",
		"schinciata",
		"schioccata",
		"schiodata",
		"schiumata",
		"schiusa",
		"schivata",
		"schizzata",
		"schizzettata",
		"sciabolata",
		"sciabordata",
		"sciacquata",
		"scialacquata",
		"sciamanizzata",
		"sciamannata",
		"sciancata",
		"sciancrata",
		"scimmieggiata",
		"scimmiottata",
		"scinta",
		"scioccata",
		"sciolinata",
		"sciolta",
		"sciorinata",
		"scippata",
		"sciroppata",
		"scissa",
		"sciupacchiata",
		"sciupata",
		"sclamata",
		"sclerosata",
		"sclerotizzata",
		"scoccata",
		"scocciata",
		"scodata",
		"scodellata",
		"scoiata",
		"scolarizzata",
		"scolata",
		"scollacciata",
		"scollata",
		"scollegata",
		"scolorata",
		"scolorita",
		"scolpata",
		"scolpita",
		"scombaciata",
		"scombinata",
		"scombussolata",
		"scommessa",
		"scomodata",
		"scompaginata",
		"scompagnata",
		"scompartita",
		"scompattata",
		"scompensata",
		"scompiacuta",
		"scompigliata",
		"scomposta",
		"scomputata",
		"scomunicata",
		"sconcertata",
		"sconciata",
		"sconclusa",
		"sconfessata",
		"sconficcata",
		"sconﬁtta",
		"sconfortata",
		"sconfusa",
		"scongelata",
		"scongiurata",
		"sconnessa",
		"sconosciuta",
		"sconquassata",
		"sconsacrata",
		"sconsigliata",
		"sconsolata",
		"scontata",
		"scontentata",
		"scontornata",
		"scontorta",
		"scontrata",
		"sconvolta",
		"scopata",
		"scoperchiata",
		"scoperta",
		"scopiazzata",
		"scoraggiata",
		"scoraggita",
		"scorata",
		"scorazzata",
		"scorciata",
		"scorcita",
		"scordata",
		"scoreggiata",
		"scorificata",
		"scornata",
		"scorniciata",
		"scoronata",
		"scorporata",
		"scorrazzata",
		"scorreggiata",
		"scorretta",
		"scorsa",
		"scortata",
		"scortecciata",
		"scorticata",
		"scorta",
		"scorzata",
		"scoscesa",
		"scosciata",
		"scossa",
		"scostata",
		"scostolata",
		"scotennata",
		"scoticata",
		"scotolata",
		"scotomizzata",
		"scottata",
		"scotta",
		"scovata",
		"scoverta",
		"scozzata",
		"scozzonata",
		"screditata",
		"scremata",
		"screpolata",
		"screziata",
		"scribacchiata",
		"scriminata",
		"scristianizzata",
		"scritta",
		"scritturata",
		"scroccata",
		"scrocchiata",
		"scrollata",
		"scrostata",
		"scrutata",
		"scrutinata",
		"scucita",
		"scudisciata",
		"scuffiata",
		"sculacciata",
		"sculettata",
		"scuoiata",
		"scuriosata",
		"scurita",
		"scusata",
		"sdaziata",
		"sdebitata",
		"sdegnata",
		"sdemanializzata",
		"sdentata",
		"sdilinquita",
		"sdoganata",
		"sdoluta",
		"sdoppiata",
		"sdraiata",
		"sdrammatizzata",
		"sdrucita",
		"secata",
		"seccata",
		"secernuta",
		"secolarizzata",
		"secondata",
		"secretata",
		"secreta",
		"sedata",
		"sedentarizzata",
		"sedotta",
		"segata",
		"seghettata",
		"segmentata",
		"segnalata",
		"segnata",
		"segnoreggiata",
		"segregata",
		"segretata",
		"seguitata",
		"seguita",
		"selciata",
		"selezionata",
		"sellata",
		"sembrata",
		"sementata",
		"semicinta",
		"seminata",
		"semplificata",
		"senilizzata",
		"sensibilizzata",
		"sensorizzata",
		"sentenziata",
		"sentita",
		"sentitasela",
		"sentita",
		"sentita",
		"separata",
		"sepolta",
		"seppellita",
		"sequenziata",
		"sequestrata",
		"serbata",
		"serrata",
		"servita",
		"servoassistita",
		"sessualizzata",
		"sestuplicata",
		"setacciata",
		"setificata",
		"settata",
		"settorializzata",
		"settuplicata",
		"seviziata",
		"sezionata",
		"sfaccettata",
		"sfagliata",
		"sfaldata",
		"sfalsata",
		"sfamata",
		"sfanalata",
		"sfangata",
		"sfarinata",
		"sfasata",
		"sfasciata",
		"sfatata",
		"sfatta",
		"sfavillata",
		"sfavorita",
		"sfegatata",
		"sfeltrata",
		"sfenduta",
		"sferragliata",
		"sferrata",
		"sferzata",
		"sfessa",
		"sfiancata",
		"sfiatata",
		"sfiata",
		"sfibbiata",
		"sfibrata",
		"sfidata",
		"sfiduciata",
		"sfigurata",
		"sfilata",
		"sfilettata",
		"sfinita",
		"sfioccata",
		"sfiorata",
		"sfittata",
		"sfocata",
		"sfociata",
		"sfoderata",
		"sfogata",
		"sfoggiata",
		"sfogliata",
		"sfollata",
		"sfoltita",
		"sfondata",
		"sforacchiata",
		"sforata",
		"sforbiciata",
		"sformata",
		"sfornaciata",
		"sfornata",
		"sfornita",
		"sforzata",
		"sfottuta",
		"sfracellata",
		"sfrangiata",
		"sfrascata",
		"sfratata",
		"sfrattata",
		"sfrecciata",
		"sfregata",
		"sfregiata",
		"sfrenata",
		"sfrisata",
		"sfrondata",
		"sfrucugliata",
		"sfruculiata",
		"sfruttata",
		"sfumata",
		"sfuocata",
		"sgamata",
		"sganasciata",
		"sganciata",
		"sgarbugliata",
		"sgattaiolata",
		"sgelata",
		"sghiacciata",
		"sgocciolata",
		"sgolata",
		"sgomberata",
		"sgombrata",
		"sgomentata",
		"sgominata",
		"sgomitata",
		"sgomitolata",
		"sgonfiata",
		"sgorbiata",
		"sgottata",
		"sgovernata",
		"sgozzata",
		"sgraffiata",
		"sgraffignata",
		"sgranata",
		"sgranchita",
		"sgranellata",
		"sgrassata",
		"sgravata",
		"sgretolata",
		"sgridata",
		"sgrommata",
		"sgrondata",
		"sgroppata",
		"sgrossata",
		"sgrovigliata",
		"sgrugnata",
		"sguainata",
		"sgualcita",
		"sguanciata",
		"sguarnita",
		"sguinzagliata",
		"sgusciata",
		"shakerata",
		"shoccata",
		"shuntata",
		"sigillata",
		"siglata",
		"significata",
		"signoreggiata",
		"silenziata",
		"silicizzata",
		"sillabata",
		"sillogizzata",
		"silurata",
		"simboleggiata",
		"simbolizzata",
		"simmetrizzata",
		"simpatizzata",
		"simulata",
		"sincerata",
		"sincopata",
		"sincretizzata",
		"sincronizzata",
		"sindacalizzata",
		"sindacata",
		"singolarizzata",
		"sinistrata",
		"sinizzata",
		"sinterizzata",
		"sintetizzata",
		"sintonizzata",
		"siringata",
		"sistematizzata",
		"sistemata",
		"situata",
		"slabbrata",
		"slacciata",
		"slamata",
		"slanciata",
		"slappolata",
		"slargata",
		"slavizzata",
		"slegata",
		"slentata",
		"slinguata",
		"slogata",
		"sloggata",
		"sloggiata",
		"slombata",
		"slungata",
		"smaccata",
		"smacchiata",
		"smagliata",
		"smagnetizzata",
		"smagrita",
		"smaliziata",
		"smallata",
		"smaltata",
		"smaltita",
		"smammata",
		"smanacciata",
		"smangiata",
		"smantellata",
		"smarcata",
		"smarginata",
		"smarrita",
		"smascellata",
		"smascherata",
		"smaterializzata",
		"smattonata",
		"smembrata",
		"smentita",
		"smerciata",
		"smerdata",
		"smerigliata",
		"smerlata",
		"smerlettata",
		"smessala",
		"smessa",
		"smezzata",
		"smidollata",
		"smielata",
		"smilitarizzata",
		"sminata",
		"sminuita",
		"sminuzzata",
		"smistata",
		"smitizzata",
		"smobiliata",
		"smobilitata",
		"smobilizzata",
		"smoccolata",
		"smollicata",
		"smonacata",
		"smontata",
		"smorbata",
		"smorzata",
		"smossa",
		"smozzicata",
		"smunta",
		"smurata",
		"smussata",
		"smutandata",
		"snaturata",
		"snazionalizzata",
		"snebbiata",
		"snellita",
		"snervata",
		"snidata",
		"sniffata",
		"snobbata",
		"snocciolata",
		"snodata",
		"snudata",
		"sobbarcata",
		"sobbollita",
		"sobillata",
		"socchiusa",
		"soccorsa",
		"soddisfatta",
		"sodisfatta",
		"sodomizzata",
		"sofferita",
		"soffermata",
		"sofferta",
		"soffiata",
		"soffocata",
		"soffregata",
		"soffritta",
		"soffusa",
		"sofisticata",
		"soggettivata",
		"soggettivizzata",
		"sogghignata",
		"soggiogata",
		"soggiunta",
		"sogguardata",
		"sognata",
		"solarizzata",
		"solcata",
		"soleggiata",
		"solennizzata",
		"solfeggiata",
		"solfitata",
		"solfonata",
		"solforata",
		"solidificata",
		"solita",
		"sollazzata",
		"sollecitata",
		"solleticata",
		"sollevata",
		"solta",
		"solubilizzata",
		"soluta",
		"soluzionata",
		"solvatata",
		"somatizzata",
		"someggiata",
		"somigliata",
		"sommata",
		"sommersa",
		"sommessa",
		"somministrata",
		"sommossa",
		"sonata",
		"sondata",
		"sonorizzata",
		"sopita",
		"soppalcata",
		"soppesata",
		"soppiantata",
		"sopportata",
		"sopposta",
		"soppressa",
		"sopraddotata",
		"sopraeccitata",
		"sopraedificata",
		"sopraelevata",
		"sopraffata",
		"sopraffatta",
		"sopraggiunta",
		"sopraintesa",
		"soprammessa",
		"soprannominata",
		"sopraposta",
		"soprappresa",
		"soprascritta",
		"sopraspesa",
		"soprassaturata",
		"soprasseduta",
		"sopravanzata",
		"sopravvalutata",
		"sopravveduta",
		"sopravvinta",
		"sopravvista",
		"sopreccitata",
		"sopredificata",
		"soprelevata",
		"soprintesa",
		"sorbettata",
		"sorbita",
		"sorgiunta",
		"sormontata",
		"sorpassata",
		"sorpresa",
		"sorrasa",
		"sorretta",
		"sorseggiata",
		"sorteggiata",
		"sortita",
		"sorvegliata",
		"sorvolata",
		"soscritta",
		"sospesa",
		"sospettata",
		"sospinta",
		"sospirata",
		"sostantivata",
		"sostanziata",
		"sostentata",
		"sostenuta",
		"sostituita",
		"sottaciuta",
		"sotterrata",
		"sottesa",
		"sottintesa",
		"sottoalimentata",
		"sottocapitalizzata",
		"sottodivisa",
		"sottoesposta",
		"sottofirmata",
		"sottolineata",
		"sottomessa",
		"sottomurata",
		"sottopagata",
		"sottopassata",
		"sottoposta",
		"sottorappresentata",
		"sottorisa",
		"sottoscritta",
		"sottostimata",
		"sottosviluppata",
		"sottotitolata",
		"sottovalutata",
		"sottratta",
		"soverchiata",
		"sovesciata",
		"sovietizzata",
		"sovracapitalizzata",
		"sovraccaricata",
		"sovradimensionata",
		"sovraeccitata",
		"sovraesposta",
		"sovraffaticata",
		"sovraffollata",
		"sovraggiunta",
		"sovraimposta",
		"sovraintesa",
		"sovralimentata",
		"sovramodulata",
		"sovrappopolata",
		"sovrapposta",
		"sovrariscaldata",
		"sovrasaturata",
		"sovrascritta",
		"sovrastampata",
		"sovrastata",
		"sovrastimata",
		"sovrautilizzata",
		"sovreccitata",
		"sovresposta",
		"sovrimposta",
		"sovrintesa",
		"sovvenuta",
		"sovvenzionata",
		"sovvertita",
		"spaccata",
		"spacchettata",
		"spacciata",
		"spaginata",
		"spaiata",
		"spalancata",
		"spalata",
		"spalcata",
		"spalleggiata",
		"spalmata",
		"spammata",
		"spampanata",
		"spampinata",
		"spanata",
		"spanciata",
		"spanduta",
		"spannata",
		"spannocchiata",
		"spansa",
		"spantanata",
		"spanta",
		"spaparacchiata",
		"spaparanzata",
		"spappolata",
		"sparata",
		"sparecchiata",
		"sparigliata",
		"sparita",
		"sparlata",
		"sparpagliata",
		"spartita",
		"spassata",
		"spassatosela",
		"spastoiata",
		"spaurata",
		"spaurita",
		"spaventata",
		"spazializzata",
		"spaziata",
		"spazieggiata",
		"spazientita",
		"spazzata",
		"spazzolata",
		"specchiata",
		"specializzata",
		"specificata",
		"specillata",
		"specolata",
		"spedita",
		"spegnata",
		"spelacchiata",
		"spelata",
		"spellata",
		"spennacchiata",
		"spennata",
		"spennellata",
		"spenta",
		"spenzolata",
		"sperata",
		"sperimentata",
		"spernacchiata",
		"speronata",
		"sperperata",
		"spersonalizzata",
		"sperticata",
		"spesata",
		"spesa",
		"spessita",
		"spettacolarizzata",
		"spettinata",
		"spezzata",
		"spezzettata",
		"spezziata",
		"spezzonata",
		"spiaccicata",
		"spianata",
		"spiantata",
		"spiata",
		"spiattellata",
		"spiazzata",
		"spiccata",
		"spicciata",
		"spiccicata",
		"spicciolata",
		"spicconata",
		"spidocchiata",
		"spiegata",
		"spiegazzata",
		"spietrata",
		"spifferata",
		"spigionata",
		"spignorata",
		"spigolata",
		"spigrita",
		"spillata",
		"spilluzzicata",
		"spiluccata",
		"spinta",
		"spintonata",
		"spiombata",
		"spiralizzata",
		"spirantizzata",
		"spirata",
		"spiritualizzata",
		"spiumata",
		"spizzicata",
		"spodestata",
		"spoetizzata",
		"spogliata",
		"spolettata",
		"spoliata",
		"spoliticizzata",
		"spollonata",
		"spolmonata",
		"spolpata",
		"spoltronita",
		"spolverata",
		"spolverizzata",
		"spompata",
		"spompinata",
		"sponsorizzata",
		"spopolata",
		"spoppata",
		"sporcata",
		"sportata",
		"sporta",
		"sposata",
		"sposseduta",
		"spossessata",
		"spostata",
		"sposta",
		"sprangata",
		"sprecata",
		"spregiata",
		"spremuta",
		"spretata",
		"sprezzata",
		"sprigionata",
		"sprimacciata",
		"spromessa",
		"spronata",
		"sprotetta",
		"sprovincializzata",
		"sprovveduta",
		"sprovvista",
		"spruzzata",
		"spugnata",
		"spulata",
		"spulciata",
		"spuntata",
		"spuntellata",
		"spupazzata",
		"spurgata",
		"sputacchiata",
		"sputata",
		"sputtanata",
		"squadernata",
		"squadrata",
		"squagliata",
		"squagliatasela",
		"squagliata",
		"squalificata",
		"squamata",
		"squarciata",
		"squartata",
		"squassata",
		"squattrinata",
		"squilibrata",
		"squinternata",
		"sradicata",
		"srotolata",
		"srugginita",
		"stabbiata",
		"stabilita",
		"stabilizzata",
		"stabulata",
		"staccata",
		"stacciata",
		"staffata",
		"staffilata",
		"staggiata",
		"staggita",
		"stagionata",
		"stagliata",
		"stagnata",
		"stamburata",
		"stampata",
		"stampigliata",
		"stanata",
		"stancata",
		"standardizzata",
		"stangata",
		"stanziata",
		"stappata",
		"starata",
		"starnazzata",
		"stasata",
		"statalizzata",
		"statizzata",
		"statoca",
		"statosena",
		"statuita",
		"stazzata",
		"stazzonata",
		"steccacciata",
		"steccata",
		"stecchita",
		"stecconata",
		"stemperata",
		"stempiata",
		"stenografata",
		"stereotipata",
		"sterilita",
		"sterilizzata",
		"sterpata",
		"sterrata",
		"sterzata",
		"stesa",
		"stigliata",
		"stigmatizzata",
		"stilata",
		"stilettata",
		"stilizzata",
		"stillata",
		"stimata",
		"stimolata",
		"stinta",
		"stipata",
		"stipendiata",
		"stipulata",
		"stiracchiata",
		"stirata",
		"stivata",
		"stizzita",
		"stoccata",
		"stolta",
		"stomacata",
		"stonata",
		"stondata",
		"stoppata",
		"stordita",
		"storicizzata",
		"stornata",
		"storpiata",
		"stortata",
		"storta",
		"stozzata",
		"strabenedetta",
		"strabuzzata",
		"stracannata",
		"straccata",
		"stracciata",
		"stracotta",
		"strafogata",
		"stragoduta",
		"stralciata",
		"stralodata",
		"stralunata",
		"stramaledetta",
		"stramortita",
		"strangolata",
		"straniata",
		"stranita",
		"straorzata",
		"strapagata",
		"strapazzata",
		"straperduta",
		"strapersa",
		"strappata",
		"strasaputa",
		"strascicata",
		"strascinata",
		"strasformata",
		"stratificata",
		"strattonata",
		"stravaccata",
		"stravinta",
		"stravolta",
		"stravoluta",
		"straziata",
		"stregata",
		"stremata",
		"stressata",
		"striata",
		"stridulata",
		"strigata",
		"strigliata",
		"strillata",
		"striminzita",
		"strimpellata",
		"strinata",
		"stringata",
		"strisciata",
		"stritolata",
		"strizzata",
		"strofinata",
		"strombata",
		"strombazzata",
		"stroncata",
		"stronzata",
		"stropicciata",
		"stroppata",
		"stroppiata",
		"strozzata",
		"struccata",
		"strumentalizzata",
		"strumentata",
		"strusciata",
		"strutta",
		"strutturalizzata",
		"strutturata",
		"stuccata",
		"studiacchiata",
		"studiata",
		"stuellata",
		"stufata",
		"stupefatta",
		"stupita",
		"stuprata",
		"sturata",
		"stutata",
		"stuzzicata",
		"suasa",
		"subaffittata",
		"subappaltata",
		"subbiata",
		"subdelegata",
		"subissata",
		"subita",
		"sublicenziata",
		"sublimata",
		"sublocata",
		"subodorata",
		"subordinata",
		"subornata",
		"suburbanizzata",
		"sucata",
		"succhiata",
		"succhiellata",
		"succiata",
		"succinta",
		"succisa",
		"suddistinta",
		"suddivisa",
		"suffissata",
		"suffissa",
		"suffragata",
		"suffumicata",
		"suffusa",
		"suggellata",
		"suggerita",
		"suggestionata",
		"suicidata",
		"sunteggiata",
		"sunta",
		"suolata",
		"suonata",
		"superata",
		"superpagata",
		"superraffreddata",
		"supervalutata",
		"supervisionata",
		"supplicata",
		"supplita",
		"supportata",
		"supposta",
		"suppurata",
		"surclassata",
		"surfata",
		"surgelata",
		"surraffreddata",
		"surriscaldata",
		"surrogata",
		"survoltata",
		"suscitata",
		"susseguita",
		"sussidiata",
		"sussunta",
		"sussurrata",
		"suturata",
		"svaccata",
		"svagata",
		"svaligiata",
		"svalutata",
		"svapata",
		"svariata",
		"svasata",
		"svecchiata",
		"svegliata",
		"svelata",
		"svelenita",
		"sveltita",
		"svelta",
		"svenata",
		"svenduta",
		"sventagliata",
		"sventata",
		"sventolata",
		"sventrata",
		"sverginata",
		"svergognata",
		"svergolata",
		"sverminata",
		"sverniciata",
		"svestita",
		"svettata",
		"svezzata",
		"sviata",
		"svignatosela",
		"svigorita",
		"svilita",
		"svillaneggiata",
		"sviluppata",
		"svinata",
		"svincolata",
		"sviolinata",
		"svirgolata",
		"svirilizzata",
		"svisata",
		"sviscerata",
		"svitata",
		"sviticchiata",
		"svolata",
		"svolazzata",
		"svolta",
		"svoluta",
		"svuotata",
		"tabuizzata",
		"tabulata",
		"taccata",
		"taccheggiata",
		"tacciata",
		"tacitata",
		"taciuta",
		"tagliata",
		"taglieggiata",
		"tagliuzzata",
		"talebanizzata",
		"tallonata",
		"tampinata",
		"tamponata",
		"tanguta",
		"tannata",
		"tappata",
		"tappezzata",
		"tarata",
		"tardata",
		"targata",
		"tariffata",
		"tarlata",
		"tarmata",
		"taroccata",
		"tarpata",
		"tartagliata",
		"tartassata",
		"tartufata",
		"tassata",
		"tassellata",
		"tastata",
		"tasteggiata",
		"tatuata",
		"tecnicizzata",
		"tecnologizzata",
		"tedeschizzata",
		"tediata",
		"teflonata",
		"telecomandata",
		"telecontrollata",
		"telediffusa",
		"telefonata",
		"telegrafata",
		"teleguidata",
		"telematizzata",
		"telemetrata",
		"teleradiotrasmessa",
		"teletrasmessa",
		"teletrasportata",
		"tematizzata",
		"temperata",
		"tempestata",
		"tempificata",
		"templatizzata",
		"temporizzata",
		"temprata",
		"temuta",
		"tentata",
		"tenuta",
		"teologizzata",
		"teorizzata",
		"tepefatta",
		"terebrata",
		"terminata",
		"termostatata",
		"terrazzata",
		"terrificata",
		"terrorizzata",
		"tersa",
		"terzarolata",
		"terziarizzata",
		"terziata",
		"tesata",
		"tesaurizzata",
		"tesa",
		"tesserata",
		"testata",
		"testificata",
		"testimoniata",
		"timbrata",
		"tindalizzata",
		"tinteggiata",
		"tinta",
		"tipicizzata",
		"tipizzata",
		"tippata",
		"tiranneggiata",
		"tirata",
		"titillata",
		"titolata",
		"toccata",
		"toelettata",
		"tollerata",
		"tolta",
		"tonalizzata",
		"tonificata",
		"tonneggiata",
		"tonsurata",
		"torchiata",
		"tormentata",
		"tornatosena",
		"tornita",
		"torrefatta",
		"torta",
		"tortoreggiata",
		"torturata",
		"tosata",
		"toscaneggiata",
		"toscanizzata",
		"tostata",
		"totalizzata",
		"traboccata",
		"trabuccata",
		"tracannata",
		"tracciata",
		"tradita",
		"tradotta",
		"trafficata",
		"trafilata",
		"trafitta",
		"traforata",
		"trafugata",
		"traghettata",
		"traguardata",
		"trainata",
		"tralasciata",
		"tralignata",
		"tramandata",
		"tramata",
		"trambasciata",
		"tramessa",
		"tramestata",
		"tramezzata",
		"tramortita",
		"tramutata",
		"tranciata",
		"trangugiata",
		"tranquillata",
		"tranquillizzata",
		"transatta",
		"transcesa",
		"transcodificata",
		"transcorsa",
		"transcritta",
		"transennata",
		"transfluita",
		"transfusa",
		"transistorizzata",
		"translitterata",
		"transposta",
		"transricevuta",
		"transustanziata",
		"transveduta",
		"transvista",
		"trapanata",
		"trapassata",
		"trapiantata",
		"traportata",
		"traposta",
		"trapposta",
		"trapuntata",
		"trapunta",
		"trarotta",
		"trasandata",
		"trasbordata",
		"trascelta",
		"trascesa",
		"trascinata",
		"trascorsa",
		"trascritta",
		"trascurata",
		"trasdotta",
		"trasferita",
		"trasfigurata",
		"trasformata",
		"trasfusa",
		"trasgredita",
		"traslata",
		"traslitterata",
		"traslocata",
		"trasmessa",
		"trasmutata",
		"trasparita",
		"traspirata",
		"trasportata",
		"trasposta",
		"trastullata",
		"trasudata",
		"trasvolata",
		"trasvolta",
		"trattata",
		"tratteggiata",
		"trattenuta",
		"tratta",
		"traumatizzata",
		"travagliata",
		"travalicata",
		"travasata",
		"traveduta",
		"traversata",
		"travestita",
		"traviata",
		"travisata",
		"travista",
		"travolta",
		"trebbiata",
		"triangolata",
		"tribbiata",
		"tribolata",
		"tributata",
		"triennalizzata",
		"trimestralizzata",
		"trincata",
		"trincerata",
		"trinciata",
		"tripartita",
		"triplicata",
		"trisecata",
		"trisezionata",
		"tritata",
		"triturata",
		"trivellata",
		"trollata",
		"trombata",
		"troncata",
		"tropicalizzata",
		"trovata",
		"truccata",
		"trucidata",
		"truffata",
		"tuffata",
		"tumefatta",
		"tumulata",
		"turata",
		"turbata",
		"turlupinata",
		"tutelata",
		"ubbligata",
		"ubicata",
		"ubidita",
		"ubiquitinata",
		"ubriacata",
		"uccellata",
		"uccellinata",
		"uccisa",
		"udita",
		"ufficializzata",
		"uggita",
		"ugnata",
		"uguagliata",
		"ulcerata",
		"ulita",
		"ulolata",
		"ultimata",
		"ultracentrifugata",
		"ululata",
		"umanata",
		"umanizzata",
		"umettata",
		"umidificata",
		"umidita",
		"umiliata",
		"uncinata",
		"unguentata",
		"unificata",
		"uniformata",
		"unita",
		"univerbata",
		"universaleggiata",
		"universalizzata",
		"untata",
		"unta",
		"uperizzata",
		"urbanizzata",
		"urgenzata",
		"urlata",
		"urtacchiata",
		"urtata",
		"urticchiata",
		"usata",
		"usciolata",
		"usolata",
		"ustionata",
		"usucapita",
		"usurata",
		"usurpata",
		"utilitata",
		"utilizzata",
		"vaccinata",
		"vagabondeggiata",
		"vagellata",
		"vagheggiata",
		"vagillata",
		"vagliata",
		"valcata",
		"valicata",
		"validata",
		"valorizzata",
		"valsa",
		"valutata",
		"vanagloriata",
		"vanata",
		"vandalizzata",
		"vangata",
		"vangelizzata",
		"vanificata",
		"vanita",
		"vantaggiata",
		"vantata",
		"vaporata",
		"vaporizzata",
		"varata",
		"varcata",
		"variata",
		"vasectomizzata",
		"vaticinata",
		"vedovata",
		"veduta",
		"vegetata",
		"veggiata",
		"vegliata",
		"veicolata",
		"velarizzata",
		"velata",
		"velettata",
		"velinata",
		"vellicata",
		"vellutata",
		"velocizzata",
		"vendemmiata",
		"vendicata",
		"vendicchiata",
		"venducchiata",
		"venduta",
		"venerata",
		"vengiata",
		"ventagliata",
		"ventilata",
		"ventolata",
		"verbalizzata",
		"vergata",
		"vergheggiata",
		"vergognata",
		"vergolata",
		"verificata",
		"verminata",
		"vernalizzata",
		"verniciata",
		"verrinata",
		"versata",
		"verseggiata",
		"versificata",
		"verticalizzata",
		"vessata",
		"vestita",
		"vestita",
		"vetrificata",
		"vetrinata",
		"vetrioleggiata",
		"vettovagliata",
		"vezzeggiata",
		"viaggiata",
		"vicinata",
		"vicitata",
		"videochattata",
		"videochiamata",
		"videocomunicata",
		"videoregistrata",
		"videotrasmessa",
		"vidimata",
		"vigilata",
		"vigliata",
		"vigoreggiata",
		"vigorita",
		"vilificata",
		"vilipesa",
		"villaneggiata",
		"vincolata",
		"vinta",
		"violata",
		"violentata",
		"violinata",
		"virgolata",
		"virgoleggiata",
		"virgolettata",
		"virilizzata",
		"virtualizzata",
		"visionata",
		"visitata",
		"vissuta",
		"vistata",
		"vista",
		"visualizzata",
		"vitaliziata",
		"vitalizzata",
		"vitaminizzata",
		"vittimizzata",
		"vituperata",
		"vivacizzata",
		"vivandata",
		"vivificata",
		"vivisezionata",
		"viziata",
		"vocabolarizzata",
		"vocalizzata",
		"vocata",
		"vociferata",
		"volantinata",
		"volatilizzata",
		"volgarizzata",
		"volicchiata",
		"volpeggiata",
		"voltata",
		"volta",
		"voltolata",
		"volturata",
		"voluminizzata",
		"voluta",
		"volutoca",
		"vomitata",
		"vorata",
		"votata",
		"vulcanizzata",
		"vuotata",
		"wappata",
		"wikificata",
		"xerocopiata",
		"zaffata",
		"zampata",
		"zampettata",
		"zampillata",
		"zannata",
		"zappata",
		"zappettata",
		"zapponata",
		"zavorrata",
		"zeppata",
		"zigrinata",
		"zigzagata",
		"zimbellata",
		"zincata",
		"zinnata",
		"zipolata",
		"zippata",
		"zirlata",
		"zittita",
		"zizzagata",
		"zoccolata",
		"zollata",
		"zombata",
		"zonata",
		"zonizzata",
		"zoppata",
		"zoppeggiata",
		"zoppicata",
		"zucconata",
		"zufolata",
		"zumata",
		"zuppata",
		"abalienate",
		"abbacchiate",
		"abbacinate",
		"abbadate",
		"abbagliate",
		"abbaiate",
		"abballate",
		"abbambinate",
		"abbancate",
		"abbandonate",
		"abbarbagliate",
		"abbarbate",
		"abbarcate",
		"abbaruffate",
		"abbassate",
		"abbatacchiate",
		"abbattute",
		"abbatuffolate",
		"abbelite",
		"abbellate",
		"abbellite",
		"abbendate",
		"abbeverate",
		"abbiadate",
		"abbicate",
		"abbigliate",
		"abbinate",
		"abbindolate",
		"abbioccate",
		"abbiosciate",
		"abbisciate",
		"abbittate",
		"abboccate",
		"abboffate",
		"abbominate",
		"abbonacciate",
		"abbonate",
		"abbonite",
		"abbordate",
		"abborracciate",
		"abborrate",
		"abborrite",
		"abbottinate",
		"abbottonate",
		"abbozzacchiate",
		"abbozzate",
		"abbozzolate",
		"abbracciate",
		"abbraciate",
		"abbrancate",
		"abbreviate",
		"abbriccate",
		"abbrigliate",
		"abbrivate",
		"abbriviate",
		"abbrividite",
		"abbronzate",
		"abbrostolate",
		"abbrostolite",
		"abbruciacchiate",
		"abbruciate",
		"abbrunate",
		"abbrunite",
		"abbruscate",
		"abbrusciate",
		"abbrustiate",
		"abbrustolate",
		"abbrustolite",
		"abbrutite",
		"abbruttite",
		"abbuffate",
		"abbuiate",
		"abbuonate",
		"abburattate",
		"abbuzzite",
		"abdicate",
		"abdotte",
		"abiettate",
		"abilitate",
		"abissate",
		"abitate",
		"abituate",
		"abiurate",
		"abolite",
		"abominate",
		"abondate",
		"aborrite",
		"abrase",
		"abrogate",
		"abusate",
		"accaffate",
		"accagionate",
		"accagliate",
		"accalappiate",
		"accalcate",
		"accaldate",
		"accallate",
		"accalorate",
		"accalorite",
		"accambiate",
		"accampate",
		"accampionate",
		"accanalate",
		"accanate",
		"accaneggiate",
		"accanite",
		"accantonate",
		"accaparrate",
		"accapezzate",
		"accapigliate",
		"accapottate",
		"accappiate",
		"accappiettate",
		"accapponate",
		"accappucciate",
		"accaprettate",
		"accareggiate",
		"accarezzate",
		"accarnate",
		"accarpionate",
		"accartocciate",
		"accasate",
		"accasciate",
		"accasellate",
		"accasermate",
		"accastellate",
		"accastellinate",
		"accatarrate",
		"accatastate",
		"accattate",
		"accattivate",
		"accavalcate",
		"accavalciate",
		"accavallate",
		"accavezzate",
		"accecate",
		"acceffate",
		"accelerate",
		"accellerate",
		"accennate",
		"accensate",
		"accentate",
		"accentrate",
		"accentuate",
		"acceppate",
		"accerchiate",
		"accercinate",
		"accertate",
		"accese",
		"accessoriate",
		"accettate",
		"acchetate",
		"acchiappate",
		"acchiocciolate",
		"acchitate",
		"acchiudute",
		"acciabattate",
		"acciaiate",
		"acciambellate",
		"acciarpate",
		"acciecate",
		"accigliate",
		"acciglionate",
		"accignute",
		"accincignate",
		"accinte",
		"acciocchite",
		"acciottolate",
		"accipigliate",
		"accismate",
		"accise",
		"acciucchite",
		"acciuffate",
		"accivettate",
		"acclamate",
		"acclarate",
		"acclimatate",
		"accluse",
		"accoccate",
		"accoccolate",
		"accoccovate",
		"accodate",
		"accollate",
		"accoltellate",
		"accolte",
		"accomandate",
		"accomiatate",
		"accommiatate",
		"accomodate",
		"accompagnate",
		"accomunate",
		"acconciate",
		"acconigliate",
		"accontate",
		"accontentate",
		"accoppate",
		"accoppiate",
		"accorate",
		"accorciate",
		"accorcite",
		"accordate",
		"accordellate",
		"accorpate",
		"accorte",
		"accosciate",
		"accostate",
		"accostumate",
		"accotonate",
		"accottimate",
		"accovacciate",
		"accovate",
		"accovonate",
		"accozzate",
		"accreditate",
		"accresciute",
		"accrespate",
		"accucciate",
		"accucciolate",
		"accudite",
		"acculate",
		"acculturate",
		"accumulate",
		"accumunate",
		"accusate",
		"acetificate",
		"acetilate",
		"acetite",
		"acidate",
		"acidificate",
		"acidulate",
		"acquadernate",
		"acquarellate",
		"acquartierate",
		"acquate",
		"acquattate",
		"acquerellate",
		"acquetate",
		"acquietate",
		"acquisite",
		"acquistate",
		"acromatizzate",
		"acuite",
		"acuminate",
		"acutizzate",
		"adacquate",
		"adagiate",
		"adattate",
		"addaziate",
		"addebbiate",
		"addebitate",
		"addecimate",
		"addensate",
		"addentate",
		"addentellate",
		"addentrate",
		"addestrate",
		"addette",
		"addiacciate",
		"addimandate",
		"addimesticate",
		"addimorate",
		"addimostrate",
		"addipanate",
		"addirizzate",
		"additate",
		"additivate",
		"addizionate",
		"addobbate",
		"addocilite",
		"addogliate",
		"addolcate",
		"addolciate",
		"addolcite",
		"addolorate",
		"addomandate",
		"addomesticate",
		"addoppiate",
		"addormentate",
		"addossate",
		"addotte",
		"addottorate",
		"addottrinate",
		"addrizzate",
		"adduate",
		"addugliate",
		"adeguate",
		"adempite",
		"adempiute",
		"adequate",
		"aderizzate",
		"adescate",
		"adibite",
		"adirate",
		"adite",
		"adiuvate",
		"adizzate",
		"adocchiate",
		"adombrate",
		"adonate",
		"adonestate",
		"adontate",
		"adoperate",
		"adoprate",
		"adorate",
		"adornate",
		"adottate",
		"adsorbite",
		"aduggiate",
		"adugnate",
		"adulate",
		"adulterate",
		"adunate",
		"adunghiate",
		"adusate",
		"aerate",
		"aereate",
		"aerotrainate",
		"aerotrasportate",
		"affabulate",
		"affaccendate",
		"affacchinate",
		"affacciate",
		"affagottate",
		"affaldate",
		"affamate",
		"affamigliate",
		"affannate",
		"affardellate",
		"affascinate",
		"affastellate",
		"affaticate",
		"affattucchiate",
		"affatturate",
		"affermate",
		"afferrate",
		"affettate",
		"affezionate",
		"affiancate",
		"affiatate",
		"affibbiate",
		"affidate",
		"affienate",
		"affievolite",
		"affigliate",
		"affigurate",
		"affilate",
		"affilettate",
		"affiliate",
		"affinate",
		"affiochite",
		"affiorate",
		"affisate",
		"affissate",
		"affisse",
		"affittate",
		"affittite",
		"afflitte",
		"afflosciate",
		"affocate",
		"affogate",
		"affogliate",
		"affollate",
		"affoltate",
		"affondate",
		"afforcate",
		"afforestate",
		"afforzate",
		"affossate",
		"affralite",
		"affrancate",
		"affrante",
		"affratellate",
		"affrenate",
		"affrenellate",
		"affrescate",
		"affrettate",
		"affrittellate",
		"affrontate",
		"affumate",
		"affumicate",
		"affumigate",
		"affuocate",
		"affusolate",
		"africanizzate",
		"ageminate",
		"agevolate",
		"aggallate",
		"agganciate",
		"aggangherate",
		"aggarbate",
		"aggattonate",
		"aggavignate",
		"aggelate",
		"aggettivate",
		"agghiacciate",
		"agghiadate",
		"agghiaiate",
		"agghindate",
		"aggiaccate",
		"aggiogate",
		"aggiornate",
		"aggirate",
		"aggiucchite",
		"aggiudicate",
		"aggiuntate",
		"aggiunte",
		"aggiustate",
		"agglomerate",
		"agglutinate",
		"aggomitolate",
		"aggottate",
		"aggradite",
		"aggraffate",
		"aggranchiate",
		"aggranchite",
		"aggrandite",
		"aggrappate",
		"aggraticciate",
		"aggravate",
		"aggredite",
		"aggregate",
		"aggrevate",
		"aggricciate",
		"aggrinzate",
		"aggrinzite",
		"aggrommate",
		"aggrondate",
		"aggroppate",
		"aggrottate",
		"aggrovigliate",
		"aggrumate",
		"aggruppate",
		"aggruzzolate",
		"agguagliate",
		"agguantate",
		"agguardate",
		"agguatate",
		"aggueffate",
		"agitate",
		"agognate",
		"agrarizzate",
		"aguatate",
		"agucchiate",
		"agunate",
		"agurate",
		"aguzzate",
		"aitate",
		"aiutate",
		"aizzate",
		"alate",
		"alberate",
		"albergate",
		"alcalinizzate",
		"alchilate",
		"alchimiate",
		"alchimizzate",
		"alcolizzate",
		"alcoolizzate",
		"alenate",
		"alesate",
		"alettate",
		"alfabetate",
		"alfabetizzate",
		"alidite",
		"alienate",
		"alimentate",
		"allacciate",
		"allagate",
		"allappate",
		"allargate",
		"allascate",
		"allattate",
		"alleate",
		"allegate",
		"alleggerite",
		"alleggiate",
		"allegorizzate",
		"alleluiate",
		"allenate",
		"allenite",
		"allentate",
		"allertate",
		"allessate",
		"allestite",
		"allettate",
		"allevate",
		"alleviate",
		"allibate",
		"allibite",
		"allibrate",
		"allicciate",
		"allietate",
		"allindate",
		"allineate",
		"allise",
		"allocate",
		"allogate",
		"alloggiate",
		"allontanate",
		"allottate",
		"allucchettate",
		"allucciolate",
		"allucinate",
		"allumate",
		"alluminate",
		"alluminiate",
		"allungate",
		"allupate",
		"alluse",
		"alluzzate",
		"alogenate",
		"alonate",
		"alpeggiate",
		"alterate",
		"alternate",
		"alzate",
		"amalgamate",
		"amareggiate",
		"amaricate",
		"amate",
		"ambientate",
		"ambiguate",
		"ambite",
		"americanizzate",
		"amicate",
		"ammaccate",
		"ammaestrate",
		"ammainate",
		"ammalate",
		"ammaliate",
		"ammalinconite",
		"ammaltate",
		"ammanettate",
		"ammanicate",
		"ammanierate",
		"ammanigliate",
		"ammannate",
		"ammannellate",
		"ammannite",
		"ammansate",
		"ammansite",
		"ammantate",
		"ammantellate",
		"ammarate",
		"ammarezzate",
		"ammassate",
		"ammassellate",
		"ammassicciate",
		"ammatassate",
		"ammattonate",
		"ammazzate",
		"ammelmate",
		"ammencite",
		"ammendate",
		"ammennicolate",
		"ammesse",
		"ammetate",
		"ammezzite",
		"amministrate",
		"amminutate",
		"ammirate",
		"ammiserite",
		"ammobiliate",
		"ammodernate",
		"ammodernizzate",
		"ammogliate",
		"ammoinate",
		"ammollate",
		"ammollite",
		"ammonite",
		"ammonticchiate",
		"ammonticellate",
		"ammorbate",
		"ammorbidate",
		"ammorbidite",
		"ammorsate",
		"ammortate",
		"ammortite",
		"ammortizzate",
		"ammorzate",
		"ammosciate",
		"ammoscite",
		"ammostate",
		"ammotinate",
		"ammucchiate",
		"ammulinate",
		"ammusate",
		"ammutate",
		"ammutinate",
		"amnistiate",
		"amoracciate",
		"ampiate",
		"ampliate",
		"amplificate",
		"amputate",
		"anagrammate",
		"analizzate",
		"anamorfizzate",
		"anastomizzate",
		"anatematizzate",
		"anatomizzate",
		"anchilosate",
		"ancise",
		"ancorate",
		"andatosene",
		"andicappate",
		"anellate",
		"anemizzate",
		"anestetizzate",
		"angariate",
		"anglicizzate",
		"angolate",
		"angosciate",
		"angustiate",
		"animate",
		"annacquate",
		"annaffiate",
		"annasate",
		"annaspate",
		"annaspicate",
		"annebbiate",
		"annegate",
		"annerate",
		"annerite",
		"annesse",
		"annestate",
		"annichilate",
		"annichilite",
		"annidate",
		"annientate",
		"annitrite",
		"annobilite",
		"annodate",
		"annodicchiate",
		"annoiate",
		"annotate",
		"annottate",
		"annottolate",
		"annoverate",
		"annullate",
		"annunciate",
		"annunziate",
		"annusate",
		"annuvolate",
		"anodizzate",
		"anonimizzate",
		"antecedute",
		"anteposte",
		"antergate",
		"anticheggiate",
		"antichizzate",
		"anticipate",
		"anticonosciute",
		"antidatate",
		"antivedute",
		"antiviste",
		"antologizzate",
		"antropizzate",
		"antropomorfizzate",
		"aocchiate",
		"aombrate",
		"aonestate",
		"aontate",
		"aperte",
		"apocopate",
		"apologizzate",
		"apostrofate",
		"appaciate",
		"appacificate",
		"appagate",
		"appaiate",
		"appalesate",
		"appallottolate",
		"appaltate",
		"appanettate",
		"appannate",
		"apparate",
		"apparecchiate",
		"apparentate",
		"apparigliate",
		"apparite",
		"appartate",
		"appassionate",
		"appastate",
		"appastellate",
		"appellate",
		"appennellate",
		"appercepite",
		"appertizzate",
		"appesantite",
		"appesite",
		"appese",
		"appestate",
		"appetite",
		"appezzate",
		"appiacevolite",
		"appianate",
		"appiastrate",
		"appiatate",
		"appiattate",
		"appiattite",
		"appiccate",
		"appiccicate",
		"appiccolite",
		"appiedate",
		"appigionate",
		"appigliate",
		"appinzate",
		"appiombate",
		"appioppate",
		"appisolate",
		"applaudite",
		"applicate",
		"appoderate",
		"appoggiate",
		"appollaiate",
		"appoppate",
		"apportate",
		"appostate",
		"apposte",
		"appratite",
		"appresentate",
		"apprese",
		"appressate",
		"apprestate",
		"apprettate",
		"apprezzate",
		"approcciate",
		"approfittate",
		"approfondate",
		"approfondite",
		"approntate",
		"appropinquate",
		"appropriate",
		"approssimate",
		"approvate",
		"approvisionate",
		"approvvigionate",
		"appruate",
		"appulcrate",
		"appuntate",
		"appuntellate",
		"appuntite",
		"appurate",
		"appuzzate",
		"arabescate",
		"arabizzate",
		"arate",
		"arbitrate",
		"arborate",
		"arcaizzate",
		"arcate",
		"architettate",
		"archiviate",
		"arcuate",
		"ardite",
		"areate",
		"argentate",
		"arginate",
		"argomentate",
		"arguite",
		"arianizzate",
		"arieggiate",
		"armate",
		"armonizzate",
		"aromatizzate",
		"arpeggiate",
		"arpionate",
		"arponate",
		"arrabattate",
		"arraffate",
		"arraffiate",
		"arrandellate",
		"arrangiate",
		"arrapate",
		"arrapinate",
		"arrappate",
		"arrazzate",
		"arrecate",
		"arredate",
		"arreggimentate",
		"arrembate",
		"arrenate",
		"arresise",
		"arrese",
		"arrestate",
		"arretrate",
		"arricchite",
		"arricciate",
		"arricciolate",
		"arriffate",
		"arringate",
		"arrischiate",
		"arrisicate",
		"arrise",
		"arrocate",
		"arroccate",
		"arrochite",
		"arrogate",
		"arrolate",
		"arroncate",
		"arronzate",
		"arrosate",
		"arrossate",
		"arrostate",
		"arrostite",
		"arrotate",
		"arrotolate",
		"arrotondate",
		"arrovellate",
		"arroventate",
		"arroventite",
		"arrovesciate",
		"arrubinate",
		"arruffate",
		"arruffianate",
		"arrugginite",
		"arruncigliate",
		"arruolate",
		"arruvidite",
		"arsicciate",
		"arse",
		"artefatte",
		"articolate",
		"artigliate",
		"ascese",
		"asciate",
		"asciolvute",
		"asciugate",
		"ascoltate",
		"ascose",
		"ascoste",
		"ascritte",
		"asfaltate",
		"asfissiate",
		"asperse",
		"aspettate",
		"aspirate",
		"asportate",
		"aspreggiate",
		"assaettate",
		"assaggiate",
		"assalite",
		"assaltate",
		"assaporate",
		"assaporite",
		"assassinate",
		"assecondate",
		"assecurate",
		"assediate",
		"asseggiate",
		"assegnate",
		"assembiate",
		"assemblate",
		"assembrate",
		"assemprate",
		"assentate",
		"asserite",
		"asserragliate",
		"asservite",
		"assestate",
		"assetate",
		"assettate",
		"asseverate",
		"assibilate",
		"assicurate",
		"assiderate",
		"assiemate",
		"assiepate",
		"assillate",
		"assimigliate",
		"assimilate",
		"assiomatizzate",
		"assise",
		"assistite",
		"associate",
		"assodate",
		"assoggettate",
		"assolcate",
		"assoldate",
		"assolte",
		"assolutizzate",
		"assomate",
		"assommate",
		"assonate",
		"assonnate",
		"assopite",
		"assorbite",
		"assordate",
		"assordite",
		"assortite",
		"assottigliate",
		"assuefatte",
		"assunte",
		"asteggiate",
		"astenute",
		"asterse",
		"astratte",
		"astrette",
		"atomizzate",
		"atrofizzate",
		"atrovate",
		"attaccate",
		"attagliate",
		"attanagliate",
		"attardate",
		"attediate",
		"atteggiate",
		"attempate",
		"attendate",
		"attentate",
		"attenuate",
		"attenute",
		"attergate",
		"atterrate",
		"atterrite",
		"atterzate",
		"attese",
		"attestate",
		"atticizzate",
		"attillate",
		"attinte",
		"attirate",
		"attivate",
		"attivizzate",
		"attizzate",
		"attorcigliate",
		"attorniate",
		"attorte",
		"attoscate",
		"attossicate",
		"attraccate",
		"attrappite",
		"attratte",
		"attraversate",
		"attrezzate",
		"attribuite",
		"attristate",
		"attristite",
		"attruppate",
		"attualizzate",
		"attuate",
		"attuffate",
		"attutate",
		"attutite",
		"auggiate",
		"augumentate",
		"augurate",
		"aulite",
		"aumentate",
		"aunghiate",
		"ausate",
		"auscultate",
		"auspicate",
		"autenticate",
		"autentificate",
		"autoaccusate",
		"autoaffondate",
		"autoalimentate",
		"autoassolte",
		"autocandidate",
		"autocensurate",
		"autocitate",
		"autocommiserate",
		"autoconsumate",
		"autoconvinte",
		"autodefinite",
		"autodenunciate",
		"autodistrutte",
		"autofinanziate",
		"autogestite",
		"autogovernate",
		"autografate",
		"autoincensate",
		"autointersecate",
		"autoinvitate",
		"autolesionate",
		"autolimitate",
		"automaticizzate",
		"automatizzate",
		"automotivate",
		"autonominate",
		"autoproclamate",
		"autoprodotte",
		"autoprotette",
		"autopubblicate",
		"autopubblicizzate",
		"autoregolamentate",
		"autoregolate",
		"autoridotte",
		"autoriparate",
		"autorizzate",
		"autosomministrate",
		"autosostenute",
		"autosuggestionate",
		"autotassate",
		"autotrapiantate",
		"autotrasportate",
		"autovalutate",
		"avallate",
		"avampate",
		"avanzate",
		"avariate",
		"avinte",
		"aviolanciate",
		"aviotrasportate",
		"avocate",
		"avolterate",
		"avulse",
		"avutacele",
		"avute",
		"avvalorate",
		"avvalse",
		"avvantaggiate",
		"avvelate",
		"avvelenate",
		"avventate",
		"avventurate",
		"avverate",
		"avversate",
		"avvertite",
		"avvezzate",
		"avviate",
		"avvicendate",
		"avvicinate",
		"avvignate",
		"avvilite",
		"avviluppate",
		"avvinate",
		"avvinchiate",
		"avvinghiate",
		"avvinte",
		"avvisate",
		"avvistate",
		"avvitate",
		"avviticchiate",
		"avvitite",
		"avvivate",
		"avvolte",
		"avvoltolate",
		"aziendalizzate",
		"azionate",
		"azotate",
		"azzannate",
		"azzardate",
		"azzeccate",
		"azzerate",
		"azzimate",
		"azzittate",
		"azzittite",
		"azzoppate",
		"azzoppite",
		"azzuffate",
		"azzurrate",
		"bacate",
		"baccagliate",
		"bacchettate",
		"bacchiate",
		"baciate",
		"badate",
		"bagnate",
		"baipassate",
		"balbettate",
		"balcanizzate",
		"ballate",
		"baloccate",
		"balzate",
		"banalizzate",
		"bancate",
		"bandite",
		"bannate",
		"baraccate",
		"barattate",
		"barbarizzate",
		"barcamenate",
		"bardate",
		"barellate",
		"barrate",
		"barricate",
		"basate",
		"basciate",
		"basculate",
		"bassate",
		"bastate",
		"bastionate",
		"bastite",
		"bastonate",
		"battezzate",
		"battute",
		"bazzicate",
		"beatificate",
		"beate",
		"beccate",
		"beccheggiate",
		"becchettate",
		"beffate",
		"beffeggiate",
		"bendate",
		"benedette",
		"beneficate",
		"benvolute",
		"berlusconizzate",
		"bersagliate",
		"bestemmiate",
		"bevute",
		"biadate",
		"bianchettate",
		"bianchite",
		"biascicate",
		"biasimate",
		"biasmate",
		"bidonate",
		"biennalizzate",
		"biforcate",
		"bigiate",
		"bilanciate",
		"binate",
		"bindolate",
		"biodegradate",
		"biografate",
		"bipartite",
		"bisbigliate",
		"biscottate",
		"bisecate",
		"bisellate",
		"bisognate",
		"bissate",
		"bistrate",
		"bistrattate",
		"bitumate",
		"bituminate",
		"blandite",
		"bleffate",
		"blindate",
		"bloccate",
		"bobinate",
		"boccheggiate",
		"bocciate",
		"boicottate",
		"bollate",
		"bollite",
		"bombardate",
		"bombate",
		"bonderizzate",
		"bonificate",
		"bootate",
		"borbottate",
		"bordate",
		"boriate",
		"borrate",
		"borseggiate",
		"braccate",
		"bracciate",
		"bramate",
		"bramite",
		"brancicate",
		"brandeggiate",
		"brandite",
		"brasate",
		"bravate",
		"brevettate",
		"breviate",
		"brillantate",
		"brillate",
		"brinate",
		"broccate",
		"brocciate",
		"broccolate",
		"brontolate",
		"bronzate",
		"brucate",
		"bruciacchiate",
		"bruciate",
		"brunite",
		"bruscate",
		"bruschinate",
		"brutalizzate",
		"bruttate",
		"bucate",
		"bucherellate",
		"bufate",
		"buffate",
		"bufferizzate",
		"buggerate",
		"bugnate",
		"bulicate",
		"bulinate",
		"bullettate",
		"bullonate",
		"burattate",
		"burlate",
		"burocratizzate",
		"burrificate",
		"buscate",
		"buttate",
		"butterate",
		"bypassate",
		"cablate",
		"cabrate",
		"cacate",
		"cacciate",
		"cadenzate",
		"cadmiate",
		"caducate",
		"cagate",
		"caggiate",
		"cagionate",
		"cagliate",
		"calafatate",
		"calamitate",
		"calandrate",
		"calate",
		"calcate",
		"calciate",
		"calcificate",
		"calcolate",
		"caldeggiate",
		"calettate",
		"calibrate",
		"calmate",
		"calmierate",
		"calpestate",
		"calumate",
		"calunniate",
		"calzate",
		"cambiate",
		"camerate",
		"campionate",
		"campite",
		"camuffate",
		"canalizzate",
		"cancellate",
		"cancerizzate",
		"candeggiate",
		"candidate",
		"candite",
		"canforate",
		"cangiate",
		"cannate",
		"canneggiate",
		"cannibalizzate",
		"cannoneggiate",
		"canonizzate",
		"cantate",
		"canterellate",
		"canticchiate",
		"cantilenate",
		"canzonate",
		"caolinizzate",
		"capacitate",
		"capeggiate",
		"capillarizzate",
		"capitalizzate",
		"capitanate",
		"capitaneggiate",
		"capite",
		"capitozzate",
		"capivolte",
		"caponate",
		"capotate",
		"capottate",
		"capovolte",
		"capponate",
		"captate",
		"caramellate",
		"caramellizzate",
		"caratate",
		"caratterizzate",
		"carbonizzate",
		"carbossilate",
		"carburate",
		"carcate",
		"carcerate",
		"cardate",
		"carenate",
		"carezzate",
		"cariate",
		"caricate",
		"caricaturate",
		"caricaturizzate",
		"carotate",
		"carpionate",
		"carpite",
		"carreggiate",
		"carrozzate",
		"cartavetrate",
		"carteggiate",
		"cartellinate",
		"cartografate",
		"cartolarizzate",
		"cartonate",
		"cascolate",
		"cassate",
		"casse",
		"castigate",
		"castrate",
		"casualizzate",
		"catabolizzate",
		"catalizzate",
		"catalogate",
		"catapultate",
		"catechizzate",
		"categorizzate",
		"cateterizzate",
		"catramate",
		"cattolicizzate",
		"catturate",
		"causate",
		"cautelate",
		"cauterizzate",
		"cauzionate",
		"cavalcate",
		"cavatasele",
		"cavate",
		"cazzate",
		"cazziate",
		"cazzottate",
		"cedrate",
		"cedute",
		"celate",
		"celebrate",
		"cellofanate",
		"cementate",
		"cementificate",
		"cennate",
		"censite",
		"censurate",
		"centellate",
		"centellinate",
		"centimetrate",
		"centinate",
		"centralizzate",
		"centrate",
		"centrifugate",
		"centuplicate",
		"cerate",
		"cercate",
		"cerchiate",
		"cernute",
		"certificate",
		"cesellate",
		"cessate",
		"cestinate",
		"cheratinizzate",
		"chetate",
		"chiamate",
		"chiappate",
		"chiarificate",
		"chiarite",
		"chiaroscurate",
		"chiavate",
		"chiazzate",
		"chieste",
		"chilificate",
		"chilometrate",
		"chimificate",
		"chinate",
		"chinizzate",
		"chiodate",
		"chiosate",
		"chiuse",
		"choccate",
		"ciancicate",
		"cianfrinate",
		"cianfrugliate",
		"ciangottate",
		"ciattate",
		"cibate",
		"cicatrizzate",
		"ciccate",
		"cicchettate",
		"ciclizzate",
		"ciclostilate",
		"cifrate",
		"cilindrate",
		"cimate",
		"cimentate",
		"cincischiate",
		"cinematografate",
		"cintate",
		"cinte",
		"cioncate",
		"ciondolate",
		"circolate",
		"circoncinte",
		"circoncise",
		"circondate",
		"circondotte",
		"circonflesse",
		"circonfluite",
		"circonfuse",
		"circonscritte",
		"circonvenute",
		"circoscritte",
		"circostanziate",
		"circuite",
		"circumcinte",
		"circumnavigate",
		"citate",
		"ciucciate",
		"ciurmate",
		"civettate",
		"civilizzate",
		"clamate",
		"classate",
		"classicizzate",
		"classificate",
		"cliccate",
		"climatizzate",
		"clivate",
		"clonate",
		"cloroformizzate",
		"clorurate",
		"clusterizzate",
		"co-dirette",
		"coacervate",
		"coadiuvate",
		"coagulate",
		"coalizzate",
		"coartate",
		"coccolate",
		"codificate",
		"coeditate",
		"coesistite",
		"cofinanziate",
		"cofirmate",
		"cofondate",
		"cogestite",
		"cogitate",
		"coglionate",
		"cognosciute",
		"coibentate",
		"coincise",
		"cointeressate",
		"cointestate",
		"coinvolte",
		"cokificate",
		"colate",
		"colettate",
		"collassate",
		"collaudate",
		"collazionate",
		"collegate",
		"collettivizzate",
		"collezionate",
		"collimate",
		"colliquate",
		"collise",
		"collocate",
		"colluttate",
		"colmate",
		"colonizzate",
		"colorate",
		"colorite",
		"colorizzate",
		"colpevolizzate",
		"colpite",
		"coltellate",
		"coltivate",
		"colte",
		"coltrate",
		"comandate",
		"combattute",
		"combinate",
		"comburute",
		"comicizzate",
		"cominciate",
		"commemorate",
		"commendate",
		"commensurate",
		"commentate",
		"commercializzate",
		"commesse",
		"comminate",
		"commiserate",
		"commissariate",
		"commissionate",
		"commisurate",
		"commosse",
		"commutate",
		"comodate",
		"compaginate",
		"comparite",
		"compartimentalizzate",
		"compartite",
		"compassionate",
		"compatibilizzate",
		"compatite",
		"compattate",
		"compendiate",
		"compenetrate",
		"compensate",
		"comperate",
		"compiaciute",
		"compiante",
		"compilate",
		"compitate",
		"compiute",
		"complessate",
		"complessificate",
		"complesse",
		"completate",
		"complicate",
		"complimentate",
		"comportate",
		"compostate",
		"composte",
		"comprate",
		"compravendute",
		"comprese",
		"compresse",
		"compromesse",
		"comprovate",
		"compulsate",
		"compunte",
		"computate",
		"computerizzate",
		"comunicate",
		"comunistizzate",
		"concatenate",
		"concedute",
		"concelebrate",
		"concentrate",
		"concepite",
		"concertate",
		"concesse",
		"concettate",
		"concettualizzate",
		"conchiuse",
		"conciate",
		"conciliate",
		"concimate",
		"concitate",
		"conclamate",
		"concluse",
		"concordate",
		"concotte",
		"concretate",
		"concretizzate",
		"conculcate",
		"concupite",
		"condannate",
		"condensate",
		"condite",
		"condivise",
		"condizionate",
		"condolute",
		"condonate",
		"condotte",
		"confatte",
		"confederate",
		"conferite",
		"confermate",
		"confessate",
		"confettate",
		"confezionate",
		"conficcate",
		"confidate",
		"configurate",
		"confinate",
		"confinte",
		"confiscate",
		"confitte",
		"conformate",
		"confortate",
		"confricate",
		"confrontate",
		"confuse",
		"confutate",
		"congedate",
		"congegnate",
		"congelate",
		"congestionate",
		"congetturate",
		"congiunte",
		"conglobate",
		"conglomerate",
		"conglutinate",
		"congratulate",
		"congregate",
		"conguagliate",
		"coniate",
		"coniugate",
		"connaturate",
		"connesse",
		"connotate",
		"connumerate",
		"conosciute",
		"conquistate",
		"consacrate",
		"consapevolizzate",
		"consegnate",
		"conseguite",
		"consentite",
		"conservate",
		"considerate",
		"consigliate",
		"consistite",
		"consociate",
		"consolate",
		"consolidate",
		"consorziate",
		"consparse",
		"consperse",
		"constatate",
		"constrette",
		"construite",
		"consultate",
		"consumate",
		"consunte",
		"contabilizzate",
		"contagiate",
		"containerizzate",
		"contaminate",
		"contate",
		"contattate",
		"conteggiate",
		"contemperate",
		"contemplate",
		"contentate",
		"contenute",
		"contese",
		"contestate",
		"contestualizzate",
		"contingentate",
		"continuate",
		"contornate",
		"contorte",
		"contrabbandate",
		"contraccambiate",
		"contraddette",
		"contraddistinte",
		"contradette",
		"contraffatte",
		"contrappesate",
		"contrapposte",
		"contrappuntate",
		"contrariate",
		"contrassegnate",
		"contrastate",
		"contrate",
		"contrattaccate",
		"contrattate",
		"contratte",
		"contravvalse",
		"contristate",
		"controbattute",
		"controbilanciate",
		"controdatate",
		"controfirmate",
		"controindicate",
		"controllate",
		"controminate",
		"contronotate",
		"controproposte",
		"controprovate",
		"controquerelate",
		"controsoffittate",
		"controstampate",
		"controventate",
		"conturbate",
		"contuse",
		"convalidate",
		"convenute",
		"convenzionate",
		"convertite",
		"convinte",
		"convitate",
		"convocate",
		"convogliate",
		"convolte",
		"coobate",
		"cooptate",
		"coordinate",
		"coperchiate",
		"coperte",
		"copiaincollate",
		"copiate",
		"copolimerizzate",
		"coppellate",
		"coprodotte",
		"corazzate",
		"corbellate",
		"corcate",
		"cordonate",
		"coreografate",
		"coricate",
		"cornificate",
		"coronate",
		"corredate",
		"correlate",
		"corresponsabilizzate",
		"corrette",
		"corricchiate",
		"corrisposte",
		"corroborate",
		"corrose",
		"corrotte",
		"corrucciate",
		"corrugate",
		"corse",
		"corteate",
		"corteggiate",
		"cortocircuitate",
		"coruscate",
		"cosate",
		"coscritte",
		"cosparse",
		"cosperse",
		"costatate",
		"costeggiate",
		"costellate",
		"costernate",
		"costicchiate",
		"costipate",
		"costituite",
		"costituzionalizzate",
		"costrette",
		"costruite",
		"costudite",
		"cotonate",
		"cotte",
		"covate",
		"coventrizzate",
		"coverchiate",
		"craccate",
		"create",
		"credute",
		"cremate",
		"crepate",
		"cresciute",
		"cresimate",
		"crespate",
		"criminalizzate",
		"crioconcentrate",
		"criptate",
		"cristallizzate",
		"cristianizzate",
		"criticate",
		"crittate",
		"crittografate",
		"crivellate",
		"crocchiate",
		"crocefisse",
		"crocefitte",
		"crocifisse",
		"crocifitte",
		"crogiolate",
		"cromate",
		"cronicizzate",
		"cronometrate",
		"crostate",
		"crucciate",
		"crucifisse",
		"crucifitte",
		"cuccate",
		"cucinate",
		"cucite",
		"cullate",
		"cumulate",
		"cuntate",
		"curate",
		"curvate",
		"curvate",
		"custodite",
		"customizzate",
		"damascate",
		"damaschinate",
		"damate",
		"dannate",
		"danneggiate",
		"danzate",
		"dardeggiate",
		"datate",
		"date",
		"dattilografate",
		"dattiloscritte",
		"daziate",
		"deacidificate",
		"deattivate",
		"debbiate",
		"debellate",
		"debilitate",
		"decaffeinate",
		"decaffeinizzate",
		"decalcate",
		"decalcificate",
		"decantate",
		"decapate",
		"decapitate",
		"decappottate",
		"decarbossilate",
		"decarburate",
		"decatizzate",
		"decelerate",
		"decentralizzate",
		"decentrate",
		"decerebrate",
		"decernute",
		"decespugliate",
		"deciferate",
		"decifrate",
		"decimalizzate",
		"decimate",
		"decise",
		"declamate",
		"declassate",
		"declassificate",
		"declinate",
		"declorate",
		"decodificate",
		"decolonizzate",
		"decolorate",
		"decompartimentate",
		"decompilate",
		"decomposte",
		"decompresse",
		"deconcentrate",
		"decondizionate",
		"decongelate",
		"decongestionate",
		"decontaminate",
		"decontestualizzate",
		"decontratte",
		"decorate",
		"decorticate",
		"decostruite",
		"decrementate",
		"decretate",
		"decriminalizzate",
		"decriptate",
		"decrittate",
		"decuplicate",
		"decurtate",
		"dedicate",
		"dedotte",
		"defacciate",
		"defalcate",
		"defascistizzate",
		"defecate",
		"defenestrate",
		"deferite",
		"defilate",
		"definite",
		"defiscalizzate",
		"defitte",
		"deflazionate",
		"deflemmate",
		"deflorate",
		"defogliate",
		"defoliate",
		"deforestate",
		"deformate",
		"defosforate",
		"defosforilate",
		"deframmentate",
		"defraudate",
		"degassate",
		"degassificate",
		"deglutite",
		"degnate",
		"degradate",
		"degustate",
		"deidratate",
		"deidrogenate",
		"deificate",
		"deindicizzate",
		"deindustrializzate",
		"deionizzate",
		"delegate",
		"delegificate",
		"delegittimate",
		"delibate",
		"deliberate",
		"delimitate",
		"delineate",
		"delirate",
		"deliziate",
		"delocalizzate",
		"delucidate",
		"deluse",
		"demagnetizzate",
		"demandate",
		"demanializzate",
		"demarcate",
		"demeritate",
		"demerse",
		"demetallizzate",
		"demilitarizzate",
		"demineralizzate",
		"demistificate",
		"demitizzate",
		"democratizzate",
		"demodulate",
		"demolite",
		"demoltiplicate",
		"demonetate",
		"demonetizzate",
		"demonizzate",
		"demoralizzate",
		"demorse",
		"demotivate",
		"denaturalizzate",
		"denaturate",
		"denazificate",
		"denazionalizzate",
		"denicotinizzate",
		"denigrate",
		"denitrificate",
		"denocciolate",
		"denominate",
		"denotate",
		"dentellate",
		"denuclearizzate",
		"denudate",
		"denunciate",
		"denunziate",
		"deodorate",
		"deossidate",
		"deossigenate",
		"deostruite",
		"depauperate",
		"depenalizzate",
		"depennate",
		"depilate",
		"depinte",
		"depistate",
		"deplorate",
		"depolarizzate",
		"depolimerizzate",
		"depoliticizzate",
		"depolverizzate",
		"deportate",
		"depositate",
		"deposte",
		"depotenziate",
		"depravate",
		"deprecate",
		"depredate",
		"depresse",
		"depressurizzate",
		"deprezzate",
		"deprivate",
		"deprotonate",
		"depulse",
		"depurate",
		"dequalificate",
		"deratizzate",
		"derattizzate",
		"dereferenziate",
		"deregolamentate",
		"deregolate",
		"derequisite",
		"deresponsabilizzate",
		"derise",
		"derubate",
		"derubricate",
		"desacralizzate",
		"desalate",
		"desalinizzate",
		"descolarizzate",
		"descritte",
		"desecretate",
		"desegretate",
		"deselezionate",
		"desensibilizzate",
		"desessualizzate",
		"desiate",
		"desiderate",
		"designate",
		"desinate",
		"desirate",
		"desolate",
		"desolforate",
		"desonorizzate",
		"desorbite",
		"desossidate",
		"desquamate",
		"destabilizzate",
		"destagionalizzate",
		"destalinizzate",
		"destatalizzate",
		"destatizzate",
		"destate",
		"destinate",
		"destituite",
		"destoricizzate",
		"destreggiate",
		"destrutte",
		"destrutturate",
		"desunte",
		"detassate",
		"detenute",
		"deteriorate",
		"determinate",
		"deterse",
		"detestate",
		"detonate",
		"detorte",
		"detossificate",
		"detratte",
		"detronizzate",
		"dettagliate",
		"dettate",
		"dette",
		"deturpate",
		"deumidificate",
		"devastate",
		"deventate",
		"deviate",
		"deviscerate",
		"devitalizzate",
		"devitaminizzate",
		"devolute",
		"dezippate",
		"diaframmate",
		"diagnosticate",
		"diagonalizzate",
		"diagrammate",
		"dializzate",
		"dialogate",
		"dialogizzate",
		"diazotate",
		"dibattute",
		"diboscate",
		"dichiarate",
		"diesate",
		"diesizzate",
		"difese",
		"diffamate",
		"differite",
		"diffidate",
		"diffrante",
		"diffratte",
		"diffuse",
		"digerite",
		"digitalizzate",
		"digitate",
		"digiunte",
		"digrassate",
		"digrignate",
		"digrossate",
		"dilacerate",
		"dilaniate",
		"dilapidate",
		"dilatate",
		"dilavate",
		"dilazionate",
		"dileggiate",
		"dileguate",
		"dilettate",
		"dilette",
		"diliscate",
		"dilucidate",
		"diluite",
		"dilungate",
		"dimagrate",
		"dimandate",
		"dimenate",
		"dimensionate",
		"dimenticate",
		"dimerizzate",
		"dimesse",
		"dimezzate",
		"diminuite",
		"dimissionate",
		"dimostrate",
		"dimunte",
		"dinamizzate",
		"dinoccate",
		"dipanate",
		"dipelate",
		"dipinte",
		"diplomate",
		"diposte",
		"diradate",
		"diramate",
		"dirette",
		"direzionate",
		"dirimute",
		"diroccate",
		"dirottate",
		"dirotte",
		"dirozzate",
		"disabilitate",
		"disabituate",
		"disaccentate",
		"disaccoppiate",
		"disaccordate",
		"disacerbate",
		"disacidate",
		"disacidificate",
		"disacidite",
		"disaerate",
		"disaffezionate",
		"disaggregate",
		"disalberate",
		"disallineate",
		"disamate",
		"disambiguate",
		"disaminate",
		"disamorate",
		"disancorate",
		"disanimate",
		"disappannate",
		"disapplicate",
		"disapprese",
		"disapprovate",
		"disarcionate",
		"disarmate",
		"disarticolate",
		"disascoste",
		"disassemblate",
		"disassuefatte",
		"disatomizzate",
		"disattese",
		"disattivate",
		"disattrezzate",
		"disavvezzate",
		"disboscate",
		"disbrigate",
		"discacciate",
		"discalzate",
		"discantate",
		"discaricate",
		"discernute",
		"discese",
		"disceverate",
		"dischieste",
		"dischiuse",
		"discinte",
		"disciolte",
		"disciplinate",
		"discolorate",
		"discolpate",
		"discommesse",
		"discompagnate",
		"discomposte",
		"disconcluse",
		"disconfitte",
		"discongiunte",
		"disconnesse",
		"disconosciute",
		"discoperte",
		"discordate",
		"discoscese",
		"discostate",
		"discreditate",
		"discresciute",
		"discriminate",
		"discritte",
		"discucite",
		"discuoiate",
		"discusse",
		"disdegnate",
		"disdettate",
		"disdette",
		"diseccate",
		"diseccitate",
		"diseducate",
		"disegnate",
		"diserbate",
		"diseredate",
		"disertate",
		"diserte",
		"disfatte",
		"disgelate",
		"disgiunte",
		"disgraziate",
		"disgregate",
		"disgustate",
		"disidentificate",
		"disiderate",
		"disidratate",
		"disilluse",
		"disimballate",
		"disimparate",
		"disimpegnate",
		"disimpresse",
		"disincagliate",
		"disincantate",
		"disincentivate",
		"disincrostate",
		"disindustrializzate",
		"disinfestate",
		"disinfettate",
		"disinflazionate",
		"disinformate",
		"disingannate",
		"disingranate",
		"disinibite",
		"disinnamorate",
		"disinnescate",
		"disinnestate",
		"disinquinate",
		"disinserite",
		"disinstallate",
		"disintasate",
		"disintegrate",
		"disinteressate",
		"disintese",
		"disintossicate",
		"disinvestite",
		"disinvolte",
		"disistimate",
		"dislocate",
		"dismesse",
		"disobbedite",
		"disobbligate",
		"disonorate",
		"disordinate",
		"disorganizzate",
		"disorientate",
		"disormeggiate",
		"disossate",
		"disossidate",
		"disostruite",
		"disotterrate",
		"disparite",
		"dispensate",
		"dispente",
		"disperdute",
		"disperse",
		"dispese",
		"dispiegate",
		"dispinte",
		"dispogliate",
		"disposte",
		"dispregiate",
		"disprezzate",
		"dispromesse",
		"disproporzionate",
		"disputate",
		"disqualificate",
		"disrotte",
		"dissacrate",
		"dissalate",
		"dissaldate",
		"dissanguate",
		"dissecate",
		"disseccate",
		"disselciate",
		"dissellate",
		"disseminate",
		"dissepolte",
		"disseppellite",
		"dissequestrate",
		"disserrate",
		"dissestate",
		"dissetate",
		"dissezionate",
		"dissigillate",
		"dissimulate",
		"dissipate",
		"dissociate",
		"dissodate",
		"dissolte",
		"dissomigliate",
		"dissotterrate",
		"dissuase",
		"dissuggellate",
		"distaccate",
		"distanziate",
		"distese",
		"distillate",
		"distinte",
		"distolte",
		"distorte",
		"distratte",
		"distrette",
		"distribuite",
		"districate",
		"distrigate",
		"distrutte",
		"disturbate",
		"disubbidite",
		"disumanate",
		"disumanizzate",
		"disunite",
		"disusate",
		"disvedute",
		"disvelate",
		"disvestite",
		"disviate",
		"disviste",
		"disvolte",
		"disvolute",
		"dittongate",
		"divallate",
		"divaricate",
		"divelte",
		"diversificate",
		"divertite",
		"divezzate",
		"divinate",
		"divincolate",
		"divinizzate",
		"divise",
		"divolte",
		"divorate",
		"divorziate",
		"divulgate",
		"documentate",
		"dogate",
		"dogmatizzate",
		"dolcificate",
		"dollarizzate",
		"dolorate",
		"dolute",
		"domandate",
		"domate",
		"domesticate",
		"domiciliate",
		"dominate",
		"donate",
		"dondolate",
		"dopate",
		"doppiate",
		"dorate",
		"dormitoce",
		"dosate",
		"dotate",
		"dovute",
		"dragate",
		"drammatizzate",
		"drappeggiate",
		"drenate",
		"dribblate",
		"drizzate",
		"drogate",
		"dugliate",
		"duplicate",
		"duramificate",
		"ebraizzate",
		"eccedute",
		"eccepite",
		"eccettuate",
		"eccitate",
		"echeggiate",
		"eclissate",
		"economizzate",
		"edificate",
		"editate",
		"edotte",
		"educate",
		"edulcorate",
		"effettuate",
		"efficientate",
		"effigiate",
		"effinte",
		"effluite",
		"effuse",
		"egemonizzate",
		"eguagliate",
		"eiettate",
		"elaborate",
		"elargite",
		"elasticizzate",
		"elementarizzate",
		"elemosinate",
		"elencate",
		"elette",
		"elettrificate",
		"elettrizzate",
		"elettrocoagulate",
		"elettrolizzate",
		"elevate",
		"eliminate",
		"elise",
		"elitrasportate",
		"ellenizzate",
		"elogiate",
		"elucidate",
		"elucubrate",
		"eluite",
		"eluse",
		"emanate",
		"emancipate",
		"emarginate",
		"embricate",
		"emendate",
		"emesse",
		"emozionate",
		"empite",
		"empiute",
		"emulate",
		"emulsionate",
		"emunte",
		"encomiate",
		"endocitate",
		"energizzate",
		"enfatizzate",
		"enfiate",
		"entusiasmate",
		"enucleate",
		"enumerate",
		"enunciate",
		"epicureggiate",
		"epurate",
		"equalizzate",
		"equilibrate",
		"equipaggiate",
		"equiparate",
		"eradicate",
		"erase",
		"ereditate",
		"erette",
		"erogate",
		"eroicizzate",
		"erose",
		"erotizzate",
		"erpicate",
		"erse",
		"erudite",
		"eruttate",
		"esacerbate",
		"esagerate",
		"esagitate",
		"esalate",
		"esaltate",
		"esaminate",
		"esasperate",
		"esaudite",
		"esaurite",
		"esautorate",
		"esborsate",
		"escluse",
		"escogitate",
		"escomiate",
		"escoriate",
		"escosse",
		"escusse",
		"esecrate",
		"esecutate",
		"eseguite",
		"esemplificate",
		"esentate",
		"esercitate",
		"esfoliate",
		"esibite",
		"esilarate",
		"esiliate",
		"esimute",
		"esitate",
		"esonerate",
		"esorbitate",
		"esorcizzate",
		"esortate",
		"espanse",
		"esparse",
		"esperimentate",
		"esperite",
		"espettorate",
		"espiantate",
		"espiate",
		"espirate",
		"espletate",
		"esplicate",
		"esplicitate",
		"esplorate",
		"esplose",
		"esportate",
		"esposte",
		"espresse",
		"espropriate",
		"espugnate",
		"espulse",
		"espunte",
		"espurgate",
		"essiccate",
		"essute",
		"estasiate",
		"estenuate",
		"esterificate",
		"esteriorizzate",
		"esterminate",
		"esternalizzate",
		"esternate",
		"estese",
		"estimate",
		"estinte",
		"estirpate",
		"estivate",
		"estorte",
		"estradate",
		"estraniate",
		"estrapolate",
		"estratte",
		"estremizzate",
		"estrinsecate",
		"estromesse",
		"estruse",
		"estubate",
		"esulcerate",
		"esultate",
		"esumate",
		"eterificate",
		"eterizzate",
		"eternate",
		"eternizzate",
		"etichettate",
		"etossilate",
		"euforizzate",
		"europeizzate",
		"evacuate",
		"evangelizzate",
		"evase",
		"evete",
		"evidenziate",
		"evinte",
		"evirate",
		"eviscerate",
		"evitate",
		"evocate",
		"evolte",
		"evolute",
		"evulse",
		"fabbricate",
		"faccettate",
		"facilitate",
		"fagocitate",
		"falciate",
		"falcidiate",
		"fallite",
		"falsate",
		"falsificate",
		"familiarizzate",
		"fanatizzate",
		"fantasticate",
		"farcite",
		"farfugliate",
		"fasciate",
		"fascicolate",
		"fascistizzate",
		"fattacele",
		"fatte",
		"fattorizzate",
		"fatturate",
		"favellate",
		"favoreggiate",
		"favorite",
		"faxate",
		"fecondate",
		"fedecommesse",
		"federalizzate",
		"federate",
		"felicitate",
		"felpate",
		"feltrate",
		"femminilizzate",
		"fendute",
		"ferite",
		"fermate",
		"fermentate",
		"ferrate",
		"fertilizzate",
		"fesse",
		"fessurate",
		"festeggiate",
		"festonate",
		"feudalizzate",
		"fiaccate",
		"fiammeggiate",
		"fiancheggiate",
		"ficcate",
		"fidanzate",
		"fidate",
		"fidecommesse",
		"fidelizzate",
		"figliate",
		"figurate",
		"filate",
		"filettate",
		"filmate",
		"filosofate",
		"filtrate",
		"finalizzate",
		"finanziate",
		"finitale",
		"finite",
		"finlandizzate",
		"fintate",
		"finte",
		"fiocinate",
		"fiondate",
		"fiorettate",
		"firmate",
		"fiscalizzate",
		"fischiate",
		"fischiettate",
		"fissate",
		"fissionate",
		"fitte",
		"fiutate",
		"flagellate",
		"flaggate",
		"flambate",
		"flangiate",
		"flemmatizzate",
		"flesse",
		"flippate",
		"flottate",
		"fluidificate",
		"fluidizzate",
		"fluorizzate",
		"fluorurate",
		"focalizzate",
		"focheggiate",
		"foderate",
		"foggiate",
		"fognate",
		"folgorate",
		"follate",
		"fomentate",
		"fonate",
		"fondate",
		"foracchiate",
		"foraggiate",
		"forate",
		"forestate",
		"forfettizzate",
		"forgiate",
		"formalizzate",
		"formate",
		"formattate",
		"formilate",
		"formulate",
		"fornite",
		"fortificate",
		"forviate",
		"forwardate",
		"forzate",
		"fosfatate",
		"fosforate",
		"fosforilate",
		"fossilizzate",
		"fotocomposte",
		"fotocopiate",
		"fotografate",
		"fottute",
		"fracassate",
		"fraintese",
		"framesse",
		"frammentate",
		"frammesse",
		"frammezzate",
		"frammischiate",
		"franceseggiate",
		"francesizzate",
		"frangiate",
		"frante",
		"frantumate",
		"frappate",
		"frapposte",
		"fraseggiate",
		"frastagliate",
		"frastornate",
		"fratturate",
		"frazionate",
		"freddate",
		"fregate",
		"fregiate",
		"frenate",
		"frequentate",
		"fresate",
		"frettate",
		"friendzonate",
		"fritte",
		"frizionate",
		"frodate",
		"frollate",
		"fronteggiate",
		"frugate",
		"fruite",
		"frullate",
		"frusciate",
		"frustate",
		"frustrate",
		"fruttate",
		"fucilate",
		"fucinate",
		"fugate",
		"fuggite",
		"fulminate",
		"fumate",
		"fumigate",
		"funestate",
		"funte",
		"funzionate",
		"fuoriuscite",
		"fuorviate",
		"fuse",
		"fustellate",
		"fustigate",
		"gabbate",
		"gabellate",
		"gallate",
		"gallicizzate",
		"gallonate",
		"galvanizzate",
		"gambizzate",
		"garantite",
		"garnettate",
		"garrotate",
		"garzate",
		"gasate",
		"gassate",
		"gassificate",
		"gazate",
		"gelatinizzate",
		"gelate",
		"gelificate",
		"gemellate",
		"gemicate",
		"geminate",
		"generalizzate",
		"generate",
		"gentrificate",
		"genuflesse",
		"geometrizzate",
		"georeferenziate",
		"gerarchizzate",
		"germanizzate",
		"gestite",
		"gettate",
		"gettonate",
		"ghermite",
		"ghettizzate",
		"ghigliottinate",
		"ghindate",
		"gibollate",
		"gingillate",
		"ginnate",
		"giocate",
		"gioite",
		"gionglate",
		"giovaneggiate",
		"girandolate",
		"girate",
		"giudicate",
		"giulebbate",
		"giuntate",
		"giunte",
		"giuracchiate",
		"giurate",
		"giustapposte",
		"giustificate",
		"giustiziate",
		"glamourizzate",
		"glassate",
		"glissate",
		"globalizzate",
		"gloriate",
		"glorificate",
		"glossate",
		"godronate",
		"godute",
		"goffrate",
		"gommate",
		"gonfiate",
		"googlate",
		"gottate",
		"governate",
		"gradinate",
		"gradite",
		"gradualizzate",
		"graduate",
		"graffate",
		"graffiate",
		"graffite",
		"graficate",
		"grafitate",
		"gramolate",
		"granagliate",
		"grandinate",
		"granellate",
		"granite",
		"granulate",
		"graticciate",
		"graticolate",
		"gratificate",
		"gratinate",
		"grattate",
		"grattugiate",
		"gravate",
		"graziate",
		"grecheggiate",
		"grecizzate",
		"gremite",
		"gridate",
		"griffate",
		"grigliate",
		"grippate",
		"groccate",
		"grondate",
		"grugate",
		"grugnite",
		"guadagnate",
		"gualcite",
		"guardate",
		"guarite",
		"guarnite",
		"guastate",
		"guatate",
		"guerreggiate",
		"gufate",
		"guidate",
		"gustate",
		"hackerate",
		"handicappate",
		"ibridate",
		"idealizzate",
		"ideate",
		"identificate",
		"ideologizzate",
		"idolatrate",
		"idoleggiate",
		"idratate",
		"idrogenate",
		"idrolizzate",
		"iettate",
		"igienizzate",
		"ignifugate",
		"ignorate",
		"illanguidite",
		"illeggiadrite",
		"illividite",
		"illuminate",
		"illuse",
		"illustrate",
		"imbacuccate",
		"imbaldanzite",
		"imballate",
		"imbalsamate",
		"imbambolate",
		"imbandierate",
		"imbandite",
		"imbarbarite",
		"imbarcate",
		"imbarilate",
		"imbastardite",
		"imbastite",
		"imbattute",
		"imbavagliate",
		"imbeccate",
		"imbellettate",
		"imbellite",
		"imbestialite",
		"imbestiate",
		"imbevute",
		"imbiaccate",
		"imbiancate",
		"imbianchite",
		"imbibite",
		"imbiettate",
		"imbiondite",
		"imbizzarrite",
		"imboccate",
		"imbonite",
		"imborghesite",
		"imboscate",
		"imboschite",
		"imbottate",
		"imbottigliate",
		"imbottite",
		"imbozzimate",
		"imbracate",
		"imbracciate",
		"imbragate",
		"imbrancate",
		"imbrattate",
		"imbrecciate",
		"imbrigliate",
		"imbrillantinate",
		"imbroccate",
		"imbrodate",
		"imbrogliate",
		"imbronciate",
		"imbruttite",
		"imbucate",
		"imbudellate",
		"imbullettate",
		"imbullonate",
		"imburrate",
		"imbussolate",
		"imbustate",
		"imbutite",
		"imitate",
		"immagazzinate",
		"immaginate",
		"immalinconite",
		"immatricolate",
		"immedesimate",
		"immerse",
		"immesse",
		"immischiate",
		"immiserite",
		"immobilizzate",
		"immolate",
		"immortalate",
		"immunizzate",
		"immusonite",
		"impaccate",
		"impacchettate",
		"impacciate",
		"impadronite",
		"impaginate",
		"impagliate",
		"impalate",
		"impalcate",
		"impallate",
		"impallinate",
		"impalmate",
		"impaludate",
		"impanate",
		"impaniate",
		"impannate",
		"impantanate",
		"impaperate",
		"impapocchiate",
		"impappinate",
		"imparentate",
		"imparruccate",
		"impartite",
		"impastate",
		"impasticcate",
		"impasticciate",
		"impastocchiate",
		"impastoiate",
		"impataccate",
		"impattate",
		"impaurite",
		"impavesate",
		"impeciate",
		"impedicate",
		"impedite",
		"impegnate",
		"impegolate",
		"impelagate",
		"impellicciate",
		"impennacchiate",
		"impennate",
		"impensierite",
		"impepate",
		"imperlate",
		"impermalite",
		"impermeabilizzate",
		"imperniate",
		"impersonate",
		"impersonificate",
		"impestate",
		"impetrate",
		"impiallacciate",
		"impiantate",
		"impiastrate",
		"impiastricciate",
		"impiccate",
		"impicciate",
		"impicciolite",
		"impiccolite",
		"impidocchiate",
		"impiegate",
		"impietosite",
		"impietrite",
		"impigliate",
		"impigrite",
		"impilate",
		"impillaccherate",
		"impinguate",
		"impinte",
		"impinzate",
		"impiombate",
		"impipate",
		"impiumate",
		"implementate",
		"implicate",
		"implorate",
		"impollinate",
		"impolpate",
		"impoltronite",
		"impolverate",
		"impomatate",
		"imporcate",
		"imporporate",
		"importate",
		"importunate",
		"impossessate",
		"impossibilitate",
		"impostate",
		"imposte",
		"impratichite",
		"impregnate",
		"imprese",
		"impressionate",
		"impresse",
		"imprestate",
		"impreziosite",
		"imprigionate",
		"impromesse",
		"improntate",
		"improsciuttite",
		"impugnate",
		"impuntite",
		"impunturate",
		"impupate",
		"imputate",
		"impuzzolentite",
		"inabilitate",
		"inabissate",
		"inacerbite",
		"inacetite",
		"inacidite",
		"inacutite",
		"inaffiate",
		"inalate",
		"inalberate",
		"inalveate",
		"inalzate",
		"inamidate",
		"inanellate",
		"inarcate",
		"inargentate",
		"inaridite",
		"inasprite",
		"inastate",
		"inattivate",
		"inaugurate",
		"incacchiate",
		"incalcinate",
		"incalorite",
		"incalzate",
		"incamerate",
		"incamiciate",
		"incamminate",
		"incanaglite",
		"incanalate",
		"incannate",
		"incannucciate",
		"incaponite",
		"incappottate",
		"incappucciate",
		"incaprettate",
		"incapricciate",
		"incapsulate",
		"incarcerate",
		"incardinate",
		"incaricate",
		"incarnate",
		"incarrozzate",
		"incartate",
		"incartocciate",
		"incartonate",
		"incasellate",
		"incasinate",
		"incassate",
		"incastellate",
		"incastonate",
		"incastrate",
		"incatenate",
		"incatramate",
		"incattivite",
		"incavate",
		"incavigliate",
		"incavolate",
		"incazzate",
		"incellofanate",
		"incendiate",
		"incenerite",
		"incensate",
		"incentivate",
		"incentrate",
		"inceppate",
		"incerate",
		"incernierate",
		"incerottate",
		"incese",
		"incettate",
		"inchiappettate",
		"inchiavardate",
		"inchieste",
		"inchinate",
		"inchiodate",
		"inchiostrate",
		"incipriate",
		"incise",
		"incistate",
		"incitate",
		"inciuccate",
		"incivilite",
		"inclinate",
		"incluse",
		"incoccate",
		"incocciate",
		"incoiate",
		"incollate",
		"incolonnate",
		"incolpate",
		"incominciate",
		"incomodate",
		"incontrate",
		"incoraggiate",
		"incordate",
		"incornate",
		"incorniciate",
		"incoronate",
		"incorporate",
		"incotte",
		"incravattate",
		"incrementate",
		"increspate",
		"incretinite",
		"incriminate",
		"incrinate",
		"incrociate",
		"incrostate",
		"incrudelite",
		"incrudite",
		"incruscate",
		"incubate",
		"inculate",
		"inculcate",
		"incuneate",
		"incuoiate",
		"incuorate",
		"incupite",
		"incuriosite",
		"incurvate",
		"incusse",
		"indagate",
		"indebitate",
		"indebolite",
		"indemaniate",
		"indennizzate",
		"indette",
		"indicate",
		"indicizzate",
		"indignate",
		"indirette",
		"indirizzate",
		"indispettite",
		"indisposte",
		"individualizzate",
		"individuate",
		"indolenzite",
		"indorate",
		"indossate",
		"indotte",
		"indottome",
		"indottrinate",
		"indovinate",
		"indugiate",
		"indulte",
		"indurate",
		"indurite",
		"industrializzate",
		"industriate",
		"inebetite",
		"inebriate",
		"inerite",
		"inerpicate",
		"infagottate",
		"infamate",
		"infangate",
		"infarcite",
		"infarinate",
		"infastidite",
		"infatuate",
		"infeltrite",
		"inferite",
		"inferocite",
		"inferte",
		"infervorate",
		"infestate",
		"infettate",
		"infeudate",
		"infiacchite",
		"infialate",
		"infialettate",
		"infiammate",
		"infiascate",
		"infibulate",
		"inficiate",
		"infilate",
		"infiltrate",
		"infilzate",
		"infingardite",
		"infinocchiate",
		"infinte",
		"infioccate",
		"infiocchettate",
		"infiochite",
		"infiorate",
		"infirmate",
		"infischiate",
		"infisse",
		"infittite",
		"inflazionate",
		"inflesse",
		"inflitte",
		"influenzate",
		"infocate",
		"infoderate",
		"infognate",
		"infoibate",
		"infoltite",
		"inforcate",
		"informatizzate",
		"informate",
		"informicolate",
		"informicolite",
		"infornaciate",
		"infornate",
		"infortunate",
		"infoscate",
		"infossate",
		"infradiciate",
		"inframesse",
		"inframezzate",
		"inframmesse",
		"inframmezzate",
		"infrancesate",
		"infrapposte",
		"infrascate",
		"infrattate",
		"infreddate",
		"infronzolate",
		"infuocate",
		"infurbite",
		"infuriate",
		"ingabbiate",
		"ingaggiate",
		"ingagliardite",
		"ingannate",
		"ingarbugliate",
		"ingavonate",
		"ingegnate",
		"ingegnerizzate",
		"ingelosite",
		"ingemmate",
		"ingenerate",
		"ingentilite",
		"ingerite",
		"ingessate",
		"inghiaiate",
		"inghiottite",
		"inghirlandate",
		"ingiallite",
		"ingigantite",
		"inginocchiate",
		"ingioiellate",
		"ingiunte",
		"ingiuriate",
		"inglesizzate",
		"inglobate",
		"ingoffite",
		"ingoiate",
		"ingolfate",
		"ingollate",
		"ingolosite",
		"ingombrate",
		"ingommate",
		"ingorgate",
		"ingozzate",
		"ingranate",
		"ingrandite",
		"ingrassate",
		"ingraticciate",
		"ingraticolate",
		"ingravidate",
		"ingraziate",
		"ingraziosite",
		"ingrigite",
		"ingrommate",
		"ingrossate",
		"ingrullite",
		"inguaiate",
		"inguainate",
		"ingualdrappate",
		"inguantate",
		"ingurgitate",
		"inibite",
		"iniettate",
		"inimicate",
		"inizializzate",
		"iniziate",
		"inmillate",
		"innacquate",
		"innaffiate",
		"innalzate",
		"innamorate",
		"innastate",
		"innervate",
		"innervosite",
		"innescate",
		"innestate",
		"innevate",
		"innocentate",
		"innocuizzate",
		"innovate",
		"inoculate",
		"inoltrate",
		"inondate",
		"inorgoglite",
		"inorpellate",
		"inorridite",
		"inquadrate",
		"inquietate",
		"inquisite",
		"insabbiate",
		"insacchettate",
		"insalate",
		"insaldate",
		"insalivate",
		"insanguinate",
		"insaponate",
		"insaporite",
		"inscatolate",
		"inscenate",
		"inscritte",
		"insecchite",
		"insediate",
		"insegnate",
		"inseguite",
		"insellate",
		"inselvatichite",
		"inserite",
		"insidiate",
		"insignite",
		"insilate",
		"insinuate",
		"insolentite",
		"insonnolite",
		"insonorizzate",
		"insordite",
		"insospettite",
		"insozzate",
		"inspessite",
		"inspirate",
		"installate",
		"instaurate",
		"insterilite",
		"instillate",
		"instituite",
		"instradate",
		"insudiciate",
		"insufflate",
		"insultate",
		"insuperbite",
		"intabaccate",
		"intabarrate",
		"intaccate",
		"intagliate",
		"intarsiate",
		"intasate",
		"intascate",
		"intavolate",
		"integrate",
		"intelaiate",
		"intelate",
		"intellettualizzate",
		"intenebrate",
		"intenerite",
		"intensificate",
		"intentate",
		"intepidite",
		"intercalate",
		"intercambiate",
		"intercettate",
		"intercise",
		"intercluse",
		"intercollegate",
		"interconnesse",
		"interconvertite",
		"interdette",
		"interessate",
		"interfacciate",
		"interfogliate",
		"interfoliate",
		"interiorizzate",
		"interlacciate",
		"interlineate",
		"intermesse",
		"intermezzate",
		"internalizzate",
		"internate",
		"internazionalizzate",
		"interpellate",
		"interpenetrate",
		"interpolate",
		"interposte",
		"interpretate",
		"interpunte",
		"interrate",
		"interrogate",
		"interrotte",
		"intersecate",
		"intervallate",
		"intervistate",
		"intese",
		"intessute",
		"intestardite",
		"intestate",
		"intiepidite",
		"intimate",
		"intimidite",
		"intimorite",
		"intinte",
		"intirizzite",
		"intitolate",
		"intonacate",
		"intonate",
		"intontite",
		"intorbidate",
		"intorbidite",
		"intorpidite",
		"intortate",
		"intossicate",
		"intralciate",
		"intramesse",
		"intramezzate",
		"intrappolate",
		"intraprese",
		"intrattenute",
		"intravedute",
		"intraviste",
		"intravvedute",
		"intravviste",
		"intrecciate",
		"intricate",
		"intrigate",
		"intrinsecate",
		"intrippate",
		"intrise",
		"introdotte",
		"introflesse",
		"introiettate",
		"introitate",
		"intromesse",
		"intronate",
		"intronizzate",
		"intrudute",
		"intrufolate",
		"intrugliate",
		"intruppate",
		"intruse",
		"intubate",
		"intubettate",
		"intuite",
		"inumate",
		"inumidite",
		"inurbate",
		"inutilizzate",
		"invaghite",
		"invaginate",
		"invalidate",
		"invasate",
		"invase",
		"invelenite",
		"inventariate",
		"inventate",
		"invenute",
		"inverdite",
		"invergate",
		"inverniciate",
		"investigate",
		"investite",
		"invetriate",
		"inviate",
		"invidiate",
		"invigorite",
		"inviluppate",
		"invischiate",
		"invitate",
		"invocate",
		"invogliate",
		"involate",
		"involgarite",
		"involtate",
		"involte",
		"inzaccherate",
		"inzeppate",
		"inzigate",
		"inzolfate",
		"inzuccate",
		"inzuccherate",
		"inzuppate",
		"iodurate",
		"ionizzate",
		"ipertrofizzate",
		"ipnotizzate",
		"ipostatizzate",
		"ipotecate",
		"ipotizzate",
		"iridate",
		"irradiate",
		"irraggiate",
		"irreggimentate",
		"irretite",
		"irrigate",
		"irrigidite",
		"irrise",
		"irritate",
		"irrobustite",
		"irrogate",
		"irrorate",
		"irrugginite",
		"irruvidite",
		"ischeletrite",
		"iscritte",
		"islamizzate",
		"isolate",
		"isomerizzate",
		"ispanizzate",
		"ispessite",
		"ispezionate",
		"ispirate",
		"issate",
		"istallate",
		"istanziate",
		"istaurate",
		"isterilite",
		"istigate",
		"istillate",
		"istituite",
		"istituzionalizzate",
		"istoriate",
		"istradate",
		"istruite",
		"istupidite",
		"italianeggiate",
		"italianizzate",
		"iterate",
		"iudicate",
		"killerate",
		"labbreggiate",
		"labializzate",
		"laccate",
		"lacerate",
		"laconizzate",
		"lacrimate",
		"ladroneggiate",
		"lagnate",
		"lagrimate",
		"laicizzate",
		"lambiccate",
		"lambite",
		"lamentate",
		"laminate",
		"lanciate",
		"lapidate",
		"lappate",
		"lardate",
		"lardellate",
		"largite",
		"larvate",
		"lascate",
		"lasciate",
		"lastricate",
		"latinizzate",
		"laudate",
		"laureate",
		"lavate",
		"lavorate",
		"leccate",
		"legalizzate",
		"legate",
		"leggicchiate",
		"leggiucchiate",
		"legittimate",
		"legittimizzate",
		"legnate",
		"lemmatizzate",
		"lenite",
		"lesinate",
		"lesionate",
		"lese",
		"lessate",
		"lette",
		"levate",
		"levigate",
		"liberalizzate",
		"liberate",
		"licenziate",
		"lievitate",
		"liftate",
		"lignificate",
		"limate",
		"limitate",
		"linciate",
		"linearizzate",
		"lineate",
		"linkate",
		"liofilizzate",
		"liquefatte",
		"liquidate",
		"lisate",
		"lisciate",
		"lisciviate",
		"listate",
		"litografate",
		"livellate",
		"lizzate",
		"lobotomizzate",
		"localizzate",
		"locate",
		"lodate",
		"logorate",
		"lordate",
		"lottate",
		"lottizzate",
		"lubrificate",
		"lucchettate",
		"lucidate",
		"lucrate",
		"lumeggiate",
		"luppolizzate",
		"lusingate",
		"lussate",
		"lustrate",
		"macadamizzate",
		"macchiate",
		"macchinate",
		"macellate",
		"macerate",
		"maciullate",
		"maggesate",
		"maggiorate",
		"magnate",
		"magnetizzate",
		"magnificate",
		"maiolicate",
		"maledette",
		"malfatte",
		"malignate",
		"malmenate",
		"malmesse",
		"maltate",
		"maltrattate",
		"malvedute",
		"malversate",
		"malviste",
		"malvolute",
		"mandate",
		"mandrinate",
		"manducate",
		"maneggiate",
		"manganate",
		"manganellate",
		"mangiate",
		"mangiucchiate",
		"manifatturate",
		"manifestate",
		"manimesse",
		"manipolate",
		"manlevate",
		"manomesse",
		"manoscritte",
		"manovrate",
		"mansuefatte",
		"mantecate",
		"mantenutase",
		"mantenute",
		"manualizzate",
		"manutenute",
		"mappate",
		"marcate",
		"marchiate",
		"marcite",
		"marezzate",
		"marginalizzate",
		"marginate",
		"margottate",
		"marimesse",
		"marinate",
		"maritate",
		"marmorizzate",
		"marnate",
		"marocchinate",
		"martellate",
		"martellinate",
		"martirizzate",
		"martoriate",
		"mascherate",
		"maschiate",
		"maschiettate",
		"mascolinizzate",
		"massacrate",
		"massaggiate",
		"massellate",
		"massicciate",
		"massificate",
		"massimate",
		"massimizzate",
		"mastectomizzate",
		"masterizzate",
		"masticate",
		"masturbate",
		"matematizzate",
		"materializzate",
		"matricolate",
		"mattonate",
		"maturate",
		"mazziate",
		"mazzolate",
		"meccanizzate",
		"medagliate",
		"mediate",
		"medicalizzate",
		"medicate",
		"meditate",
		"membrate",
		"memorizzate",
		"menate",
		"mendicate",
		"menomate",
		"mentovate",
		"menzionate",
		"meravigliate",
		"mercanteggiate",
		"mercerizzate",
		"mercificate",
		"meriate",
		"meridionalizzate",
		"meritate",
		"merlate",
		"merlettate",
		"merse",
		"mesciate",
		"mesciute",
		"mescolate",
		"mescute",
		"mesmerizzate",
		"messaggiate",
		"messe",
		"messoce",
		"mestate",
		"mesticate",
		"mestruate",
		"metabolizzate",
		"metaforeggiate",
		"metaforizzate",
		"metallizzate",
		"metamorfizzate",
		"metamorfosate",
		"metanizzate",
		"metilate",
		"metodizzate",
		"microfilmate",
		"microfonate",
		"microminiaturizzate",
		"micronizzate",
		"mietute",
		"migliorate",
		"militarizzate",
		"millantate",
		"millimetrate",
		"mimate",
		"mimeografate",
		"mimetizzate",
		"minacciate",
		"minate",
		"minchionate",
		"mineralizzate",
		"miniate",
		"miniaturizzate",
		"minimizzate",
		"minuite",
		"minuzzate",
		"miracolate",
		"miscelate",
		"mischiate",
		"misconosciute",
		"missate",
		"mistificate",
		"misturate",
		"misurate",
		"miticizzate",
		"mitigate",
		"mitizzate",
		"mitragliate",
		"mitrate",
		"mixate",
		"mobiliate",
		"mobilitate",
		"mobilizzate",
		"modanate",
		"modellate",
		"modellizzate",
		"moderate",
		"modernizzate",
		"modificate",
		"modulate",
		"molate",
		"molestate",
		"mollate",
		"molleggiate",
		"moltiplicate",
		"monacate",
		"mondate",
		"mondializzate",
		"monetarizzate",
		"monetate",
		"monetizzate",
		"monitorate",
		"monitorizzate",
		"monocromatizzate",
		"monopolizzate",
		"monottongate",
		"montate",
		"monumentalizzate",
		"mordenzate",
		"mordicchiate",
		"mormorate",
		"morphate",
		"morsicate",
		"morsicchiate",
		"morse",
		"mortasate",
		"mortificate",
		"mosse",
		"mostrate",
		"motivate",
		"motorizzate",
		"motteggiate",
		"movimentate",
		"mozzate",
		"mugolate",
		"mulcite",
		"multate",
		"multiplexate",
		"mummificate",
		"municipalizzate",
		"munite",
		"munte",
		"murate",
		"musate",
		"musicate",
		"mussate",
		"mutate",
		"mutilate",
		"mutizzate",
		"mutuate",
		"nappate",
		"narcotizzate",
		"narrativizzate",
		"narrate",
		"nasalizzate",
		"nascose",
		"nascoste",
		"nastrate",
		"naturaleggiate",
		"naturalizzate",
		"nauseate",
		"naverate",
		"navicate",
		"navigate",
		"nazificate",
		"nazionalizzate",
		"nebulizzate",
		"necessitate",
		"necrosate",
		"necrotizzate",
		"negativizzate",
		"negate",
		"neglette",
		"negoziate",
		"negreggiate",
		"neologizzate",
		"nerbate",
		"nericate",
		"nettate",
		"neutralizzate",
		"nevate",
		"nevicate",
		"nevischiate",
		"nevrotizzate",
		"nichelate",
		"niellate",
		"ninfeggiate",
		"ninnate",
		"ninnolate",
		"nitratate",
		"nitrificate",
		"nobilitate",
		"noiate",
		"noleggiate",
		"nomate",
		"nominalizzate",
		"nominate",
		"normalizzate",
		"normate",
		"notate",
		"notificate",
		"notiziate",
		"notricate",
		"noverate",
		"nuclearizzate",
		"nudricate",
		"nullificate",
		"numerate",
		"numerizzate",
		"nuotate",
		"nutrite",
		"obbiettate",
		"obbliate",
		"obbligate",
		"oberate",
		"obiettate",
		"obiettivate",
		"obiettivizzate",
		"obiurgate",
		"obliate",
		"obliterate",
		"obnubilate",
		"occasionate",
		"occhieggiate",
		"occidentalizzate",
		"occise",
		"occluse",
		"occultate",
		"occupate",
		"ocheggiate",
		"odiate",
		"odorate",
		"odorizzate",
		"offerite",
		"offerte",
		"offese",
		"officiate",
		"offiziate",
		"offuscate",
		"ofiziate",
		"oggettivate",
		"oggettivizzate",
		"oggettualizzate",
		"oliate",
		"olite",
		"olografate",
		"oltraggiate",
		"oltrapassate",
		"oltrepassate",
		"omaggiate",
		"ombrate",
		"ombreggiate",
		"omesse",
		"omogeneizzate",
		"omogenizzate",
		"omologate",
		"ondate",
		"ondulate",
		"onestate",
		"onnubilate",
		"onorate",
		"opacate",
		"opacizzate",
		"operate",
		"opinate",
		"oppiate",
		"oppignorate",
		"oppilate",
		"opposte",
		"oppresse",
		"oppugnate",
		"oprate",
		"opsonizzate",
		"optate",
		"opzionate",
		"orbitate",
		"orchestrate",
		"ordinate",
		"ordite",
		"orecchiate",
		"organate",
		"organicate",
		"organizzate",
		"orgasmate",
		"orientalizzate",
		"orientate",
		"originate",
		"origliate",
		"orizzontate",
		"orlate",
		"orlettate",
		"ormate",
		"ormeggiate",
		"ornate",
		"orpellate",
		"orrate",
		"orripilate",
		"ortogonalizzate",
		"osannate",
		"osate",
		"osculate",
		"oscurate",
		"ospedalizzate",
		"ospitate",
		"ossedute",
		"ossequiate",
		"osservate",
		"ossessionate",
		"ossidate",
		"ossificate",
		"ossitonizzate",
		"ostacolate",
		"osteggiate",
		"ostentate",
		"ostinate",
		"ostracizzate",
		"ostruite",
		"ottemperate",
		"ottenebrate",
		"ottenute",
		"ottimalizzate",
		"ottimate",
		"ottimizzate",
		"ottonate",
		"ottriate",
		"ottuplicate",
		"otturate",
		"ottuse",
		"ottusse",
		"ovalizzate",
		"ovariectomizzate",
		"ovattate",
		"overcloccate",
		"ovrate",
		"ovviate",
		"ozieggiate",
		"ozonizzate",
		"pacate",
		"pacciamate",
		"pacificate",
		"padroneggiate",
		"paganizzate",
		"pagate",
		"paginate",
		"palafittate",
		"palatalizzate",
		"palate",
		"palesate",
		"palettate",
		"palettizzate",
		"palificate",
		"palleggiate",
		"pallettizzate",
		"palpate",
		"palpeggiate",
		"panate",
		"panneggiate",
		"panoramicate",
		"pappate",
		"paracadutate",
		"parafate",
		"paraffinate",
		"parafrasate",
		"paragonate",
		"paragrafate",
		"paralizzate",
		"parallelizzate",
		"parametrate",
		"parametrizzate",
		"parassitate",
		"parate",
		"parcate",
		"parcellizzate",
		"parcheggiate",
		"pareggiate",
		"parificate",
		"parkerizzate",
		"parlate",
		"parlucchiate",
		"parodiate",
		"partecipate",
		"particolareggiate",
		"particolarizzate",
		"partizionate",
		"partorite",
		"parzializzate",
		"pasciute",
		"pascolate",
		"passate",
		"passeggiate",
		"passionate",
		"passivate",
		"pasticciate",
		"pastorizzate",
		"pasturate",
		"patinate",
		"patite",
		"patrocinate",
		"patteggiate",
		"pattugliate",
		"pattuite",
		"paventate",
		"pavesate",
		"pavimentate",
		"pavoneggiate",
		"pazziate",
		"pedinate",
		"pedonalizzate",
		"peggiorate",
		"pelate",
		"pellettizzate",
		"penalizzate",
		"penetrate",
		"pennellate",
		"pensate",
		"pensionate",
		"pentite",
		"pepate",
		"peptonizzate",
		"peragrate",
		"percentualizzate",
		"percepite",
		"percolate",
		"percorse",
		"percosse",
		"perdonate",
		"perdotte",
		"perdute",
		"perequate",
		"perfatte",
		"perfezionate",
		"perforate",
		"performate",
		"perite",
		"periziate",
		"perlustrate",
		"permeate",
		"permesse",
		"perorate",
		"perpetrate",
		"perpetuate",
		"perplimute",
		"perquisite",
		"perscrutate",
		"perseguitate",
		"perseguite",
		"perse",
		"personalizzate",
		"personificate",
		"persuase",
		"perturbate",
		"pervase",
		"pervertite",
		"pesate",
		"pescate",
		"pestate",
		"petrarcheggiate",
		"pettegolate",
		"pettinate",
		"piagate",
		"piaggiate",
		"piallate",
		"pianeggiate",
		"pianificate",
		"piantate",
		"piantatale",
		"piantate",
		"piante",
		"piantonate",
		"piantumate",
		"piastrellate",
		"piatite",
		"piazzate",
		"picchettate",
		"picchiate",
		"picchierellate",
		"picchiettate",
		"picconate",
		"piegate",
		"pieghettate",
		"pietrificate",
		"pigiate",
		"pigliate",
		"pigmentate",
		"pignorate",
		"pigolate",
		"pilotate",
		"pimentate",
		"pinte",
		"pinzate",
		"piombate",
		"piovigginate",
		"piovute",
		"pipate",
		"pippate",
		"piratate",
		"pirogenate",
		"pisciate",
		"pitoccate",
		"pittate",
		"pitturate",
		"pizzicate",
		"pizzicottate",
		"placate",
		"placcate",
		"plagiate",
		"plasmate",
		"plasticate",
		"plastificate",
		"platinate",
		"plissettate",
		"pluralizzate",
		"poetate",
		"poeticizzate",
		"poggiate",
		"polarizzate",
		"poligrafate",
		"polimerizzate",
		"politicizzate",
		"polverizzate",
		"pomiciate",
		"pompate",
		"ponderate",
		"ponzate",
		"popolarizzate",
		"popolate",
		"poppate",
		"porcellanate",
		"porfirizzate",
		"portate",
		"portese",
		"porte",
		"porzionate",
		"posate",
		"posdatate",
		"positivizzate",
		"posizionate",
		"posposte",
		"possedute",
		"postate",
		"postdatate",
		"posteggiate",
		"posticipate",
		"postillate",
		"poste",
		"postsincronizzate",
		"postulate",
		"potabilizzate",
		"potate",
		"potenziate",
		"potute",
		"pralinate",
		"praticate",
		"preaccennate",
		"preannunciate",
		"preannunziate",
		"preavvertite",
		"preavvisate",
		"precaricate",
		"precedute",
		"precettate",
		"precinte",
		"precisate",
		"precluse",
		"precompilate",
		"precompresse",
		"preconfezionate",
		"preconizzate",
		"preconosciute",
		"precorse",
		"precostituite",
		"predate",
		"predefinite",
		"predestinate",
		"predeterminate",
		"predette",
		"predicate",
		"predigerite",
		"predilette",
		"predisposte",
		"preelette",
		"preesistute",
		"prefabbricate",
		"prefate",
		"prefatte",
		"prefazionate",
		"preferite",
		"prefigurate",
		"prefinanziate",
		"prefissate",
		"prefisse",
		"preformate",
		"pregate",
		"pregiate",
		"pregiudicate",
		"pregustate",
		"preimpregnate",
		"prelevate",
		"premeditate",
		"premescolate",
		"premesse",
		"premiate",
		"premonite",
		"premunite",
		"premurate",
		"premute",
		"prenotate",
		"preoccupate",
		"preordinate",
		"preparate",
		"prepensionate",
		"prepigmentate",
		"preposte",
		"preprogrammate",
		"preraffreddate",
		"prerefrigerate",
		"preregistrate",
		"preregolate",
		"preriscaldate",
		"prese",
		"presagite",
		"presapute",
		"presasele",
		"prescelte",
		"prescritte",
		"presedute",
		"presegnalate",
		"preselezionate",
		"presentate",
		"presentite",
		"preservate",
		"presidiate",
		"presiedute",
		"prese",
		"pressate",
		"presse",
		"pressurizzate",
		"prestabilite",
		"prestampate",
		"prestate",
		"prestigiate",
		"presunte",
		"presupposte",
		"pretermesse",
		"pretese",
		"pretrattate",
		"prevaricate",
		"prevedute",
		"prevendute",
		"preventivate",
		"prevenute",
		"previste",
		"prezzate",
		"prezzolate",
		"principiate",
		"privatizzate",
		"private",
		"privilegiate",
		"problematizzate",
		"procacciate",
		"processate",
		"proclamate",
		"procrastinate",
		"procreate",
		"procurate",
		"prodigate",
		"prodotte",
		"profanate",
		"proferite",
		"professate",
		"professionalizzate",
		"profetate",
		"profetizzate",
		"profferite",
		"profilate",
		"profondate",
		"profumate",
		"profuse",
		"progettate",
		"prognosticate",
		"programmate",
		"proibite",
		"proiettate",
		"proletarizzate",
		"prolungate",
		"promanate",
		"promesse",
		"promosse",
		"promozionate",
		"promulgate",
		"pronosticate",
		"pronunciate",
		"pronunziate",
		"propagandate",
		"propagate",
		"propagginate",
		"propalate",
		"propinate",
		"propiziate",
		"proporzionate",
		"proposte",
		"propugnate",
		"propulse",
		"prorogate",
		"prosciolte",
		"prosciugate",
		"proscritte",
		"proseguite",
		"prospettate",
		"prosternate",
		"prostese",
		"prostituite",
		"prostrate",
		"prosunte",
		"protese",
		"protestate",
		"protette",
		"protocollate",
		"protonate",
		"protratte",
		"protruse",
		"provate",
		"provedute",
		"provincializzate",
		"proviste",
		"provocate",
		"provvedute",
		"provviste",
		"psicanalizzate",
		"psichiatrizzate",
		"psicoanalizzate",
		"psicologizzate",
		"pubblicate",
		"pubblicizzate",
		"puddellate",
		"pugnalate",
		"pulite",
		"pungolate",
		"punite",
		"puntate",
		"punteggiate",
		"puntellate",
		"punte",
		"puntualizzate",
		"punzecchiate",
		"punzonate",
		"purgate",
		"purificate",
		"putite",
		"putrefatte",
		"putrite",
		"quadrate",
		"quadrettate",
		"quadriennalizzate",
		"quadruplicate",
		"qualificate",
		"quantificate",
		"quantizzate",
		"querelate",
		"questuate",
		"quetate",
		"quietanzate",
		"quietate",
		"quintessenziate",
		"quintuplicate",
		"quotate",
		"quotizzate",
		"rabberciate",
		"rabboccate",
		"rabbonite",
		"rabbuffate",
		"rabuffate",
		"raccapezzate",
		"raccapricciate",
		"raccattate",
		"raccerchiate",
		"raccese",
		"racchetate",
		"racchiuse",
		"raccolte",
		"raccolte",
		"raccomandate",
		"raccomodate",
		"raccontate",
		"raccorciate",
		"raccorcite",
		"raccordate",
		"raccostate",
		"raccozzate",
		"racemizzate",
		"racimolate",
		"radazzate",
		"raddensate",
		"raddobbate",
		"raddolcite",
		"raddoppiate",
		"raddotte",
		"raddrizzate",
		"radiate",
		"radicalizzate",
		"radioassistite",
		"radioattivate",
		"radiocomandate",
		"radiodiffuse",
		"radiografate",
		"radioguidate",
		"radiolocalizzate",
		"radiomarcate",
		"radiotelegrafate",
		"radiotrasmesse",
		"radunate",
		"raffazzonate",
		"raffermate",
		"raffigurate",
		"raffilate",
		"raffinate",
		"rafforzate",
		"raffreddate",
		"raffrenate",
		"raffrescate",
		"raffrontate",
		"raggelate",
		"raggentilite",
		"ragghiate",
		"raggirate",
		"raggiunte",
		"raggiustate",
		"raggomitolate",
		"raggranchiate",
		"raggranchite",
		"raggranellate",
		"raggrinzate",
		"raggrinzite",
		"raggrumate",
		"raggruppate",
		"raggruzzolate",
		"ragguagliate",
		"ralingate",
		"rallegrate",
		"rallentate",
		"ramate",
		"ramazzate",
		"rammagliate",
		"rammaricate",
		"rammemorate",
		"rammendate",
		"rammentate",
		"rammodernate",
		"rammollite",
		"rammorbidite",
		"rampognate",
		"randellate",
		"randomizzate",
		"rannicchiate",
		"rannuvolate",
		"ranzate",
		"rapate",
		"rapinate",
		"rapite",
		"rappacificate",
		"rappate",
		"rappattumate",
		"rappezzate",
		"rapportate",
		"rappresantate",
		"rappresentate",
		"rapprese",
		"rarefatte",
		"rasate",
		"raschiate",
		"raschiettate",
		"rasentate",
		"rase",
		"raspate",
		"rassegnate",
		"rasserenate",
		"rassettate",
		"rassicurate",
		"rassodate",
		"rassomigliate",
		"rassottigliate",
		"rassunte",
		"rastrellate",
		"rastremate",
		"rateate",
		"rateizzate",
		"ratificate",
		"ratinate",
		"rattizzate",
		"rattoppate",
		"rattorte",
		"rattrappite",
		"rattristate",
		"rattristite",
		"raunate",
		"ravvalorate",
		"ravvedute",
		"ravviate",
		"ravvicinate",
		"ravviluppate",
		"ravvisate",
		"ravviste",
		"ravvivate",
		"ravvolte",
		"ravvoltolate",
		"razionalizzate",
		"razionate",
		"razziate",
		"razzolate",
		"realizzate",
		"reassunte",
		"recapitate",
		"recate",
		"recedute",
		"recensite",
		"recepite",
		"recidivate",
		"recintate",
		"recinte",
		"reciprocate",
		"recise",
		"recitate",
		"reclamate",
		"reclamizzate",
		"reclinate",
		"recluse",
		"reclutate",
		"recuperate",
		"redarguite",
		"redatte",
		"redazzate",
		"reddute",
		"redente",
		"redistribuite",
		"redotte",
		"referenziate",
		"refertate",
		"refilate",
		"reflesse",
		"reflettute",
		"refrante",
		"refrigerate",
		"regalate",
		"regimate",
		"regimentate",
		"regionalizzate",
		"registrate",
		"regolamentate",
		"regolarizzate",
		"regolate",
		"reidratate",
		"reificate",
		"reimbarcate",
		"reimmerse",
		"reimmesse",
		"reimparate",
		"reimpastate",
		"reimpiantate",
		"reimpiegate",
		"reimportate",
		"reimpostate",
		"reincarcerate",
		"reincaricate",
		"reincarnate",
		"reincise",
		"reincontrate",
		"reindirizzate",
		"reindustrializzate",
		"reinfettate",
		"reingaggiate",
		"reinizializzate",
		"reinnestate",
		"reinoltrate",
		"reinscritte",
		"reinsediate",
		"reinserite",
		"reinstallate",
		"reinstaurate",
		"reintegrate",
		"reinterpretate",
		"reintitolate",
		"reintrodotte",
		"reinventate",
		"reinvestite",
		"reiterate",
		"relativizzate",
		"relazionate",
		"relegate",
		"remixate",
		"remunerate",
		"renderizzate",
		"reperite",
		"repertate",
		"replicate",
		"represse",
		"repulse",
		"reputate",
		"requisite",
		"rescisse",
		"resecate",
		"resettate",
		"residuate",
		"resinificate",
		"rese",
		"resolate",
		"resolte",
		"respinte",
		"respirate",
		"responsabilizzate",
		"resposte",
		"restaurate",
		"restituite",
		"resunte",
		"resuscitate",
		"reticolate",
		"retinate",
		"retribuite",
		"retrocedute",
		"retrocesse",
		"retrodatate",
		"rettificate",
		"rette",
		"reumatizzate",
		"revisionate",
		"revocate",
		"riabbassate",
		"riabbellite",
		"riabbonate",
		"riabbottonate",
		"riabbracciate",
		"riabilitate",
		"riabitate",
		"riabituate",
		"riaccadute",
		"riaccasate",
		"riaccese",
		"riaccettate",
		"riacchiappate",
		"riacciuffate",
		"riaccolte",
		"riaccomodate",
		"riaccompagnate",
		"riaccordate",
		"riaccostate",
		"riaccreditate",
		"riacquisite",
		"riacquistate",
		"riacutizzate",
		"riadattate",
		"riaddestrate",
		"riaddormentate",
		"riadoperate",
		"riaffacciate",
		"riaffermate",
		"riafferrate",
		"riaffiorate",
		"riaffittate",
		"riaffrontate",
		"riagganciate",
		"riaggiornate",
		"riaggiustate",
		"riaggravate",
		"riaggregate",
		"riagguantate",
		"rialimentate",
		"riallacciate",
		"riallargate",
		"riallineate",
		"riallocate",
		"riallungate",
		"rialzate",
		"riamate",
		"riambientate",
		"riammalate",
		"riammesse",
		"riammodernate",
		"riammogliate",
		"rianimate",
		"riannesse",
		"riannodate",
		"riannunciate",
		"riaperte",
		"riappacificate",
		"riappaltate",
		"riapparecchiate",
		"riapparite",
		"riappese",
		"riappiccicate",
		"riapplicate",
		"riapprese",
		"riapprodate",
		"riappropriate",
		"riapprovate",
		"riarmate",
		"riarrangiate",
		"riarredate",
		"riascoltate",
		"riasfaltate",
		"riassalite",
		"riassaporate",
		"riassegnate",
		"riassemblate",
		"riassestate",
		"riassettate",
		"riassicurate",
		"riassociate",
		"riassopite",
		"riassorbite",
		"riassunte",
		"riattaccate",
		"riattate",
		"riattese",
		"riattinte",
		"riattivate",
		"riattizzate",
		"riattraversate",
		"riaumentate",
		"riavute",
		"riavventate",
		"riavvertite",
		"riavviate",
		"riavvicinate",
		"riavvinte",
		"riavvisate",
		"riavvistate",
		"riavvolte",
		"riazzuffate",
		"ribaciate",
		"ribadite",
		"ribaltate",
		"ribassate",
		"ribattezzate",
		"ribattute",
		"ribellate",
		"ribenedette",
		"ribevute",
		"ributtate",
		"ricacciate",
		"ricalate",
		"ricalcate",
		"ricalcificate",
		"ricalcitrate",
		"ricalcolate",
		"ricalibrate",
		"ricamate",
		"ricambiate",
		"ricanalizzate",
		"ricandidate",
		"ricantate",
		"ricapitalizzate",
		"ricapitolate",
		"ricaricate",
		"ricategorizzate",
		"ricattate",
		"ricavate",
		"ricelebrate",
		"ricercate",
		"ricetrasmesse",
		"ricettate",
		"ricevute",
		"richiamate",
		"richieste",
		"richiuse",
		"riciclate",
		"ricinte",
		"ricircolate",
		"riclassificate",
		"ricodificate",
		"ricollegate",
		"ricollocate",
		"ricolmate",
		"ricolonizzate",
		"ricolorate",
		"ricolorite",
		"ricoltivate",
		"ricombinate",
		"ricominciate",
		"ricommesse",
		"ricomparite",
		"ricompattate",
		"ricompensate",
		"ricomperate",
		"ricompilate",
		"ricompiute",
		"ricomposte",
		"ricomprate",
		"ricompresse",
		"ricomunicate",
		"riconcedute",
		"riconcesse",
		"riconciliate",
		"ricondizionate",
		"ricondotte",
		"riconfermate",
		"riconfezionate",
		"riconfigurate",
		"riconfortate",
		"riconfuse",
		"ricongelate",
		"ricongiunte",
		"riconnesse",
		"riconosciute",
		"riconquistate",
		"riconsacrate",
		"riconsegnate",
		"riconsiderate",
		"riconsigliate",
		"riconsolate",
		"ricontate",
		"ricontattate",
		"ricontrattate",
		"ricontratte",
		"ricontrollate",
		"riconvalidate",
		"riconvenute",
		"riconvertite",
		"riconvinte",
		"riconvocate",
		"riconvogliate",
		"ricoperte",
		"ricopiate",
		"ricordate",
		"ricoricate",
		"ricorrette",
		"ricosparse",
		"ricostituite",
		"ricostrette",
		"ricostruite",
		"ricotte",
		"ricoverate",
		"ricreate",
		"ricristallizzate",
		"ricrocifisse",
		"ricucite",
		"ricuperate",
		"ricusate",
		"ridate",
		"ridecorate",
		"ridefinite",
		"ridenominate",
		"ridestate",
		"rideterminate",
		"ridette",
		"ridicolizzate",
		"ridigitate",
		"ridimensionate",
		"ridipinte",
		"ridiscese",
		"ridisciolte",
		"ridisciplinate",
		"ridiscusse",
		"ridisegnate",
		"ridisfatte",
		"ridisposte",
		"ridistese",
		"ridistinte",
		"ridistribuite",
		"ridivise",
		"ridomandate",
		"ridonate",
		"ridondate",
		"ridorate",
		"ridotate",
		"ridotte",
		"ridovute",
		"riecheggiate",
		"riedificate",
		"rieducate",
		"rielaborate",
		"rielette",
		"riemesse",
		"riempite",
		"riempiute",
		"rientrate",
		"riepilogate",
		"riequilibrate",
		"riequipaggiate",
		"riesaminate",
		"rieseguite",
		"riesercitate",
		"riesplose",
		"riesportate",
		"riesposte",
		"riespresse",
		"riespulse",
		"riestese",
		"riesumate",
		"rietichettate",
		"rievaporate",
		"rievocate",
		"rifabbricate",
		"rifasciate",
		"rifatte",
		"rifendute",
		"riferite",
		"rifermate",
		"rifermentate",
		"rifesse",
		"rificcate",
		"rifilate",
		"rifiltrate",
		"rifinanziate",
		"rifinite",
		"rifirmate",
		"rifischiate",
		"rifisse",
		"rifiutate",
		"riflesse",
		"riflettute",
		"rifocillate",
		"rifoderate",
		"rifondate",
		"riforestate",
		"riforgiate",
		"riformate",
		"riformattate",
		"riformulate",
		"rifornite",
		"rifrante",
		"rifritte",
		"rifrugate",
		"rifuggite",
		"rifugiate",
		"rifuse",
		"rigassificate",
		"rigate",
		"rigelate",
		"rigenerate",
		"rigettate",
		"righettate",
		"rigiocate",
		"rigirate",
		"rigiudicate",
		"rigiunte",
		"rigodute",
		"rigonfiate",
		"rigovernate",
		"riguadagnate",
		"riguardate",
		"rigurgitate",
		"rilanciate",
		"rilasciate",
		"rilassate",
		"rilavate",
		"rilavorate",
		"rilegate",
		"rilette",
		"rilevate",
		"rilocalizzate",
		"rimagliate",
		"rimandate",
		"rimaneggiate",
		"rimangiate",
		"rimappate",
		"rimarcate",
		"rimarchiate",
		"rimarginate",
		"rimaritate",
		"rimasticate",
		"rimate",
		"rimbacuccate",
		"rimbaldanzite",
		"rimbarcate",
		"rimbeccate",
		"rimbecillite",
		"rimbellite",
		"rimbiancate",
		"rimbiondite",
		"rimboccate",
		"rimbombate",
		"rimborsate",
		"rimboscate",
		"rimboschite",
		"rimbrottate",
		"rimediate",
		"rimembrate",
		"rimemorate",
		"rimenate",
		"rimeritate",
		"rimescolate",
		"rimesse",
		"rimestate",
		"rimilitarizzate",
		"rimirate",
		"rimischiate",
		"rimisurate",
		"rimodellate",
		"rimodernate",
		"rimodulate",
		"rimondate",
		"rimontate",
		"rimorchiate",
		"rimorse",
		"rimosse",
		"rimostrate",
		"rimotivate",
		"rimpacchettate",
		"rimpadronite",
		"rimpaginate",
		"rimpagliate",
		"rimpannucciate",
		"rimpastate",
		"rimpatriate",
		"rimpiallacciate",
		"rimpiante",
		"rimpiattate",
		"rimpiazzate",
		"rimpicciolite",
		"rimpiccolite",
		"rimpiegate",
		"rimpinguate",
		"rimpinzate",
		"rimpolpate",
		"rimpossessate",
		"rimpresse",
		"rimproverate",
		"rimuginate",
		"rimunerate",
		"rimunte",
		"rimusicate",
		"rimutate",
		"rinarrate",
		"rinascoste",
		"rincalcate",
		"rincalzate",
		"rincamminate",
		"rincantucciate",
		"rincarate",
		"rincarcerate",
		"rincarnate",
		"rincentrate",
		"rinchieste",
		"rinchiodate",
		"rinchiuse",
		"rincitrullite",
		"rincivilite",
		"rincoglionite",
		"rincollate",
		"rincominciate",
		"rincontrate",
		"rincoraggiate",
		"rincorate",
		"rincorporate",
		"rincorse",
		"rincretinite",
		"rincrudite",
		"rinculcate",
		"rincuorate",
		"rindossate",
		"rindurite",
		"rinegoziate",
		"rinfacciate",
		"rinfagottate",
		"rinfiammate",
		"rinfiancate",
		"rinfilate",
		"rinfittite",
		"rinfocolate",
		"rinfoderate",
		"rinforzate",
		"rinfrancate",
		"rinfrante",
		"rinfrescate",
		"rinfuse",
		"ringagliardite",
		"ringalluzzite",
		"ringiovanite",
		"ringiovenite",
		"ringoiate",
		"ringorgate",
		"ringraziate",
		"ringuainate",
		"rinnamorate",
		"rinnegate",
		"rinnestate",
		"rinnovate",
		"rinnovellate",
		"rinociute",
		"rinomate",
		"rinominate",
		"rinormalizzate",
		"rinquadrate",
		"rinsaccate",
		"rinsaldate",
		"rinsanguate",
		"rinselvatichite",
		"rinselvate",
		"rinserrate",
		"rintanate",
		"rintasate",
		"rintascate",
		"rintavolate",
		"rintenerite",
		"rinterrate",
		"rinterrogate",
		"rintese",
		"rintiepidite",
		"rintoccate",
		"rintonacate",
		"rintontite",
		"rintorpidite",
		"rintracciate",
		"rintrodotte",
		"rintronate",
		"rintuzzate",
		"rinunciate",
		"rinunziate",
		"rinutrite",
		"rinvangate",
		"rinvasate",
		"rinvenute",
		"rinverdite",
		"rinvestite",
		"rinviate",
		"rinvigorite",
		"rinvilite",
		"rinvitate",
		"rinvoltate",
		"rinvolte",
		"rinvoltolate",
		"rinzaffate",
		"rinzeppate",
		"riobbligate",
		"rioccupate",
		"riofferte",
		"rioffese",
		"rioperate",
		"riordinate",
		"riorganizzate",
		"riorientate",
		"riosservate",
		"riottenute",
		"riottimizzate",
		"riotturate",
		"ripagate",
		"riparametrizzate",
		"riparate",
		"ripartite",
		"ripassate",
		"ripercorse",
		"ripercosse",
		"riperdute",
		"riperse",
		"ripesate",
		"ripescate",
		"ripestate",
		"ripetute",
		"ripianate",
		"ripianificate",
		"ripiantate",
		"ripiante",
		"ripicchiate",
		"ripiegate",
		"ripigliate",
		"ripinte",
		"ripiovute",
		"ripitturate",
		"riplasmate",
		"ripolarizzate",
		"ripopolate",
		"riportate",
		"riporte",
		"riposate",
		"riposizionate",
		"ripossedute",
		"riposte",
		"ripotute",
		"ripresentate",
		"riprese",
		"riprestate",
		"ripretese",
		"riprincipiate",
		"ripristinate",
		"riprivatizzate",
		"riprodotte",
		"riprogettate",
		"riprogrammate",
		"ripromesse",
		"riproposte",
		"riprotette",
		"riprovate",
		"riprovvedute",
		"riprovviste",
		"ripubblicate",
		"ripudiate",
		"ripugnate",
		"ripulite",
		"ripuntate",
		"ripunte",
		"ripurgate",
		"riputate",
		"riquadrate",
		"riqualificate",
		"rirese",
		"rirotte",
		"risaldate",
		"risalite",
		"risaltate",
		"risalutate",
		"risanate",
		"risapute",
		"risarcite",
		"riscalate",
		"riscaldate",
		"riscattate",
		"riscelte",
		"riscese",
		"rischiarate",
		"rischiate",
		"risciacquate",
		"risciolte",
		"riscommesse",
		"riscontate",
		"riscontrate",
		"risconvolte",
		"riscoperte",
		"riscoppiate",
		"riscorse",
		"riscosse",
		"riscritte",
		"risecate",
		"risedute",
		"risegate",
		"risegnate",
		"riselciate",
		"riselezionate",
		"riseminate",
		"risentite",
		"riseppellite",
		"riserbate",
		"riservate",
		"risicate",
		"risigillate",
		"risistemate",
		"rise",
		"risoffiate",
		"risoggiunte",
		"risolate",
		"risolidificate",
		"risollevate",
		"risolte",
		"risommate",
		"risommerse",
		"risonate",
		"risorpassate",
		"risospese",
		"risospinte",
		"risottomesse",
		"risparmiate",
		"risparse",
		"rispecchiate",
		"rispedite",
		"rispente",
		"risperse",
		"rispettate",
		"rispiegate",
		"rispinte",
		"rispolverate",
		"risposate",
		"risposte",
		"rissate",
		"ristabilite",
		"ristagnate",
		"ristampate",
		"ristaurate",
		"ristese",
		"ristilizzate",
		"ristorate",
		"ristrette",
		"ristrutte",
		"ristrutturate",
		"ristuccate",
		"ristudiate",
		"risucchiate",
		"risultate",
		"risuolate",
		"risuonate",
		"risuscitate",
		"risvegliate",
		"risvolte",
		"ritagliate",
		"ritarate",
		"ritardate",
		"ritemprate",
		"ritentate",
		"ritenute",
		"riterse",
		"ritese",
		"ritinte",
		"ritirate",
		"ritoccate",
		"ritolte",
		"ritorte",
		"ritracciate",
		"ritradotte",
		"ritrascorse",
		"ritrascritte",
		"ritrasferite",
		"ritrasformate",
		"ritrasmesse",
		"ritrasposte",
		"ritrattate",
		"ritratte",
		"ritrovate",
		"ritualizzate",
		"rituffate",
		"riudite",
		"riunificate",
		"riunite",
		"riusate",
		"riutilizzate",
		"rivaccinate",
		"rivaleggiate",
		"rivalorizzate",
		"rivalse",
		"rivalutate",
		"rivangate",
		"rivedute",
		"rivelate",
		"rivendicate",
		"rivendute",
		"riverberate",
		"riverite",
		"riverniciate",
		"riversate",
		"rivestite",
		"rivettate",
		"rivinte",
		"rivisitate",
		"rivissute",
		"riviste",
		"rivitalizzate",
		"rivivificate",
		"rivoltate",
		"rivolte",
		"rivoltolate",
		"rivolute",
		"rivoluzionate",
		"rizappate",
		"rizzate",
		"robotizzate",
		"rodate",
		"rogate",
		"rollate",
		"romanizzate",
		"romanticizzate",
		"romanzate",
		"roncolate",
		"rosicate",
		"rosicchiate",
		"rose",
		"rosolate",
		"rotacizzate",
		"rotate",
		"roteate",
		"rotolate",
		"rottamate",
		"rotte",
		"rovesciate",
		"rovinate",
		"rovistate",
		"rubacchiate",
		"rubate",
		"rullate",
		"ruminate",
		"ruotate",
		"russificate",
		"ruzzolate",
		"sabbiate",
		"sabotate",
		"saccarificate",
		"saccheggiate",
		"sacralizzate",
		"sacramentate",
		"sacrificate",
		"saettate",
		"saggiate",
		"sagginate",
		"sagomate",
		"salamoiate",
		"salariate",
		"salassate",
		"salate",
		"saldate",
		"salificate",
		"salinizzate",
		"salite",
		"salmeggiate",
		"salmistrate",
		"salpate",
		"saltate",
		"salutate",
		"salvaguardate",
		"salvate",
		"sanate",
		"sancite",
		"sanforizzate",
		"sanificate",
		"sanitizzate",
		"santificate",
		"sanzionate",
		"saponificate",
		"sapute",
		"sarchiate",
		"sarchiellate",
		"sartiate",
		"satellizzate",
		"satinate",
		"satireggiate",
		"satisfatte",
		"satollate",
		"saturate",
		"saziate",
		"sbaccellate",
		"sbaciucchiate",
		"sbafate",
		"sbaffate",
		"sbalestrate",
		"sballate",
		"sballottate",
		"sballottolate",
		"sbalordite",
		"sbalzate",
		"sbancate",
		"sbandate",
		"sbandierate",
		"sbandite",
		"sbaraccate",
		"sbaragliate",
		"sbarazzate",
		"sbarbate",
		"sbarcate",
		"sbardate",
		"sbarrate",
		"sbassate",
		"sbastite",
		"sbatacchiate",
		"sbattezzate",
		"sbattute",
		"sbeccate",
		"sbeffeggiate",
		"sbellicate",
		"sbendate",
		"sbertucciate",
		"sbiadite",
		"sbiancate",
		"sbianchite",
		"sbiellate",
		"sbiettate",
		"sbigottite",
		"sbilanciate",
		"sbirbate",
		"sbirciate",
		"sbizzarrite",
		"sbloccate",
		"sbobinate",
		"sboccate",
		"sbocconcellate",
		"sbollentate",
		"sbolognate",
		"sborniate",
		"sborsate",
		"sboscate",
		"sbottonate",
		"sbozzate",
		"sbozzimate",
		"sbozzolate",
		"sbracate",
		"sbracciate",
		"sbraciate",
		"sbraitate",
		"sbranate",
		"sbrancate",
		"sbrattate",
		"sbreccate",
		"sbriciolate",
		"sbrigate",
		"sbrigliate",
		"sbrinate",
		"sbrindellate",
		"sbrodolate",
		"sbrogliate",
		"sbronzate",
		"sbruffate",
		"sbucciate",
		"sbudellate",
		"sbuffate",
		"sbugiardate",
		"sbullettate",
		"sbullonate",
		"sburrate",
		"scacazzate",
		"scacchiate",
		"scacciate",
		"scaccolate",
		"scadenzate",
		"scafate",
		"scaffalate",
		"scagionate",
		"scagliate",
		"scaglionate",
		"scalate",
		"scalcate",
		"scalcinate",
		"scaldate",
		"scalettate",
		"scalfate",
		"scalfite",
		"scalmanate",
		"scaloppate",
		"scalpate",
		"scalpellate",
		"scalpellinate",
		"scaltrite",
		"scalzate",
		"scambiate",
		"scamiciate",
		"scamosciate",
		"scamozzate",
		"scampate",
		"scampatale",
		"scampate",
		"scamuffate",
		"scanalate",
		"scancellate",
		"scandagliate",
		"scandalizzate",
		"scandite",
		"scannate",
		"scannellate",
		"scannerate",
		"scannerizate",
		"scannerizzate",
		"scansate",
		"scansionate",
		"scapecchiate",
		"scapezzate",
		"scapicollate",
		"scapigliate",
		"scapitozzate",
		"scapocchiate",
		"scappate",
		"scappellate",
		"scappottate",
		"scapricciate",
		"scapsulate",
		"scarabocchiate",
		"scaracchiate",
		"scaraventate",
		"scarcerate",
		"scardassate",
		"scardate",
		"scardinate",
		"scaricate",
		"scarificate",
		"scarmigliate",
		"scarnate",
		"scarnificate",
		"scarnite",
		"scarrellate",
		"scarrocciate",
		"scarrozzate",
		"scarruffate",
		"scartabellate",
		"scartate",
		"scartavetrate",
		"scartinate",
		"scartocciate",
		"scassate",
		"scassinate",
		"scatenate",
		"scattate",
		"scavalcate",
		"scavallate",
		"scavate",
		"scavezzate",
		"scazzottate",
		"scekerate",
		"scelte",
		"scempiate",
		"sceneggiate",
		"scernute",
		"scervellate",
		"scese",
		"sceverate",
		"schedate",
		"schedulate",
		"scheggiate",
		"scheletrite",
		"schematizzate",
		"schermate",
		"schermite",
		"schermografate",
		"schernite",
		"schiacciate",
		"schiaffate",
		"schiaffeggiate",
		"schiantate",
		"schiarite",
		"schiavardate",
		"schiavizzate",
		"schiccherate",
		"schierate",
		"schifate",
		"schinciate",
		"schioccate",
		"schiodate",
		"schiumate",
		"schiuse",
		"schivate",
		"schizzate",
		"schizzettate",
		"sciabolate",
		"sciabordate",
		"sciacquate",
		"scialacquate",
		"sciamanizzate",
		"sciamannate",
		"sciancate",
		"sciancrate",
		"scimmieggiate",
		"scimmiottate",
		"scinte",
		"scioccate",
		"sciolinate",
		"sciolte",
		"sciorinate",
		"scippate",
		"sciroppate",
		"scisse",
		"sciupacchiate",
		"sciupate",
		"sclamate",
		"sclerosate",
		"sclerotizzate",
		"scoccate",
		"scocciate",
		"scodate",
		"scodellate",
		"scoiate",
		"scolarizzate",
		"scolate",
		"scollacciate",
		"scollate",
		"scollegate",
		"scolorate",
		"scolorite",
		"scolpate",
		"scolpite",
		"scombaciate",
		"scombinate",
		"scombussolate",
		"scommesse",
		"scomodate",
		"scompaginate",
		"scompagnate",
		"scompartite",
		"scompattate",
		"scompensate",
		"scompiacute",
		"scompigliate",
		"scomposte",
		"scomputate",
		"scomunicate",
		"sconcertate",
		"sconciate",
		"sconcluse",
		"sconfessate",
		"sconficcate",
		"sconﬁtte",
		"sconfortate",
		"sconfuse",
		"scongelate",
		"scongiurate",
		"sconnesse",
		"sconosciute",
		"sconquassate",
		"sconsacrate",
		"sconsigliate",
		"sconsolate",
		"scontate",
		"scontentate",
		"scontornate",
		"scontorte",
		"scontrate",
		"sconvolte",
		"scopate",
		"scoperchiate",
		"scoperte",
		"scopiazzate",
		"scoraggiate",
		"scoraggite",
		"scorate",
		"scorazzate",
		"scorciate",
		"scorcite",
		"scordate",
		"scoreggiate",
		"scorificate",
		"scornate",
		"scorniciate",
		"scoronate",
		"scorporate",
		"scorrazzate",
		"scorreggiate",
		"scorrette",
		"scorse",
		"scortate",
		"scortecciate",
		"scorticate",
		"scorte",
		"scorzate",
		"scoscese",
		"scosciate",
		"scosse",
		"scostate",
		"scostolate",
		"scotennate",
		"scoticate",
		"scotolate",
		"scotomizzate",
		"scottate",
		"scotte",
		"scovate",
		"scoverte",
		"scozzate",
		"scozzonate",
		"screditate",
		"scremate",
		"screpolate",
		"screziate",
		"scribacchiate",
		"scriminate",
		"scristianizzate",
		"scritte",
		"scritturate",
		"scroccate",
		"scrocchiate",
		"scrollate",
		"scrostate",
		"scrutate",
		"scrutinate",
		"scucite",
		"scudisciate",
		"scuffiate",
		"sculacciate",
		"sculettate",
		"scuoiate",
		"scuriosate",
		"scurite",
		"scusate",
		"sdaziate",
		"sdebitate",
		"sdegnate",
		"sdemanializzate",
		"sdentate",
		"sdilinquite",
		"sdoganate",
		"sdolute",
		"sdoppiate",
		"sdraiate",
		"sdrammatizzate",
		"sdrucite",
		"secate",
		"seccate",
		"secernute",
		"secolarizzate",
		"secondate",
		"secretate",
		"secrete",
		"sedate",
		"sedentarizzate",
		"sedotte",
		"segate",
		"seghettate",
		"segmentate",
		"segnalate",
		"segnate",
		"segnoreggiate",
		"segregate",
		"segretate",
		"seguitate",
		"seguite",
		"selciate",
		"selezionate",
		"sellate",
		"sembrate",
		"sementate",
		"semicinte",
		"seminate",
		"semplificate",
		"senilizzate",
		"sensibilizzate",
		"sensorizzate",
		"sentenziate",
		"sentite",
		"sentitasele",
		"sentite",
		"sentite",
		"separate",
		"sepolte",
		"seppellite",
		"sequenziate",
		"sequestrate",
		"serbate",
		"serrate",
		"servite",
		"servoassistite",
		"sessualizzate",
		"sestuplicate",
		"setacciate",
		"setificate",
		"settate",
		"settorializzate",
		"settuplicate",
		"seviziate",
		"sezionate",
		"sfaccettate",
		"sfagliate",
		"sfaldate",
		"sfalsate",
		"sfamate",
		"sfanalate",
		"sfangate",
		"sfarinate",
		"sfasate",
		"sfasciate",
		"sfatate",
		"sfatte",
		"sfavillate",
		"sfavorite",
		"sfegatate",
		"sfeltrate",
		"sfendute",
		"sferragliate",
		"sferrate",
		"sferzate",
		"sfesse",
		"sfiancate",
		"sfiatate",
		"sfiate",
		"sfibbiate",
		"sfibrate",
		"sfidate",
		"sfiduciate",
		"sfigurate",
		"sfilate",
		"sfilettate",
		"sfinite",
		"sfioccate",
		"sfiorate",
		"sfittate",
		"sfocate",
		"sfociate",
		"sfoderate",
		"sfogate",
		"sfoggiate",
		"sfogliate",
		"sfollate",
		"sfoltite",
		"sfondate",
		"sforacchiate",
		"sforate",
		"sforbiciate",
		"sformate",
		"sfornaciate",
		"sfornate",
		"sfornite",
		"sforzate",
		"sfottute",
		"sfracellate",
		"sfrangiate",
		"sfrascate",
		"sfratate",
		"sfrattate",
		"sfrecciate",
		"sfregate",
		"sfregiate",
		"sfrenate",
		"sfrisate",
		"sfrondate",
		"sfrucugliate",
		"sfruculiate",
		"sfruttate",
		"sfumate",
		"sfuocate",
		"sgamate",
		"sganasciate",
		"sganciate",
		"sgarbugliate",
		"sgattaiolate",
		"sgelate",
		"sghiacciate",
		"sgocciolate",
		"sgolate",
		"sgomberate",
		"sgombrate",
		"sgomentate",
		"sgominate",
		"sgomitate",
		"sgomitolate",
		"sgonfiate",
		"sgorbiate",
		"sgottate",
		"sgovernate",
		"sgozzate",
		"sgraffiate",
		"sgraffignate",
		"sgranate",
		"sgranchite",
		"sgranellate",
		"sgrassate",
		"sgravate",
		"sgretolate",
		"sgridate",
		"sgrommate",
		"sgrondate",
		"sgroppate",
		"sgrossate",
		"sgrovigliate",
		"sgrugnate",
		"sguainate",
		"sgualcite",
		"sguanciate",
		"sguarnite",
		"sguinzagliate",
		"sgusciate",
		"shakerate",
		"shoccate",
		"shuntate",
		"sigillate",
		"siglate",
		"significate",
		"signoreggiate",
		"silenziate",
		"silicizzate",
		"sillabate",
		"sillogizzate",
		"silurate",
		"simboleggiate",
		"simbolizzate",
		"simmetrizzate",
		"simpatizzate",
		"simulate",
		"sincerate",
		"sincopate",
		"sincretizzate",
		"sincronizzate",
		"sindacalizzate",
		"sindacate",
		"singolarizzate",
		"sinistrate",
		"sinizzate",
		"sinterizzate",
		"sintetizzate",
		"sintonizzate",
		"siringate",
		"sistematizzate",
		"sistemate",
		"situate",
		"slabbrate",
		"slacciate",
		"slamate",
		"slanciate",
		"slappolate",
		"slargate",
		"slavizzate",
		"slegate",
		"slentate",
		"slinguate",
		"slogate",
		"sloggate",
		"sloggiate",
		"slombate",
		"slungate",
		"smaccate",
		"smacchiate",
		"smagliate",
		"smagnetizzate",
		"smagrite",
		"smaliziate",
		"smallate",
		"smaltate",
		"smaltite",
		"smammate",
		"smanacciate",
		"smangiate",
		"smantellate",
		"smarcate",
		"smarginate",
		"smarrite",
		"smascellate",
		"smascherate",
		"smaterializzate",
		"smattonate",
		"smembrate",
		"smentite",
		"smerciate",
		"smerdate",
		"smerigliate",
		"smerlate",
		"smerlettate",
		"smessale",
		"smesse",
		"smezzate",
		"smidollate",
		"smielate",
		"smilitarizzate",
		"sminate",
		"sminuite",
		"sminuzzate",
		"smistate",
		"smitizzate",
		"smobiliate",
		"smobilitate",
		"smobilizzate",
		"smoccolate",
		"smollicate",
		"smonacate",
		"smontate",
		"smorbate",
		"smorzate",
		"smosse",
		"smozzicate",
		"smunte",
		"smurate",
		"smussate",
		"smutandate",
		"snaturate",
		"snazionalizzate",
		"snebbiate",
		"snellite",
		"snervate",
		"snidate",
		"sniffate",
		"snobbate",
		"snocciolate",
		"snodate",
		"snudate",
		"sobbarcate",
		"sobbollite",
		"sobillate",
		"socchiuse",
		"soccorse",
		"soddisfatte",
		"sodisfatte",
		"sodomizzate",
		"sofferite",
		"soffermate",
		"sofferte",
		"soffiate",
		"soffocate",
		"soffregate",
		"soffritte",
		"soffuse",
		"sofisticate",
		"soggettivate",
		"soggettivizzate",
		"sogghignate",
		"soggiogate",
		"soggiunte",
		"sogguardate",
		"sognate",
		"solarizzate",
		"solcate",
		"soleggiate",
		"solennizzate",
		"solfeggiate",
		"solfitate",
		"solfonate",
		"solforate",
		"solidificate",
		"solite",
		"sollazzate",
		"sollecitate",
		"solleticate",
		"sollevate",
		"solte",
		"solubilizzate",
		"solute",
		"soluzionate",
		"solvatate",
		"somatizzate",
		"someggiate",
		"somigliate",
		"sommate",
		"sommerse",
		"sommesse",
		"somministrate",
		"sommosse",
		"sonate",
		"sondate",
		"sonorizzate",
		"sopite",
		"soppalcate",
		"soppesate",
		"soppiantate",
		"sopportate",
		"sopposte",
		"soppresse",
		"sopraddotate",
		"sopraeccitate",
		"sopraedificate",
		"sopraelevate",
		"sopraffate",
		"sopraffatte",
		"sopraggiunte",
		"sopraintese",
		"soprammesse",
		"soprannominate",
		"sopraposte",
		"soprapprese",
		"soprascritte",
		"sopraspese",
		"soprassaturate",
		"soprassedute",
		"sopravanzate",
		"sopravvalutate",
		"sopravvedute",
		"sopravvinte",
		"sopravviste",
		"sopreccitate",
		"sopredificate",
		"soprelevate",
		"soprintese",
		"sorbettate",
		"sorbite",
		"sorgiunte",
		"sormontate",
		"sorpassate",
		"sorprese",
		"sorrase",
		"sorrette",
		"sorseggiate",
		"sorteggiate",
		"sortite",
		"sorvegliate",
		"sorvolate",
		"soscritte",
		"sospese",
		"sospettate",
		"sospinte",
		"sospirate",
		"sostantivate",
		"sostanziate",
		"sostentate",
		"sostenute",
		"sostituite",
		"sottaciute",
		"sotterrate",
		"sottese",
		"sottintese",
		"sottoalimentate",
		"sottocapitalizzate",
		"sottodivise",
		"sottoesposte",
		"sottofirmate",
		"sottolineate",
		"sottomesse",
		"sottomurate",
		"sottopagate",
		"sottopassate",
		"sottoposte",
		"sottorappresentate",
		"sottorise",
		"sottoscritte",
		"sottostimate",
		"sottosviluppate",
		"sottotitolate",
		"sottovalutate",
		"sottratte",
		"soverchiate",
		"sovesciate",
		"sovietizzate",
		"sovracapitalizzate",
		"sovraccaricate",
		"sovradimensionate",
		"sovraeccitate",
		"sovraesposte",
		"sovraffaticate",
		"sovraffollate",
		"sovraggiunte",
		"sovraimposte",
		"sovraintese",
		"sovralimentate",
		"sovramodulate",
		"sovrappopolate",
		"sovrapposte",
		"sovrariscaldate",
		"sovrasaturate",
		"sovrascritte",
		"sovrastampate",
		"sovrastate",
		"sovrastimate",
		"sovrautilizzate",
		"sovreccitate",
		"sovresposte",
		"sovrimposte",
		"sovrintese",
		"sovvenute",
		"sovvenzionate",
		"sovvertite",
		"spaccate",
		"spacchettate",
		"spacciate",
		"spaginate",
		"spaiate",
		"spalancate",
		"spalate",
		"spalcate",
		"spalleggiate",
		"spalmate",
		"spammate",
		"spampanate",
		"spampinate",
		"spanate",
		"spanciate",
		"spandute",
		"spannate",
		"spannocchiate",
		"spanse",
		"spantanate",
		"spante",
		"spaparacchiate",
		"spaparanzate",
		"spappolate",
		"sparate",
		"sparecchiate",
		"sparigliate",
		"sparite",
		"sparlate",
		"sparpagliate",
		"spartite",
		"spassate",
		"spassatosele",
		"spastoiate",
		"spaurate",
		"spaurite",
		"spaventate",
		"spazializzate",
		"spaziate",
		"spazieggiate",
		"spazientite",
		"spazzate",
		"spazzolate",
		"specchiate",
		"specializzate",
		"specificate",
		"specillate",
		"specolate",
		"spedite",
		"spegnate",
		"spelacchiate",
		"spelate",
		"spellate",
		"spennacchiate",
		"spennate",
		"spennellate",
		"spente",
		"spenzolate",
		"sperate",
		"sperimentate",
		"spernacchiate",
		"speronate",
		"sperperate",
		"spersonalizzate",
		"sperticate",
		"spesate",
		"spese",
		"spessite",
		"spettacolarizzate",
		"spettinate",
		"spezzate",
		"spezzettate",
		"spezziate",
		"spezzonate",
		"spiaccicate",
		"spianate",
		"spiantate",
		"spiate",
		"spiattellate",
		"spiazzate",
		"spiccate",
		"spicciate",
		"spiccicate",
		"spicciolate",
		"spicconate",
		"spidocchiate",
		"spiegate",
		"spiegazzate",
		"spietrate",
		"spifferate",
		"spigionate",
		"spignorate",
		"spigolate",
		"spigrite",
		"spillate",
		"spilluzzicate",
		"spiluccate",
		"spinte",
		"spintonate",
		"spiombate",
		"spiralizzate",
		"spirantizzate",
		"spirate",
		"spiritualizzate",
		"spiumate",
		"spizzicate",
		"spodestate",
		"spoetizzate",
		"spogliate",
		"spolettate",
		"spoliate",
		"spoliticizzate",
		"spollonate",
		"spolmonate",
		"spolpate",
		"spoltronite",
		"spolverate",
		"spolverizzate",
		"spompate",
		"spompinate",
		"sponsorizzate",
		"spopolate",
		"spoppate",
		"sporcate",
		"sportate",
		"sporte",
		"sposate",
		"spossedute",
		"spossessate",
		"spostate",
		"sposte",
		"sprangate",
		"sprecate",
		"spregiate",
		"spremute",
		"spretate",
		"sprezzate",
		"sprigionate",
		"sprimacciate",
		"spromesse",
		"spronate",
		"sprotette",
		"sprovincializzate",
		"sprovvedute",
		"sprovviste",
		"spruzzate",
		"spugnate",
		"spulate",
		"spulciate",
		"spuntate",
		"spuntellate",
		"spupazzate",
		"spurgate",
		"sputacchiate",
		"sputate",
		"sputtanate",
		"squadernate",
		"squadrate",
		"squagliate",
		"squagliatasele",
		"squagliate",
		"squalificate",
		"squamate",
		"squarciate",
		"squartate",
		"squassate",
		"squattrinate",
		"squilibrate",
		"squinternate",
		"sradicate",
		"srotolate",
		"srugginite",
		"stabbiate",
		"stabilite",
		"stabilizzate",
		"stabulate",
		"staccate",
		"stacciate",
		"staffate",
		"staffilate",
		"staggiate",
		"staggite",
		"stagionate",
		"stagliate",
		"stagnate",
		"stamburate",
		"stampate",
		"stampigliate",
		"stanate",
		"stancate",
		"standardizzate",
		"stangate",
		"stanziate",
		"stappate",
		"starate",
		"starnazzate",
		"stasate",
		"statalizzate",
		"statizzate",
		"statoce",
		"statosene",
		"statuite",
		"stazzate",
		"stazzonate",
		"steccacciate",
		"steccate",
		"stecchite",
		"stecconate",
		"stemperate",
		"stempiate",
		"stenografate",
		"stereotipate",
		"sterilite",
		"sterilizzate",
		"sterpate",
		"sterrate",
		"sterzate",
		"stese",
		"stigliate",
		"stigmatizzate",
		"stilate",
		"stilettate",
		"stilizzate",
		"stillate",
		"stimate",
		"stimolate",
		"stinte",
		"stipate",
		"stipendiate",
		"stipulate",
		"stiracchiate",
		"stirate",
		"stivate",
		"stizzite",
		"stoccate",
		"stolte",
		"stomacate",
		"stonate",
		"stondate",
		"stoppate",
		"stordite",
		"storicizzate",
		"stornate",
		"storpiate",
		"stortate",
		"storte",
		"stozzate",
		"strabenedette",
		"strabuzzate",
		"stracannate",
		"straccate",
		"stracciate",
		"stracotte",
		"strafogate",
		"stragodute",
		"stralciate",
		"stralodate",
		"stralunate",
		"stramaledette",
		"stramortite",
		"strangolate",
		"straniate",
		"stranite",
		"straorzate",
		"strapagate",
		"strapazzate",
		"straperdute",
		"straperse",
		"strappate",
		"strasapute",
		"strascicate",
		"strascinate",
		"strasformate",
		"stratificate",
		"strattonate",
		"stravaccate",
		"stravinte",
		"stravolte",
		"stravolute",
		"straziate",
		"stregate",
		"stremate",
		"stressate",
		"striate",
		"stridulate",
		"strigate",
		"strigliate",
		"strillate",
		"striminzite",
		"strimpellate",
		"strinate",
		"stringate",
		"strisciate",
		"stritolate",
		"strizzate",
		"strofinate",
		"strombate",
		"strombazzate",
		"stroncate",
		"stronzate",
		"stropicciate",
		"stroppate",
		"stroppiate",
		"strozzate",
		"struccate",
		"strumentalizzate",
		"strumentate",
		"strusciate",
		"strutte",
		"strutturalizzate",
		"strutturate",
		"stuccate",
		"studiacchiate",
		"studiate",
		"stuellate",
		"stufate",
		"stupefatte",
		"stupite",
		"stuprate",
		"sturate",
		"stutate",
		"stuzzicate",
		"suase",
		"subaffittate",
		"subappaltate",
		"subbiate",
		"subdelegate",
		"subissate",
		"subite",
		"sublicenziate",
		"sublimate",
		"sublocate",
		"subodorate",
		"subordinate",
		"subornate",
		"suburbanizzate",
		"sucate",
		"succhiate",
		"succhiellate",
		"succiate",
		"succinte",
		"succise",
		"suddistinte",
		"suddivise",
		"suffissate",
		"suffisse",
		"suffragate",
		"suffumicate",
		"suffuse",
		"suggellate",
		"suggerite",
		"suggestionate",
		"suicidate",
		"sunteggiate",
		"sunte",
		"suolate",
		"suonate",
		"superate",
		"superpagate",
		"superraffreddate",
		"supervalutate",
		"supervisionate",
		"supplicate",
		"supplite",
		"supportate",
		"supposte",
		"suppurate",
		"surclassate",
		"surfate",
		"surgelate",
		"surraffreddate",
		"surriscaldate",
		"surrogate",
		"survoltate",
		"suscitate",
		"susseguite",
		"sussidiate",
		"sussunte",
		"sussurrate",
		"suturate",
		"svaccate",
		"svagate",
		"svaligiate",
		"svalutate",
		"svapate",
		"svariate",
		"svasate",
		"svecchiate",
		"svegliate",
		"svelate",
		"svelenite",
		"sveltite",
		"svelte",
		"svenate",
		"svendute",
		"sventagliate",
		"sventate",
		"sventolate",
		"sventrate",
		"sverginate",
		"svergognate",
		"svergolate",
		"sverminate",
		"sverniciate",
		"svestite",
		"svettate",
		"svezzate",
		"sviate",
		"svignatosele",
		"svigorite",
		"svilite",
		"svillaneggiate",
		"sviluppate",
		"svinate",
		"svincolate",
		"sviolinate",
		"svirgolate",
		"svirilizzate",
		"svisate",
		"sviscerate",
		"svitate",
		"sviticchiate",
		"svolate",
		"svolazzate",
		"svolte",
		"svolute",
		"svuotate",
		"tabuizzate",
		"tabulate",
		"taccate",
		"taccheggiate",
		"tacciate",
		"tacitate",
		"taciute",
		"tagliate",
		"taglieggiate",
		"tagliuzzate",
		"talebanizzate",
		"tallonate",
		"tampinate",
		"tamponate",
		"tangute",
		"tannate",
		"tappate",
		"tappezzate",
		"tarate",
		"tardate",
		"targate",
		"tariffate",
		"tarlate",
		"tarmate",
		"taroccate",
		"tarpate",
		"tartagliate",
		"tartassate",
		"tartufate",
		"tassate",
		"tassellate",
		"tastate",
		"tasteggiate",
		"tatuate",
		"tecnicizzate",
		"tecnologizzate",
		"tedeschizzate",
		"tediate",
		"teflonate",
		"telecomandate",
		"telecontrollate",
		"telediffuse",
		"telefonate",
		"telegrafate",
		"teleguidate",
		"telematizzate",
		"telemetrate",
		"teleradiotrasmesse",
		"teletrasmesse",
		"teletrasportate",
		"tematizzate",
		"temperate",
		"tempestate",
		"tempificate",
		"templatizzate",
		"temporizzate",
		"temprate",
		"temute",
		"tentate",
		"tenute",
		"teologizzate",
		"teorizzate",
		"tepefatte",
		"terebrate",
		"terminate",
		"termostatate",
		"terrazzate",
		"terrificate",
		"terrorizzate",
		"terse",
		"terzarolate",
		"terziarizzate",
		"terziate",
		"tesate",
		"tesaurizzate",
		"tese",
		"tesserate",
		"testate",
		"testificate",
		"testimoniate",
		"timbrate",
		"tindalizzate",
		"tinteggiate",
		"tinte",
		"tipicizzate",
		"tipizzate",
		"tippate",
		"tiranneggiate",
		"tirate",
		"titillate",
		"titolate",
		"toccate",
		"toelettate",
		"tollerate",
		"tolte",
		"tonalizzate",
		"tonificate",
		"tonneggiate",
		"tonsurate",
		"torchiate",
		"tormentate",
		"tornatosene",
		"tornite",
		"torrefatte",
		"torte",
		"tortoreggiate",
		"torturate",
		"tosate",
		"toscaneggiate",
		"toscanizzate",
		"tostate",
		"totalizzate",
		"traboccate",
		"trabuccate",
		"tracannate",
		"tracciate",
		"tradite",
		"tradotte",
		"trafficate",
		"trafilate",
		"trafitte",
		"traforate",
		"trafugate",
		"traghettate",
		"traguardate",
		"trainate",
		"tralasciate",
		"tralignate",
		"tramandate",
		"tramate",
		"trambasciate",
		"tramesse",
		"tramestate",
		"tramezzate",
		"tramortite",
		"tramutate",
		"tranciate",
		"trangugiate",
		"tranquillate",
		"tranquillizzate",
		"transatte",
		"transcese",
		"transcodificate",
		"transcorse",
		"transcritte",
		"transennate",
		"transfluite",
		"transfuse",
		"transistorizzate",
		"translitterate",
		"transposte",
		"transricevute",
		"transustanziate",
		"transvedute",
		"transviste",
		"trapanate",
		"trapassate",
		"trapiantate",
		"traportate",
		"traposte",
		"trapposte",
		"trapuntate",
		"trapunte",
		"trarotte",
		"trasandate",
		"trasbordate",
		"trascelte",
		"trascese",
		"trascinate",
		"trascorse",
		"trascritte",
		"trascurate",
		"trasdotte",
		"trasferite",
		"trasfigurate",
		"trasformate",
		"trasfuse",
		"trasgredite",
		"traslate",
		"traslitterate",
		"traslocate",
		"trasmesse",
		"trasmutate",
		"trasparite",
		"traspirate",
		"trasportate",
		"trasposte",
		"trastullate",
		"trasudate",
		"trasvolate",
		"trasvolte",
		"trattate",
		"tratteggiate",
		"trattenute",
		"tratte",
		"traumatizzate",
		"travagliate",
		"travalicate",
		"travasate",
		"travedute",
		"traversate",
		"travestite",
		"traviate",
		"travisate",
		"traviste",
		"travolte",
		"trebbiate",
		"triangolate",
		"tribbiate",
		"tribolate",
		"tributate",
		"triennalizzate",
		"trimestralizzate",
		"trincate",
		"trincerate",
		"trinciate",
		"tripartite",
		"triplicate",
		"trisecate",
		"trisezionate",
		"tritate",
		"triturate",
		"trivellate",
		"trollate",
		"trombate",
		"troncate",
		"tropicalizzate",
		"trovate",
		"truccate",
		"trucidate",
		"truffate",
		"tuffate",
		"tumefatte",
		"tumulate",
		"turate",
		"turbate",
		"turlupinate",
		"tutelate",
		"ubbligate",
		"ubicate",
		"ubidite",
		"ubiquitinate",
		"ubriacate",
		"uccellate",
		"uccellinate",
		"uccise",
		"udite",
		"ufficializzate",
		"uggite",
		"ugnate",
		"uguagliate",
		"ulcerate",
		"ulite",
		"ulolate",
		"ultimate",
		"ultracentrifugate",
		"ululate",
		"umanate",
		"umanizzate",
		"umettate",
		"umidificate",
		"umidite",
		"umiliate",
		"uncinate",
		"unguentate",
		"unificate",
		"uniformate",
		"unite",
		"univerbate",
		"universaleggiate",
		"universalizzate",
		"untate",
		"unte",
		"uperizzate",
		"urbanizzate",
		"urgenzate",
		"urlate",
		"urtacchiate",
		"urtate",
		"urticchiate",
		"usate",
		"usciolate",
		"usolate",
		"ustionate",
		"usucapite",
		"usurate",
		"usurpate",
		"utilitate",
		"utilizzate",
		"vaccinate",
		"vagabondeggiate",
		"vagellate",
		"vagheggiate",
		"vagillate",
		"vagliate",
		"valcate",
		"valicate",
		"validate",
		"valorizzate",
		"valse",
		"valutate",
		"vanagloriate",
		"vanate",
		"vandalizzate",
		"vangate",
		"vangelizzate",
		"vanificate",
		"vanite",
		"vantaggiate",
		"vantate",
		"vaporate",
		"vaporizzate",
		"varate",
		"varcate",
		"variate",
		"vasectomizzate",
		"vaticinate",
		"vedovate",
		"vedute",
		"vegetate",
		"veggiate",
		"vegliate",
		"veicolate",
		"velarizzate",
		"velate",
		"velettate",
		"velinate",
		"vellicate",
		"vellutate",
		"velocizzate",
		"vendemmiate",
		"vendicate",
		"vendicchiate",
		"venducchiate",
		"vendute",
		"venerate",
		"vengiate",
		"ventagliate",
		"ventilate",
		"ventolate",
		"verbalizzate",
		"vergate",
		"vergheggiate",
		"vergognate",
		"vergolate",
		"verificate",
		"verminate",
		"vernalizzate",
		"verniciate",
		"verrinate",
		"versate",
		"verseggiate",
		"versificate",
		"verticalizzate",
		"vessate",
		"vestite",
		"vestite",
		"vetrificate",
		"vetrinate",
		"vetrioleggiate",
		"vettovagliate",
		"vezzeggiate",
		"viaggiate",
		"vicinate",
		"vicitate",
		"videochattate",
		"videochiamate",
		"videocomunicate",
		"videoregistrate",
		"videotrasmesse",
		"vidimate",
		"vigilate",
		"vigliate",
		"vigoreggiate",
		"vigorite",
		"vilificate",
		"vilipese",
		"villaneggiate",
		"vincolate",
		"vinte",
		"violate",
		"violentate",
		"violinate",
		"virgolate",
		"virgoleggiate",
		"virgolettate",
		"virilizzate",
		"virtualizzate",
		"visionate",
		"visitate",
		"vissute",
		"vistate",
		"viste",
		"visualizzate",
		"vitaliziate",
		"vitalizzate",
		"vitaminizzate",
		"vittimizzate",
		"vituperate",
		"vivacizzate",
		"vivandate",
		"vivificate",
		"vivisezionate",
		"viziate",
		"vocabolarizzate",
		"vocalizzate",
		"vocate",
		"vociferate",
		"volantinate",
		"volatilizzate",
		"volgarizzate",
		"volicchiate",
		"volpeggiate",
		"voltate",
		"volte",
		"voltolate",
		"volturate",
		"voluminizzate",
		"volute",
		"volutoce",
		"vomitate",
		"vorate",
		"votate",
		"vulcanizzate",
		"vuotate",
		"wappate",
		"wikificate",
		"xerocopiate",
		"zaffate",
		"zampate",
		"zampettate",
		"zampillate",
		"zannate",
		"zappate",
		"zappettate",
		"zapponate",
		"zavorrate",
		"zeppate",
		"zigrinate",
		"zigzagate",
		"zimbellate",
		"zincate",
		"zinnate",
		"zipolate",
		"zippate",
		"zirlate",
		"zittite",
		"zizzagate",
		"zoccolate",
		"zollate",
		"zombate",
		"zonate",
		"zonizzate",
		"zoppate",
		"zoppeggiate",
		"zoppicate",
		"zucconate",
		"zufolate",
		"zumate",
		"zuppate",
		"abalienati",
		"abbacchiati",
		"abbacinati",
		"abbadati",
		"abbagliati",
		"abbaiati",
		"abballati",
		"abbambinati",
		"abbancati",
		"abbandonati",
		"abbarbagliati",
		"abbarbati",
		"abbarcati",
		"abbaruffati",
		"abbassati",
		"abbatacchiati",
		"abbattuti",
		"abbatuffolati",
		"abbeliti",
		"abbellati",
		"abbelliti",
		"abbendati",
		"abbeverati",
		"abbiadati",
		"abbicati",
		"abbigliati",
		"abbinati",
		"abbindolati",
		"abbioccati",
		"abbiosciati",
		"abbisciati",
		"abbittati",
		"abboccati",
		"abboffati",
		"abbominati",
		"abbonacciati",
		"abbonati",
		"abboniti",
		"abbordati",
		"abborracciati",
		"abborrati",
		"abborriti",
		"abbottinati",
		"abbottonati",
		"abbozzacchiati",
		"abbozzati",
		"abbozzolati",
		"abbracciati",
		"abbraciati",
		"abbrancati",
		"abbreviati",
		"abbriccati",
		"abbrigliati",
		"abbrivati",
		"abbriviati",
		"abbrividiti",
		"abbronzati",
		"abbrostolati",
		"abbrostoliti",
		"abbruciacchiati",
		"abbruciati",
		"abbrunati",
		"abbruniti",
		"abbruscati",
		"abbrusciati",
		"abbrustiati",
		"abbrustolati",
		"abbrustoliti",
		"abbrutiti",
		"abbruttiti",
		"abbuffati",
		"abbuiati",
		"abbuonati",
		"abburattati",
		"abbuzziti",
		"abdicati",
		"abdotti",
		"abiettati",
		"abilitati",
		"abissati",
		"abitati",
		"abituati",
		"abiurati",
		"aboliti",
		"abominati",
		"abondati",
		"aborriti",
		"abrasi",
		"abrogati",
		"abusati",
		"accaffati",
		"accagionati",
		"accagliati",
		"accalappiati",
		"accalcati",
		"accaldati",
		"accallati",
		"accalorati",
		"accaloriti",
		"accambiati",
		"accampati",
		"accampionati",
		"accanalati",
		"accanati",
		"accaneggiati",
		"accaniti",
		"accantonati",
		"accaparrati",
		"accapezzati",
		"accapigliati",
		"accapottati",
		"accappiati",
		"accappiettati",
		"accapponati",
		"accappucciati",
		"accaprettati",
		"accareggiati",
		"accarezzati",
		"accarnati",
		"accarpionati",
		"accartocciati",
		"accasati",
		"accasciati",
		"accasellati",
		"accasermati",
		"accastellati",
		"accastellinati",
		"accatarrati",
		"accatastati",
		"accattati",
		"accattivati",
		"accavalcati",
		"accavalciati",
		"accavallati",
		"accavezzati",
		"accecati",
		"acceffati",
		"accelerati",
		"accellerati",
		"accennati",
		"accensati",
		"accentati",
		"accentrati",
		"accentuati",
		"acceppati",
		"accerchiati",
		"accercinati",
		"accertati",
		"accesi",
		"accessoriati",
		"accettati",
		"acchetati",
		"acchiappati",
		"acchiocciolati",
		"acchitati",
		"acchiuduti",
		"acciabattati",
		"acciaiati",
		"acciambellati",
		"acciarpati",
		"acciecati",
		"accigliati",
		"acciglionati",
		"accignuti",
		"accincignati",
		"accinti",
		"acciocchiti",
		"acciottolati",
		"accipigliati",
		"accismati",
		"accisi",
		"acciucchiti",
		"acciuffati",
		"accivettati",
		"acclamati",
		"acclarati",
		"acclimatati",
		"acclusi",
		"accoccati",
		"accoccolati",
		"accoccovati",
		"accodati",
		"accollati",
		"accoltellati",
		"accolti",
		"accomandati",
		"accomiatati",
		"accommiatati",
		"accomodati",
		"accompagnati",
		"accomunati",
		"acconciati",
		"acconigliati",
		"accontati",
		"accontentati",
		"accoppati",
		"accoppiati",
		"accorati",
		"accorciati",
		"accorciti",
		"accordati",
		"accordellati",
		"accorpati",
		"accorti",
		"accosciati",
		"accostati",
		"accostumati",
		"accotonati",
		"accottimati",
		"accovacciati",
		"accovati",
		"accovonati",
		"accozzati",
		"accreditati",
		"accresciuti",
		"accrespati",
		"accucciati",
		"accucciolati",
		"accuditi",
		"acculati",
		"acculturati",
		"accumulati",
		"accumunati",
		"accusati",
		"acetificati",
		"acetilati",
		"acetiti",
		"acidati",
		"acidificati",
		"acidulati",
		"acquadernati",
		"acquarellati",
		"acquartierati",
		"acquati",
		"acquattati",
		"acquerellati",
		"acquetati",
		"acquietati",
		"acquisiti",
		"acquistati",
		"acromatizzati",
		"acuiti",
		"acuminati",
		"acutizzati",
		"adacquati",
		"adagiati",
		"adattati",
		"addaziati",
		"addebbiati",
		"addebitati",
		"addecimati",
		"addensati",
		"addentati",
		"addentellati",
		"addentrati",
		"addestrati",
		"addetti",
		"addiacciati",
		"addimandati",
		"addimesticati",
		"addimorati",
		"addimostrati",
		"addipanati",
		"addirizzati",
		"additati",
		"additivati",
		"addizionati",
		"addobbati",
		"addociliti",
		"addogliati",
		"addolcati",
		"addolciati",
		"addolciti",
		"addolorati",
		"addomandati",
		"addomesticati",
		"addoppiati",
		"addormentati",
		"addossati",
		"addotti",
		"addottorati",
		"addottrinati",
		"addrizzati",
		"adduati",
		"addugliati",
		"adeguati",
		"adempiti",
		"adempiuti",
		"adequati",
		"aderizzati",
		"adescati",
		"adibiti",
		"adirati",
		"aditi",
		"adiuvati",
		"adizzati",
		"adocchiati",
		"adombrati",
		"adonati",
		"adonestati",
		"adontati",
		"adoperati",
		"adoprati",
		"adorati",
		"adornati",
		"adottati",
		"adsorbiti",
		"aduggiati",
		"adugnati",
		"adulati",
		"adulterati",
		"adunati",
		"adunghiati",
		"adusati",
		"aerati",
		"aereati",
		"aerotrainati",
		"aerotrasportati",
		"affabulati",
		"affaccendati",
		"affacchinati",
		"affacciati",
		"affagottati",
		"affaldati",
		"affamati",
		"affamigliati",
		"affannati",
		"affardellati",
		"affascinati",
		"affastellati",
		"affaticati",
		"affattucchiati",
		"affatturati",
		"affermati",
		"afferrati",
		"affettati",
		"affezionati",
		"affiancati",
		"affiatati",
		"affibbiati",
		"affidati",
		"affienati",
		"affievoliti",
		"affigliati",
		"affigurati",
		"affilati",
		"affilettati",
		"affiliati",
		"affinati",
		"affiochiti",
		"affiorati",
		"affisati",
		"affissati",
		"affissi",
		"affittati",
		"affittiti",
		"afflitti",
		"afflosciati",
		"affocati",
		"affogati",
		"affogliati",
		"affollati",
		"affoltati",
		"affondati",
		"afforcati",
		"afforestati",
		"afforzati",
		"affossati",
		"affraliti",
		"affrancati",
		"affranti",
		"affratellati",
		"affrenati",
		"affrenellati",
		"affrescati",
		"affrettati",
		"affrittellati",
		"affrontati",
		"affumati",
		"affumicati",
		"affumigati",
		"affuocati",
		"affusolati",
		"africanizzati",
		"ageminati",
		"agevolati",
		"aggallati",
		"agganciati",
		"aggangherati",
		"aggarbati",
		"aggattonati",
		"aggavignati",
		"aggelati",
		"aggettivati",
		"agghiacciati",
		"agghiadati",
		"agghiaiati",
		"agghindati",
		"aggiaccati",
		"aggiogati",
		"aggiornati",
		"aggirati",
		"aggiucchiti",
		"aggiudicati",
		"aggiuntati",
		"aggiunti",
		"aggiustati",
		"agglomerati",
		"agglutinati",
		"aggomitolati",
		"aggottati",
		"aggraditi",
		"aggraffati",
		"aggranchiati",
		"aggranchiti",
		"aggranditi",
		"aggrappati",
		"aggraticciati",
		"aggravati",
		"aggrediti",
		"aggregati",
		"aggrevati",
		"aggricciati",
		"aggrinzati",
		"aggrinziti",
		"aggrommati",
		"aggrondati",
		"aggroppati",
		"aggrottati",
		"aggrovigliati",
		"aggrumati",
		"aggruppati",
		"aggruzzolati",
		"agguagliati",
		"agguantati",
		"agguardati",
		"agguatati",
		"aggueffati",
		"agitati",
		"agognati",
		"agrarizzati",
		"aguatati",
		"agucchiati",
		"agunati",
		"agurati",
		"aguzzati",
		"aitati",
		"aiutati",
		"aizzati",
		"alati",
		"alberati",
		"albergati",
		"alcalinizzati",
		"alchilati",
		"alchimiati",
		"alchimizzati",
		"alcolizzati",
		"alcoolizzati",
		"alenati",
		"alesati",
		"alettati",
		"alfabetati",
		"alfabetizzati",
		"aliditi",
		"alienati",
		"alimentati",
		"allacciati",
		"allagati",
		"allappati",
		"allargati",
		"allascati",
		"allattati",
		"alleati",
		"allegati",
		"alleggeriti",
		"alleggiati",
		"allegorizzati",
		"alleluiati",
		"allenati",
		"alleniti",
		"allentati",
		"allertati",
		"allessati",
		"allestiti",
		"allettati",
		"allevati",
		"alleviati",
		"allibati",
		"allibiti",
		"allibrati",
		"allicciati",
		"allietati",
		"allindati",
		"allineati",
		"allisi",
		"allocati",
		"allogati",
		"alloggiati",
		"allontanati",
		"allottati",
		"allucchettati",
		"allucciolati",
		"allucinati",
		"allumati",
		"alluminati",
		"alluminiati",
		"allungati",
		"allupati",
		"allusi",
		"alluzzati",
		"alogenati",
		"alonati",
		"alpeggiati",
		"alterati",
		"alternati",
		"alzati",
		"amalgamati",
		"amareggiati",
		"amaricati",
		"amati",
		"ambientati",
		"ambiguati",
		"ambiti",
		"americanizzati",
		"amicati",
		"ammaccati",
		"ammaestrati",
		"ammainati",
		"ammalati",
		"ammaliati",
		"ammalinconiti",
		"ammaltati",
		"ammanettati",
		"ammanicati",
		"ammanierati",
		"ammanigliati",
		"ammannati",
		"ammannellati",
		"ammanniti",
		"ammansati",
		"ammansiti",
		"ammantati",
		"ammantellati",
		"ammarati",
		"ammarezzati",
		"ammassati",
		"ammassellati",
		"ammassicciati",
		"ammatassati",
		"ammattonati",
		"ammazzati",
		"ammelmati",
		"ammenciti",
		"ammendati",
		"ammennicolati",
		"ammessi",
		"ammetati",
		"ammezziti",
		"amministrati",
		"amminutati",
		"ammirati",
		"ammiseriti",
		"ammobiliati",
		"ammodernati",
		"ammodernizzati",
		"ammogliati",
		"ammoinati",
		"ammollati",
		"ammolliti",
		"ammoniti",
		"ammonticchiati",
		"ammonticellati",
		"ammorbati",
		"ammorbidati",
		"ammorbiditi",
		"ammorsati",
		"ammortati",
		"ammortiti",
		"ammortizzati",
		"ammorzati",
		"ammosciati",
		"ammosciti",
		"ammostati",
		"ammotinati",
		"ammucchiati",
		"ammulinati",
		"ammusati",
		"ammutati",
		"ammutinati",
		"amnistiati",
		"amoracciati",
		"ampiati",
		"ampliati",
		"amplificati",
		"amputati",
		"anagrammati",
		"analizzati",
		"anamorfizzati",
		"anastomizzati",
		"anatematizzati",
		"anatomizzati",
		"anchilosati",
		"ancisi",
		"ancorati",
		"andatoseni",
		"andicappati",
		"anellati",
		"anemizzati",
		"anestetizzati",
		"angariati",
		"anglicizzati",
		"angolati",
		"angosciati",
		"angustiati",
		"animati",
		"annacquati",
		"annaffiati",
		"annasati",
		"annaspati",
		"annaspicati",
		"annebbiati",
		"annegati",
		"annerati",
		"anneriti",
		"annessi",
		"annestati",
		"annichilati",
		"annichiliti",
		"annidati",
		"annientati",
		"annitriti",
		"annobiliti",
		"annodati",
		"annodicchiati",
		"annoiati",
		"annotati",
		"annottati",
		"annottolati",
		"annoverati",
		"annullati",
		"annunciati",
		"annunziati",
		"annusati",
		"annuvolati",
		"anodizzati",
		"anonimizzati",
		"anteceduti",
		"anteposti",
		"antergati",
		"anticheggiati",
		"antichizzati",
		"anticipati",
		"anticonosciuti",
		"antidatati",
		"antiveduti",
		"antivisti",
		"antologizzati",
		"antropizzati",
		"antropomorfizzati",
		"aocchiati",
		"aombrati",
		"aonestati",
		"aontati",
		"aperti",
		"apocopati",
		"apologizzati",
		"apostrofati",
		"appaciati",
		"appacificati",
		"appagati",
		"appaiati",
		"appalesati",
		"appallottolati",
		"appaltati",
		"appanettati",
		"appannati",
		"apparati",
		"apparecchiati",
		"apparentati",
		"apparigliati",
		"appariti",
		"appartati",
		"appassionati",
		"appastati",
		"appastellati",
		"appellati",
		"appennellati",
		"appercepiti",
		"appertizzati",
		"appesantiti",
		"appesiti",
		"appesi",
		"appestati",
		"appetiti",
		"appezzati",
		"appiacevoliti",
		"appianati",
		"appiastrati",
		"appiatati",
		"appiattati",
		"appiattiti",
		"appiccati",
		"appiccicati",
		"appiccoliti",
		"appiedati",
		"appigionati",
		"appigliati",
		"appinzati",
		"appiombati",
		"appioppati",
		"appisolati",
		"applauditi",
		"applicati",
		"appoderati",
		"appoggiati",
		"appollaiati",
		"appoppati",
		"apportati",
		"appostati",
		"apposti",
		"appratiti",
		"appresentati",
		"appresi",
		"appressati",
		"apprestati",
		"apprettati",
		"apprezzati",
		"approcciati",
		"approfittati",
		"approfondati",
		"approfonditi",
		"approntati",
		"appropinquati",
		"appropriati",
		"approssimati",
		"approvati",
		"approvisionati",
		"approvvigionati",
		"appruati",
		"appulcrati",
		"appuntati",
		"appuntellati",
		"appuntiti",
		"appurati",
		"appuzzati",
		"arabescati",
		"arabizzati",
		"arati",
		"arbitrati",
		"arborati",
		"arcaizzati",
		"arcati",
		"architettati",
		"archiviati",
		"arcuati",
		"arditi",
		"areati",
		"argentati",
		"arginati",
		"argomentati",
		"arguiti",
		"arianizzati",
		"arieggiati",
		"armati",
		"armonizzati",
		"aromatizzati",
		"arpeggiati",
		"arpionati",
		"arponati",
		"arrabattati",
		"arraffati",
		"arraffiati",
		"arrandellati",
		"arrangiati",
		"arrapati",
		"arrapinati",
		"arrappati",
		"arrazzati",
		"arrecati",
		"arredati",
		"arreggimentati",
		"arrembati",
		"arrenati",
		"arresisi",
		"arresi",
		"arrestati",
		"arretrati",
		"arricchiti",
		"arricciati",
		"arricciolati",
		"arriffati",
		"arringati",
		"arrischiati",
		"arrisicati",
		"arrisi",
		"arrocati",
		"arroccati",
		"arrochiti",
		"arrogati",
		"arrolati",
		"arroncati",
		"arronzati",
		"arrosati",
		"arrossati",
		"arrostati",
		"arrostiti",
		"arrotati",
		"arrotolati",
		"arrotondati",
		"arrovellati",
		"arroventati",
		"arroventiti",
		"arrovesciati",
		"arrubinati",
		"arruffati",
		"arruffianati",
		"arrugginiti",
		"arruncigliati",
		"arruolati",
		"arruviditi",
		"arsicciati",
		"arsi",
		"artefatti",
		"articolati",
		"artigliati",
		"ascesi",
		"asciati",
		"asciolvuti",
		"asciugati",
		"ascoltati",
		"ascosi",
		"ascosti",
		"ascritti",
		"asfaltati",
		"asfissiati",
		"aspersi",
		"aspettati",
		"aspirati",
		"asportati",
		"aspreggiati",
		"assaettati",
		"assaggiati",
		"assaliti",
		"assaltati",
		"assaporati",
		"assaporiti",
		"assassinati",
		"assecondati",
		"assecurati",
		"assediati",
		"asseggiati",
		"assegnati",
		"assembiati",
		"assemblati",
		"assembrati",
		"assemprati",
		"assentati",
		"asseriti",
		"asserragliati",
		"asserviti",
		"assestati",
		"assetati",
		"assettati",
		"asseverati",
		"assibilati",
		"assicurati",
		"assiderati",
		"assiemati",
		"assiepati",
		"assillati",
		"assimigliati",
		"assimilati",
		"assiomatizzati",
		"assisi",
		"assistiti",
		"associati",
		"assodati",
		"assoggettati",
		"assolcati",
		"assoldati",
		"assolti",
		"assolutizzati",
		"assomati",
		"assommati",
		"assonati",
		"assonnati",
		"assopiti",
		"assorbiti",
		"assordati",
		"assorditi",
		"assortiti",
		"assottigliati",
		"assuefatti",
		"assunti",
		"asteggiati",
		"astenuti",
		"astersi",
		"astratti",
		"astretti",
		"atomizzati",
		"atrofizzati",
		"atrovati",
		"attaccati",
		"attagliati",
		"attanagliati",
		"attardati",
		"attediati",
		"atteggiati",
		"attempati",
		"attendati",
		"attentati",
		"attenuati",
		"attenuti",
		"attergati",
		"atterrati",
		"atterriti",
		"atterzati",
		"attesi",
		"attestati",
		"atticizzati",
		"attillati",
		"attinti",
		"attirati",
		"attivati",
		"attivizzati",
		"attizzati",
		"attorcigliati",
		"attorniati",
		"attorti",
		"attoscati",
		"attossicati",
		"attraccati",
		"attrappiti",
		"attratti",
		"attraversati",
		"attrezzati",
		"attribuiti",
		"attristati",
		"attristiti",
		"attruppati",
		"attualizzati",
		"attuati",
		"attuffati",
		"attutati",
		"attutiti",
		"auggiati",
		"augumentati",
		"augurati",
		"auliti",
		"aumentati",
		"aunghiati",
		"ausati",
		"auscultati",
		"auspicati",
		"autenticati",
		"autentificati",
		"autoaccusati",
		"autoaffondati",
		"autoalimentati",
		"autoassolti",
		"autocandidati",
		"autocensurati",
		"autocitati",
		"autocommiserati",
		"autoconsumati",
		"autoconvinti",
		"autodefiniti",
		"autodenunciati",
		"autodistrutti",
		"autofinanziati",
		"autogestiti",
		"autogovernati",
		"autografati",
		"autoincensati",
		"autointersecati",
		"autoinvitati",
		"autolesionati",
		"autolimitati",
		"automaticizzati",
		"automatizzati",
		"automotivati",
		"autonominati",
		"autoproclamati",
		"autoprodotti",
		"autoprotetti",
		"autopubblicati",
		"autopubblicizzati",
		"autoregolamentati",
		"autoregolati",
		"autoridotti",
		"autoriparati",
		"autorizzati",
		"autosomministrati",
		"autosostenuti",
		"autosuggestionati",
		"autotassati",
		"autotrapiantati",
		"autotrasportati",
		"autovalutati",
		"avallati",
		"avampati",
		"avanzati",
		"avariati",
		"avinti",
		"aviolanciati",
		"aviotrasportati",
		"avocati",
		"avolterati",
		"avulsi",
		"avutaceli",
		"avuti",
		"avvalorati",
		"avvalsi",
		"avvantaggiati",
		"avvelati",
		"avvelenati",
		"avventati",
		"avventurati",
		"avverati",
		"avversati",
		"avvertiti",
		"avvezzati",
		"avviati",
		"avvicendati",
		"avvicinati",
		"avvignati",
		"avviliti",
		"avviluppati",
		"avvinati",
		"avvinchiati",
		"avvinghiati",
		"avvinti",
		"avvisati",
		"avvistati",
		"avvitati",
		"avviticchiati",
		"avvititi",
		"avvivati",
		"avvolti",
		"avvoltolati",
		"aziendalizzati",
		"azionati",
		"azotati",
		"azzannati",
		"azzardati",
		"azzeccati",
		"azzerati",
		"azzimati",
		"azzittati",
		"azzittiti",
		"azzoppati",
		"azzoppiti",
		"azzuffati",
		"azzurrati",
		"bacati",
		"baccagliati",
		"bacchettati",
		"bacchiati",
		"baciati",
		"badati",
		"bagnati",
		"baipassati",
		"balbettati",
		"balcanizzati",
		"ballati",
		"baloccati",
		"balzati",
		"banalizzati",
		"bancati",
		"banditi",
		"bannati",
		"baraccati",
		"barattati",
		"barbarizzati",
		"barcamenati",
		"bardati",
		"barellati",
		"barrati",
		"barricati",
		"basati",
		"basciati",
		"basculati",
		"bassati",
		"bastati",
		"bastionati",
		"bastiti",
		"bastonati",
		"battezzati",
		"battuti",
		"bazzicati",
		"beatificati",
		"beati",
		"beccati",
		"beccheggiati",
		"becchettati",
		"beffati",
		"beffeggiati",
		"bendati",
		"benedetti",
		"beneficati",
		"benvoluti",
		"berlusconizzati",
		"bersagliati",
		"bestemmiati",
		"bevuti",
		"biadati",
		"bianchettati",
		"bianchiti",
		"biascicati",
		"biasimati",
		"biasmati",
		"bidonati",
		"biennalizzati",
		"biforcati",
		"bigiati",
		"bilanciati",
		"binati",
		"bindolati",
		"biodegradati",
		"biografati",
		"bipartiti",
		"bisbigliati",
		"biscottati",
		"bisecati",
		"bisellati",
		"bisognati",
		"bissati",
		"bistrati",
		"bistrattati",
		"bitumati",
		"bituminati",
		"blanditi",
		"bleffati",
		"blindati",
		"bloccati",
		"bobinati",
		"boccheggiati",
		"bocciati",
		"boicottati",
		"bollati",
		"bolliti",
		"bombardati",
		"bombati",
		"bonderizzati",
		"bonificati",
		"bootati",
		"borbottati",
		"bordati",
		"boriati",
		"borrati",
		"borseggiati",
		"braccati",
		"bracciati",
		"bramati",
		"bramiti",
		"brancicati",
		"brandeggiati",
		"branditi",
		"brasati",
		"bravati",
		"brevettati",
		"breviati",
		"brillantati",
		"brillati",
		"brinati",
		"broccati",
		"brocciati",
		"broccolati",
		"brontolati",
		"bronzati",
		"brucati",
		"bruciacchiati",
		"bruciati",
		"bruniti",
		"bruscati",
		"bruschinati",
		"brutalizzati",
		"bruttati",
		"bucati",
		"bucherellati",
		"bufati",
		"buffati",
		"bufferizzati",
		"buggerati",
		"bugnati",
		"bulicati",
		"bulinati",
		"bullettati",
		"bullonati",
		"burattati",
		"burlati",
		"burocratizzati",
		"burrificati",
		"buscati",
		"buttati",
		"butterati",
		"bypassati",
		"cablati",
		"cabrati",
		"cacati",
		"cacciati",
		"cadenzati",
		"cadmiati",
		"caducati",
		"cagati",
		"caggiati",
		"cagionati",
		"cagliati",
		"calafatati",
		"calamitati",
		"calandrati",
		"calati",
		"calcati",
		"calciati",
		"calcificati",
		"calcolati",
		"caldeggiati",
		"calettati",
		"calibrati",
		"calmati",
		"calmierati",
		"calpestati",
		"calumati",
		"calunniati",
		"calzati",
		"cambiati",
		"camerati",
		"campionati",
		"campiti",
		"camuffati",
		"canalizzati",
		"cancellati",
		"cancerizzati",
		"candeggiati",
		"candidati",
		"canditi",
		"canforati",
		"cangiati",
		"cannati",
		"canneggiati",
		"cannibalizzati",
		"cannoneggiati",
		"canonizzati",
		"cantati",
		"canterellati",
		"canticchiati",
		"cantilenati",
		"canzonati",
		"caolinizzati",
		"capacitati",
		"capeggiati",
		"capillarizzati",
		"capitalizzati",
		"capitanati",
		"capitaneggiati",
		"capiti",
		"capitozzati",
		"capivolti",
		"caponati",
		"capotati",
		"capottati",
		"capovolti",
		"capponati",
		"captati",
		"caramellati",
		"caramellizzati",
		"caratati",
		"caratterizzati",
		"carbonizzati",
		"carbossilati",
		"carburati",
		"carcati",
		"carcerati",
		"cardati",
		"carenati",
		"carezzati",
		"cariati",
		"caricati",
		"caricaturati",
		"caricaturizzati",
		"carotati",
		"carpionati",
		"carpiti",
		"carreggiati",
		"carrozzati",
		"cartavetrati",
		"carteggiati",
		"cartellinati",
		"cartografati",
		"cartolarizzati",
		"cartonati",
		"cascolati",
		"cassati",
		"cassi",
		"castigati",
		"castrati",
		"casualizzati",
		"catabolizzati",
		"catalizzati",
		"catalogati",
		"catapultati",
		"catechizzati",
		"categorizzati",
		"cateterizzati",
		"catramati",
		"cattolicizzati",
		"catturati",
		"causati",
		"cautelati",
		"cauterizzati",
		"cauzionati",
		"cavalcati",
		"cavataseli",
		"cavati",
		"cazzati",
		"cazziati",
		"cazzottati",
		"cedrati",
		"ceduti",
		"celati",
		"celebrati",
		"cellofanati",
		"cementati",
		"cementificati",
		"cennati",
		"censiti",
		"censurati",
		"centellati",
		"centellinati",
		"centimetrati",
		"centinati",
		"centralizzati",
		"centrati",
		"centrifugati",
		"centuplicati",
		"cerati",
		"cercati",
		"cerchiati",
		"cernuti",
		"certificati",
		"cesellati",
		"cessati",
		"cestinati",
		"cheratinizzati",
		"chetati",
		"chiamati",
		"chiappati",
		"chiarificati",
		"chiariti",
		"chiaroscurati",
		"chiavati",
		"chiazzati",
		"chiesti",
		"chilificati",
		"chilometrati",
		"chimificati",
		"chinati",
		"chinizzati",
		"chiodati",
		"chiosati",
		"chiusi",
		"choccati",
		"ciancicati",
		"cianfrinati",
		"cianfrugliati",
		"ciangottati",
		"ciattati",
		"cibati",
		"cicatrizzati",
		"ciccati",
		"cicchettati",
		"ciclizzati",
		"ciclostilati",
		"cifrati",
		"cilindrati",
		"cimati",
		"cimentati",
		"cincischiati",
		"cinematografati",
		"cintati",
		"cinti",
		"cioncati",
		"ciondolati",
		"circolati",
		"circoncinti",
		"circoncisi",
		"circondati",
		"circondotti",
		"circonflessi",
		"circonfluiti",
		"circonfusi",
		"circonscritti",
		"circonvenuti",
		"circoscritti",
		"circostanziati",
		"circuiti",
		"circumcinti",
		"circumnavigati",
		"citati",
		"ciucciati",
		"ciurmati",
		"civettati",
		"civilizzati",
		"clamati",
		"classati",
		"classicizzati",
		"classificati",
		"cliccati",
		"climatizzati",
		"clivati",
		"clonati",
		"cloroformizzati",
		"clorurati",
		"clusterizzati",
		"co-diretti",
		"coacervati",
		"coadiuvati",
		"coagulati",
		"coalizzati",
		"coartati",
		"coccolati",
		"codificati",
		"coeditati",
		"coesistiti",
		"cofinanziati",
		"cofirmati",
		"cofondati",
		"cogestiti",
		"cogitati",
		"coglionati",
		"cognosciuti",
		"coibentati",
		"coincisi",
		"cointeressati",
		"cointestati",
		"coinvolti",
		"cokificati",
		"colati",
		"colettati",
		"collassati",
		"collaudati",
		"collazionati",
		"collegati",
		"collettivizzati",
		"collezionati",
		"collimati",
		"colliquati",
		"collisi",
		"collocati",
		"colluttati",
		"colmati",
		"colonizzati",
		"colorati",
		"coloriti",
		"colorizzati",
		"colpevolizzati",
		"colpiti",
		"coltellati",
		"coltivati",
		"colti",
		"coltrati",
		"comandati",
		"combattuti",
		"combinati",
		"comburuti",
		"comicizzati",
		"cominciati",
		"commemorati",
		"commendati",
		"commensurati",
		"commentati",
		"commercializzati",
		"commessi",
		"comminati",
		"commiserati",
		"commissariati",
		"commissionati",
		"commisurati",
		"commossi",
		"commutati",
		"comodati",
		"compaginati",
		"compariti",
		"compartimentalizzati",
		"compartiti",
		"compassionati",
		"compatibilizzati",
		"compatiti",
		"compattati",
		"compendiati",
		"compenetrati",
		"compensati",
		"comperati",
		"compiaciuti",
		"compianti",
		"compilati",
		"compitati",
		"compiuti",
		"complessati",
		"complessificati",
		"complessi",
		"completati",
		"complicati",
		"complimentati",
		"comportati",
		"compostati",
		"composti",
		"comprati",
		"compravenduti",
		"compresi",
		"compressi",
		"compromessi",
		"comprovati",
		"compulsati",
		"compunti",
		"computati",
		"computerizzati",
		"comunicati",
		"comunistizzati",
		"concatenati",
		"conceduti",
		"concelebrati",
		"concentrati",
		"concepiti",
		"concertati",
		"concessi",
		"concettati",
		"concettualizzati",
		"conchiusi",
		"conciati",
		"conciliati",
		"concimati",
		"concitati",
		"conclamati",
		"conclusi",
		"concordati",
		"concotti",
		"concretati",
		"concretizzati",
		"conculcati",
		"concupiti",
		"condannati",
		"condensati",
		"conditi",
		"condivisi",
		"condizionati",
		"condoluti",
		"condonati",
		"condotti",
		"confatti",
		"confederati",
		"conferiti",
		"confermati",
		"confessati",
		"confettati",
		"confezionati",
		"conficcati",
		"confidati",
		"configurati",
		"confinati",
		"confinti",
		"confiscati",
		"confitti",
		"conformati",
		"confortati",
		"confricati",
		"confrontati",
		"confusi",
		"confutati",
		"congedati",
		"congegnati",
		"congelati",
		"congestionati",
		"congetturati",
		"congiunti",
		"conglobati",
		"conglomerati",
		"conglutinati",
		"congratulati",
		"congregati",
		"conguagliati",
		"coniati",
		"coniugati",
		"connaturati",
		"connessi",
		"connotati",
		"connumerati",
		"conosciuti",
		"conquistati",
		"consacrati",
		"consapevolizzati",
		"consegnati",
		"conseguiti",
		"consentiti",
		"conservati",
		"considerati",
		"consigliati",
		"consistiti",
		"consociati",
		"consolati",
		"consolidati",
		"consorziati",
		"consparsi",
		"conspersi",
		"constatati",
		"constretti",
		"construiti",
		"consultati",
		"consumati",
		"consunti",
		"contabilizzati",
		"contagiati",
		"containerizzati",
		"contaminati",
		"contati",
		"contattati",
		"conteggiati",
		"contemperati",
		"contemplati",
		"contentati",
		"contenuti",
		"contesi",
		"contestati",
		"contestualizzati",
		"contingentati",
		"continuati",
		"contornati",
		"contorti",
		"contrabbandati",
		"contraccambiati",
		"contraddetti",
		"contraddistinti",
		"contradetti",
		"contraffatti",
		"contrappesati",
		"contrapposti",
		"contrappuntati",
		"contrariati",
		"contrassegnati",
		"contrastati",
		"contrati",
		"contrattaccati",
		"contrattati",
		"contratti",
		"contravvalsi",
		"contristati",
		"controbattuti",
		"controbilanciati",
		"controdatati",
		"controfirmati",
		"controindicati",
		"controllati",
		"controminati",
		"contronotati",
		"controproposti",
		"controprovati",
		"controquerelati",
		"controsoffittati",
		"controstampati",
		"controventati",
		"conturbati",
		"contusi",
		"convalidati",
		"convenuti",
		"convenzionati",
		"convertiti",
		"convinti",
		"convitati",
		"convocati",
		"convogliati",
		"convolti",
		"coobati",
		"cooptati",
		"coordinati",
		"coperchiati",
		"coperti",
		"copiaincollati",
		"copiati",
		"copolimerizzati",
		"coppellati",
		"coprodotti",
		"corazzati",
		"corbellati",
		"corcati",
		"cordonati",
		"coreografati",
		"coricati",
		"cornificati",
		"coronati",
		"corredati",
		"correlati",
		"corresponsabilizzati",
		"corretti",
		"corricchiati",
		"corrisposti",
		"corroborati",
		"corrosi",
		"corrotti",
		"corrucciati",
		"corrugati",
		"corsi",
		"corteati",
		"corteggiati",
		"cortocircuitati",
		"coruscati",
		"cosati",
		"coscritti",
		"cosparsi",
		"cospersi",
		"costatati",
		"costeggiati",
		"costellati",
		"costernati",
		"costicchiati",
		"costipati",
		"costituiti",
		"costituzionalizzati",
		"costretti",
		"costruiti",
		"costuditi",
		"cotonati",
		"cotti",
		"covati",
		"coventrizzati",
		"coverchiati",
		"craccati",
		"creati",
		"creduti",
		"cremati",
		"crepati",
		"cresciuti",
		"cresimati",
		"crespati",
		"criminalizzati",
		"crioconcentrati",
		"criptati",
		"cristallizzati",
		"cristianizzati",
		"criticati",
		"crittati",
		"crittografati",
		"crivellati",
		"crocchiati",
		"crocefissi",
		"crocefitti",
		"crocifissi",
		"crocifitti",
		"crogiolati",
		"cromati",
		"cronicizzati",
		"cronometrati",
		"crostati",
		"crucciati",
		"crucifissi",
		"crucifitti",
		"cuccati",
		"cucinati",
		"cuciti",
		"cullati",
		"cumulati",
		"cuntati",
		"curati",
		"curvati",
		"curvati",
		"custoditi",
		"customizzati",
		"damascati",
		"damaschinati",
		"damati",
		"dannati",
		"danneggiati",
		"danzati",
		"dardeggiati",
		"datati",
		"dati",
		"dattilografati",
		"dattiloscritti",
		"daziati",
		"deacidificati",
		"deattivati",
		"debbiati",
		"debellati",
		"debilitati",
		"decaffeinati",
		"decaffeinizzati",
		"decalcati",
		"decalcificati",
		"decantati",
		"decapati",
		"decapitati",
		"decappottati",
		"decarbossilati",
		"decarburati",
		"decatizzati",
		"decelerati",
		"decentralizzati",
		"decentrati",
		"decerebrati",
		"decernuti",
		"decespugliati",
		"deciferati",
		"decifrati",
		"decimalizzati",
		"decimati",
		"decisi",
		"declamati",
		"declassati",
		"declassificati",
		"declinati",
		"declorati",
		"decodificati",
		"decolonizzati",
		"decolorati",
		"decompartimentati",
		"decompilati",
		"decomposti",
		"decompressi",
		"deconcentrati",
		"decondizionati",
		"decongelati",
		"decongestionati",
		"decontaminati",
		"decontestualizzati",
		"decontratti",
		"decorati",
		"decorticati",
		"decostruiti",
		"decrementati",
		"decretati",
		"decriminalizzati",
		"decriptati",
		"decrittati",
		"decuplicati",
		"decurtati",
		"dedicati",
		"dedotti",
		"defacciati",
		"defalcati",
		"defascistizzati",
		"defecati",
		"defenestrati",
		"deferiti",
		"defilati",
		"definiti",
		"defiscalizzati",
		"defitti",
		"deflazionati",
		"deflemmati",
		"deflorati",
		"defogliati",
		"defoliati",
		"deforestati",
		"deformati",
		"defosforati",
		"defosforilati",
		"deframmentati",
		"defraudati",
		"degassati",
		"degassificati",
		"deglutiti",
		"degnati",
		"degradati",
		"degustati",
		"deidratati",
		"deidrogenati",
		"deificati",
		"deindicizzati",
		"deindustrializzati",
		"deionizzati",
		"delegati",
		"delegificati",
		"delegittimati",
		"delibati",
		"deliberati",
		"delimitati",
		"delineati",
		"delirati",
		"deliziati",
		"delocalizzati",
		"delucidati",
		"delusi",
		"demagnetizzati",
		"demandati",
		"demanializzati",
		"demarcati",
		"demeritati",
		"demersi",
		"demetallizzati",
		"demilitarizzati",
		"demineralizzati",
		"demistificati",
		"demitizzati",
		"democratizzati",
		"demodulati",
		"demoliti",
		"demoltiplicati",
		"demonetati",
		"demonetizzati",
		"demonizzati",
		"demoralizzati",
		"demorsi",
		"demotivati",
		"denaturalizzati",
		"denaturati",
		"denazificati",
		"denazionalizzati",
		"denicotinizzati",
		"denigrati",
		"denitrificati",
		"denocciolati",
		"denominati",
		"denotati",
		"dentellati",
		"denuclearizzati",
		"denudati",
		"denunciati",
		"denunziati",
		"deodorati",
		"deossidati",
		"deossigenati",
		"deostruiti",
		"depauperati",
		"depenalizzati",
		"depennati",
		"depilati",
		"depinti",
		"depistati",
		"deplorati",
		"depolarizzati",
		"depolimerizzati",
		"depoliticizzati",
		"depolverizzati",
		"deportati",
		"depositati",
		"deposti",
		"depotenziati",
		"depravati",
		"deprecati",
		"depredati",
		"depressi",
		"depressurizzati",
		"deprezzati",
		"deprivati",
		"deprotonati",
		"depulsi",
		"depurati",
		"dequalificati",
		"deratizzati",
		"derattizzati",
		"dereferenziati",
		"deregolamentati",
		"deregolati",
		"derequisiti",
		"deresponsabilizzati",
		"derisi",
		"derubati",
		"derubricati",
		"desacralizzati",
		"desalati",
		"desalinizzati",
		"descolarizzati",
		"descritti",
		"desecretati",
		"desegretati",
		"deselezionati",
		"desensibilizzati",
		"desessualizzati",
		"desiati",
		"desiderati",
		"designati",
		"desinati",
		"desirati",
		"desolati",
		"desolforati",
		"desonorizzati",
		"desorbiti",
		"desossidati",
		"desquamati",
		"destabilizzati",
		"destagionalizzati",
		"destalinizzati",
		"destatalizzati",
		"destatizzati",
		"destati",
		"destinati",
		"destituiti",
		"destoricizzati",
		"destreggiati",
		"destrutti",
		"destrutturati",
		"desunti",
		"detassati",
		"detenuti",
		"deteriorati",
		"determinati",
		"detersi",
		"detestati",
		"detonati",
		"detorti",
		"detossificati",
		"detratti",
		"detronizzati",
		"dettagliati",
		"dettati",
		"detti",
		"deturpati",
		"deumidificati",
		"devastati",
		"deventati",
		"deviati",
		"deviscerati",
		"devitalizzati",
		"devitaminizzati",
		"devoluti",
		"dezippati",
		"diaframmati",
		"diagnosticati",
		"diagonalizzati",
		"diagrammati",
		"dializzati",
		"dialogati",
		"dialogizzati",
		"diazotati",
		"dibattuti",
		"diboscati",
		"dichiarati",
		"diesati",
		"diesizzati",
		"difesi",
		"diffamati",
		"differiti",
		"diffidati",
		"diffranti",
		"diffratti",
		"diffusi",
		"digeriti",
		"digitalizzati",
		"digitati",
		"digiunti",
		"digrassati",
		"digrignati",
		"digrossati",
		"dilacerati",
		"dilaniati",
		"dilapidati",
		"dilatati",
		"dilavati",
		"dilazionati",
		"dileggiati",
		"dileguati",
		"dilettati",
		"diletti",
		"diliscati",
		"dilucidati",
		"diluiti",
		"dilungati",
		"dimagrati",
		"dimandati",
		"dimenati",
		"dimensionati",
		"dimenticati",
		"dimerizzati",
		"dimessi",
		"dimezzati",
		"diminuiti",
		"dimissionati",
		"dimostrati",
		"dimunti",
		"dinamizzati",
		"dinoccati",
		"dipanati",
		"dipelati",
		"dipinti",
		"diplomati",
		"diposti",
		"diradati",
		"diramati",
		"diretti",
		"direzionati",
		"dirimuti",
		"diroccati",
		"dirottati",
		"dirotti",
		"dirozzati",
		"disabilitati",
		"disabituati",
		"disaccentati",
		"disaccoppiati",
		"disaccordati",
		"disacerbati",
		"disacidati",
		"disacidificati",
		"disaciditi",
		"disaerati",
		"disaffezionati",
		"disaggregati",
		"disalberati",
		"disallineati",
		"disamati",
		"disambiguati",
		"disaminati",
		"disamorati",
		"disancorati",
		"disanimati",
		"disappannati",
		"disapplicati",
		"disappresi",
		"disapprovati",
		"disarcionati",
		"disarmati",
		"disarticolati",
		"disascosti",
		"disassemblati",
		"disassuefatti",
		"disatomizzati",
		"disattesi",
		"disattivati",
		"disattrezzati",
		"disavvezzati",
		"disboscati",
		"disbrigati",
		"discacciati",
		"discalzati",
		"discantati",
		"discaricati",
		"discernuti",
		"discesi",
		"disceverati",
		"dischiesti",
		"dischiusi",
		"discinti",
		"disciolti",
		"disciplinati",
		"discolorati",
		"discolpati",
		"discommessi",
		"discompagnati",
		"discomposti",
		"disconclusi",
		"disconfitti",
		"discongiunti",
		"disconnessi",
		"disconosciuti",
		"discoperti",
		"discordati",
		"discoscesi",
		"discostati",
		"discreditati",
		"discresciuti",
		"discriminati",
		"discritti",
		"discuciti",
		"discuoiati",
		"discussi",
		"disdegnati",
		"disdettati",
		"disdetti",
		"diseccati",
		"diseccitati",
		"diseducati",
		"disegnati",
		"diserbati",
		"diseredati",
		"disertati",
		"diserti",
		"disfatti",
		"disgelati",
		"disgiunti",
		"disgraziati",
		"disgregati",
		"disgustati",
		"disidentificati",
		"disiderati",
		"disidratati",
		"disillusi",
		"disimballati",
		"disimparati",
		"disimpegnati",
		"disimpressi",
		"disincagliati",
		"disincantati",
		"disincentivati",
		"disincrostati",
		"disindustrializzati",
		"disinfestati",
		"disinfettati",
		"disinflazionati",
		"disinformati",
		"disingannati",
		"disingranati",
		"disinibiti",
		"disinnamorati",
		"disinnescati",
		"disinnestati",
		"disinquinati",
		"disinseriti",
		"disinstallati",
		"disintasati",
		"disintegrati",
		"disinteressati",
		"disintesi",
		"disintossicati",
		"disinvestiti",
		"disinvolti",
		"disistimati",
		"dislocati",
		"dismessi",
		"disobbediti",
		"disobbligati",
		"disonorati",
		"disordinati",
		"disorganizzati",
		"disorientati",
		"disormeggiati",
		"disossati",
		"disossidati",
		"disostruiti",
		"disotterrati",
		"dispariti",
		"dispensati",
		"dispenti",
		"disperduti",
		"dispersi",
		"dispesi",
		"dispiegati",
		"dispinti",
		"dispogliati",
		"disposti",
		"dispregiati",
		"disprezzati",
		"dispromessi",
		"disproporzionati",
		"disputati",
		"disqualificati",
		"disrotti",
		"dissacrati",
		"dissalati",
		"dissaldati",
		"dissanguati",
		"dissecati",
		"disseccati",
		"disselciati",
		"dissellati",
		"disseminati",
		"dissepolti",
		"disseppelliti",
		"dissequestrati",
		"disserrati",
		"dissestati",
		"dissetati",
		"dissezionati",
		"dissigillati",
		"dissimulati",
		"dissipati",
		"dissociati",
		"dissodati",
		"dissolti",
		"dissomigliati",
		"dissotterrati",
		"dissuasi",
		"dissuggellati",
		"distaccati",
		"distanziati",
		"distesi",
		"distillati",
		"distinti",
		"distolti",
		"distorti",
		"distratti",
		"distretti",
		"distribuiti",
		"districati",
		"distrigati",
		"distrutti",
		"disturbati",
		"disubbiditi",
		"disumanati",
		"disumanizzati",
		"disuniti",
		"disusati",
		"disveduti",
		"disvelati",
		"disvestiti",
		"disviati",
		"disvisti",
		"disvolti",
		"disvoluti",
		"dittongati",
		"divallati",
		"divaricati",
		"divelti",
		"diversificati",
		"divertiti",
		"divezzati",
		"divinati",
		"divincolati",
		"divinizzati",
		"divisi",
		"divolti",
		"divorati",
		"divorziati",
		"divulgati",
		"documentati",
		"dogati",
		"dogmatizzati",
		"dolcificati",
		"dollarizzati",
		"dolorati",
		"doluti",
		"domandati",
		"domati",
		"domesticati",
		"domiciliati",
		"dominati",
		"donati",
		"dondolati",
		"dopati",
		"doppiati",
		"dorati",
		"dormitoci",
		"dosati",
		"dotati",
		"dovuti",
		"dragati",
		"drammatizzati",
		"drappeggiati",
		"drenati",
		"dribblati",
		"drizzati",
		"drogati",
		"dugliati",
		"duplicati",
		"duramificati",
		"ebraizzati",
		"ecceduti",
		"eccepiti",
		"eccettuati",
		"eccitati",
		"echeggiati",
		"eclissati",
		"economizzati",
		"edificati",
		"editati",
		"edotti",
		"educati",
		"edulcorati",
		"effettuati",
		"efficientati",
		"effigiati",
		"effinti",
		"effluiti",
		"effusi",
		"egemonizzati",
		"eguagliati",
		"eiettati",
		"elaborati",
		"elargiti",
		"elasticizzati",
		"elementarizzati",
		"elemosinati",
		"elencati",
		"eletti",
		"elettrificati",
		"elettrizzati",
		"elettrocoagulati",
		"elettrolizzati",
		"elevati",
		"eliminati",
		"elisi",
		"elitrasportati",
		"ellenizzati",
		"elogiati",
		"elucidati",
		"elucubrati",
		"eluiti",
		"elusi",
		"emanati",
		"emancipati",
		"emarginati",
		"embricati",
		"emendati",
		"emessi",
		"emozionati",
		"empiti",
		"empiuti",
		"emulati",
		"emulsionati",
		"emunti",
		"encomiati",
		"endocitati",
		"energizzati",
		"enfatizzati",
		"enfiati",
		"entusiasmati",
		"enucleati",
		"enumerati",
		"enunciati",
		"epicureggiati",
		"epurati",
		"equalizzati",
		"equilibrati",
		"equipaggiati",
		"equiparati",
		"eradicati",
		"erasi",
		"ereditati",
		"eretti",
		"erogati",
		"eroicizzati",
		"erosi",
		"erotizzati",
		"erpicati",
		"ersi",
		"eruditi",
		"eruttati",
		"esacerbati",
		"esagerati",
		"esagitati",
		"esalati",
		"esaltati",
		"esaminati",
		"esasperati",
		"esauditi",
		"esauriti",
		"esautorati",
		"esborsati",
		"esclusi",
		"escogitati",
		"escomiati",
		"escoriati",
		"escossi",
		"escussi",
		"esecrati",
		"esecutati",
		"eseguiti",
		"esemplificati",
		"esentati",
		"esercitati",
		"esfoliati",
		"esibiti",
		"esilarati",
		"esiliati",
		"esimuti",
		"esitati",
		"esonerati",
		"esorbitati",
		"esorcizzati",
		"esortati",
		"espansi",
		"esparsi",
		"esperimentati",
		"esperiti",
		"espettorati",
		"espiantati",
		"espiati",
		"espirati",
		"espletati",
		"esplicati",
		"esplicitati",
		"esplorati",
		"esplosi",
		"esportati",
		"esposti",
		"espressi",
		"espropriati",
		"espugnati",
		"espulsi",
		"espunti",
		"espurgati",
		"essiccati",
		"essuti",
		"estasiati",
		"estenuati",
		"esterificati",
		"esteriorizzati",
		"esterminati",
		"esternalizzati",
		"esternati",
		"estesi",
		"estimati",
		"estinti",
		"estirpati",
		"estivati",
		"estorti",
		"estradati",
		"estraniati",
		"estrapolati",
		"estratti",
		"estremizzati",
		"estrinsecati",
		"estromessi",
		"estrusi",
		"estubati",
		"esulcerati",
		"esultati",
		"esumati",
		"eterificati",
		"eterizzati",
		"eternati",
		"eternizzati",
		"etichettati",
		"etossilati",
		"euforizzati",
		"europeizzati",
		"evacuati",
		"evangelizzati",
		"evasi",
		"eveti",
		"evidenziati",
		"evinti",
		"evirati",
		"eviscerati",
		"evitati",
		"evocati",
		"evolti",
		"evoluti",
		"evulsi",
		"fabbricati",
		"faccettati",
		"facilitati",
		"fagocitati",
		"falciati",
		"falcidiati",
		"falliti",
		"falsati",
		"falsificati",
		"familiarizzati",
		"fanatizzati",
		"fantasticati",
		"farciti",
		"farfugliati",
		"fasciati",
		"fascicolati",
		"fascistizzati",
		"fattaceli",
		"fatti",
		"fattorizzati",
		"fatturati",
		"favellati",
		"favoreggiati",
		"favoriti",
		"faxati",
		"fecondati",
		"fedecommessi",
		"federalizzati",
		"federati",
		"felicitati",
		"felpati",
		"feltrati",
		"femminilizzati",
		"fenduti",
		"feriti",
		"fermati",
		"fermentati",
		"ferrati",
		"fertilizzati",
		"fessi",
		"fessurati",
		"festeggiati",
		"festonati",
		"feudalizzati",
		"fiaccati",
		"fiammeggiati",
		"fiancheggiati",
		"ficcati",
		"fidanzati",
		"fidati",
		"fidecommessi",
		"fidelizzati",
		"figliati",
		"figurati",
		"filati",
		"filettati",
		"filmati",
		"filosofati",
		"filtrati",
		"finalizzati",
		"finanziati",
		"finitali",
		"finiti",
		"finlandizzati",
		"fintati",
		"finti",
		"fiocinati",
		"fiondati",
		"fiorettati",
		"firmati",
		"fiscalizzati",
		"fischiati",
		"fischiettati",
		"fissati",
		"fissionati",
		"fitti",
		"fiutati",
		"flagellati",
		"flaggati",
		"flambati",
		"flangiati",
		"flemmatizzati",
		"flessi",
		"flippati",
		"flottati",
		"fluidificati",
		"fluidizzati",
		"fluorizzati",
		"fluorurati",
		"focalizzati",
		"focheggiati",
		"foderati",
		"foggiati",
		"fognati",
		"folgorati",
		"follati",
		"fomentati",
		"fonati",
		"fondati",
		"foracchiati",
		"foraggiati",
		"forati",
		"forestati",
		"forfettizzati",
		"forgiati",
		"formalizzati",
		"formati",
		"formattati",
		"formilati",
		"formulati",
		"forniti",
		"fortificati",
		"forviati",
		"forwardati",
		"forzati",
		"fosfatati",
		"fosforati",
		"fosforilati",
		"fossilizzati",
		"fotocomposti",
		"fotocopiati",
		"fotografati",
		"fottuti",
		"fracassati",
		"fraintesi",
		"framessi",
		"frammentati",
		"frammessi",
		"frammezzati",
		"frammischiati",
		"franceseggiati",
		"francesizzati",
		"frangiati",
		"franti",
		"frantumati",
		"frappati",
		"frapposti",
		"fraseggiati",
		"frastagliati",
		"frastornati",
		"fratturati",
		"frazionati",
		"freddati",
		"fregati",
		"fregiati",
		"frenati",
		"frequentati",
		"fresati",
		"frettati",
		"friendzonati",
		"fritti",
		"frizionati",
		"frodati",
		"frollati",
		"fronteggiati",
		"frugati",
		"fruiti",
		"frullati",
		"frusciati",
		"frustati",
		"frustrati",
		"fruttati",
		"fucilati",
		"fucinati",
		"fugati",
		"fuggiti",
		"fulminati",
		"fumati",
		"fumigati",
		"funestati",
		"funti",
		"funzionati",
		"fuoriusciti",
		"fuorviati",
		"fusi",
		"fustellati",
		"fustigati",
		"gabbati",
		"gabellati",
		"gallati",
		"gallicizzati",
		"gallonati",
		"galvanizzati",
		"gambizzati",
		"garantiti",
		"garnettati",
		"garrotati",
		"garzati",
		"gasati",
		"gassati",
		"gassificati",
		"gazati",
		"gelatinizzati",
		"gelati",
		"gelificati",
		"gemellati",
		"gemicati",
		"geminati",
		"generalizzati",
		"generati",
		"gentrificati",
		"genuflessi",
		"geometrizzati",
		"georeferenziati",
		"gerarchizzati",
		"germanizzati",
		"gestiti",
		"gettati",
		"gettonati",
		"ghermiti",
		"ghettizzati",
		"ghigliottinati",
		"ghindati",
		"gibollati",
		"gingillati",
		"ginnati",
		"giocati",
		"gioiti",
		"gionglati",
		"giovaneggiati",
		"girandolati",
		"girati",
		"giudicati",
		"giulebbati",
		"giuntati",
		"giunti",
		"giuracchiati",
		"giurati",
		"giustapposti",
		"giustificati",
		"giustiziati",
		"glamourizzati",
		"glassati",
		"glissati",
		"globalizzati",
		"gloriati",
		"glorificati",
		"glossati",
		"godronati",
		"goduti",
		"goffrati",
		"gommati",
		"gonfiati",
		"googlati",
		"gottati",
		"governati",
		"gradinati",
		"graditi",
		"gradualizzati",
		"graduati",
		"graffati",
		"graffiati",
		"graffiti",
		"graficati",
		"grafitati",
		"gramolati",
		"granagliati",
		"grandinati",
		"granellati",
		"graniti",
		"granulati",
		"graticciati",
		"graticolati",
		"gratificati",
		"gratinati",
		"grattati",
		"grattugiati",
		"gravati",
		"graziati",
		"grecheggiati",
		"grecizzati",
		"gremiti",
		"gridati",
		"griffati",
		"grigliati",
		"grippati",
		"groccati",
		"grondati",
		"grugati",
		"grugniti",
		"guadagnati",
		"gualciti",
		"guardati",
		"guariti",
		"guarniti",
		"guastati",
		"guatati",
		"guerreggiati",
		"gufati",
		"guidati",
		"gustati",
		"hackerati",
		"handicappati",
		"ibridati",
		"idealizzati",
		"ideati",
		"identificati",
		"ideologizzati",
		"idolatrati",
		"idoleggiati",
		"idratati",
		"idrogenati",
		"idrolizzati",
		"iettati",
		"igienizzati",
		"ignifugati",
		"ignorati",
		"illanguiditi",
		"illeggiadriti",
		"illividiti",
		"illuminati",
		"illusi",
		"illustrati",
		"imbacuccati",
		"imbaldanziti",
		"imballati",
		"imbalsamati",
		"imbambolati",
		"imbandierati",
		"imbanditi",
		"imbarbariti",
		"imbarcati",
		"imbarilati",
		"imbastarditi",
		"imbastiti",
		"imbattuti",
		"imbavagliati",
		"imbeccati",
		"imbellettati",
		"imbelliti",
		"imbestialiti",
		"imbestiati",
		"imbevuti",
		"imbiaccati",
		"imbiancati",
		"imbianchiti",
		"imbibiti",
		"imbiettati",
		"imbionditi",
		"imbizzarriti",
		"imboccati",
		"imboniti",
		"imborghesiti",
		"imboscati",
		"imboschiti",
		"imbottati",
		"imbottigliati",
		"imbottiti",
		"imbozzimati",
		"imbracati",
		"imbracciati",
		"imbragati",
		"imbrancati",
		"imbrattati",
		"imbrecciati",
		"imbrigliati",
		"imbrillantinati",
		"imbroccati",
		"imbrodati",
		"imbrogliati",
		"imbronciati",
		"imbruttiti",
		"imbucati",
		"imbudellati",
		"imbullettati",
		"imbullonati",
		"imburrati",
		"imbussolati",
		"imbustati",
		"imbutiti",
		"imitati",
		"immagazzinati",
		"immaginati",
		"immalinconiti",
		"immatricolati",
		"immedesimati",
		"immersi",
		"immessi",
		"immischiati",
		"immiseriti",
		"immobilizzati",
		"immolati",
		"immortalati",
		"immunizzati",
		"immusoniti",
		"impaccati",
		"impacchettati",
		"impacciati",
		"impadroniti",
		"impaginati",
		"impagliati",
		"impalati",
		"impalcati",
		"impallati",
		"impallinati",
		"impalmati",
		"impaludati",
		"impanati",
		"impaniati",
		"impannati",
		"impantanati",
		"impaperati",
		"impapocchiati",
		"impappinati",
		"imparentati",
		"imparruccati",
		"impartiti",
		"impastati",
		"impasticcati",
		"impasticciati",
		"impastocchiati",
		"impastoiati",
		"impataccati",
		"impattati",
		"impauriti",
		"impavesati",
		"impeciati",
		"impedicati",
		"impediti",
		"impegnati",
		"impegolati",
		"impelagati",
		"impellicciati",
		"impennacchiati",
		"impennati",
		"impensieriti",
		"impepati",
		"imperlati",
		"impermaliti",
		"impermeabilizzati",
		"imperniati",
		"impersonati",
		"impersonificati",
		"impestati",
		"impetrati",
		"impiallacciati",
		"impiantati",
		"impiastrati",
		"impiastricciati",
		"impiccati",
		"impicciati",
		"impiccioliti",
		"impiccoliti",
		"impidocchiati",
		"impiegati",
		"impietositi",
		"impietriti",
		"impigliati",
		"impigriti",
		"impilati",
		"impillaccherati",
		"impinguati",
		"impinti",
		"impinzati",
		"impiombati",
		"impipati",
		"impiumati",
		"implementati",
		"implicati",
		"implorati",
		"impollinati",
		"impolpati",
		"impoltroniti",
		"impolverati",
		"impomatati",
		"imporcati",
		"imporporati",
		"importati",
		"importunati",
		"impossessati",
		"impossibilitati",
		"impostati",
		"imposti",
		"impratichiti",
		"impregnati",
		"impresi",
		"impressionati",
		"impressi",
		"imprestati",
		"impreziositi",
		"imprigionati",
		"impromessi",
		"improntati",
		"improsciuttiti",
		"impugnati",
		"impuntiti",
		"impunturati",
		"impupati",
		"imputati",
		"impuzzolentiti",
		"inabilitati",
		"inabissati",
		"inacerbiti",
		"inacetiti",
		"inaciditi",
		"inacutiti",
		"inaffiati",
		"inalati",
		"inalberati",
		"inalveati",
		"inalzati",
		"inamidati",
		"inanellati",
		"inarcati",
		"inargentati",
		"inariditi",
		"inaspriti",
		"inastati",
		"inattivati",
		"inaugurati",
		"incacchiati",
		"incalcinati",
		"incaloriti",
		"incalzati",
		"incamerati",
		"incamiciati",
		"incamminati",
		"incanagliti",
		"incanalati",
		"incannati",
		"incannucciati",
		"incaponiti",
		"incappottati",
		"incappucciati",
		"incaprettati",
		"incapricciati",
		"incapsulati",
		"incarcerati",
		"incardinati",
		"incaricati",
		"incarnati",
		"incarrozzati",
		"incartati",
		"incartocciati",
		"incartonati",
		"incasellati",
		"incasinati",
		"incassati",
		"incastellati",
		"incastonati",
		"incastrati",
		"incatenati",
		"incatramati",
		"incattiviti",
		"incavati",
		"incavigliati",
		"incavolati",
		"incazzati",
		"incellofanati",
		"incendiati",
		"inceneriti",
		"incensati",
		"incentivati",
		"incentrati",
		"inceppati",
		"incerati",
		"incernierati",
		"incerottati",
		"incesi",
		"incettati",
		"inchiappettati",
		"inchiavardati",
		"inchiesti",
		"inchinati",
		"inchiodati",
		"inchiostrati",
		"incipriati",
		"incisi",
		"incistati",
		"incitati",
		"inciuccati",
		"inciviliti",
		"inclinati",
		"inclusi",
		"incoccati",
		"incocciati",
		"incoiati",
		"incollati",
		"incolonnati",
		"incolpati",
		"incominciati",
		"incomodati",
		"incontrati",
		"incoraggiati",
		"incordati",
		"incornati",
		"incorniciati",
		"incoronati",
		"incorporati",
		"incotti",
		"incravattati",
		"incrementati",
		"increspati",
		"incretiniti",
		"incriminati",
		"incrinati",
		"incrociati",
		"incrostati",
		"incrudeliti",
		"incruditi",
		"incruscati",
		"incubati",
		"inculati",
		"inculcati",
		"incuneati",
		"incuoiati",
		"incuorati",
		"incupiti",
		"incuriositi",
		"incurvati",
		"incussi",
		"indagati",
		"indebitati",
		"indeboliti",
		"indemaniati",
		"indennizzati",
		"indetti",
		"indicati",
		"indicizzati",
		"indignati",
		"indiretti",
		"indirizzati",
		"indispettiti",
		"indisposti",
		"individualizzati",
		"individuati",
		"indolenziti",
		"indorati",
		"indossati",
		"indotti",
		"indottomi",
		"indottrinati",
		"indovinati",
		"indugiati",
		"indulti",
		"indurati",
		"induriti",
		"industrializzati",
		"industriati",
		"inebetiti",
		"inebriati",
		"ineriti",
		"inerpicati",
		"infagottati",
		"infamati",
		"infangati",
		"infarciti",
		"infarinati",
		"infastiditi",
		"infatuati",
		"infeltriti",
		"inferiti",
		"inferociti",
		"inferti",
		"infervorati",
		"infestati",
		"infettati",
		"infeudati",
		"infiacchiti",
		"infialati",
		"infialettati",
		"infiammati",
		"infiascati",
		"infibulati",
		"inficiati",
		"infilati",
		"infiltrati",
		"infilzati",
		"infingarditi",
		"infinocchiati",
		"infinti",
		"infioccati",
		"infiocchettati",
		"infiochiti",
		"infiorati",
		"infirmati",
		"infischiati",
		"infissi",
		"infittiti",
		"inflazionati",
		"inflessi",
		"inflitti",
		"influenzati",
		"infocati",
		"infoderati",
		"infognati",
		"infoibati",
		"infoltiti",
		"inforcati",
		"informatizzati",
		"informati",
		"informicolati",
		"informicoliti",
		"infornaciati",
		"infornati",
		"infortunati",
		"infoscati",
		"infossati",
		"infradiciati",
		"inframessi",
		"inframezzati",
		"inframmessi",
		"inframmezzati",
		"infrancesati",
		"infrapposti",
		"infrascati",
		"infrattati",
		"infreddati",
		"infronzolati",
		"infuocati",
		"infurbiti",
		"infuriati",
		"ingabbiati",
		"ingaggiati",
		"ingagliarditi",
		"ingannati",
		"ingarbugliati",
		"ingavonati",
		"ingegnati",
		"ingegnerizzati",
		"ingelositi",
		"ingemmati",
		"ingenerati",
		"ingentiliti",
		"ingeriti",
		"ingessati",
		"inghiaiati",
		"inghiottiti",
		"inghirlandati",
		"ingialliti",
		"ingigantiti",
		"inginocchiati",
		"ingioiellati",
		"ingiunti",
		"ingiuriati",
		"inglesizzati",
		"inglobati",
		"ingoffiti",
		"ingoiati",
		"ingolfati",
		"ingollati",
		"ingolositi",
		"ingombrati",
		"ingommati",
		"ingorgati",
		"ingozzati",
		"ingranati",
		"ingranditi",
		"ingrassati",
		"ingraticciati",
		"ingraticolati",
		"ingravidati",
		"ingraziati",
		"ingraziositi",
		"ingrigiti",
		"ingrommati",
		"ingrossati",
		"ingrulliti",
		"inguaiati",
		"inguainati",
		"ingualdrappati",
		"inguantati",
		"ingurgitati",
		"inibiti",
		"iniettati",
		"inimicati",
		"inizializzati",
		"iniziati",
		"inmillati",
		"innacquati",
		"innaffiati",
		"innalzati",
		"innamorati",
		"innastati",
		"innervati",
		"innervositi",
		"innescati",
		"innestati",
		"innevati",
		"innocentati",
		"innocuizzati",
		"innovati",
		"inoculati",
		"inoltrati",
		"inondati",
		"inorgogliti",
		"inorpellati",
		"inorriditi",
		"inquadrati",
		"inquietati",
		"inquisiti",
		"insabbiati",
		"insacchettati",
		"insalati",
		"insaldati",
		"insalivati",
		"insanguinati",
		"insaponati",
		"insaporiti",
		"inscatolati",
		"inscenati",
		"inscritti",
		"insecchiti",
		"insediati",
		"insegnati",
		"inseguiti",
		"insellati",
		"inselvatichiti",
		"inseriti",
		"insidiati",
		"insigniti",
		"insilati",
		"insinuati",
		"insolentiti",
		"insonnoliti",
		"insonorizzati",
		"insorditi",
		"insospettiti",
		"insozzati",
		"inspessiti",
		"inspirati",
		"installati",
		"instaurati",
		"insteriliti",
		"instillati",
		"instituiti",
		"instradati",
		"insudiciati",
		"insufflati",
		"insultati",
		"insuperbiti",
		"intabaccati",
		"intabarrati",
		"intaccati",
		"intagliati",
		"intarsiati",
		"intasati",
		"intascati",
		"intavolati",
		"integrati",
		"intelaiati",
		"intelati",
		"intellettualizzati",
		"intenebrati",
		"inteneriti",
		"intensificati",
		"intentati",
		"intepiditi",
		"intercalati",
		"intercambiati",
		"intercettati",
		"intercisi",
		"interclusi",
		"intercollegati",
		"interconnessi",
		"interconvertiti",
		"interdetti",
		"interessati",
		"interfacciati",
		"interfogliati",
		"interfoliati",
		"interiorizzati",
		"interlacciati",
		"interlineati",
		"intermessi",
		"intermezzati",
		"internalizzati",
		"internati",
		"internazionalizzati",
		"interpellati",
		"interpenetrati",
		"interpolati",
		"interposti",
		"interpretati",
		"interpunti",
		"interrati",
		"interrogati",
		"interrotti",
		"intersecati",
		"intervallati",
		"intervistati",
		"intesi",
		"intessuti",
		"intestarditi",
		"intestati",
		"intiepiditi",
		"intimati",
		"intimiditi",
		"intimoriti",
		"intinti",
		"intirizziti",
		"intitolati",
		"intonacati",
		"intonati",
		"intontiti",
		"intorbidati",
		"intorbiditi",
		"intorpiditi",
		"intortati",
		"intossicati",
		"intralciati",
		"intramessi",
		"intramezzati",
		"intrappolati",
		"intrapresi",
		"intrattenuti",
		"intraveduti",
		"intravisti",
		"intravveduti",
		"intravvisti",
		"intrecciati",
		"intricati",
		"intrigati",
		"intrinsecati",
		"intrippati",
		"intrisi",
		"introdotti",
		"introflessi",
		"introiettati",
		"introitati",
		"intromessi",
		"intronati",
		"intronizzati",
		"intruduti",
		"intrufolati",
		"intrugliati",
		"intruppati",
		"intrusi",
		"intubati",
		"intubettati",
		"intuiti",
		"inumati",
		"inumiditi",
		"inurbati",
		"inutilizzati",
		"invaghiti",
		"invaginati",
		"invalidati",
		"invasati",
		"invasi",
		"inveleniti",
		"inventariati",
		"inventati",
		"invenuti",
		"inverditi",
		"invergati",
		"inverniciati",
		"investigati",
		"investiti",
		"invetriati",
		"inviati",
		"invidiati",
		"invigoriti",
		"inviluppati",
		"invischiati",
		"invitati",
		"invocati",
		"invogliati",
		"involati",
		"involgariti",
		"involtati",
		"involti",
		"inzaccherati",
		"inzeppati",
		"inzigati",
		"inzolfati",
		"inzuccati",
		"inzuccherati",
		"inzuppati",
		"iodurati",
		"ionizzati",
		"ipertrofizzati",
		"ipnotizzati",
		"ipostatizzati",
		"ipotecati",
		"ipotizzati",
		"iridati",
		"irradiati",
		"irraggiati",
		"irreggimentati",
		"irretiti",
		"irrigati",
		"irrigiditi",
		"irrisi",
		"irritati",
		"irrobustiti",
		"irrogati",
		"irrorati",
		"irrugginiti",
		"irruviditi",
		"ischeletriti",
		"iscritti",
		"islamizzati",
		"isolati",
		"isomerizzati",
		"ispanizzati",
		"ispessiti",
		"ispezionati",
		"ispirati",
		"issati",
		"istallati",
		"istanziati",
		"istaurati",
		"isteriliti",
		"istigati",
		"istillati",
		"istituiti",
		"istituzionalizzati",
		"istoriati",
		"istradati",
		"istruiti",
		"istupiditi",
		"italianeggiati",
		"italianizzati",
		"iterati",
		"iudicati",
		"killerati",
		"labbreggiati",
		"labializzati",
		"laccati",
		"lacerati",
		"laconizzati",
		"lacrimati",
		"ladroneggiati",
		"lagnati",
		"lagrimati",
		"laicizzati",
		"lambiccati",
		"lambiti",
		"lamentati",
		"laminati",
		"lanciati",
		"lapidati",
		"lappati",
		"lardati",
		"lardellati",
		"largiti",
		"larvati",
		"lascati",
		"lasciati",
		"lastricati",
		"latinizzati",
		"laudati",
		"laureati",
		"lavati",
		"lavorati",
		"leccati",
		"legalizzati",
		"legati",
		"leggicchiati",
		"leggiucchiati",
		"legittimati",
		"legittimizzati",
		"legnati",
		"lemmatizzati",
		"leniti",
		"lesinati",
		"lesionati",
		"lesi",
		"lessati",
		"letti",
		"levati",
		"levigati",
		"liberalizzati",
		"liberati",
		"licenziati",
		"lievitati",
		"liftati",
		"lignificati",
		"limati",
		"limitati",
		"linciati",
		"linearizzati",
		"lineati",
		"linkati",
		"liofilizzati",
		"liquefatti",
		"liquidati",
		"lisati",
		"lisciati",
		"lisciviati",
		"listati",
		"litografati",
		"livellati",
		"lizzati",
		"lobotomizzati",
		"localizzati",
		"locati",
		"lodati",
		"logorati",
		"lordati",
		"lottati",
		"lottizzati",
		"lubrificati",
		"lucchettati",
		"lucidati",
		"lucrati",
		"lumeggiati",
		"luppolizzati",
		"lusingati",
		"lussati",
		"lustrati",
		"macadamizzati",
		"macchiati",
		"macchinati",
		"macellati",
		"macerati",
		"maciullati",
		"maggesati",
		"maggiorati",
		"magnati",
		"magnetizzati",
		"magnificati",
		"maiolicati",
		"maledetti",
		"malfatti",
		"malignati",
		"malmenati",
		"malmessi",
		"maltati",
		"maltrattati",
		"malveduti",
		"malversati",
		"malvisti",
		"malvoluti",
		"mandati",
		"mandrinati",
		"manducati",
		"maneggiati",
		"manganati",
		"manganellati",
		"mangiati",
		"mangiucchiati",
		"manifatturati",
		"manifestati",
		"manimessi",
		"manipolati",
		"manlevati",
		"manomessi",
		"manoscritti",
		"manovrati",
		"mansuefatti",
		"mantecati",
		"mantenutasi",
		"mantenuti",
		"manualizzati",
		"manutenuti",
		"mappati",
		"marcati",
		"marchiati",
		"marciti",
		"marezzati",
		"marginalizzati",
		"marginati",
		"margottati",
		"marimessi",
		"marinati",
		"maritati",
		"marmorizzati",
		"marnati",
		"marocchinati",
		"martellati",
		"martellinati",
		"martirizzati",
		"martoriati",
		"mascherati",
		"maschiati",
		"maschiettati",
		"mascolinizzati",
		"massacrati",
		"massaggiati",
		"massellati",
		"massicciati",
		"massificati",
		"massimati",
		"massimizzati",
		"mastectomizzati",
		"masterizzati",
		"masticati",
		"masturbati",
		"matematizzati",
		"materializzati",
		"matricolati",
		"mattonati",
		"maturati",
		"mazziati",
		"mazzolati",
		"meccanizzati",
		"medagliati",
		"mediati",
		"medicalizzati",
		"medicati",
		"meditati",
		"membrati",
		"memorizzati",
		"menati",
		"mendicati",
		"menomati",
		"mentovati",
		"menzionati",
		"meravigliati",
		"mercanteggiati",
		"mercerizzati",
		"mercificati",
		"meriati",
		"meridionalizzati",
		"meritati",
		"merlati",
		"merlettati",
		"mersi",
		"mesciati",
		"mesciuti",
		"mescolati",
		"mescuti",
		"mesmerizzati",
		"messaggiati",
		"messi",
		"messoci",
		"mestati",
		"mesticati",
		"mestruati",
		"metabolizzati",
		"metaforeggiati",
		"metaforizzati",
		"metallizzati",
		"metamorfizzati",
		"metamorfosati",
		"metanizzati",
		"metilati",
		"metodizzati",
		"microfilmati",
		"microfonati",
		"microminiaturizzati",
		"micronizzati",
		"mietuti",
		"migliorati",
		"militarizzati",
		"millantati",
		"millimetrati",
		"mimati",
		"mimeografati",
		"mimetizzati",
		"minacciati",
		"minati",
		"minchionati",
		"mineralizzati",
		"miniati",
		"miniaturizzati",
		"minimizzati",
		"minuiti",
		"minuzzati",
		"miracolati",
		"miscelati",
		"mischiati",
		"misconosciuti",
		"missati",
		"mistificati",
		"misturati",
		"misurati",
		"miticizzati",
		"mitigati",
		"mitizzati",
		"mitragliati",
		"mitrati",
		"mixati",
		"mobiliati",
		"mobilitati",
		"mobilizzati",
		"modanati",
		"modellati",
		"modellizzati",
		"moderati",
		"modernizzati",
		"modificati",
		"modulati",
		"molati",
		"molestati",
		"mollati",
		"molleggiati",
		"moltiplicati",
		"monacati",
		"mondati",
		"mondializzati",
		"monetarizzati",
		"monetati",
		"monetizzati",
		"monitorati",
		"monitorizzati",
		"monocromatizzati",
		"monopolizzati",
		"monottongati",
		"montati",
		"monumentalizzati",
		"mordenzati",
		"mordicchiati",
		"mormorati",
		"morphati",
		"morsicati",
		"morsicchiati",
		"morsi",
		"mortasati",
		"mortificati",
		"mossi",
		"mostrati",
		"motivati",
		"motorizzati",
		"motteggiati",
		"movimentati",
		"mozzati",
		"mugolati",
		"mulciti",
		"multati",
		"multiplexati",
		"mummificati",
		"municipalizzati",
		"muniti",
		"munti",
		"murati",
		"musati",
		"musicati",
		"mussati",
		"mutati",
		"mutilati",
		"mutizzati",
		"mutuati",
		"nappati",
		"narcotizzati",
		"narrativizzati",
		"narrati",
		"nasalizzati",
		"nascosi",
		"nascosti",
		"nastrati",
		"naturaleggiati",
		"naturalizzati",
		"nauseati",
		"naverati",
		"navicati",
		"navigati",
		"nazificati",
		"nazionalizzati",
		"nebulizzati",
		"necessitati",
		"necrosati",
		"necrotizzati",
		"negativizzati",
		"negati",
		"negletti",
		"negoziati",
		"negreggiati",
		"neologizzati",
		"nerbati",
		"nericati",
		"nettati",
		"neutralizzati",
		"nevati",
		"nevicati",
		"nevischiati",
		"nevrotizzati",
		"nichelati",
		"niellati",
		"ninfeggiati",
		"ninnati",
		"ninnolati",
		"nitratati",
		"nitrificati",
		"nobilitati",
		"noiati",
		"noleggiati",
		"nomati",
		"nominalizzati",
		"nominati",
		"normalizzati",
		"normati",
		"notati",
		"notificati",
		"notiziati",
		"notricati",
		"noverati",
		"nuclearizzati",
		"nudricati",
		"nullificati",
		"numerati",
		"numerizzati",
		"nuotati",
		"nutriti",
		"obbiettati",
		"obbliati",
		"obbligati",
		"oberati",
		"obiettati",
		"obiettivati",
		"obiettivizzati",
		"obiurgati",
		"obliati",
		"obliterati",
		"obnubilati",
		"occasionati",
		"occhieggiati",
		"occidentalizzati",
		"occisi",
		"occlusi",
		"occultati",
		"occupati",
		"ocheggiati",
		"odiati",
		"odorati",
		"odorizzati",
		"offeriti",
		"offerti",
		"offesi",
		"officiati",
		"offiziati",
		"offuscati",
		"ofiziati",
		"oggettivati",
		"oggettivizzati",
		"oggettualizzati",
		"oliati",
		"oliti",
		"olografati",
		"oltraggiati",
		"oltrapassati",
		"oltrepassati",
		"omaggiati",
		"ombrati",
		"ombreggiati",
		"omessi",
		"omogeneizzati",
		"omogenizzati",
		"omologati",
		"ondati",
		"ondulati",
		"onestati",
		"onnubilati",
		"onorati",
		"opacati",
		"opacizzati",
		"operati",
		"opinati",
		"oppiati",
		"oppignorati",
		"oppilati",
		"opposti",
		"oppressi",
		"oppugnati",
		"oprati",
		"opsonizzati",
		"optati",
		"opzionati",
		"orbitati",
		"orchestrati",
		"ordinati",
		"orditi",
		"orecchiati",
		"organati",
		"organicati",
		"organizzati",
		"orgasmati",
		"orientalizzati",
		"orientati",
		"originati",
		"origliati",
		"orizzontati",
		"orlati",
		"orlettati",
		"ormati",
		"ormeggiati",
		"ornati",
		"orpellati",
		"orrati",
		"orripilati",
		"ortogonalizzati",
		"osannati",
		"osati",
		"osculati",
		"oscurati",
		"ospedalizzati",
		"ospitati",
		"osseduti",
		"ossequiati",
		"osservati",
		"ossessionati",
		"ossidati",
		"ossificati",
		"ossitonizzati",
		"ostacolati",
		"osteggiati",
		"ostentati",
		"ostinati",
		"ostracizzati",
		"ostruiti",
		"ottemperati",
		"ottenebrati",
		"ottenuti",
		"ottimalizzati",
		"ottimati",
		"ottimizzati",
		"ottonati",
		"ottriati",
		"ottuplicati",
		"otturati",
		"ottusi",
		"ottussi",
		"ovalizzati",
		"ovariectomizzati",
		"ovattati",
		"overcloccati",
		"ovrati",
		"ovviati",
		"ozieggiati",
		"ozonizzati",
		"pacati",
		"pacciamati",
		"pacificati",
		"padroneggiati",
		"paganizzati",
		"pagati",
		"paginati",
		"palafittati",
		"palatalizzati",
		"palati",
		"palesati",
		"palettati",
		"palettizzati",
		"palificati",
		"palleggiati",
		"pallettizzati",
		"palpati",
		"palpeggiati",
		"panati",
		"panneggiati",
		"panoramicati",
		"pappati",
		"paracadutati",
		"parafati",
		"paraffinati",
		"parafrasati",
		"paragonati",
		"paragrafati",
		"paralizzati",
		"parallelizzati",
		"parametrati",
		"parametrizzati",
		"parassitati",
		"parati",
		"parcati",
		"parcellizzati",
		"parcheggiati",
		"pareggiati",
		"parificati",
		"parkerizzati",
		"parlati",
		"parlucchiati",
		"parodiati",
		"partecipati",
		"particolareggiati",
		"particolarizzati",
		"partizionati",
		"partoriti",
		"parzializzati",
		"pasciuti",
		"pascolati",
		"passati",
		"passeggiati",
		"passionati",
		"passivati",
		"pasticciati",
		"pastorizzati",
		"pasturati",
		"patinati",
		"patiti",
		"patrocinati",
		"patteggiati",
		"pattugliati",
		"pattuiti",
		"paventati",
		"pavesati",
		"pavimentati",
		"pavoneggiati",
		"pazziati",
		"pedinati",
		"pedonalizzati",
		"peggiorati",
		"pelati",
		"pellettizzati",
		"penalizzati",
		"penetrati",
		"pennellati",
		"pensati",
		"pensionati",
		"pentiti",
		"pepati",
		"peptonizzati",
		"peragrati",
		"percentualizzati",
		"percepiti",
		"percolati",
		"percorsi",
		"percossi",
		"perdonati",
		"perdotti",
		"perduti",
		"perequati",
		"perfatti",
		"perfezionati",
		"perforati",
		"performati",
		"periti",
		"periziati",
		"perlustrati",
		"permeati",
		"permessi",
		"perorati",
		"perpetrati",
		"perpetuati",
		"perplimuti",
		"perquisiti",
		"perscrutati",
		"perseguitati",
		"perseguiti",
		"persi",
		"personalizzati",
		"personificati",
		"persuasi",
		"perturbati",
		"pervasi",
		"pervertiti",
		"pesati",
		"pescati",
		"pestati",
		"petrarcheggiati",
		"pettegolati",
		"pettinati",
		"piagati",
		"piaggiati",
		"piallati",
		"pianeggiati",
		"pianificati",
		"piantati",
		"piantatali",
		"piantati",
		"pianti",
		"piantonati",
		"piantumati",
		"piastrellati",
		"piatiti",
		"piazzati",
		"picchettati",
		"picchiati",
		"picchierellati",
		"picchiettati",
		"picconati",
		"piegati",
		"pieghettati",
		"pietrificati",
		"pigiati",
		"pigliati",
		"pigmentati",
		"pignorati",
		"pigolati",
		"pilotati",
		"pimentati",
		"pinti",
		"pinzati",
		"piombati",
		"piovigginati",
		"piovuti",
		"pipati",
		"pippati",
		"piratati",
		"pirogenati",
		"pisciati",
		"pitoccati",
		"pittati",
		"pitturati",
		"pizzicati",
		"pizzicottati",
		"placati",
		"placcati",
		"plagiati",
		"plasmati",
		"plasticati",
		"plastificati",
		"platinati",
		"plissettati",
		"pluralizzati",
		"poetati",
		"poeticizzati",
		"poggiati",
		"polarizzati",
		"poligrafati",
		"polimerizzati",
		"politicizzati",
		"polverizzati",
		"pomiciati",
		"pompati",
		"ponderati",
		"ponzati",
		"popolarizzati",
		"popolati",
		"poppati",
		"porcellanati",
		"porfirizzati",
		"portati",
		"portesi",
		"porti",
		"porzionati",
		"posati",
		"posdatati",
		"positivizzati",
		"posizionati",
		"posposti",
		"posseduti",
		"postati",
		"postdatati",
		"posteggiati",
		"posticipati",
		"postillati",
		"posti",
		"postsincronizzati",
		"postulati",
		"potabilizzati",
		"potati",
		"potenziati",
		"potuti",
		"pralinati",
		"praticati",
		"preaccennati",
		"preannunciati",
		"preannunziati",
		"preavvertiti",
		"preavvisati",
		"precaricati",
		"preceduti",
		"precettati",
		"precinti",
		"precisati",
		"preclusi",
		"precompilati",
		"precompressi",
		"preconfezionati",
		"preconizzati",
		"preconosciuti",
		"precorsi",
		"precostituiti",
		"predati",
		"predefiniti",
		"predestinati",
		"predeterminati",
		"predetti",
		"predicati",
		"predigeriti",
		"prediletti",
		"predisposti",
		"preeletti",
		"preesistuti",
		"prefabbricati",
		"prefati",
		"prefatti",
		"prefazionati",
		"preferiti",
		"prefigurati",
		"prefinanziati",
		"prefissati",
		"prefissi",
		"preformati",
		"pregati",
		"pregiati",
		"pregiudicati",
		"pregustati",
		"preimpregnati",
		"prelevati",
		"premeditati",
		"premescolati",
		"premessi",
		"premiati",
		"premoniti",
		"premuniti",
		"premurati",
		"premuti",
		"prenotati",
		"preoccupati",
		"preordinati",
		"preparati",
		"prepensionati",
		"prepigmentati",
		"preposti",
		"preprogrammati",
		"preraffreddati",
		"prerefrigerati",
		"preregistrati",
		"preregolati",
		"preriscaldati",
		"presi",
		"presagiti",
		"presaputi",
		"presaseli",
		"prescelti",
		"prescritti",
		"preseduti",
		"presegnalati",
		"preselezionati",
		"presentati",
		"presentiti",
		"preservati",
		"presidiati",
		"presieduti",
		"presi",
		"pressati",
		"pressi",
		"pressurizzati",
		"prestabiliti",
		"prestampati",
		"prestati",
		"prestigiati",
		"presunti",
		"presupposti",
		"pretermessi",
		"pretesi",
		"pretrattati",
		"prevaricati",
		"preveduti",
		"prevenduti",
		"preventivati",
		"prevenuti",
		"previsti",
		"prezzati",
		"prezzolati",
		"principiati",
		"privatizzati",
		"privati",
		"privilegiati",
		"problematizzati",
		"procacciati",
		"processati",
		"proclamati",
		"procrastinati",
		"procreati",
		"procurati",
		"prodigati",
		"prodotti",
		"profanati",
		"proferiti",
		"professati",
		"professionalizzati",
		"profetati",
		"profetizzati",
		"profferiti",
		"profilati",
		"profondati",
		"profumati",
		"profusi",
		"progettati",
		"prognosticati",
		"programmati",
		"proibiti",
		"proiettati",
		"proletarizzati",
		"prolungati",
		"promanati",
		"promessi",
		"promossi",
		"promozionati",
		"promulgati",
		"pronosticati",
		"pronunciati",
		"pronunziati",
		"propagandati",
		"propagati",
		"propagginati",
		"propalati",
		"propinati",
		"propiziati",
		"proporzionati",
		"proposti",
		"propugnati",
		"propulsi",
		"prorogati",
		"prosciolti",
		"prosciugati",
		"proscritti",
		"proseguiti",
		"prospettati",
		"prosternati",
		"prostesi",
		"prostituiti",
		"prostrati",
		"prosunti",
		"protesi",
		"protestati",
		"protetti",
		"protocollati",
		"protonati",
		"protratti",
		"protrusi",
		"provati",
		"proveduti",
		"provincializzati",
		"provisti",
		"provocati",
		"provveduti",
		"provvisti",
		"psicanalizzati",
		"psichiatrizzati",
		"psicoanalizzati",
		"psicologizzati",
		"pubblicati",
		"pubblicizzati",
		"puddellati",
		"pugnalati",
		"puliti",
		"pungolati",
		"puniti",
		"puntati",
		"punteggiati",
		"puntellati",
		"punti",
		"puntualizzati",
		"punzecchiati",
		"punzonati",
		"purgati",
		"purificati",
		"putiti",
		"putrefatti",
		"putriti",
		"quadrati",
		"quadrettati",
		"quadriennalizzati",
		"quadruplicati",
		"qualificati",
		"quantificati",
		"quantizzati",
		"querelati",
		"questuati",
		"quetati",
		"quietanzati",
		"quietati",
		"quintessenziati",
		"quintuplicati",
		"quotati",
		"quotizzati",
		"rabberciati",
		"rabboccati",
		"rabboniti",
		"rabbuffati",
		"rabuffati",
		"raccapezzati",
		"raccapricciati",
		"raccattati",
		"raccerchiati",
		"raccesi",
		"racchetati",
		"racchiusi",
		"raccolti",
		"raccolti",
		"raccomandati",
		"raccomodati",
		"raccontati",
		"raccorciati",
		"raccorciti",
		"raccordati",
		"raccostati",
		"raccozzati",
		"racemizzati",
		"racimolati",
		"radazzati",
		"raddensati",
		"raddobbati",
		"raddolciti",
		"raddoppiati",
		"raddotti",
		"raddrizzati",
		"radiati",
		"radicalizzati",
		"radioassistiti",
		"radioattivati",
		"radiocomandati",
		"radiodiffusi",
		"radiografati",
		"radioguidati",
		"radiolocalizzati",
		"radiomarcati",
		"radiotelegrafati",
		"radiotrasmessi",
		"radunati",
		"raffazzonati",
		"raffermati",
		"raffigurati",
		"raffilati",
		"raffinati",
		"rafforzati",
		"raffreddati",
		"raffrenati",
		"raffrescati",
		"raffrontati",
		"raggelati",
		"raggentiliti",
		"ragghiati",
		"raggirati",
		"raggiunti",
		"raggiustati",
		"raggomitolati",
		"raggranchiati",
		"raggranchiti",
		"raggranellati",
		"raggrinzati",
		"raggrinziti",
		"raggrumati",
		"raggruppati",
		"raggruzzolati",
		"ragguagliati",
		"ralingati",
		"rallegrati",
		"rallentati",
		"ramati",
		"ramazzati",
		"rammagliati",
		"rammaricati",
		"rammemorati",
		"rammendati",
		"rammentati",
		"rammodernati",
		"rammolliti",
		"rammorbiditi",
		"rampognati",
		"randellati",
		"randomizzati",
		"rannicchiati",
		"rannuvolati",
		"ranzati",
		"rapati",
		"rapinati",
		"rapiti",
		"rappacificati",
		"rappati",
		"rappattumati",
		"rappezzati",
		"rapportati",
		"rappresantati",
		"rappresentati",
		"rappresi",
		"rarefatti",
		"rasati",
		"raschiati",
		"raschiettati",
		"rasentati",
		"rasi",
		"raspati",
		"rassegnati",
		"rasserenati",
		"rassettati",
		"rassicurati",
		"rassodati",
		"rassomigliati",
		"rassottigliati",
		"rassunti",
		"rastrellati",
		"rastremati",
		"rateati",
		"rateizzati",
		"ratificati",
		"ratinati",
		"rattizzati",
		"rattoppati",
		"rattorti",
		"rattrappiti",
		"rattristati",
		"rattristiti",
		"raunati",
		"ravvalorati",
		"ravveduti",
		"ravviati",
		"ravvicinati",
		"ravviluppati",
		"ravvisati",
		"ravvisti",
		"ravvivati",
		"ravvolti",
		"ravvoltolati",
		"razionalizzati",
		"razionati",
		"razziati",
		"razzolati",
		"realizzati",
		"reassunti",
		"recapitati",
		"recati",
		"receduti",
		"recensiti",
		"recepiti",
		"recidivati",
		"recintati",
		"recinti",
		"reciprocati",
		"recisi",
		"recitati",
		"reclamati",
		"reclamizzati",
		"reclinati",
		"reclusi",
		"reclutati",
		"recuperati",
		"redarguiti",
		"redatti",
		"redazzati",
		"redduti",
		"redenti",
		"redistribuiti",
		"redotti",
		"referenziati",
		"refertati",
		"refilati",
		"reflessi",
		"reflettuti",
		"refranti",
		"refrigerati",
		"regalati",
		"regimati",
		"regimentati",
		"regionalizzati",
		"registrati",
		"regolamentati",
		"regolarizzati",
		"regolati",
		"reidratati",
		"reificati",
		"reimbarcati",
		"reimmersi",
		"reimmessi",
		"reimparati",
		"reimpastati",
		"reimpiantati",
		"reimpiegati",
		"reimportati",
		"reimpostati",
		"reincarcerati",
		"reincaricati",
		"reincarnati",
		"reincisi",
		"reincontrati",
		"reindirizzati",
		"reindustrializzati",
		"reinfettati",
		"reingaggiati",
		"reinizializzati",
		"reinnestati",
		"reinoltrati",
		"reinscritti",
		"reinsediati",
		"reinseriti",
		"reinstallati",
		"reinstaurati",
		"reintegrati",
		"reinterpretati",
		"reintitolati",
		"reintrodotti",
		"reinventati",
		"reinvestiti",
		"reiterati",
		"relativizzati",
		"relazionati",
		"relegati",
		"remixati",
		"remunerati",
		"renderizzati",
		"reperiti",
		"repertati",
		"replicati",
		"repressi",
		"repulsi",
		"reputati",
		"requisiti",
		"rescissi",
		"resecati",
		"resettati",
		"residuati",
		"resinificati",
		"resi",
		"resolati",
		"resolti",
		"respinti",
		"respirati",
		"responsabilizzati",
		"resposti",
		"restaurati",
		"restituiti",
		"resunti",
		"resuscitati",
		"reticolati",
		"retinati",
		"retribuiti",
		"retroceduti",
		"retrocessi",
		"retrodatati",
		"rettificati",
		"retti",
		"reumatizzati",
		"revisionati",
		"revocati",
		"riabbassati",
		"riabbelliti",
		"riabbonati",
		"riabbottonati",
		"riabbracciati",
		"riabilitati",
		"riabitati",
		"riabituati",
		"riaccaduti",
		"riaccasati",
		"riaccesi",
		"riaccettati",
		"riacchiappati",
		"riacciuffati",
		"riaccolti",
		"riaccomodati",
		"riaccompagnati",
		"riaccordati",
		"riaccostati",
		"riaccreditati",
		"riacquisiti",
		"riacquistati",
		"riacutizzati",
		"riadattati",
		"riaddestrati",
		"riaddormentati",
		"riadoperati",
		"riaffacciati",
		"riaffermati",
		"riafferrati",
		"riaffiorati",
		"riaffittati",
		"riaffrontati",
		"riagganciati",
		"riaggiornati",
		"riaggiustati",
		"riaggravati",
		"riaggregati",
		"riagguantati",
		"rialimentati",
		"riallacciati",
		"riallargati",
		"riallineati",
		"riallocati",
		"riallungati",
		"rialzati",
		"riamati",
		"riambientati",
		"riammalati",
		"riammessi",
		"riammodernati",
		"riammogliati",
		"rianimati",
		"riannessi",
		"riannodati",
		"riannunciati",
		"riaperti",
		"riappacificati",
		"riappaltati",
		"riapparecchiati",
		"riappariti",
		"riappesi",
		"riappiccicati",
		"riapplicati",
		"riappresi",
		"riapprodati",
		"riappropriati",
		"riapprovati",
		"riarmati",
		"riarrangiati",
		"riarredati",
		"riascoltati",
		"riasfaltati",
		"riassaliti",
		"riassaporati",
		"riassegnati",
		"riassemblati",
		"riassestati",
		"riassettati",
		"riassicurati",
		"riassociati",
		"riassopiti",
		"riassorbiti",
		"riassunti",
		"riattaccati",
		"riattati",
		"riattesi",
		"riattinti",
		"riattivati",
		"riattizzati",
		"riattraversati",
		"riaumentati",
		"riavuti",
		"riavventati",
		"riavvertiti",
		"riavviati",
		"riavvicinati",
		"riavvinti",
		"riavvisati",
		"riavvistati",
		"riavvolti",
		"riazzuffati",
		"ribaciati",
		"ribaditi",
		"ribaltati",
		"ribassati",
		"ribattezzati",
		"ribattuti",
		"ribellati",
		"ribenedetti",
		"ribevuti",
		"ributtati",
		"ricacciati",
		"ricalati",
		"ricalcati",
		"ricalcificati",
		"ricalcitrati",
		"ricalcolati",
		"ricalibrati",
		"ricamati",
		"ricambiati",
		"ricanalizzati",
		"ricandidati",
		"ricantati",
		"ricapitalizzati",
		"ricapitolati",
		"ricaricati",
		"ricategorizzati",
		"ricattati",
		"ricavati",
		"ricelebrati",
		"ricercati",
		"ricetrasmessi",
		"ricettati",
		"ricevuti",
		"richiamati",
		"richiesti",
		"richiusi",
		"riciclati",
		"ricinti",
		"ricircolati",
		"riclassificati",
		"ricodificati",
		"ricollegati",
		"ricollocati",
		"ricolmati",
		"ricolonizzati",
		"ricolorati",
		"ricoloriti",
		"ricoltivati",
		"ricombinati",
		"ricominciati",
		"ricommessi",
		"ricompariti",
		"ricompattati",
		"ricompensati",
		"ricomperati",
		"ricompilati",
		"ricompiuti",
		"ricomposti",
		"ricomprati",
		"ricompressi",
		"ricomunicati",
		"riconceduti",
		"riconcessi",
		"riconciliati",
		"ricondizionati",
		"ricondotti",
		"riconfermati",
		"riconfezionati",
		"riconfigurati",
		"riconfortati",
		"riconfusi",
		"ricongelati",
		"ricongiunti",
		"riconnessi",
		"riconosciuti",
		"riconquistati",
		"riconsacrati",
		"riconsegnati",
		"riconsiderati",
		"riconsigliati",
		"riconsolati",
		"ricontati",
		"ricontattati",
		"ricontrattati",
		"ricontratti",
		"ricontrollati",
		"riconvalidati",
		"riconvenuti",
		"riconvertiti",
		"riconvinti",
		"riconvocati",
		"riconvogliati",
		"ricoperti",
		"ricopiati",
		"ricordati",
		"ricoricati",
		"ricorretti",
		"ricosparsi",
		"ricostituiti",
		"ricostretti",
		"ricostruiti",
		"ricotti",
		"ricoverati",
		"ricreati",
		"ricristallizzati",
		"ricrocifissi",
		"ricuciti",
		"ricuperati",
		"ricusati",
		"ridati",
		"ridecorati",
		"ridefiniti",
		"ridenominati",
		"ridestati",
		"rideterminati",
		"ridetti",
		"ridicolizzati",
		"ridigitati",
		"ridimensionati",
		"ridipinti",
		"ridiscesi",
		"ridisciolti",
		"ridisciplinati",
		"ridiscussi",
		"ridisegnati",
		"ridisfatti",
		"ridisposti",
		"ridistesi",
		"ridistinti",
		"ridistribuiti",
		"ridivisi",
		"ridomandati",
		"ridonati",
		"ridondati",
		"ridorati",
		"ridotati",
		"ridotti",
		"ridovuti",
		"riecheggiati",
		"riedificati",
		"rieducati",
		"rielaborati",
		"rieletti",
		"riemessi",
		"riempiti",
		"riempiuti",
		"rientrati",
		"riepilogati",
		"riequilibrati",
		"riequipaggiati",
		"riesaminati",
		"rieseguiti",
		"riesercitati",
		"riesplosi",
		"riesportati",
		"riesposti",
		"riespressi",
		"riespulsi",
		"riestesi",
		"riesumati",
		"rietichettati",
		"rievaporati",
		"rievocati",
		"rifabbricati",
		"rifasciati",
		"rifatti",
		"rifenduti",
		"riferiti",
		"rifermati",
		"rifermentati",
		"rifessi",
		"rificcati",
		"rifilati",
		"rifiltrati",
		"rifinanziati",
		"rifiniti",
		"rifirmati",
		"rifischiati",
		"rifissi",
		"rifiutati",
		"riflessi",
		"riflettuti",
		"rifocillati",
		"rifoderati",
		"rifondati",
		"riforestati",
		"riforgiati",
		"riformati",
		"riformattati",
		"riformulati",
		"riforniti",
		"rifranti",
		"rifritti",
		"rifrugati",
		"rifuggiti",
		"rifugiati",
		"rifusi",
		"rigassificati",
		"rigati",
		"rigelati",
		"rigenerati",
		"rigettati",
		"righettati",
		"rigiocati",
		"rigirati",
		"rigiudicati",
		"rigiunti",
		"rigoduti",
		"rigonfiati",
		"rigovernati",
		"riguadagnati",
		"riguardati",
		"rigurgitati",
		"rilanciati",
		"rilasciati",
		"rilassati",
		"rilavati",
		"rilavorati",
		"rilegati",
		"riletti",
		"rilevati",
		"rilocalizzati",
		"rimagliati",
		"rimandati",
		"rimaneggiati",
		"rimangiati",
		"rimappati",
		"rimarcati",
		"rimarchiati",
		"rimarginati",
		"rimaritati",
		"rimasticati",
		"rimati",
		"rimbacuccati",
		"rimbaldanziti",
		"rimbarcati",
		"rimbeccati",
		"rimbecilliti",
		"rimbelliti",
		"rimbiancati",
		"rimbionditi",
		"rimboccati",
		"rimbombati",
		"rimborsati",
		"rimboscati",
		"rimboschiti",
		"rimbrottati",
		"rimediati",
		"rimembrati",
		"rimemorati",
		"rimenati",
		"rimeritati",
		"rimescolati",
		"rimessi",
		"rimestati",
		"rimilitarizzati",
		"rimirati",
		"rimischiati",
		"rimisurati",
		"rimodellati",
		"rimodernati",
		"rimodulati",
		"rimondati",
		"rimontati",
		"rimorchiati",
		"rimorsi",
		"rimossi",
		"rimostrati",
		"rimotivati",
		"rimpacchettati",
		"rimpadroniti",
		"rimpaginati",
		"rimpagliati",
		"rimpannucciati",
		"rimpastati",
		"rimpatriati",
		"rimpiallacciati",
		"rimpianti",
		"rimpiattati",
		"rimpiazzati",
		"rimpiccioliti",
		"rimpiccoliti",
		"rimpiegati",
		"rimpinguati",
		"rimpinzati",
		"rimpolpati",
		"rimpossessati",
		"rimpressi",
		"rimproverati",
		"rimuginati",
		"rimunerati",
		"rimunti",
		"rimusicati",
		"rimutati",
		"rinarrati",
		"rinascosti",
		"rincalcati",
		"rincalzati",
		"rincamminati",
		"rincantucciati",
		"rincarati",
		"rincarcerati",
		"rincarnati",
		"rincentrati",
		"rinchiesti",
		"rinchiodati",
		"rinchiusi",
		"rincitrulliti",
		"rinciviliti",
		"rincoglioniti",
		"rincollati",
		"rincominciati",
		"rincontrati",
		"rincoraggiati",
		"rincorati",
		"rincorporati",
		"rincorsi",
		"rincretiniti",
		"rincruditi",
		"rinculcati",
		"rincuorati",
		"rindossati",
		"rinduriti",
		"rinegoziati",
		"rinfacciati",
		"rinfagottati",
		"rinfiammati",
		"rinfiancati",
		"rinfilati",
		"rinfittiti",
		"rinfocolati",
		"rinfoderati",
		"rinforzati",
		"rinfrancati",
		"rinfranti",
		"rinfrescati",
		"rinfusi",
		"ringagliarditi",
		"ringalluzziti",
		"ringiovaniti",
		"ringioveniti",
		"ringoiati",
		"ringorgati",
		"ringraziati",
		"ringuainati",
		"rinnamorati",
		"rinnegati",
		"rinnestati",
		"rinnovati",
		"rinnovellati",
		"rinociuti",
		"rinomati",
		"rinominati",
		"rinormalizzati",
		"rinquadrati",
		"rinsaccati",
		"rinsaldati",
		"rinsanguati",
		"rinselvatichiti",
		"rinselvati",
		"rinserrati",
		"rintanati",
		"rintasati",
		"rintascati",
		"rintavolati",
		"rinteneriti",
		"rinterrati",
		"rinterrogati",
		"rintesi",
		"rintiepiditi",
		"rintoccati",
		"rintonacati",
		"rintontiti",
		"rintorpiditi",
		"rintracciati",
		"rintrodotti",
		"rintronati",
		"rintuzzati",
		"rinunciati",
		"rinunziati",
		"rinutriti",
		"rinvangati",
		"rinvasati",
		"rinvenuti",
		"rinverditi",
		"rinvestiti",
		"rinviati",
		"rinvigoriti",
		"rinviliti",
		"rinvitati",
		"rinvoltati",
		"rinvolti",
		"rinvoltolati",
		"rinzaffati",
		"rinzeppati",
		"riobbligati",
		"rioccupati",
		"riofferti",
		"rioffesi",
		"rioperati",
		"riordinati",
		"riorganizzati",
		"riorientati",
		"riosservati",
		"riottenuti",
		"riottimizzati",
		"riotturati",
		"ripagati",
		"riparametrizzati",
		"riparati",
		"ripartiti",
		"ripassati",
		"ripercorsi",
		"ripercossi",
		"riperduti",
		"ripersi",
		"ripesati",
		"ripescati",
		"ripestati",
		"ripetuti",
		"ripianati",
		"ripianificati",
		"ripiantati",
		"ripianti",
		"ripicchiati",
		"ripiegati",
		"ripigliati",
		"ripinti",
		"ripiovuti",
		"ripitturati",
		"riplasmati",
		"ripolarizzati",
		"ripopolati",
		"riportati",
		"riporti",
		"riposati",
		"riposizionati",
		"riposseduti",
		"riposti",
		"ripotuti",
		"ripresentati",
		"ripresi",
		"riprestati",
		"ripretesi",
		"riprincipiati",
		"ripristinati",
		"riprivatizzati",
		"riprodotti",
		"riprogettati",
		"riprogrammati",
		"ripromessi",
		"riproposti",
		"riprotetti",
		"riprovati",
		"riprovveduti",
		"riprovvisti",
		"ripubblicati",
		"ripudiati",
		"ripugnati",
		"ripuliti",
		"ripuntati",
		"ripunti",
		"ripurgati",
		"riputati",
		"riquadrati",
		"riqualificati",
		"riresi",
		"rirotti",
		"risaldati",
		"risaliti",
		"risaltati",
		"risalutati",
		"risanati",
		"risaputi",
		"risarciti",
		"riscalati",
		"riscaldati",
		"riscattati",
		"riscelti",
		"riscesi",
		"rischiarati",
		"rischiati",
		"risciacquati",
		"risciolti",
		"riscommessi",
		"riscontati",
		"riscontrati",
		"risconvolti",
		"riscoperti",
		"riscoppiati",
		"riscorsi",
		"riscossi",
		"riscritti",
		"risecati",
		"riseduti",
		"risegati",
		"risegnati",
		"riselciati",
		"riselezionati",
		"riseminati",
		"risentiti",
		"riseppelliti",
		"riserbati",
		"riservati",
		"risicati",
		"risigillati",
		"risistemati",
		"risi",
		"risoffiati",
		"risoggiunti",
		"risolati",
		"risolidificati",
		"risollevati",
		"risolti",
		"risommati",
		"risommersi",
		"risonati",
		"risorpassati",
		"risospesi",
		"risospinti",
		"risottomessi",
		"risparmiati",
		"risparsi",
		"rispecchiati",
		"rispediti",
		"rispenti",
		"rispersi",
		"rispettati",
		"rispiegati",
		"rispinti",
		"rispolverati",
		"risposati",
		"risposti",
		"rissati",
		"ristabiliti",
		"ristagnati",
		"ristampati",
		"ristaurati",
		"ristesi",
		"ristilizzati",
		"ristorati",
		"ristretti",
		"ristrutti",
		"ristrutturati",
		"ristuccati",
		"ristudiati",
		"risucchiati",
		"risultati",
		"risuolati",
		"risuonati",
		"risuscitati",
		"risvegliati",
		"risvolti",
		"ritagliati",
		"ritarati",
		"ritardati",
		"ritemprati",
		"ritentati",
		"ritenuti",
		"ritersi",
		"ritesi",
		"ritinti",
		"ritirati",
		"ritoccati",
		"ritolti",
		"ritorti",
		"ritracciati",
		"ritradotti",
		"ritrascorsi",
		"ritrascritti",
		"ritrasferiti",
		"ritrasformati",
		"ritrasmessi",
		"ritrasposti",
		"ritrattati",
		"ritratti",
		"ritrovati",
		"ritualizzati",
		"rituffati",
		"riuditi",
		"riunificati",
		"riuniti",
		"riusati",
		"riutilizzati",
		"rivaccinati",
		"rivaleggiati",
		"rivalorizzati",
		"rivalsi",
		"rivalutati",
		"rivangati",
		"riveduti",
		"rivelati",
		"rivendicati",
		"rivenduti",
		"riverberati",
		"riveriti",
		"riverniciati",
		"riversati",
		"rivestiti",
		"rivettati",
		"rivinti",
		"rivisitati",
		"rivissuti",
		"rivisti",
		"rivitalizzati",
		"rivivificati",
		"rivoltati",
		"rivolti",
		"rivoltolati",
		"rivoluti",
		"rivoluzionati",
		"rizappati",
		"rizzati",
		"robotizzati",
		"rodati",
		"rogati",
		"rollati",
		"romanizzati",
		"romanticizzati",
		"romanzati",
		"roncolati",
		"rosicati",
		"rosicchiati",
		"rosi",
		"rosolati",
		"rotacizzati",
		"rotati",
		"roteati",
		"rotolati",
		"rottamati",
		"rotti",
		"rovesciati",
		"rovinati",
		"rovistati",
		"rubacchiati",
		"rubati",
		"rullati",
		"ruminati",
		"ruotati",
		"russificati",
		"ruzzolati",
		"sabbiati",
		"sabotati",
		"saccarificati",
		"saccheggiati",
		"sacralizzati",
		"sacramentati",
		"sacrificati",
		"saettati",
		"saggiati",
		"sagginati",
		"sagomati",
		"salamoiati",
		"salariati",
		"salassati",
		"salati",
		"saldati",
		"salificati",
		"salinizzati",
		"saliti",
		"salmeggiati",
		"salmistrati",
		"salpati",
		"saltati",
		"salutati",
		"salvaguardati",
		"salvati",
		"sanati",
		"sanciti",
		"sanforizzati",
		"sanificati",
		"sanitizzati",
		"santificati",
		"sanzionati",
		"saponificati",
		"saputi",
		"sarchiati",
		"sarchiellati",
		"sartiati",
		"satellizzati",
		"satinati",
		"satireggiati",
		"satisfatti",
		"satollati",
		"saturati",
		"saziati",
		"sbaccellati",
		"sbaciucchiati",
		"sbafati",
		"sbaffati",
		"sbalestrati",
		"sballati",
		"sballottati",
		"sballottolati",
		"sbalorditi",
		"sbalzati",
		"sbancati",
		"sbandati",
		"sbandierati",
		"sbanditi",
		"sbaraccati",
		"sbaragliati",
		"sbarazzati",
		"sbarbati",
		"sbarcati",
		"sbardati",
		"sbarrati",
		"sbassati",
		"sbastiti",
		"sbatacchiati",
		"sbattezzati",
		"sbattuti",
		"sbeccati",
		"sbeffeggiati",
		"sbellicati",
		"sbendati",
		"sbertucciati",
		"sbiaditi",
		"sbiancati",
		"sbianchiti",
		"sbiellati",
		"sbiettati",
		"sbigottiti",
		"sbilanciati",
		"sbirbati",
		"sbirciati",
		"sbizzarriti",
		"sbloccati",
		"sbobinati",
		"sboccati",
		"sbocconcellati",
		"sbollentati",
		"sbolognati",
		"sborniati",
		"sborsati",
		"sboscati",
		"sbottonati",
		"sbozzati",
		"sbozzimati",
		"sbozzolati",
		"sbracati",
		"sbracciati",
		"sbraciati",
		"sbraitati",
		"sbranati",
		"sbrancati",
		"sbrattati",
		"sbreccati",
		"sbriciolati",
		"sbrigati",
		"sbrigliati",
		"sbrinati",
		"sbrindellati",
		"sbrodolati",
		"sbrogliati",
		"sbronzati",
		"sbruffati",
		"sbucciati",
		"sbudellati",
		"sbuffati",
		"sbugiardati",
		"sbullettati",
		"sbullonati",
		"sburrati",
		"scacazzati",
		"scacchiati",
		"scacciati",
		"scaccolati",
		"scadenzati",
		"scafati",
		"scaffalati",
		"scagionati",
		"scagliati",
		"scaglionati",
		"scalati",
		"scalcati",
		"scalcinati",
		"scaldati",
		"scalettati",
		"scalfati",
		"scalfiti",
		"scalmanati",
		"scaloppati",
		"scalpati",
		"scalpellati",
		"scalpellinati",
		"scaltriti",
		"scalzati",
		"scambiati",
		"scamiciati",
		"scamosciati",
		"scamozzati",
		"scampati",
		"scampatali",
		"scampati",
		"scamuffati",
		"scanalati",
		"scancellati",
		"scandagliati",
		"scandalizzati",
		"scanditi",
		"scannati",
		"scannellati",
		"scannerati",
		"scannerizati",
		"scannerizzati",
		"scansati",
		"scansionati",
		"scapecchiati",
		"scapezzati",
		"scapicollati",
		"scapigliati",
		"scapitozzati",
		"scapocchiati",
		"scappati",
		"scappellati",
		"scappottati",
		"scapricciati",
		"scapsulati",
		"scarabocchiati",
		"scaracchiati",
		"scaraventati",
		"scarcerati",
		"scardassati",
		"scardati",
		"scardinati",
		"scaricati",
		"scarificati",
		"scarmigliati",
		"scarnati",
		"scarnificati",
		"scarniti",
		"scarrellati",
		"scarrocciati",
		"scarrozzati",
		"scarruffati",
		"scartabellati",
		"scartati",
		"scartavetrati",
		"scartinati",
		"scartocciati",
		"scassati",
		"scassinati",
		"scatenati",
		"scattati",
		"scavalcati",
		"scavallati",
		"scavati",
		"scavezzati",
		"scazzottati",
		"scekerati",
		"scelti",
		"scempiati",
		"sceneggiati",
		"scernuti",
		"scervellati",
		"scesi",
		"sceverati",
		"schedati",
		"schedulati",
		"scheggiati",
		"scheletriti",
		"schematizzati",
		"schermati",
		"schermiti",
		"schermografati",
		"scherniti",
		"schiacciati",
		"schiaffati",
		"schiaffeggiati",
		"schiantati",
		"schiariti",
		"schiavardati",
		"schiavizzati",
		"schiccherati",
		"schierati",
		"schifati",
		"schinciati",
		"schioccati",
		"schiodati",
		"schiumati",
		"schiusi",
		"schivati",
		"schizzati",
		"schizzettati",
		"sciabolati",
		"sciabordati",
		"sciacquati",
		"scialacquati",
		"sciamanizzati",
		"sciamannati",
		"sciancati",
		"sciancrati",
		"scimmieggiati",
		"scimmiottati",
		"scinti",
		"scioccati",
		"sciolinati",
		"sciolti",
		"sciorinati",
		"scippati",
		"sciroppati",
		"scissi",
		"sciupacchiati",
		"sciupati",
		"sclamati",
		"sclerosati",
		"sclerotizzati",
		"scoccati",
		"scocciati",
		"scodati",
		"scodellati",
		"scoiati",
		"scolarizzati",
		"scolati",
		"scollacciati",
		"scollati",
		"scollegati",
		"scolorati",
		"scoloriti",
		"scolpati",
		"scolpiti",
		"scombaciati",
		"scombinati",
		"scombussolati",
		"scommessi",
		"scomodati",
		"scompaginati",
		"scompagnati",
		"scompartiti",
		"scompattati",
		"scompensati",
		"scompiacuti",
		"scompigliati",
		"scomposti",
		"scomputati",
		"scomunicati",
		"sconcertati",
		"sconciati",
		"sconclusi",
		"sconfessati",
		"sconficcati",
		"sconﬁtti",
		"sconfortati",
		"sconfusi",
		"scongelati",
		"scongiurati",
		"sconnessi",
		"sconosciuti",
		"sconquassati",
		"sconsacrati",
		"sconsigliati",
		"sconsolati",
		"scontati",
		"scontentati",
		"scontornati",
		"scontorti",
		"scontrati",
		"sconvolti",
		"scopati",
		"scoperchiati",
		"scoperti",
		"scopiazzati",
		"scoraggiati",
		"scoraggiti",
		"scorati",
		"scorazzati",
		"scorciati",
		"scorciti",
		"scordati",
		"scoreggiati",
		"scorificati",
		"scornati",
		"scorniciati",
		"scoronati",
		"scorporati",
		"scorrazzati",
		"scorreggiati",
		"scorretti",
		"scorsi",
		"scortati",
		"scortecciati",
		"scorticati",
		"scorti",
		"scorzati",
		"scoscesi",
		"scosciati",
		"scossi",
		"scostati",
		"scostolati",
		"scotennati",
		"scoticati",
		"scotolati",
		"scotomizzati",
		"scottati",
		"scotti",
		"scovati",
		"scoverti",
		"scozzati",
		"scozzonati",
		"screditati",
		"scremati",
		"screpolati",
		"screziati",
		"scribacchiati",
		"scriminati",
		"scristianizzati",
		"scritti",
		"scritturati",
		"scroccati",
		"scrocchiati",
		"scrollati",
		"scrostati",
		"scrutati",
		"scrutinati",
		"scuciti",
		"scudisciati",
		"scuffiati",
		"sculacciati",
		"sculettati",
		"scuoiati",
		"scuriosati",
		"scuriti",
		"scusati",
		"sdaziati",
		"sdebitati",
		"sdegnati",
		"sdemanializzati",
		"sdentati",
		"sdilinquiti",
		"sdoganati",
		"sdoluti",
		"sdoppiati",
		"sdraiati",
		"sdrammatizzati",
		"sdruciti",
		"secati",
		"seccati",
		"secernuti",
		"secolarizzati",
		"secondati",
		"secretati",
		"secreti",
		"sedati",
		"sedentarizzati",
		"sedotti",
		"segati",
		"seghettati",
		"segmentati",
		"segnalati",
		"segnati",
		"segnoreggiati",
		"segregati",
		"segretati",
		"seguitati",
		"seguiti",
		"selciati",
		"selezionati",
		"sellati",
		"sembrati",
		"sementati",
		"semicinti",
		"seminati",
		"semplificati",
		"senilizzati",
		"sensibilizzati",
		"sensorizzati",
		"sentenziati",
		"sentiti",
		"sentitaseli",
		"sentiti",
		"sentiti",
		"separati",
		"sepolti",
		"seppelliti",
		"sequenziati",
		"sequestrati",
		"serbati",
		"serrati",
		"serviti",
		"servoassistiti",
		"sessualizzati",
		"sestuplicati",
		"setacciati",
		"setificati",
		"settati",
		"settorializzati",
		"settuplicati",
		"seviziati",
		"sezionati",
		"sfaccettati",
		"sfagliati",
		"sfaldati",
		"sfalsati",
		"sfamati",
		"sfanalati",
		"sfangati",
		"sfarinati",
		"sfasati",
		"sfasciati",
		"sfatati",
		"sfatti",
		"sfavillati",
		"sfavoriti",
		"sfegatati",
		"sfeltrati",
		"sfenduti",
		"sferragliati",
		"sferrati",
		"sferzati",
		"sfessi",
		"sfiancati",
		"sfiatati",
		"sfiati",
		"sfibbiati",
		"sfibrati",
		"sfidati",
		"sfiduciati",
		"sfigurati",
		"sfilati",
		"sfilettati",
		"sfiniti",
		"sfioccati",
		"sfiorati",
		"sfittati",
		"sfocati",
		"sfociati",
		"sfoderati",
		"sfogati",
		"sfoggiati",
		"sfogliati",
		"sfollati",
		"sfoltiti",
		"sfondati",
		"sforacchiati",
		"sforati",
		"sforbiciati",
		"sformati",
		"sfornaciati",
		"sfornati",
		"sforniti",
		"sforzati",
		"sfottuti",
		"sfracellati",
		"sfrangiati",
		"sfrascati",
		"sfratati",
		"sfrattati",
		"sfrecciati",
		"sfregati",
		"sfregiati",
		"sfrenati",
		"sfrisati",
		"sfrondati",
		"sfrucugliati",
		"sfruculiati",
		"sfruttati",
		"sfumati",
		"sfuocati",
		"sgamati",
		"sganasciati",
		"sganciati",
		"sgarbugliati",
		"sgattaiolati",
		"sgelati",
		"sghiacciati",
		"sgocciolati",
		"sgolati",
		"sgomberati",
		"sgombrati",
		"sgomentati",
		"sgominati",
		"sgomitati",
		"sgomitolati",
		"sgonfiati",
		"sgorbiati",
		"sgottati",
		"sgovernati",
		"sgozzati",
		"sgraffiati",
		"sgraffignati",
		"sgranati",
		"sgranchiti",
		"sgranellati",
		"sgrassati",
		"sgravati",
		"sgretolati",
		"sgridati",
		"sgrommati",
		"sgrondati",
		"sgroppati",
		"sgrossati",
		"sgrovigliati",
		"sgrugnati",
		"sguainati",
		"sgualciti",
		"sguanciati",
		"sguarniti",
		"sguinzagliati",
		"sgusciati",
		"shakerati",
		"shoccati",
		"shuntati",
		"sigillati",
		"siglati",
		"significati",
		"signoreggiati",
		"silenziati",
		"silicizzati",
		"sillabati",
		"sillogizzati",
		"silurati",
		"simboleggiati",
		"simbolizzati",
		"simmetrizzati",
		"simpatizzati",
		"simulati",
		"sincerati",
		"sincopati",
		"sincretizzati",
		"sincronizzati",
		"sindacalizzati",
		"sindacati",
		"singolarizzati",
		"sinistrati",
		"sinizzati",
		"sinterizzati",
		"sintetizzati",
		"sintonizzati",
		"siringati",
		"sistematizzati",
		"sistemati",
		"situati",
		"slabbrati",
		"slacciati",
		"slamati",
		"slanciati",
		"slappolati",
		"slargati",
		"slavizzati",
		"slegati",
		"slentati",
		"slinguati",
		"slogati",
		"sloggati",
		"sloggiati",
		"slombati",
		"slungati",
		"smaccati",
		"smacchiati",
		"smagliati",
		"smagnetizzati",
		"smagriti",
		"smaliziati",
		"smallati",
		"smaltati",
		"smaltiti",
		"smammati",
		"smanacciati",
		"smangiati",
		"smantellati",
		"smarcati",
		"smarginati",
		"smarriti",
		"smascellati",
		"smascherati",
		"smaterializzati",
		"smattonati",
		"smembrati",
		"smentiti",
		"smerciati",
		"smerdati",
		"smerigliati",
		"smerlati",
		"smerlettati",
		"smessali",
		"smessi",
		"smezzati",
		"smidollati",
		"smielati",
		"smilitarizzati",
		"sminati",
		"sminuiti",
		"sminuzzati",
		"smistati",
		"smitizzati",
		"smobiliati",
		"smobilitati",
		"smobilizzati",
		"smoccolati",
		"smollicati",
		"smonacati",
		"smontati",
		"smorbati",
		"smorzati",
		"smossi",
		"smozzicati",
		"smunti",
		"smurati",
		"smussati",
		"smutandati",
		"snaturati",
		"snazionalizzati",
		"snebbiati",
		"snelliti",
		"snervati",
		"snidati",
		"sniffati",
		"snobbati",
		"snocciolati",
		"snodati",
		"snudati",
		"sobbarcati",
		"sobbolliti",
		"sobillati",
		"socchiusi",
		"soccorsi",
		"soddisfatti",
		"sodisfatti",
		"sodomizzati",
		"sofferiti",
		"soffermati",
		"sofferti",
		"soffiati",
		"soffocati",
		"soffregati",
		"soffritti",
		"soffusi",
		"sofisticati",
		"soggettivati",
		"soggettivizzati",
		"sogghignati",
		"soggiogati",
		"soggiunti",
		"sogguardati",
		"sognati",
		"solarizzati",
		"solcati",
		"soleggiati",
		"solennizzati",
		"solfeggiati",
		"solfitati",
		"solfonati",
		"solforati",
		"solidificati",
		"soliti",
		"sollazzati",
		"sollecitati",
		"solleticati",
		"sollevati",
		"solti",
		"solubilizzati",
		"soluti",
		"soluzionati",
		"solvatati",
		"somatizzati",
		"someggiati",
		"somigliati",
		"sommati",
		"sommersi",
		"sommessi",
		"somministrati",
		"sommossi",
		"sonati",
		"sondati",
		"sonorizzati",
		"sopiti",
		"soppalcati",
		"soppesati",
		"soppiantati",
		"sopportati",
		"sopposti",
		"soppressi",
		"sopraddotati",
		"sopraeccitati",
		"sopraedificati",
		"sopraelevati",
		"sopraffati",
		"sopraffatti",
		"sopraggiunti",
		"sopraintesi",
		"soprammessi",
		"soprannominati",
		"sopraposti",
		"soprappresi",
		"soprascritti",
		"sopraspesi",
		"soprassaturati",
		"soprasseduti",
		"sopravanzati",
		"sopravvalutati",
		"sopravveduti",
		"sopravvinti",
		"sopravvisti",
		"sopreccitati",
		"sopredificati",
		"soprelevati",
		"soprintesi",
		"sorbettati",
		"sorbiti",
		"sorgiunti",
		"sormontati",
		"sorpassati",
		"sorpresi",
		"sorrasi",
		"sorretti",
		"sorseggiati",
		"sorteggiati",
		"sortiti",
		"sorvegliati",
		"sorvolati",
		"soscritti",
		"sospesi",
		"sospettati",
		"sospinti",
		"sospirati",
		"sostantivati",
		"sostanziati",
		"sostentati",
		"sostenuti",
		"sostituiti",
		"sottaciuti",
		"sotterrati",
		"sottesi",
		"sottintesi",
		"sottoalimentati",
		"sottocapitalizzati",
		"sottodivisi",
		"sottoesposti",
		"sottofirmati",
		"sottolineati",
		"sottomessi",
		"sottomurati",
		"sottopagati",
		"sottopassati",
		"sottoposti",
		"sottorappresentati",
		"sottorisi",
		"sottoscritti",
		"sottostimati",
		"sottosviluppati",
		"sottotitolati",
		"sottovalutati",
		"sottratti",
		"soverchiati",
		"sovesciati",
		"sovietizzati",
		"sovracapitalizzati",
		"sovraccaricati",
		"sovradimensionati",
		"sovraeccitati",
		"sovraesposti",
		"sovraffaticati",
		"sovraffollati",
		"sovraggiunti",
		"sovraimposti",
		"sovraintesi",
		"sovralimentati",
		"sovramodulati",
		"sovrappopolati",
		"sovrapposti",
		"sovrariscaldati",
		"sovrasaturati",
		"sovrascritti",
		"sovrastampati",
		"sovrastati",
		"sovrastimati",
		"sovrautilizzati",
		"sovreccitati",
		"sovresposti",
		"sovrimposti",
		"sovrintesi",
		"sovvenuti",
		"sovvenzionati",
		"sovvertiti",
		"spaccati",
		"spacchettati",
		"spacciati",
		"spaginati",
		"spaiati",
		"spalancati",
		"spalati",
		"spalcati",
		"spalleggiati",
		"spalmati",
		"spammati",
		"spampanati",
		"spampinati",
		"spanati",
		"spanciati",
		"spanduti",
		"spannati",
		"spannocchiati",
		"spansi",
		"spantanati",
		"spanti",
		"spaparacchiati",
		"spaparanzati",
		"spappolati",
		"sparati",
		"sparecchiati",
		"sparigliati",
		"spariti",
		"sparlati",
		"sparpagliati",
		"spartiti",
		"spassati",
		"spassatoseli",
		"spastoiati",
		"spaurati",
		"spauriti",
		"spaventati",
		"spazializzati",
		"spaziati",
		"spazieggiati",
		"spazientiti",
		"spazzati",
		"spazzolati",
		"specchiati",
		"specializzati",
		"specificati",
		"specillati",
		"specolati",
		"spediti",
		"spegnati",
		"spelacchiati",
		"spelati",
		"spellati",
		"spennacchiati",
		"spennati",
		"spennellati",
		"spenti",
		"spenzolati",
		"sperati",
		"sperimentati",
		"spernacchiati",
		"speronati",
		"sperperati",
		"spersonalizzati",
		"sperticati",
		"spesati",
		"spesi",
		"spessiti",
		"spettacolarizzati",
		"spettinati",
		"spezzati",
		"spezzettati",
		"spezziati",
		"spezzonati",
		"spiaccicati",
		"spianati",
		"spiantati",
		"spiati",
		"spiattellati",
		"spiazzati",
		"spiccati",
		"spicciati",
		"spiccicati",
		"spicciolati",
		"spicconati",
		"spidocchiati",
		"spiegati",
		"spiegazzati",
		"spietrati",
		"spifferati",
		"spigionati",
		"spignorati",
		"spigolati",
		"spigriti",
		"spillati",
		"spilluzzicati",
		"spiluccati",
		"spinti",
		"spintonati",
		"spiombati",
		"spiralizzati",
		"spirantizzati",
		"spirati",
		"spiritualizzati",
		"spiumati",
		"spizzicati",
		"spodestati",
		"spoetizzati",
		"spogliati",
		"spolettati",
		"spoliati",
		"spoliticizzati",
		"spollonati",
		"spolmonati",
		"spolpati",
		"spoltroniti",
		"spolverati",
		"spolverizzati",
		"spompati",
		"spompinati",
		"sponsorizzati",
		"spopolati",
		"spoppati",
		"sporcati",
		"sportati",
		"sporti",
		"sposati",
		"sposseduti",
		"spossessati",
		"spostati",
		"sposti",
		"sprangati",
		"sprecati",
		"spregiati",
		"spremuti",
		"spretati",
		"sprezzati",
		"sprigionati",
		"sprimacciati",
		"spromessi",
		"spronati",
		"sprotetti",
		"sprovincializzati",
		"sprovveduti",
		"sprovvisti",
		"spruzzati",
		"spugnati",
		"spulati",
		"spulciati",
		"spuntati",
		"spuntellati",
		"spupazzati",
		"spurgati",
		"sputacchiati",
		"sputati",
		"sputtanati",
		"squadernati",
		"squadrati",
		"squagliati",
		"squagliataseli",
		"squagliati",
		"squalificati",
		"squamati",
		"squarciati",
		"squartati",
		"squassati",
		"squattrinati",
		"squilibrati",
		"squinternati",
		"sradicati",
		"srotolati",
		"srugginiti",
		"stabbiati",
		"stabiliti",
		"stabilizzati",
		"stabulati",
		"staccati",
		"stacciati",
		"staffati",
		"staffilati",
		"staggiati",
		"staggiti",
		"stagionati",
		"stagliati",
		"stagnati",
		"stamburati",
		"stampati",
		"stampigliati",
		"stanati",
		"stancati",
		"standardizzati",
		"stangati",
		"stanziati",
		"stappati",
		"starati",
		"starnazzati",
		"stasati",
		"statalizzati",
		"statizzati",
		"statoci",
		"statoseni",
		"statuiti",
		"stazzati",
		"stazzonati",
		"steccacciati",
		"steccati",
		"stecchiti",
		"stecconati",
		"stemperati",
		"stempiati",
		"stenografati",
		"stereotipati",
		"steriliti",
		"sterilizzati",
		"sterpati",
		"sterrati",
		"sterzati",
		"stesi",
		"stigliati",
		"stigmatizzati",
		"stilati",
		"stilettati",
		"stilizzati",
		"stillati",
		"stimati",
		"stimolati",
		"stinti",
		"stipati",
		"stipendiati",
		"stipulati",
		"stiracchiati",
		"stirati",
		"stivati",
		"stizziti",
		"stoccati",
		"stolti",
		"stomacati",
		"stonati",
		"stondati",
		"stoppati",
		"storditi",
		"storicizzati",
		"stornati",
		"storpiati",
		"stortati",
		"storti",
		"stozzati",
		"strabenedetti",
		"strabuzzati",
		"stracannati",
		"straccati",
		"stracciati",
		"stracotti",
		"strafogati",
		"stragoduti",
		"stralciati",
		"stralodati",
		"stralunati",
		"stramaledetti",
		"stramortiti",
		"strangolati",
		"straniati",
		"straniti",
		"straorzati",
		"strapagati",
		"strapazzati",
		"straperduti",
		"strapersi",
		"strappati",
		"strasaputi",
		"strascicati",
		"strascinati",
		"strasformati",
		"stratificati",
		"strattonati",
		"stravaccati",
		"stravinti",
		"stravolti",
		"stravoluti",
		"straziati",
		"stregati",
		"stremati",
		"stressati",
		"striati",
		"stridulati",
		"strigati",
		"strigliati",
		"strillati",
		"striminziti",
		"strimpellati",
		"strinati",
		"stringati",
		"strisciati",
		"stritolati",
		"strizzati",
		"strofinati",
		"strombati",
		"strombazzati",
		"stroncati",
		"stronzati",
		"stropicciati",
		"stroppati",
		"stroppiati",
		"strozzati",
		"struccati",
		"strumentalizzati",
		"strumentati",
		"strusciati",
		"strutti",
		"strutturalizzati",
		"strutturati",
		"stuccati",
		"studiacchiati",
		"studiati",
		"stuellati",
		"stufati",
		"stupefatti",
		"stupiti",
		"stuprati",
		"sturati",
		"stutati",
		"stuzzicati",
		"suasi",
		"subaffittati",
		"subappaltati",
		"subbiati",
		"subdelegati",
		"subissati",
		"subiti",
		"sublicenziati",
		"sublimati",
		"sublocati",
		"subodorati",
		"subordinati",
		"subornati",
		"suburbanizzati",
		"sucati",
		"succhiati",
		"succhiellati",
		"succiati",
		"succinti",
		"succisi",
		"suddistinti",
		"suddivisi",
		"suffissati",
		"suffissi",
		"suffragati",
		"suffumicati",
		"suffusi",
		"suggellati",
		"suggeriti",
		"suggestionati",
		"suicidati",
		"sunteggiati",
		"sunti",
		"suolati",
		"suonati",
		"superati",
		"superpagati",
		"superraffreddati",
		"supervalutati",
		"supervisionati",
		"supplicati",
		"suppliti",
		"supportati",
		"supposti",
		"suppurati",
		"surclassati",
		"surfati",
		"surgelati",
		"surraffreddati",
		"surriscaldati",
		"surrogati",
		"survoltati",
		"suscitati",
		"susseguiti",
		"sussidiati",
		"sussunti",
		"sussurrati",
		"suturati",
		"svaccati",
		"svagati",
		"svaligiati",
		"svalutati",
		"svapati",
		"svariati",
		"svasati",
		"svecchiati",
		"svegliati",
		"svelati",
		"sveleniti",
		"sveltiti",
		"svelti",
		"svenati",
		"svenduti",
		"sventagliati",
		"sventati",
		"sventolati",
		"sventrati",
		"sverginati",
		"svergognati",
		"svergolati",
		"sverminati",
		"sverniciati",
		"svestiti",
		"svettati",
		"svezzati",
		"sviati",
		"svignatoseli",
		"svigoriti",
		"sviliti",
		"svillaneggiati",
		"sviluppati",
		"svinati",
		"svincolati",
		"sviolinati",
		"svirgolati",
		"svirilizzati",
		"svisati",
		"sviscerati",
		"svitati",
		"sviticchiati",
		"svolati",
		"svolazzati",
		"svolti",
		"svoluti",
		"svuotati",
		"tabuizzati",
		"tabulati",
		"taccati",
		"taccheggiati",
		"tacciati",
		"tacitati",
		"taciuti",
		"tagliati",
		"taglieggiati",
		"tagliuzzati",
		"talebanizzati",
		"tallonati",
		"tampinati",
		"tamponati",
		"tanguti",
		"tannati",
		"tappati",
		"tappezzati",
		"tarati",
		"tardati",
		"targati",
		"tariffati",
		"tarlati",
		"tarmati",
		"taroccati",
		"tarpati",
		"tartagliati",
		"tartassati",
		"tartufati",
		"tassati",
		"tassellati",
		"tastati",
		"tasteggiati",
		"tatuati",
		"tecnicizzati",
		"tecnologizzati",
		"tedeschizzati",
		"tediati",
		"teflonati",
		"telecomandati",
		"telecontrollati",
		"telediffusi",
		"telefonati",
		"telegrafati",
		"teleguidati",
		"telematizzati",
		"telemetrati",
		"teleradiotrasmessi",
		"teletrasmessi",
		"teletrasportati",
		"tematizzati",
		"temperati",
		"tempestati",
		"tempificati",
		"templatizzati",
		"temporizzati",
		"temprati",
		"temuti",
		"tentati",
		"tenuti",
		"teologizzati",
		"teorizzati",
		"tepefatti",
		"terebrati",
		"terminati",
		"termostatati",
		"terrazzati",
		"terrificati",
		"terrorizzati",
		"tersi",
		"terzarolati",
		"terziarizzati",
		"terziati",
		"tesati",
		"tesaurizzati",
		"tesi",
		"tesserati",
		"testati",
		"testificati",
		"testimoniati",
		"timbrati",
		"tindalizzati",
		"tinteggiati",
		"tinti",
		"tipicizzati",
		"tipizzati",
		"tippati",
		"tiranneggiati",
		"tirati",
		"titillati",
		"titolati",
		"toccati",
		"toelettati",
		"tollerati",
		"tolti",
		"tonalizzati",
		"tonificati",
		"tonneggiati",
		"tonsurati",
		"torchiati",
		"tormentati",
		"tornatoseni",
		"torniti",
		"torrefatti",
		"torti",
		"tortoreggiati",
		"torturati",
		"tosati",
		"toscaneggiati",
		"toscanizzati",
		"tostati",
		"totalizzati",
		"traboccati",
		"trabuccati",
		"tracannati",
		"tracciati",
		"traditi",
		"tradotti",
		"trafficati",
		"trafilati",
		"trafitti",
		"traforati",
		"trafugati",
		"traghettati",
		"traguardati",
		"trainati",
		"tralasciati",
		"tralignati",
		"tramandati",
		"tramati",
		"trambasciati",
		"tramessi",
		"tramestati",
		"tramezzati",
		"tramortiti",
		"tramutati",
		"tranciati",
		"trangugiati",
		"tranquillati",
		"tranquillizzati",
		"transatti",
		"transcesi",
		"transcodificati",
		"transcorsi",
		"transcritti",
		"transennati",
		"transfluiti",
		"transfusi",
		"transistorizzati",
		"translitterati",
		"transposti",
		"transricevuti",
		"transustanziati",
		"transveduti",
		"transvisti",
		"trapanati",
		"trapassati",
		"trapiantati",
		"traportati",
		"traposti",
		"trapposti",
		"trapuntati",
		"trapunti",
		"trarotti",
		"trasandati",
		"trasbordati",
		"trascelti",
		"trascesi",
		"trascinati",
		"trascorsi",
		"trascritti",
		"trascurati",
		"trasdotti",
		"trasferiti",
		"trasfigurati",
		"trasformati",
		"trasfusi",
		"trasgrediti",
		"traslati",
		"traslitterati",
		"traslocati",
		"trasmessi",
		"trasmutati",
		"traspariti",
		"traspirati",
		"trasportati",
		"trasposti",
		"trastullati",
		"trasudati",
		"trasvolati",
		"trasvolti",
		"trattati",
		"tratteggiati",
		"trattenuti",
		"tratti",
		"traumatizzati",
		"travagliati",
		"travalicati",
		"travasati",
		"traveduti",
		"traversati",
		"travestiti",
		"traviati",
		"travisati",
		"travisti",
		"travolti",
		"trebbiati",
		"triangolati",
		"tribbiati",
		"tribolati",
		"tributati",
		"triennalizzati",
		"trimestralizzati",
		"trincati",
		"trincerati",
		"trinciati",
		"tripartiti",
		"triplicati",
		"trisecati",
		"trisezionati",
		"tritati",
		"triturati",
		"trivellati",
		"trollati",
		"trombati",
		"troncati",
		"tropicalizzati",
		"trovati",
		"truccati",
		"trucidati",
		"truffati",
		"tuffati",
		"tumefatti",
		"tumulati",
		"turati",
		"turbati",
		"turlupinati",
		"tutelati",
		"ubbligati",
		"ubicati",
		"ubiditi",
		"ubiquitinati",
		"ubriacati",
		"uccellati",
		"uccellinati",
		"uccisi",
		"uditi",
		"ufficializzati",
		"uggiti",
		"ugnati",
		"uguagliati",
		"ulcerati",
		"uliti",
		"ulolati",
		"ultimati",
		"ultracentrifugati",
		"ululati",
		"umanati",
		"umanizzati",
		"umettati",
		"umidificati",
		"umiditi",
		"umiliati",
		"uncinati",
		"unguentati",
		"unificati",
		"uniformati",
		"uniti",
		"univerbati",
		"universaleggiati",
		"universalizzati",
		"untati",
		"unti",
		"uperizzati",
		"urbanizzati",
		"urgenzati",
		"urlati",
		"urtacchiati",
		"urtati",
		"urticchiati",
		"usati",
		"usciolati",
		"usolati",
		"ustionati",
		"usucapiti",
		"usurati",
		"usurpati",
		"utilitati",
		"utilizzati",
		"vaccinati",
		"vagabondeggiati",
		"vagellati",
		"vagheggiati",
		"vagillati",
		"vagliati",
		"valcati",
		"valicati",
		"validati",
		"valorizzati",
		"valsi",
		"valutati",
		"vanagloriati",
		"vanati",
		"vandalizzati",
		"vangati",
		"vangelizzati",
		"vanificati",
		"vaniti",
		"vantaggiati",
		"vantati",
		"vaporati",
		"vaporizzati",
		"varati",
		"varcati",
		"variati",
		"vasectomizzati",
		"vaticinati",
		"vedovati",
		"veduti",
		"vegetati",
		"veggiati",
		"vegliati",
		"veicolati",
		"velarizzati",
		"velati",
		"velettati",
		"velinati",
		"vellicati",
		"vellutati",
		"velocizzati",
		"vendemmiati",
		"vendicati",
		"vendicchiati",
		"venducchiati",
		"venduti",
		"venerati",
		"vengiati",
		"ventagliati",
		"ventilati",
		"ventolati",
		"verbalizzati",
		"vergati",
		"vergheggiati",
		"vergognati",
		"vergolati",
		"verificati",
		"verminati",
		"vernalizzati",
		"verniciati",
		"verrinati",
		"versati",
		"verseggiati",
		"versificati",
		"verticalizzati",
		"vessati",
		"vestiti",
		"vestiti",
		"vetrificati",
		"vetrinati",
		"vetrioleggiati",
		"vettovagliati",
		"vezzeggiati",
		"viaggiati",
		"vicinati",
		"vicitati",
		"videochattati",
		"videochiamati",
		"videocomunicati",
		"videoregistrati",
		"videotrasmessi",
		"vidimati",
		"vigilati",
		"vigliati",
		"vigoreggiati",
		"vigoriti",
		"vilificati",
		"vilipesi",
		"villaneggiati",
		"vincolati",
		"vinti",
		"violati",
		"violentati",
		"violinati",
		"virgolati",
		"virgoleggiati",
		"virgolettati",
		"virilizzati",
		"virtualizzati",
		"visionati",
		"visitati",
		"vissuti",
		"vistati",
		"visti",
		"visualizzati",
		"vitaliziati",
		"vitalizzati",
		"vitaminizzati",
		"vittimizzati",
		"vituperati",
		"vivacizzati",
		"vivandati",
		"vivificati",
		"vivisezionati",
		"viziati",
		"vocabolarizzati",
		"vocalizzati",
		"vocati",
		"vociferati",
		"volantinati",
		"volatilizzati",
		"volgarizzati",
		"volicchiati",
		"volpeggiati",
		"voltati",
		"volti",
		"voltolati",
		"volturati",
		"voluminizzati",
		"voluti",
		"volutoci",
		"vomitati",
		"vorati",
		"votati",
		"vulcanizzati",
		"vuotati",
		"wappati",
		"wikificati",
		"xerocopiati",
		"zaffati",
		"zampati",
		"zampettati",
		"zampillati",
		"zannati",
		"zappati",
		"zappettati",
		"zapponati",
		"zavorrati",
		"zeppati",
		"zigrinati",
		"zigzagati",
		"zimbellati",
		"zincati",
		"zinnati",
		"zipolati",
		"zippati",
		"zirlati",
		"zittiti",
		"zizzagati",
		"zoccolati",
		"zollati",
		"zombati",
		"zonati",
		"zonizzati",
		"zoppati",
		"zoppeggiati",
		"zoppicati",
		"zucconati",
		"zufolati",
		"zumati",
		"zuppati",
	];
}
